import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    "en": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 System Admin Platform Admin",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Description",
            "Enter Description": "Enter Description",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "Email",
            "Enter Email": "Enter Email",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "First Name",
            "Enter First Name": "Enter First Name",
            "Middle Name": "Middle Name",
            "Enter Middle Name": "Enter Middle Name",
            "Last Name": "Last Name",
            "Enter Last Name": "Enter Last Name",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 Organization Stakeholder Onboarding",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Website",
            "Enter Website": "Enter Website",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 Investor Onboarding Compliance",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Date of Birth",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 Asset SPV Due Diligence Legal",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 Escrow Investor Protection Market",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 Core Operations Audit Reporting",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Priority",
            "Enter Priority": "Enter Priority",
            "Subject": "Subject",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 Asset Owner Sponsor Asset Setup",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 Offering Legal Compliance Readiness",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 Investor Subscription Token Issuance",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Payment Method",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 Property Manager Rental Operations",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 Finance Escrow Distribution Reporting",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 Asset Manager Lifecycle Exit",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 Asset Owner Sponsor Revenue Setup",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 Offering Legal Compliance Readiness",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 Investor Subscription Token Issuance",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 Revenue Operator Verifier Operations",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 Finance Escrow Distribution Reporting",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 Sponsor Governance Lifecycle Exit",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 Asset Owner Sponsor Asset Exit Setup",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 Offering Legal Compliance Readiness",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 Investor Subscription Token Issuance",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 Asset Manager Sale Process Execution",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 Finance Escrow Profit Distribution",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 Investor Relations Tax Closeout",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 Asset Owner Sponsor NAV Asset Setup",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 Offering NAV Legal Compliance Readiness",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 Investor Subscription Token Issuance",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 Asset Manager NAV Lifecycle Monitoring",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 Finance Escrow Appreciation Distribution",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 Investor Relations Tax Exit",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 Asset Owner Sponsor Preferred Equity Setup",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 Offering Legal Preferred Waterfall Readiness",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 Investor Subscription Token Issuance",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 Inspection Escrow Capital Release",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 Finance Preferred Return Distribution",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 Investor Relations Tax Reporting",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 Asset Manager Lifecycle Exit",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 Asset Owner Sponsor Equity Setup",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 Offering Legal Compliance Readiness",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 Investor Subscription Token Issuance",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 Equity Ownership Governance Management",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 Finance Escrow Distribution Reporting",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 Asset Manager Lifecycle Exit",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 Asset Owner Sponsor Collateral Setup",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 Debt Structuring Legal Risk Readiness",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 Investor Subscription Token Issuance",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 Debt Servicing Interest Payment Management",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 Finance Escrow Investor Reporting",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 Lifecycle Default Maturity Exit",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 Offering Structuring Hybrid Model Setup",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 Legal Risk Escrow Readiness",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 Investor Subscription Token Issuance",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 Finance Waterfall Distribution Reporting",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 Asset Manager Lifecycle Exit",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 Sponsor Auction Opportunity Intake",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 Due Diligence Title Risk Max Bid",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 Pool Structuring Escrow Compliance",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 Investor Pledge Escrow Funding",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 Bid Authorization Submission Result",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 Refund Transition Reporting Closeout",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 Sponsor Auction Result Intake Closing",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 Legal Title Lien Redemption Clearance",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 Property Control Condition Rehab Appraisal",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV Transfer Readiness Risk",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 Offering Disclosure Compliance Approval",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 Investor Relations Update Reporting",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "ar": {
        "translation": {
            "Logo": "الشعار",
            "$3,500 / month / 10 tokens": "3,500 دولار / شهرياً / 10 رموز",
            "$500 / month / token": "500 دولار / شهرياً / لكل رمز",
            "▣ Layers": "▣ الطبقات",
            "☰ Filters": "☰ عوامل التصفية",
            "♡ Save search": "♡ حفظ البحث",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "منصة منظّمة لترميز الأصول الحقيقية تشمل الأراضي والعقارات المؤجرة ومشروعات التطوير والفرص العقارية القائمة على المزادات.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "يعني التحويل الثانوي نقل رمز بعد الإصدار الأصلي، مثل نقله من حامل معتمد إلى حامل معتمد آخر. وقد تتطلب التحويلات الثانوية موافقات إضافية أو قيوداً على التحويل أو مراجعة قانونية أو دعماً من وسيط-تاجر أو وكيل تحويل أو خطوات امتثال أخرى.",
            "About": "حول",
            "Active listing": "إدراج نشط",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "يرجى إضافة أي تفاصيل تتعلق بدورك أو مشروعك أو الأصل أو الرمز أو احتياجات الخدمة أو الاتفاقيات أو طريقة الدفع أو طلب التحويل الثانوي.",
            "Add review": "إضافة مراجعة",
            "Additional notes": "ملاحظات إضافية",
            "Address pending": "العنوان قيد الانتظار",
            "Advanced data, listing, reporting, and operational workflow support": "دعم متقدم للبيانات والإدراج وإعداد التقارير ومسارات العمل التشغيلية",
            "after completed buy or sell transaction": "بعد اكتمال معاملة شراء أو بيع",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "بعد التحقق من الهوية ومراجعة الأهلية، يمكن للمستخدمين المعتمدين الاطلاع على تفاصيل الإدراج كاملة وطلب المراجعات وتنفيذ إجراءات الشراء أو البيع المسموح بها ضمن حدود كل طرح.",
            "Alabama": "ألاباما",
            "Alaska": "ألاسكا",
            "All": "الكل",
            "American Samoa": "ساموا الأمريكية",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "يجوز للمهنيين المعتمدين دعم أعمال المراجعة والشؤون القانونية وحساب الضمان والامتثال والتقييم وإعداد التقارير وغيرها من مسارات الخدمة المسندة إليهم.",
            "Arizona": "أريزونا",
            "Arkansas": "أركنساس",
            "Asset class": "فئة الأصل",
            "Asset owner": "مالك الأصل",
            "Asset owner, sponsor, issuer, or operator service plan": "خطة خدمة لمالك الأصل أو الراعي أو الجهة المُصدِرة أو المشغّل",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "مالك الأصل أو الراعي أو الجهة المُصدِرة أو مدير العقار أو مدير الأصل أو مدير إعادة التأهيل",
            "Auction": "مزاد",
            "Authentication options": "خيارات المصادقة",
            "Back to login": "العودة إلى تسجيل الدخول",
            "Basic asset and token workflow access": "وصول أساسي إلى مسارات عمل الأصول والرموز",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "خدمة إدارة SaaS أساسية لكل رمز نشط، ومناسبة لعدد محدود من الأصول أو لإطلاق أولي.",
            "Blockchain network": "شبكة البلوك تشين",
            "Boundary": "الحدود",
            "Broker-dealer signer, transfer agent, or token operations user": "موقّع لدى وسيط-تاجر أو وكيل تحويل أو مستخدم عمليات الرموز",
            "Buy Tokens": "شراء الرموز",
            "California": "كاليفورنيا",
            "Charged only after a completed purchase or sale": "تُفرض الرسوم فقط بعد اكتمال عملية شراء أو بيع",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "تُفرض الرسوم فقط على مستخدم معتمد يكون موقّعاً لدى وسيط-تاجر أو وكيل تحويل أو مستخدم عمليات الرموز",
            "Checking your session...": "جارٍ التحقق من جلستك...",
            "Close details": "إغلاق التفاصيل",
            "Colorado": "كولورادو",
            "Common Equity": "الأسهم العادية",
"Rental Income": "دخل الإيجار",
"Revenue Share": "مشاركة الإيرادات",
"Sale Profit": "ربح البيع",
"Equity Appreciation": "ارتفاع قيمة حقوق الملكية",
"Preferred Equity": "حقوق الملكية الممتازة",
"Common Equity": "الأسهم العادية",
"Debt Note": "سند دين",
"Hybrid": "هجين",
"Pre-Auction Pool": "مجمع ما قبل المزاد",
"Post-Auction Token": "رمز ما بعد المزاد",
"United Arab Emirates": "الإمارات العربية المتحدة",
"Abu Dhabi": "أبوظبي",
"Ajman": "عجمان",
"Dubai": "دبي",
"Fujairah": "الفجيرة",
"Ras Al Khaimah": "رأس الخيمة",
"Sharjah": "الشارقة",
"Umm Al Quwain": "أم القيوين",
"Archived": "مؤرشف",
"Closed": "مغلق",
"Listed": "مدرج",
"Listed - Investment Open": "مدرج - الاستثمار مفتوح",
"Listed - Not Investable": "مدرج - غير متاح للاستثمار",
"Not Listed": "غير مدرج",
"Paused": "متوقف مؤقتاً",
"Pre-Listing Draft": "مسودة ما قبل الإدراج",
"Preview Only": "للمعاينة فقط",
"Active": "نشط",
"Auction Asset": "أصل مزاد",
"Development Project": "مشروع تطوير",
"Distressed Asset": "أصل متعثر",
"Land": "أرض",
"Mixed-Use Asset": "أصل متعدد الاستخدامات",
"Operating Business": "نشاط تشغيلي",
"Real Asset": "أصل حقيقي",
"Rental Property": "عقار للإيجار",
"Revenue Contract": "عقد إيرادات",
"Bankruptcy Sale": "بيع بالمزاد بسبب الإفلاس",
"Foreclosure": "مزاد حجز الرهن",
"Online Auction": "مزاد إلكتروني",
"Other": "أخرى",
"Private Auction": "مزاد خاص",
"REO Auction": "مزاد عقار مملوك للمقرض (REO)",
"Sheriff Sale": "مزاد مأمور التنفيذ",
"Tax Sale": "مزاد بسبب مستحقات ضريبية",
"Auction Type": "نوع المزاد",
"Auction Status": "حالة المزاد",
"Auction Source": "مصدر المزاد",
"Auction Source Link": "رابط مصدر المزاد",
"Auction Opportunity ID": "معرّف فرصة المزاد",
"Pre-Auction Opportunity ID": "معرّف فرصة ما قبل المزاد",
"Pre-Auction Auction Opportunity": "فرصة مزاد ما قبل المزاد",

"Post-Auction Result Intake": "إدخال نتيجة ما بعد المزاد",
"Post-Auction Result Intake ID": "معرّف إدخال نتيجة ما بعد المزاد",
"Pre-Auction Result ID": "معرّف نتيجة ما قبل المزاد",

"Winning Bid USD": "قيمة العرض الفائز بالدولار الأمريكي",
"Winning Bidder Name": "اسم صاحب العرض الفائز",
"Auction Result Date": "تاريخ نتيجة المزاد",
"Identified": "تم تحديده",
"Due Diligence": "قيد العناية الواجبة",
"Bid Authorized": "تمت الموافقة على تقديم العرض",
"Bid Submitted": "تم تقديم العرض",
"Pool Open": "مجمع المزاد مفتوح",
"Won": "تم الفوز",
"Lost": "لم يتم الفوز",
"Cancelled": "ملغى",
"Closed": "مغلق",
"Purchase / request actions": "إجراءات الشراء / الطلب",

"Request purchase": "طلب شراء",
"Reserve allocation": "حجز تخصيص",
"Open data room": "فتح غرفة البيانات",

"Join auction pool": "الانضمام إلى مجمع المزاد",
"Submit bid-interest request": "تقديم طلب إبداء اهتمام بالمزايدة",
"Open auction package": "فتح حزمة المزاد",
"Schedule investor call": "جدولة مكالمة مع المستثمر",

"Request post-auction allocation": "طلب تخصيص ما بعد المزاد",
"Review foreclosure package": "مراجعة حزمة حبس الرهن",

"Request note purchase": "طلب شراء سند",
"View note terms": "عرض شروط السند",
"Schedule lender call": "جدولة مكالمة مع المُقرض",

"Buy equity token": "شراء رمز حقوق الملكية",
"Request subscription": "طلب اشتراك",
"View offering memorandum": "عرض مذكرة الطرح",

"Buy income token": "شراء رمز الدخل",
"View cash-flow summary": "عرض ملخص التدفقات النقدية",

"Request sale-profit token": "طلب رمز ربح البيع",
"View exit plan": "عرض خطة الخروج",

"Request hybrid token": "طلب رمز هجين",
"Compare components": "مقارنة المكونات",
"Private Auction": "مزاد خاص",

"Approximate Irregular Parcel Boundary":
  "حدود تقريبية لقطعة أرض غير منتظمة",

"Use these options to show or hide map-only overlays.":
  "استخدم هذه الخيارات لإظهار أو إخفاء الطبقات الخاصة بالخريطة.",

"Token boundary polygons after zoom 15+":
  "إظهار مضلعات حدود الرمز عند مستوى تكبير 15 فأعلى",

"Show all visible boundaries only when 50 or fewer tokens are filtered":
  "إظهار جميع الحدود المرئية فقط عند تصفية 50 رمزاً أو أقل",
"A global operating system for tokenized real-world assets": "نظام تشغيل عالمي للأصول الحقيقية المرمّزة",

"SRWAE is designed as a global platform to help qualified asset owners, sponsors, issuers, operators, investors, and professional service providers structure and manage approved tokenized interests connected to land, construction, rental property, real estate equity, debt, revenue, sale profit, and auction opportunities.": "صُممت SRWAE كمنصة عالمية لمساعدة مالكي الأصول المؤهلين والرعاة والمُصدرين والمشغلين والمستثمرين ومقدمي الخدمات المهنية على هيكلة وإدارة المصالح المرمّزة المعتمدة المرتبطة بالأراضي والإنشاءات والعقارات المؤجرة وحقوق الملكية العقارية والديون والإيرادات وأرباح البيع وفرص المزادات.",

"The platform is designed for global tokenization, with an initial phased launch in the United States and a limited number of selected countries. Unless otherwise stated, the market estimates and capacity illustrations on this page are based on U.S. data.": "صُممت المنصة للترميز على المستوى العالمي، مع إطلاق أولي مرحلي في الولايات المتحدة وعدد محدود من الدول المختارة. وما لم يُذكر خلاف ذلك، تستند تقديرات السوق والسيناريوهات التوضيحية للقدرة في هذه الصفحة إلى بيانات الولايات المتحدة.",

"Platform focus areas": "مجالات تركيز المنصة",
"Global design, phased launch": "تصميم عالمي وإطلاق مرحلي",
"Real estate and land": "العقارات والأراضي",
"Ten tokenization models": "عشرة نماذج للترميز",
"Role-based access": "وصول قائم على الأدوار",
"On-chain and off-chain records": "سجلات على السلسلة وخارجها",
"No required platform stablecoin": "لا تتطلب المنصة عملة مستقرة خاصة بها",
"SRWAE market position": "الموقع السوقي لمنصة SRWAE",
"Market position": "الموقع السوقي",
"Large underlying market, disciplined initial entry": "سوق أساسي كبير، ودخول أولي منضبط",

"U.S. real estate is used on this page as the initial market benchmark and represents tens of trillions of dollars, while tokenized real estate remains early. SRWAE is designed for broader international expansion without requiring a large share of any single national market.": "تُستخدم العقارات في الولايات المتحدة في هذه الصفحة كمعيار أولي للسوق، وهي تمثل عشرات التريليونات من الدولارات، في حين لا يزال سوق العقارات المرمّزة في مراحله المبكرة. وقد صُممت SRWAE للتوسع الدولي الأوسع دون الحاجة إلى حصة كبيرة من سوق أي دولة منفردة.",

"A $30 billion represented-asset scenario equals approximately this share of the Federal Reserve household and nonprofit real estate measure for 2026 Q1.": "يمثل سيناريو أصول بقيمة 30 مليار دولار تقريباً هذه النسبة من مقياس الاحتياطي الفيدرالي لعقارات الأسر والمؤسسات غير الربحية للربع الأول من عام 2026.",

"Platform definition": "تعريف المنصة",
"What SRWAE is built to coordinate": "ما الذي صُممت SRWAE لتنسيقه",

"The system combines marketplace discovery with controlled project, professional, legal, operational, and investor workflows. Access is determined by role, verification, offering terms, jurisdiction, agreements, and applicable law.": "يجمع النظام بين اكتشاف الفرص في السوق وسير العمل المنضبط للمشروعات والمهنيين والجوانب القانونية والتشغيلية والمستثمرين. ويتم تحديد مستوى الوصول وفقاً للدور والتحقق وشروط الطرح والاختصاص القضائي والاتفاقيات والقانون المعمول به.",

"Global platform with phased market entry": "منصة عالمية بدخول مرحلي إلى الأسواق",

"SRWAE is designed for international use, with the initial launch focused on the United States and a limited number of selected countries. Availability, user roles, services, and transaction workflows are determined by the applicable requirements in each jurisdiction.": "صُممت SRWAE للاستخدام الدولي، مع تركيز الإطلاق الأولي على الولايات المتحدة وعدد محدود من الدول المختارة. ويتم تحديد توافر المنصة وأدوار المستخدمين والخدمات وسير عمل المعاملات وفقاً للمتطلبات المعمول بها في كل اختصاص قضائي.",

"Full asset and token lifecycle": "دورة حياة كاملة للأصل والرمز",

"SRWAE connects asset intake, due diligence, data rooms, legal review, valuation, escrow, offering preparation, investor access, reporting, distributions, and approved transfers.": "تربط SRWAE بين إدخال الأصول والعناية الواجبة وغرف البيانات والمراجعة القانونية والتقييم والضمان وإعداد الطرح ووصول المستثمرين وإعداد التقارير والتوزيعات والتحويلات المعتمدة.",

"Role-based access and responsibility": "الوصول والمسؤوليات القائمة على الأدوار",

"Public visitors, verified investors, sponsors, issuers, operators, broker-dealers, transfer agents, escrow users, legal reviewers, and other professionals receive different permissions.": "يحصل الزوار العامون والمستثمرون الذين تم التحقق منهم والرعاة والمُصدرون والمشغلون والوسطاء والمتعاملون ووكلاء التحويل ومستخدمو الضمان والمراجعون القانونيون وغيرهم من المهنيين على صلاحيات مختلفة.",

"The platform is designed around real-world asset workflows and approved payment or settlement arrangements rather than requiring a proprietary stablecoin.": "صُممت المنصة حول سير عمل الأصول الحقيقية وترتيبات الدفع أو التسوية المعتمدة، بدلاً من اشتراط استخدام عملة مستقرة مملوكة للمنصة.",

"United States market context": "سياق السوق في الولايات المتحدة",
"The underlying asset market is already extremely large": "سوق الأصول الأساسية كبير للغاية بالفعل",

"These figures describe the scale of selected U.S. real estate categories. They are not estimates of assets that are legally eligible, operationally ready, or likely to use SRWAE.": "توضح هذه الأرقام حجم فئات مختارة من العقارات في الولايات المتحدة. وهي لا تمثل تقديرات للأصول المؤهلة قانونياً أو الجاهزة تشغيلياً أو التي يُحتمل أن تستخدم SRWAE.",

"U.S. household and nonprofit real estate": "عقارات الأسر والمؤسسات غير الربحية في الولايات المتحدة",

"Market value reported for the first quarter of 2026. This measure demonstrates the depth of the underlying U.S. real estate base, but it is not the same as the immediately tokenizable market.": "القيمة السوقية المعلنة للربع الأول من عام 2026. يوضح هذا المقياس حجم قاعدة العقارات الأساسية في الولايات المتحدة، لكنه لا يمثل حجم السوق القابل للترميز الفوري.",

"Federal Reserve, Financial Accounts of the United States, 2026 Q1": "الاحتياطي الفيدرالي، الحسابات المالية للولايات المتحدة، الربع الأول 2026",
"U.S. commercial real estate benchmark": "معيار سوق العقارات التجارية في الولايات المتحدة",

"Nareit estimated the U.S. commercial real estate market at this level in the second quarter of 2021. It remains a useful scale benchmark, although current sector values vary by property type and market.": "قدّرت Nareit سوق العقارات التجارية في الولايات المتحدة بهذا المستوى في الربع الثاني من عام 2021. ولا يزال هذا الرقم معياراً مفيداً للحجم، رغم اختلاف القيم الحالية حسب نوع العقار والسوق.",

"Nareit commercial real estate market estimate": "تقدير Nareit لسوق العقارات التجارية",
"U.S. farm real estate": "العقارات الزراعية في الولايات المتحدة",

"Forecast value of U.S. farm land and structures in 2025. Land-based assets are a major potential category, subject to title, valuation, use, transfer, and offering requirements.": "القيمة المتوقعة للأراضي والمنشآت الزراعية في الولايات المتحدة لعام 2025. وتمثل الأصول القائمة على الأراضي فئة محتملة مهمة، مع خضوعها لمتطلبات الملكية والتقييم والاستخدام والتحويل والطرح.",

"USDA Economic Research Service, updated May 2026": "خدمة البحوث الاقتصادية بوزارة الزراعة الأمريكية (USDA)، تحديث مايو 2026",
"Renter-occupied U.S. housing units": "الوحدات السكنية المستأجرة في الولايات المتحدة",

"The 2024 American Community Survey estimated more than forty-six million renter-occupied housing units, showing the breadth of the rental-income ecosystem.": "قدّر مسح المجتمع الأمريكي لعام 2024 وجود أكثر من 46 مليون وحدة سكنية يشغلها مستأجرون، مما يوضح اتساع منظومة دخل الإيجار.",

"U.S. Census Bureau, 2024 American Community Survey": "مكتب الإحصاء الأمريكي، مسح المجتمع الأمريكي لعام 2024",

"Growth potential": "إمكانات النمو",
"Why real estate tokenization can expand quickly from a small base": "لماذا يمكن لترميز العقارات أن يتوسع بسرعة انطلاقاً من قاعدة صغيرة",

"Independent forecasts use different definitions and should not be added together. Taken as directional evidence, they indicate strong long-term interest in tokenized funds, loans, securitizations, land, construction projects, and other real-world assets.": "تستخدم التوقعات المستقلة تعريفات مختلفة، ولذلك لا ينبغي جمع أرقامها معاً. وعند النظر إليها كمؤشرات للاتجاه العام، فإنها تدل على اهتمام قوي طويل الأجل بالصناديق والقروض والتوريق والأراضي ومشروعات البناء وغيرها من الأصول الحقيقية المرمّزة.",

"Tokenized real estate by 2035": "العقارات المرمّزة بحلول عام 2035",

"Deloitte forecasts that the global tokenized real estate ecosystem could grow from less than $0.3 trillion in 2024 to $4 trillion by 2035.": "تتوقع Deloitte أن تنمو منظومة العقارات المرمّزة عالمياً من أقل من 0.3 تريليون دولار في عام 2024 إلى 4 تريليونات دولار بحلول عام 2035.",

"Illustrative annual growth rate": "معدل نمو سنوي توضيحي",

"Deloitte associates its real estate tokenization forecast with an estimated compound annual growth rate of approximately twenty-seven percent.": "تربط Deloitte توقعاتها لترميز العقارات بمعدل نمو سنوي مركب تقديري يبلغ نحو 27%.",

"Broader tokenized market by 2030": "السوق الأوسع للأصول المرمّزة بحلول عام 2030",

"McKinsey estimates that tokenized market capitalization could reach approximately $2 trillion by 2030, excluding cryptocurrencies and stablecoins.": "تقدّر McKinsey أن القيمة السوقية للأصول المرمّزة قد تصل إلى نحو تريليوني دولار بحلول عام 2030، باستثناء العملات المشفرة والعملات المستقرة.",

"Greater U.S. regulatory clarity": "وضوح تنظيمي أكبر في الولايات المتحدة",

"The SEC has published current guidance explaining that a tokenized security remains subject to federal securities laws regardless of its on-chain or off-chain format.": "نشرت هيئة الأوراق المالية والبورصات الأمريكية (SEC) إرشادات توضح أن الورقة المالية المرمّزة تظل خاضعة لقوانين الأوراق المالية الفيدرالية سواء كانت على السلسلة أو خارجها.",

"Smaller investment units": "وحدات استثمار أصغر",
"More flexible capital formation": "مرونة أكبر في تكوين رأس المال",
"More visible operating records": "سجلات تشغيلية أكثر وضوحاً",
"Programmable transfer controls": "ضوابط تحويل قابلة للبرمجة",
"Better asset discovery": "اكتشاف أفضل للأصول",
"Potential for controlled secondary transfers": "إمكانات التحويلات الثانوية المنضبطة",

"A properly structured fractional interest can reduce the minimum capital required for an individual investor, although investor eligibility and offering limits still apply.": "يمكن للحصة الجزئية المهيكلة بصورة صحيحة أن تقلل الحد الأدنى لرأس المال المطلوب من المستثمر الفردي، مع استمرار تطبيق متطلبات أهلية المستثمر وحدود الطرح.",

"Sponsors may seek capital against a defined economic interest without necessarily selling the entire asset, but the transaction must follow its legal structure and disclosures.": "يمكن للرعاة السعي للحصول على رأس مال مقابل مصلحة اقتصادية محددة دون الحاجة بالضرورة إلى بيع الأصل بالكامل، على أن تلتزم المعاملة بهيكلها القانوني ومتطلبات الإفصاح.",

"Standardized data rooms, review records, milestone evidence, distribution reports, and transfer histories can improve transparency when the underlying data is accurate and verified.": "يمكن لغرف البيانات الموحدة وسجلات المراجعة وأدلة مراحل الإنجاز وتقارير التوزيعات وسجلات التحويل أن تعزز الشفافية عندما تكون البيانات الأساسية دقيقة وتم التحقق منها.",

"Approved systems can support wallet allowlists, transfer restrictions, holding rules, identity checks, and synchronized on-chain and off-chain records.": "يمكن للأنظمة المعتمدة دعم قوائم المحافظ المسموح بها وقيود التحويل وقواعد الاحتفاظ والتحقق من الهوية والسجلات المتزامنة على السلسلة وخارجها.",

"Search, maps, standardized token codes, risk indicators, document access, and comparable records can help approved users evaluate opportunities more efficiently.": "يمكن للبحث والخرائط ورموز التوكن الموحدة ومؤشرات المخاطر والوصول إلى المستندات والسجلات القابلة للمقارنة مساعدة المستخدمين المعتمدين على تقييم الفرص بكفاءة أكبر.",

"Tokenization may make approved transfers easier to administer, but it does not guarantee a secondary market, buyers, price stability, or immediate liquidity.": "قد يسهل الترميز إدارة التحويلات المعتمدة، لكنه لا يضمن وجود سوق ثانوية أو مشترين أو استقرار الأسعار أو سيولة فورية.",

"SRWAE tokenization coverage": "نطاق الترميز في SRWAE",
"Ten supported economic and project models": "عشرة نماذج اقتصادية ونماذج مشاريع مدعومة",

"Each model describes a possible economic or workflow structure. The actual legal rights come from the issuer, entity documents, offering documents, contracts, records, and applicable law—not from the model name or token code alone.": "يصف كل نموذج هيكلاً اقتصادياً محتملاً أو سير عمل ممكناً. أما الحقوق القانونية الفعلية فتنبع من المُصدر ومستندات الكيان ومستندات الطرح والعقود والسجلات والقانون المعمول به، وليس من اسم النموذج أو رمز التوكن وحده.",

"Rental Income": "دخل الإيجار",
"Revenue Share": "مشاركة الإيرادات",
"Sale Profit": "ربح البيع",
"Equity Appreciation": "ارتفاع قيمة حقوق الملكية",
"Preferred Equity": "حقوق الملكية الممتازة",
"Common Equity": "الأسهم العادية",
"Debt Note": "سند دين",
"Hybrid": "هجين",
"Pre-Auction Pool": "مجمع ما قبل المزاد",
"Post-Auction Token": "رمز ما بعد المزاد",

"Represents an approved economic interest connected to rental cash flow, subject to the offering documents, operating expenses, reserves, property performance, and distribution rules.": "يمثل مصلحة اقتصادية معتمدة مرتبطة بالتدفقات النقدية للإيجار، وفقاً لمستندات الطرح والمصروفات التشغيلية والاحتياطيات وأداء العقار وقواعد التوزيع.",

"Connects investor economics to an agreed share of qualifying project or property revenue rather than direct ownership of the underlying real estate.": "يربط العائد الاقتصادي للمستثمر بحصة متفق عليها من إيرادات مشروع أو عقار مؤهل، بدلاً من الملكية المباشرة للعقار الأساسي.",

"Supports projects in which the primary economic objective is a defined share of net profit after an approved property sale and related costs.": "يدعم المشروعات التي يكون هدفها الاقتصادي الرئيسي الحصول على حصة محددة من صافي الربح بعد بيع عقار معتمد وخصم التكاليف ذات الصلة.",

"Represents an approved participation structure connected to increases or decreases in property or project equity under the controlling agreements.": "يمثل هيكل مشاركة معتمداً مرتبطاً بزيادة أو انخفاض حقوق الملكية في العقار أو المشروع وفقاً للاتفاقيات المنظمة.",

"Supports a preferred economic position with defined priority, return mechanics, limitations, and risk disclosures established by the issuer and legal documents.": "يدعم مركزاً اقتصادياً مفضلاً بأولوية محددة وآليات عائد وقيود وإفصاحات عن المخاطر يحددها المُصدر والمستندات القانونية.",

"Supports a common ownership interest in an approved entity or series, including applicable voting, distribution, dilution, and transfer provisions.": "يدعم مصلحة ملكية عادية في كيان أو سلسلة معتمدة، بما يشمل أحكام التصويت والتوزيع والتخفيف والتحويل المعمول بها.",

"Represents an approved debt obligation with documented principal, interest, maturity, collateral, payment priority, default, and enforcement terms.": "يمثل التزام دين معتمداً بشروط موثقة لأصل الدين والفائدة والاستحقاق والضمان وأولوية السداد والتعثر والتنفيذ.",

"Combines two or more approved economic components, such as debt, preferred return, revenue share, rental income, or appreciation participation.": "يجمع بين مكونين اقتصاديين معتمدين أو أكثر، مثل الدين أو العائد المفضل أو مشاركة الإيرادات أو دخل الإيجار أو المشاركة في ارتفاع القيمة.",

"Organizes approved capital commitments and acquisition workflows before an auction, with eligibility, bidding authority, escrow, refund, and allocation rules.": "ينظم التزامات رأس المال المعتمدة وسير عمل الاستحواذ قبل المزاد، بما يشمل الأهلية وصلاحية المزايدة والضمان والاسترداد وقواعد التخصيص.",

"Supports an acquired auction asset after purchase, including title review, rehabilitation, stabilization, refinancing, rental, sale, and investor reporting workflows.": "يدعم الأصل الذي تم الاستحواذ عليه في المزاد بعد الشراء، بما يشمل مراجعة الملكية وإعادة التأهيل والاستقرار وإعادة التمويل والتأجير والبيع وإعداد تقارير المستثمرين.",

"Phased initial market entry": "دخول أولي مرحلي إلى السوق",
"Where underused or locked real estate capital may enter first": "أين يمكن أن يبدأ دخول رأس المال العقاري غير المستغل أو المقيّد",

"The fastest practical start is not the entire global market. It is a controlled launch in the United States and a limited number of selected countries, focused on assets with understandable ownership, complete documents, measurable economics, qualified sponsors, assigned professional partners, and a clearly identified investor audience.": "لا تتمثل أسرع بداية عملية في استهداف السوق العالمي بأكمله، بل في إطلاق منضبط في الولايات المتحدة وعدد محدود من الدول المختارة، مع التركيز على أصول ذات ملكية واضحة ومستندات مكتملة ومؤشرات اقتصادية قابلة للقياس ورعاة مؤهلين وشركاء مهنيين محددين وجمهور مستثمرين واضح.",

"Documented rental portfolios": "محافظ إيجارية موثقة",
"Land and construction projects": "مشروعات الأراضي والإنشاءات",
"Pre-auction acquisition opportunities": "فرص الاستحواذ قبل المزاد",
"Post-auction rehabilitation": "إعادة التأهيل بعد المزاد",
"Existing external token review": "مراجعة الرموز الخارجية القائمة",

"Small and midsize rental portfolios with clear ownership, leases, operating history, insurance, expenses, reserves, and property management records can provide an understandable first use case.": "يمكن للمحافظ الإيجارية الصغيرة والمتوسطة ذات الملكية الواضحة وعقود الإيجار والسجل التشغيلي والتأمين والمصروفات والاحتياطيات وسجلات إدارة العقارات أن توفر حالة استخدام أولية واضحة.",

"Undeveloped land and construction projects may use milestone-based escrow, independent inspection, controlled releases, and progress reporting to improve transparency.": "يمكن للأراضي غير المطورة ومشروعات البناء استخدام الضمان القائم على مراحل الإنجاز والتفتيش المستقل والإفراج المنضبط عن الأموال وتقارير التقدم لتعزيز الشفافية.",

"Approved acquisition entities can organize time-sensitive capital, bidding limits, escrow instructions, refund rules, and post-acquisition allocation before an auction.": "يمكن لكيانات الاستحواذ المعتمدة تنظيم رأس المال الحساس للوقت وحدود المزايدة وتعليمات الضمان وقواعد الاسترداد والتخصيص بعد الاستحواذ قبل إجراء المزاد.",

"Recently acquired properties may need title resolution, repair funding, inspections, stabilization, leasing, refinancing, or sale before a complete investment strategy is established.": "قد تحتاج العقارات التي تم الاستحواذ عليها حديثاً إلى تسوية مسائل الملكية وتمويل الإصلاحات والتفتيش والاستقرار والتأجير وإعادة التمويل أو البيع قبل اكتمال استراتيجية الاستثمار.",

"Issuers that already created a token elsewhere can request document review, data-room support, display, reporting, or restricted listing workflows without assuming automatic approval.": "يمكن للمُصدرين الذين أنشأوا رمزاً بالفعل على منصة أخرى طلب مراجعة المستندات أو دعم غرفة البيانات أو العرض أو إعداد التقارير أو سير عمل الإدراج المقيد، دون افتراض الموافقة التلقائية.",

"A realistic early target is measured in qualified projects, not a percentage of all U.S. property.": "يُقاس الهدف الأولي الواقعي بعدد المشروعات المؤهلة، وليس بنسبة مئوية من إجمالي العقارات في الولايات المتحدة.",

"For example, one hundred qualified projects with an average represented value of $1 million would create a $100 million initial asset base. Five hundred projects averaging $1.5 million would represent $750 million. These are planning illustrations, not forecasts or fundraising promises.": "على سبيل المثال، فإن مئة مشروع مؤهل بمتوسط قيمة ممثلة قدره مليون دولار ستنشئ قاعدة أصول أولية بقيمة 100 مليون دولار. كما أن خمسمئة مشروع بمتوسط 1.5 مليون دولار ستمثل 750 مليون دولار. وهذه أمثلة لأغراض التخطيط وليست توقعات أو وعوداً بجمع التمويل.",

"Illustrative platform capacity": "قدرة المنصة التوضيحية",
"Illustrative U.S. launch capacity": "قدرة إطلاق توضيحية في الولايات المتحدة",

"The uploaded user-interface files do not prove production throughput, transaction capacity, cybersecurity readiness, or legal operating capacity. The following table is a business-planning model that shows how a very small U.S. market share can still create meaningful scale.": "لا تثبت ملفات واجهة المستخدم القدرة التشغيلية في بيئة الإنتاج أو قدرة معالجة المعاملات أو الجاهزية للأمن السيبراني أو القدرة القانونية على التشغيل. ويعرض الجدول التالي نموذجاً لتخطيط الأعمال يوضح كيف يمكن حتى لحصة صغيرة جداً من السوق الأمريكية أن تحقق نطاقاً ذا قيمة.",
"UAE platform with jurisdiction-specific market entry": "منصة الإمارات مع دخول إلى السوق وفق الولاية القضائية",
"SRWAE UAE uses one software and data standard while routing each project through the applicable UAE pathway. Dubai outside DIFC, DIFC, ADGM, and other Emirates can require different authorities, permissions, property records, and licensed roles.": "تستخدم SRWAE UAE معياراً موحداً للبرمجيات والبيانات، مع توجيه كل مشروع عبر المسار المعمول به في دولة الإمارات. وقد تتطلب دبي خارج DIFC، وDIFC، وADGM، والإمارات الأخرى جهات تنظيمية وتصاريح وسجلات عقارية وأدواراً مرخصة مختلفة.",
"SRWAE connects asset intake, property-record review, due diligence, data rooms, legal and regulatory review, valuation, escrow/banking, issuance or listing preparation, investor access, reporting, distributions, and approved transfers.": "تربط SRWAE بين استقبال الأصل، ومراجعة السجلات العقارية، والعناية الواجبة، وغرف البيانات، والمراجعة القانونية والتنظيمية، والتقييم، وحسابات الضمان/الخدمات المصرفية، وإعداد الإصدار أو الإدراج، ووصول المستثمرين، والتقارير، والتوزيعات، والتحويلات المعتمدة.",
"Role-based access and regulatory responsibility": "وصول قائم على الأدوار ومسؤولية تنظيمية",
"Public visitors, verified investors, sponsors, issuers, operators, licensed brokers or arrangers where applicable, custody/holder-record users, escrow or banking users, legal reviewers, compliance professionals, and other service providers receive different permissions.": "يحصل الزوار العامون، والمستثمرون المتحقق منهم، والرعاة، والمصدرون، والمشغلون، والوسطاء أو المرتبون المرخصون حيثما ينطبق، ومستخدمو الحفظ أو سجلات حاملي الرموز، ومستخدمو حسابات الضمان أو الخدمات المصرفية، والمراجعون القانونيون، ومتخصصو الامتثال، وغيرهم من مقدمي الخدمات على صلاحيات مختلفة.",
"AED-first settlement; no required platform stablecoin": "التسوية بالدرهم الإماراتي أولاً؛ دون اشتراط عملة مستقرة خاصة بالمنصة",
"The platform is designed around real-world asset workflows and approved bank, escrow, or settlement arrangements. It does not require a proprietary stablecoin. Payment-token functionality would be enabled only when permitted under the applicable CBUAE or financial-free-zone framework.": "صُممت المنصة حول مسارات عمل الأصول الحقيقية وترتيبات الدفع أو حساب الضمان أو التسوية المعتمدة. ولا تشترط استخدام عملة مستقرة مملوكة للمنصة. ولن يتم تفعيل وظائف رموز الدفع إلا عندما تكون مسموحاً بها ضمن إطار CBUAE أو إطار المنطقة المالية الحرة المعمول به.",
"Dubai real-estate transactions, Q1 2026": "معاملات دبي العقارية، الربع الأول 2026",
"Dubai Land Department reported AED 252 billion of real-estate transactions in Q1 2026 across 60,303 transactions, up 31% in value year over year. This is a transaction-flow indicator, not immediately tokenizable market value.": "أفادت دائرة الأراضي والأملاك في دبي بأن قيمة المعاملات العقارية في الربع الأول من 2026 بلغت 252 مليار درهم إماراتي عبر 60,303 معاملات، بزيادة سنوية قدرها 31% في القيمة. ويُعد هذا مؤشراً على تدفق المعاملات، وليس تقديراً لقيمة سوق قابلة للترميز فوراً.",
"Dubai Land Department, Q1 2026 real-estate transaction data": "دائرة الأراضي والأملاك في دبي، بيانات معاملات العقارات للربع الأول من 2026",
"Abu Dhabi real-estate transactions, H1 2026": "معاملات أبوظبي العقارية، النصف الأول 2026",
"Abu Dhabi Real Estate Centre reported AED 117 billion of real-estate transactions in the first half of 2026, with transaction value up 112% year over year. This demonstrates market activity but is not a tokenizable asset-stock estimate.": "أفاد مركز أبوظبي العقاري بأن قيمة المعاملات العقارية في النصف الأول من 2026 بلغت 117 مليار درهم إماراتي، مع ارتفاع قيمة المعاملات بنسبة 112% على أساس سنوي. ويُظهر ذلك نشاط السوق، لكنه لا يمثل تقديراً لمخزون أصول قابل للترميز.",
"Abu Dhabi Real Estate Centre, H1 2026 transaction report": "مركز أبوظبي العقاري، تقرير معاملات النصف الأول من 2026",
"Dubai rental-contract value, Q1 2026": "قيمة عقود الإيجار في دبي، الربع الأول 2026",
"Dubai Land Department reported AED 32.2 billion in rental-contract value in Q1 2026, including 118,385 new rental contracts and 135,607 renewals, showing the depth of recurring rental and property-management workflows.": "أفادت دائرة الأراضي والأملاك في دبي بأن قيمة عقود الإيجار في الربع الأول من 2026 بلغت 32.2 مليار درهم إماراتي، بما في ذلك 118,385 عقد إيجار جديد و135,607 عقود مجددة، مما يوضح عمق مسارات العمل المتكررة للإيجار وإدارة العقارات.",
"Dubai Land Department, Q1 2026 rental-market data": "دائرة الأراضي والأملاك في دبي، بيانات سوق الإيجارات للربع الأول من 2026",
"Active Abu Dhabi residential leases, H1 2026": "عقود الإيجار السكنية النشطة في أبوظبي، النصف الأول 2026",
"ADREC reported 233,000 active residential lease contracts with AED 9.3 billion of lease value in H1 2026, alongside approximately 409,000 residential units in supply.": "أفاد مركز أبوظبي العقاري (ADREC) بوجود 233,000 عقد إيجار سكني نشط بقيمة إيجارية تبلغ 9.3 مليار درهم إماراتي في النصف الأول من 2026، إلى جانب نحو 409,000 وحدة سكنية ضمن المعروض.",
"Abu Dhabi Real Estate Centre, H1 2026 market report": "مركز أبوظبي العقاري، تقرير السوق للنصف الأول من 2026",
"Dubai tokenized real estate by 2033": "العقارات المرمزة في دبي بحلول 2033",
"Dubai Land Department projects the value of the tokenized real-estate sector could reach AED 60 billion by 2033.": "تتوقع دائرة الأراضي والأملاك في دبي أن تصل قيمة قطاع العقارات المرمزة إلى 60 مليار درهم إماراتي بحلول عام 2033.",
"Projected share of Dubai real-estate transactions": "الحصة المتوقعة من معاملات دبي العقارية",
"DLD states that the AED 60 billion 2033 projection would represent about seven percent of Dubai total real-estate transactions.": "تشير دائرة الأراضي والأملاك في دبي إلى أن توقع بلوغ 60 مليار درهم إماراتي بحلول 2033 سيمثل نحو 7% من إجمالي معاملات دبي العقارية.",
"Global tokenized real estate by 2035": "العقارات المرمزة عالمياً بحلول 2035",
"Deloitte forecasts that the global tokenized real-estate ecosystem could grow from less than $0.3 trillion in 2024 to $4 trillion by 2035.": "تتوقع Deloitte أن تنمو منظومة العقارات المرمزة عالمياً من أقل من 0.3 تريليون دولار في 2024 إلى 4 تريليونات دولار بحلول 2035.",
"Controlled resale moves into Phase II in Dubai": "إعادة البيع المنضبطة تنتقل إلى المرحلة الثانية في دبي",
"Dubai Land Department launched Phase II of its Real Estate Tokenisation Project in February 2026, enabling resale activity within a regulated and controlled model rather than implying unrestricted liquidity.": "أطلقت دائرة الأراضي والأملاك في دبي المرحلة الثانية من مشروع ترميز العقارات في فبراير 2026، بما يتيح نشاط إعادة البيع ضمن نموذج منظم وخاضع للرقابة، دون أن يعني ذلك وجود سيولة غير مقيدة.",
"A properly structured fractional interest can reduce the minimum capital needed for an individual investor. DLD’s initial Prypco Mint pilot allowed participation from AED 2,000 for UAE ID holders, but every SRWAE project must follow its own eligibility, offering, and jurisdiction rules.": "يمكن للمصلحة المجزأة المهيكلة بصورة سليمة أن تخفض الحد الأدنى لرأس المال المطلوب من المستثمر الفردي. وقد أتاح البرنامج التجريبي الأولي Prypco Mint التابع لدائرة الأراضي والأملاك المشاركة ابتداءً من 2,000 درهم إماراتي لحاملي هوية الإمارات، إلا أن كل مشروع على SRWAE يجب أن يلتزم بقواعد الأهلية والطرح والولاية القضائية الخاصة به.",
"Sponsors may seek capital against a defined legal or economic interest without selling the entire property, but the structure must match the issuer/SPV documents, property records, disclosures, and applicable regulatory pathway.": "قد يسعى الرعاة إلى جمع رأس مال مقابل مصلحة قانونية أو اقتصادية محددة دون بيع العقار بالكامل، لكن يجب أن يتوافق الهيكل مع مستندات الجهة المصدرة/SPV، وسجلات العقار، والإفصاحات، والمسار التنظيمي المعمول به.",
"Standardized data rooms, property-record evidence, valuation, review records, milestone evidence, distribution reports, and transfer histories can improve transparency when the underlying data is accurate and independently verified.": "يمكن لغرف البيانات الموحدة، وأدلة السجلات العقارية، والتقييم، وسجلات المراجعة، وأدلة المراحل الرئيسية، وتقارير التوزيعات، وسجلات التحويل أن تحسن الشفافية عندما تكون البيانات الأساسية دقيقة وتم التحقق منها بصورة مستقلة.",
"Approved systems can support wallet allowlists, investor eligibility, transfer restrictions, holding rules, identity checks, approval gates, and synchronized on-chain and off-chain records.": "يمكن للأنظمة المعتمدة دعم قوائم السماح للمحافظ، وأهلية المستثمرين، وقيود التحويل، وقواعد الاحتفاظ، والتحقق من الهوية، وبوابات الموافقة، ومزامنة السجلات داخل السلسلة وخارجها.",
"Search, maps, standardized token codes, risk indicators, document access, jurisdiction labels, property-record status, and comparable data can help approved users evaluate opportunities more efficiently.": "يمكن لخصائص البحث والخرائط ورموز التوكن الموحدة ومؤشرات المخاطر والوصول إلى المستندات وتسميات الولاية القضائية وحالة السجل العقاري والبيانات القابلة للمقارنة أن تساعد المستخدمين المعتمدين على تقييم الفرص بكفاءة أكبر.",
"Tokenization may make permitted transfers easier to administer. Dubai Phase II demonstrates a controlled resale pathway, but tokenization does not guarantee buyers, price stability, market depth, or immediate liquidity.": "قد يسهل الترميز إدارة التحويلات المسموح بها. وتوضح المرحلة الثانية في دبي مساراً منضبطاً لإعادة البيع، لكن الترميز لا يضمن وجود مشترين أو استقرار الأسعار أو عمق السوق أو السيولة الفورية.",
"Represents an approved economic interest connected to rental cash flow, subject to property and issuer records, offering/issuance documents, operating expenses, reserves, financing, property performance, and distribution rules.": "يمثل مصلحة اقتصادية معتمدة مرتبطة بالتدفقات النقدية للإيجار، مع مراعاة سجلات العقار والجهة المصدرة، ومستندات الطرح/الإصدار، والمصروفات التشغيلية، والاحتياطيات، والتمويل، وأداء العقار، وقواعد التوزيع.",
"Connects investor economics to an agreed share of qualifying project or property revenue rather than automatically conveying direct ownership of the underlying property.": "يربط العائد الاقتصادي للمستثمر بحصة متفق عليها من إيرادات مشروع أو عقار مؤهل، بدلاً من أن يمنح تلقائياً ملكية مباشرة للعقار الأساسي.",
"Supports projects in which the primary economic objective is a defined share of net profit after an approved property sale and related documented costs.": "يدعم المشاريع التي يكون هدفها الاقتصادي الأساسي الحصول على حصة محددة من صافي الربح بعد بيع عقار معتمد وخصم التكاليف الموثقة ذات الصلة.",
"Represents an approved participation structure connected to increases or decreases in property, project, or issuer/SPV equity value under the controlling agreements and valuation method.": "يمثل هيكل مشاركة معتمداً مرتبطاً بالزيادة أو النقص في قيمة حقوق ملكية العقار أو المشروع أو الجهة المصدرة/SPV وفق الاتفاقيات الحاكمة ومنهجية التقييم.",
"Supports a preferred economic position with defined priority, return mechanics, limitations, and risk disclosures established by the issuer/SPV and controlling legal documents.": "يدعم مركزاً اقتصادياً ممتازاً بأولوية محددة وآليات عائد وقيود وإفصاحات مخاطر يحددها المصدر/SPV والمستندات القانونية الحاكمة.",
"Supports a common ownership interest in an approved entity/SPV or other permitted structure, including applicable voting, distribution, dilution, and transfer provisions.": "يدعم مصلحة ملكية عادية في كيان/SPV معتمد أو أي هيكل آخر مسموح به، بما في ذلك أحكام التصويت والتوزيعات والتخفيف والتحويل المعمول بها.",
"Represents an approved debt or financing obligation with documented principal, return/interest mechanics, maturity, collateral/security, payment priority, default, and enforcement terms.": "يمثل التزام دين أو تمويل معتمداً مع توثيق أصل المبلغ وآلية العائد/الفائدة والاستحقاق والضمان/التأمين وأولوية السداد والتعثر وشروط التنفيذ.",
"Combines two or more approved economic components, such as debt, preferred return, revenue share, rental income, or appreciation participation, under a documented hierarchy and waterfall.": "يجمع بين مكونين اقتصاديين معتمدين أو أكثر، مثل الدين أو العائد الممتاز أو تقاسم الإيرادات أو دخل الإيجار أو المشاركة في ارتفاع القيمة، ضمن ترتيب هرمي وآلية توزيع موثقة.",
"Organizes approved capital commitments and acquisition workflows before an auction, with investor eligibility, bidding authority, escrow/banking, refund, and allocation rules.": "ينظم التزامات رأس المال المعتمدة ومسارات عمل الاستحواذ قبل المزاد، مع قواعد أهلية المستثمر، وصلاحية تقديم العطاءات، وحساب الضمان/الخدمات المصرفية، والاسترداد، والتخصيص.",
"Supports an acquired auction asset after purchase, including registry/title review, rehabilitation, stabilization, refinancing, leasing, sale, and investor reporting workflows.": "يدعم أصلاً تم شراؤه في مزاد بعد الاستحواذ، بما يشمل مراجعة السجل/الملكية، وإعادة التأهيل، والاستقرار، وإعادة التمويل، والتأجير، والبيع، ومسارات تقارير المستثمرين.",
"Small and midsize rental portfolios in Dubai or Abu Dhabi with clear ownership/registry records, leases, operating history, insurance, expenses, reserves, and property-management records can provide an understandable first use case.": "يمكن لمحافظ الإيجار الصغيرة والمتوسطة في دبي أو أبوظبي، التي تتمتع بسجلات ملكية/تسجيل واضحة وعقود إيجار وسجل تشغيلي وتأمين ومصروفات واحتياطيات وسجلات لإدارة العقار، أن تشكل حالة استخدام أولى مفهومة.",
"Registered land and approved construction projects may use milestone-based escrow or banking controls, independent engineering/inspection, controlled releases, project-status evidence, and progress reporting, subject to the applicable developer and regulatory framework.": "قد تستخدم الأراضي المسجلة ومشاريع البناء المعتمدة حسابات ضمان أو ضوابط مصرفية مرتبطة بالمراحل الرئيسية، ومراجعة هندسية/تفتيشاً مستقلاً، وصرفاً منضبطاً، وأدلة على حالة المشروع، وتقارير تقدم، وفق إطار المطور والجهة التنظيمية المعمول به.",
"Approved acquisition entities can organize time-sensitive capital, bidding limits, escrow/banking instructions, refund rules, eligibility, and post-acquisition allocation before an auction.": "يمكن لكيانات الاستحواذ المعتمدة تنظيم رأس المال الحساس للوقت وحدود المزايدة وتعليمات حساب الضمان/الخدمات المصرفية وقواعد الاسترداد والأهلية والتخصيص بعد الاستحواذ قبل المزاد.",
"Recently acquired properties may need registry/title resolution, repair funding, inspections, stabilization, leasing, refinancing, or sale before a complete investment strategy is established.": "قد تحتاج العقارات التي تم الاستحواذ عليها حديثاً إلى تسوية السجل/الملكية، وتمويل الإصلاح، والتفتيش، والاستقرار، والتأجير، وإعادة التمويل، أو البيع قبل اكتمال استراتيجية الاستثمار.",
"Issuers that created a token elsewhere can request document review, UAE jurisdiction mapping, data-room support, normalized display, reporting, or restricted listing/routing workflows without assuming automatic approval or UAE distribution rights.": "يمكن للمصدرين الذين أنشؤوا توكناً في مكان آخر طلب مراجعة المستندات، وتحديد مسار الولاية القضائية في الإمارات، ودعم غرفة البيانات، وعرض موحد، وتقارير، أو مسارات إدراج/توجيه مقيدة، دون افتراض الحصول تلقائياً على الموافقة أو حقوق التوزيع في الإمارات.",
"A small launch used to validate UAE legal templates, property-record evidence, data quality, partner workflows, investor onboarding, reporting, security, and operational controls.": "إطلاق صغير لاختبار القوالب القانونية في الإمارات، وأدلة السجلات العقارية، وجودة البيانات، ومسارات عمل الشركاء، وانضمام المستثمرين، والتقارير، والأمن، والضوابط التشغيلية.",
"Dubai launch": "إطلاق دبي",
"A multi-partner operation serving several qualified asset owners, property types, reviewers, and approved investor groups through defined Dubai pathways.": "عملية متعددة الشركاء تخدم عدداً من مالكي الأصول المؤهلين وأنواع العقارات والمراجعين ومجموعات المستثمرين المعتمدين عبر مسارات دبي المحددة.",
"Multi-emirate scale": "التوسع على مستوى عدة إمارات",
"A scaled service with standardized onboarding, stronger automation, multiple property/regulatory pathways, licensed partners, portfolio reporting, and mature support operations.": "خدمة موسعة مع انضمام موحد وأتمتة أقوى ومسارات متعددة للعقارات/الجهات التنظيمية وشركاء مرخصين وتقارير للمحافظ وعمليات دعم ناضجة.",
"UAE platform scale": "نطاق منصة الإمارات",
"A national operating scenario requiring enterprise architecture, redundancy, independent controls, deep partner capacity, jurisdiction routing, property-record integrations, and mature compliance/support operations.": "سيناريو تشغيل وطني يتطلب بنية مؤسسية، وتكراراً احتياطياً، وضوابط مستقلة، وقدرة كبيرة لدى الشركاء، وتوجيهاً بحسب الولاية القضائية، وتكاملات مع السجلات العقارية، وعمليات امتثال/دعم ناضجة.",
"Identify the asset, property registry, ownership entity, Emirate/zone, intended economics, project stage, investor audience, token rights, users, documents, payment/settlement method, and requested tokenization model.": "تحديد الأصل، والسجل العقاري، وكيان الملكية، والإمارة/المنطقة، والاقتصاديات المقصودة، ومرحلة المشروع، وجمهور المستثمرين، وحقوق التوكن، والمستخدمين، والمستندات، وطريقة الدفع/التسوية، ونموذج الترميز المطلوب.",
"Collect and review registry/title evidence, entity records, financials, valuation, leases, project or auction information, construction/inspection, insurance, tax, identity, KYC/AML, source-of-funds, and other source records as applicable.": "جمع ومراجعة أدلة السجل/الملكية، وسجلات الكيان، والبيانات المالية، والتقييم، وعقود الإيجار، ومعلومات المشروع أو المزاد، والبناء/التفتيش، والتأمين، والضرائب، والهوية، وإجراءات KYC/AML، ومصدر الأموال، وغيرها من السجلات المصدرية حسبما ينطبق.",
"Define the issuer/SPV, investor rights, property-title relationship, token classification, jurisdiction pathway, investor eligibility, restrictions, disclosures, transfer rules, governance, distributions, and risk allocation.": "تحديد الجهة المصدرة/SPV، وحقوق المستثمرين، وعلاقة التوكن بملكية العقار، وتصنيف التوكن، ومسار الولاية القضائية، وأهلية المستثمرين، والقيود، والإفصاحات، وقواعد التحويل، والحوكمة، والتوزيعات، وتوزيع المخاطر.",
"Route the project to assigned UAE legal, regulatory/compliance, valuation, property-title/registry, escrow/banking, inspection/engineering, financial, tax/audit, custody/holder-record, and operational reviewers as required.": "توجيه المشروع إلى المراجعين المعينين في الإمارات للشؤون القانونية والتنظيمية/الامتثال، والتقييم، وملكية العقار/السجل، وحساب الضمان/الخدمات المصرفية، والتفتيش/الهندسة، والشؤون المالية، والضرائب/التدقيق، والحفظ/سجل حاملي الرموز، والعمليات، حسب الحاجة.",
"Prepare approved listing or offering workflow": "إعداد مسار عمل معتمد للإدراج أو الطرح",
"Create the approved listing/data room, map view, token record, risk information, documents, jurisdiction labels, investor-eligibility rules, payment/settlement instructions, and subscription or access workflow permitted for the selected pathway.": "إنشاء الإدراج/غرفة البيانات المعتمدة، وعرض الخريطة، وسجل التوكن، ومعلومات المخاطر، والمستندات، وتسميات الولاية القضائية، وقواعد أهلية المستثمرين، وتعليمات الدفع/التسوية، ومسار الاشتراك أو الوصول المسموح به للمسار المختار.",
"Track funding, bank/escrow status, milestones, property activity, rental/revenue data, expenses, reserves, inspections, distributions, documents, reviews, and investor communications.": "تتبع التمويل، وحالة البنك/حساب الضمان، والمراحل الرئيسية، ونشاط العقار، وبيانات الإيجار/الإيرادات، والمصروفات، والاحتياطيات، والتفتيشات، والتوزيعات، والمستندات، والمراجعات، واتصالات المستثمرين.",
"Apply holder eligibility, legal restrictions, licensed-partner approvals, holder/registry record updates, tax/accounting records, settlement conditions, and audit trails to permitted transfers.": "تطبيق أهلية حاملي الرموز، والقيود القانونية، وموافقات الشركاء المرخصين، وتحديثات سجل الحيازة/السجل العقاري، وسجلات الضرائب/المحاسبة، وشروط التسوية، ومسارات التدقيق على التحويلات المسموح بها.",
"Offering / listing administrator": "مسؤول الطرح / الإدراج",
"Issuer / SPV administrator": "مسؤول الجهة المصدرة / الشركة ذات الغرض الخاص (SPV)",
"Rehabilitation / construction manager": "مدير إعادة التأهيل / الإنشاءات",
"Licensed broker / arranger user where applicable": "مستخدم وسيط / مرتّب مرخص حيثما ينطبق",
"Custody or holder-record user": "مستخدم الحفظ أو سجل حاملي الرموز",
"Escrow / banking user": "مستخدم حساب الضمان / الخدمات المصرفية",
"Settlement administrator": "مسؤول التسوية",
"UAE legal counsel": "مستشار قانوني في دولة الإمارات",
"Regulatory / securities / virtual-asset counsel": "مستشار تنظيمي / أوراق مالية / أصول افتراضية",
"Compliance / MLRO reviewer": "مراجع الامتثال / مسؤول الإبلاغ عن غسل الأموال (MLRO)",
"Property title / registry reviewer": "مراجع سند الملكية / السجل العقاري",
"Inspector / engineer": "مفتش / مهندس",
"Public users may view limited listing information and approximate map information without receiving precise locations, confidential property records, complete documents, review requests, investor-only data, or transaction access.": "يمكن للمستخدمين العامين عرض معلومات إدراج محدودة ومعلومات تقريبية على الخريطة دون الحصول على المواقع الدقيقة أو السجلات العقارية السرية أو المستندات الكاملة أو طلبات المراجعة أو بيانات خاصة بالمستثمرين أو إمكانية إجراء المعاملات.",
"Role, eligibility, and jurisdiction based": "قائم على الدور والأهلية والولاية القضائية",
"Verified and approved users may receive broader access according to identity, investor eligibility, jurisdiction, token rights, project/offer terms, agreements, professional role, and assigned permissions.": "قد يحصل المستخدمون الذين تم التحقق منهم واعتمادهم على وصول أوسع وفق الهوية، وأهلية المستثمر، والولاية القضائية، وحقوق التوكن، وشروط المشروع/الطرح، والاتفاقيات، والدور المهني، والصلاحيات الممنوحة.",
"Asset owners, sponsors, issuers/SPVs, developers, and operators can select a service plan for active assets, token records, listings, data rooms, reporting, review, and workflow support.": "يمكن لمالكي الأصول والرعاة والمصدرين/SPVs والمطورين والمشغلين اختيار خطة خدمة للأصول النشطة وسجلات التوكن والإدراجات وغرف البيانات والتقارير والمراجعات ودعم مسارات العمل.",
"Licensed arrangement pricing only": "التسعير وفق الترتيب المرخص فقط",
"Any transaction, routing, arranging, brokerage, custody, settlement, or transfer-related fee is applied only where permitted under a reviewed UAE pathway and documented agreement with the appropriately authorized entity. No blanket 0.5% UAE fee is assumed.": "لا تُطبق أي رسوم مرتبطة بالمعاملة أو التوجيه أو الترتيب أو الوساطة أو الحفظ أو التسوية أو التحويل إلا حيث يكون ذلك مسموحاً به ضمن مسار إماراتي تمت مراجعته وبموجب اتفاقية موثقة مع الجهة المخولة حسب الأصول. ولا يُفترض وجود رسم إماراتي موحد بنسبة 0.5%.",
"Tokenization does not eliminate authorization, licensing, disclosure, market-conduct, client-asset, AML/CFT, sanctions, recordkeeping, anti-fraud, investor-protection, or property-registry requirements. The exact obligations depend on the rights and jurisdiction.": "لا يلغي الترميز متطلبات التفويض أو الترخيص أو الإفصاح أو سلوك السوق أو حماية أصول العملاء أو AML/CFT أو العقوبات أو حفظ السجلات أو مكافحة الاحتيال أو حماية المستثمر أو السجل العقاري. وتعتمد الالتزامات الدقيقة على طبيعة الحقوق والولاية القضائية.",
"A token does not by itself prove property title, ownership, valuation, income, collateral, regulatory compliance, or enforceability. The controlling property registry/title records and issuer/SPV documents must be identified and reconciled.": "لا يثبت التوكن بذاته ملكية العقار أو الحيازة أو التقييم أو الدخل أو الضمان أو الامتثال التنظيمي أو قابلية التنفيذ. ويجب تحديد السجلات العقارية/سندات الملكية الحاكمة ومستندات الجهة المصدرة/SPV ومطابقتها.",
"Listings, reviews, approvals, risk labels, inspections, property records, and documents can reduce information gaps but cannot eliminate investment, property, off-plan, construction, auction, market, technology, regulatory, or counterparty risk.": "يمكن للإدراجات والمراجعات والموافقات وتسميات المخاطر والتفتيشات وسجلات العقار والمستندات تقليل فجوات المعلومات، لكنها لا تستطيع إلغاء مخاطر الاستثمار أو العقار أو البيع على المخطط أو الإنشاءات أو المزادات أو السوق أو التقنية أو التنظيم أو الأطراف المقابلة.",
"Liquidity, distributions, appreciation, rental income, project revenue, refinancing, resale, auction success, and investment returns are never guaranteed. Controlled secondary resale does not imply an unrestricted or always-liquid market.": "لا تُضمن أبداً السيولة أو التوزيعات أو ارتفاع القيمة أو دخل الإيجار أو إيرادات المشروع أو إعادة التمويل أو إعادة البيع أو نجاح المزاد أو عوائد الاستثمار. كما أن إعادة البيع الثانوية المنضبطة لا تعني وجود سوق غير مقيد أو دائم السيولة.",
"Each UAE project may require jurisdiction-specific analysis involving DLD/VARA, DIFC/DFSA, ADGM/FSRA, SCA/local authorities, CBUAE payment rules where applicable, investor eligibility, KYC/AML and sanctions controls, tax and accounting review, custody/holder-record support, transfer restrictions, and separate partner agreements.": "قد يتطلب كل مشروع في الإمارات تحليلاً خاصاً بالولاية القضائية يشمل DLD/VARA وDIFC/DFSA وADGM/FSRA وSCA/الجهات المحلية، وقواعد الدفع لدى CBUAE حيثما تنطبق، وأهلية المستثمر، وضوابط KYC/AML والعقوبات، ومراجعة الضرائب والمحاسبة، ودعم الحفظ/سجل حاملي الرموز، وقيود التحويل، واتفاقيات منفصلة مع الشركاء.",
"Dubai Land Department — Q1 2026 Real Estate Transactions": "دائرة الأراضي والأملاك في دبي — معاملات العقارات للربع الأول من 2026",
"AED 252 billion of Q1 2026 real-estate transactions, transaction count, investment activity, and Dubai market context.": "معاملات عقارية بقيمة 252 مليار درهم إماراتي في الربع الأول من 2026، وعدد المعاملات، ونشاط الاستثمار، وسياق سوق دبي.",
"Abu Dhabi Real Estate Centre — H1 2026 Real Estate Market Report": "مركز أبوظبي العقاري — تقرير سوق العقارات للنصف الأول من 2026",
"AED 117 billion total transactions, 233,000 active residential leases, AED 9.3 billion lease value, residential supply, and market context.": "إجمالي معاملات بقيمة 117 مليار درهم إماراتي، و233,000 عقد إيجار سكني نشط، وقيمة إيجارية قدرها 9.3 مليار درهم إماراتي، ومعروض الوحدات السكنية، وسياق السوق.",
"Dubai Land Department — Real Estate Tokenisation Project and Phase II": "دائرة الأراضي والأملاك في دبي — مشروع ترميز العقارات والمرحلة الثانية",
"DLD’s AED 60 billion / 7% 2033 projection, official title-deed tokenisation pilot, and the 2026 move to controlled resale activity.": "توقع دائرة الأراضي والأملاك بقيمة 60 مليار درهم إماراتي / 7% لعام 2033، والبرنامج التجريبي الرسمي لترميز سندات الملكية، والانتقال في 2026 إلى نشاط إعادة بيع منضبط.",
"Virtual Assets Regulatory Authority — Virtual Asset Issuance Rulebook / ARVA Rules": "سلطة تنظيم الأصول الافتراضية (VARA) — لائحة إصدار الأصول الافتراضية / قواعد ARVA",
"Current Dubai virtual-asset issuance framework and Asset-Referenced Virtual Asset requirements outside DIFC.": "الإطار الحالي لإصدار الأصول الافتراضية في دبي ومتطلبات الأصول الافتراضية المرجعية للأصول (ARVA) خارج DIFC.",
"UAE Federal Legislation / Securities and Commodities Authority — Virtual Assets Framework": "التشريعات الاتحادية لدولة الإمارات / هيئة الأوراق المالية والسلع — إطار الأصول الافتراضية",
"Federal virtual-asset and VASP framework, local-authority coordination, and the principle that digital securities remain securities subject to securities regulation.": "الإطار الاتحادي للأصول الافتراضية ومزودي خدمات الأصول الافتراضية (VASP)، والتنسيق مع الجهات المحلية، ومبدأ بقاء الأوراق المالية الرقمية خاضعة لتنظيم الأوراق المالية.",
"Abu Dhabi Global Market / FSRA — Digital Assets and Digital Securities": "سوق أبوظبي العالمي / سلطة تنظيم الخدمات المالية (FSRA) — الأصول الرقمية والأوراق المالية الرقمية",
"ADGM framework for Virtual Assets, Digital Securities, FRTs and related regulated financial services.": "إطار ADGM للأصول الافتراضية والأوراق المالية الرقمية وFRTs والخدمات المالية المنظمة ذات الصلة.",
"Dubai Financial Services Authority — Investment Tokens / Crypto Token Framework": "سلطة دبي للخدمات المالية (DFSA) — إطار رموز الاستثمار / رموز الأصول المشفرة",
"DIFC framework for Investment Tokens and updated Crypto Token regulation for financial services in or from DIFC.": "إطار DIFC لرموز الاستثمار والتنظيم المحدث لرموز الأصول المشفرة للخدمات المالية داخل DIFC أو الصادرة منه.",
"United States": "الولايات المتحدة",
"United States market": "سوق الولايات المتحدة",
"U.S. market data, federal and state legal context, controlled launch assumptions, and U.S. research sources.": "بيانات سوق الولايات المتحدة، والسياق القانوني الفدرالي وعلى مستوى الولايات، وافتراضات الإطلاق المنضبط، ومصادر الأبحاث الأمريكية.",
"U.S. real estate is used as the initial market benchmark and represents tens of trillions of dollars, while tokenized real estate remains early. SRWAE is designed for broader international expansion without requiring a large share of any single national market.": "يُستخدم سوق العقارات في الولايات المتحدة كمعيار أولي لحجم السوق، وهو يمثل عشرات التريليونات من الدولارات، بينما لا يزال ترميز العقارات في مراحله المبكرة. وقد صُممت SRWAE للتوسع الدولي الأوسع دون الحاجة إلى حصة كبيرة من أي سوق وطني منفرد.",
"United Arab Emirates": "الإمارات العربية المتحدة",
"United Arab Emirates market": "سوق الإمارات العربية المتحدة",
"UAE market data, jurisdiction-specific regulatory pathways, AED-based capacity assumptions, and UAE research sources.": "بيانات سوق الإمارات، والمسارات التنظيمية الخاصة بكل ولاية قضائية، وافتراضات السعة المقومة بالدرهم الإماراتي، ومصادر الأبحاث الخاصة بالإمارات.",
"Deep property activity, disciplined regulated entry": "نشاط عقاري قوي، ودخول منضبط وخاضع للتنظيم",
"Dubai and Abu Dhabi already show large, active real-estate markets, while official Dubai initiatives are moving tokenized property from pilot testing toward controlled operational use. SRWAE UAE is designed to enter through one approved pathway first, without requiring a large share of the underlying property market.": "تُظهر دبي وأبوظبي بالفعل أسواقاً عقارية كبيرة ونشطة، فيما تنقل المبادرات الرسمية في دبي العقارات المرمزة من مرحلة الاختبار التجريبي إلى الاستخدام التشغيلي المنضبط. وقد صُممت SRWAE UAE للدخول أولاً عبر مسار واحد معتمد، دون الحاجة إلى حصة كبيرة من سوق العقارات الأساسي.",
"Dubai Land Department projects that tokenized real estate could reach AED 60 billion by 2033, representing about 7% of Dubai real-estate transactions. This is a DLD market projection, not an SRWAE forecast or promised market share.": "تتوقع دائرة الأراضي والأملاك في دبي أن تصل قيمة العقارات المرمزة إلى 60 مليار درهم إماراتي بحلول 2033، بما يمثل نحو 7% من معاملات دبي العقارية. وهذا توقع سوقي صادر عن الدائرة، وليس توقعاً من SRWAE أو حصة سوقية موعودة.",
"What SRWAE UAE is built to coordinate": "ما الذي صُممت منصة SRWAE UAE لتنسيقه",
"The system combines marketplace discovery with controlled project, professional, legal, operational, investor, property-record, and transaction workflows. Access and available features are determined by role, verification, token rights, property registry, jurisdiction, agreements, licensed-partner responsibilities, and applicable law.": "يجمع النظام بين اكتشاف الفرص في السوق ومسارات العمل المنضبطة للمشروعات والمهنيين والشؤون القانونية والتشغيلية والمستثمرين والسجلات العقارية والمعاملات. ويتم تحديد الوصول والميزات المتاحة وفق الدور والتحقق وحقوق التوكن والسجل العقاري والولاية القضائية والاتفاقيات ومسؤوليات الشركاء المرخصين والقانون المعمول به.",
"United Arab Emirates market context": "سياق سوق الإمارات العربية المتحدة",
"The underlying property ecosystem is already large and active": "منظومة العقارات الأساسية كبيرة ونشطة بالفعل",
"These figures describe selected official Dubai and Abu Dhabi real-estate activity, rental, and supply indicators. They are not estimates of assets that are legally eligible, operationally ready, or likely to use SRWAE UAE.": "تصف هذه الأرقام مؤشرات مختارة ورسمية لنشاط العقارات والإيجارات والمعروض في دبي وأبوظبي. وهي ليست تقديرات للأصول المؤهلة قانونياً أو الجاهزة تشغيلياً أو المرجح استخدامها لمنصة SRWAE UAE.",
"Why UAE real-estate tokenization can grow from a controlled base": "لماذا يمكن لترميز العقارات في الإمارات أن ينمو من قاعدة منضبطة",
"Official UAE initiatives and independent global forecasts use different definitions and should not be added together. Taken as directional evidence, they show a meaningful long-term opportunity for regulated infrastructure around tokenized property, funds, debt, project interests, and other real-world assets.": "تستخدم المبادرات الرسمية في الإمارات والتوقعات العالمية المستقلة تعريفات مختلفة ولا ينبغي جمعها معاً. وباعتبارها مؤشرات اتجاهية، فإنها توضح فرصة طويلة الأجل ذات مغزى لبنية تحتية منظمة حول العقارات المرمزة والصناديق والديون ومصالح المشروعات وغيرها من الأصول الحقيقية.",
"Each model describes a possible economic or workflow structure. The actual legal rights come from the issuer or SPV, property and entity records, offering or issuance documents, contracts, holder records, and applicable UAE or financial-free-zone law — not from the model name or token code alone.": "يصف كل نموذج هيكلاً اقتصادياً أو مسار عمل محتملاً. أما الحقوق القانونية الفعلية فتنبع من الجهة المصدرة أو SPV، وسجلات العقار والكيان، ومستندات الطرح أو الإصدار، والعقود، وسجلات حاملي الحقوق، والقانون المعمول به في الإمارات أو المناطق المالية الحرة، وليس من اسم النموذج أو رمز التوكن وحده.",
"Where well-documented UAE real-estate opportunities may enter first": "أين يمكن أن تدخل فرص العقارات الموثقة جيداً في الإمارات أولاً",
"The fastest practical start is not the entire UAE property market. It is one controlled, approved jurisdiction pathway focused on assets with clear property records, complete documents, measurable economics, qualified sponsors, assigned professional and licensed partners, and a clearly identified investor audience.": "البداية العملية الأسرع ليست سوق العقارات الإماراتي بالكامل، بل مسار واحد منضبط ومعتمد ضمن ولاية قضائية محددة، يركز على الأصول ذات السجلات العقارية الواضحة والمستندات المكتملة والاقتصاديات القابلة للقياس والرعاة المؤهلين والشركاء المهنيين والمرخصين المعينين وجمهور المستثمرين المحدد بوضوح.",
"A realistic early target is measured in qualified projects, not a percentage of all UAE property.": "يُقاس الهدف المبكر الواقعي بعدد المشروعات المؤهلة، وليس بنسبة من إجمالي عقارات الإمارات.",
"For example, one hundred qualified projects with an average represented value of AED 5 million would create an AED 500 million initial asset base. Five hundred projects averaging AED 7.5 million would represent AED 3.75 billion. These are planning illustrations, not forecasts, fundraising promises, or claims of regulatory approval.": "على سبيل المثال، فإن مئة مشروع مؤهل بمتوسط قيمة ممثلة قدرها 5 ملايين درهم إماراتي ستنشئ قاعدة أصول أولية بقيمة 500 مليون درهم. وخمسمئة مشروع بمتوسط 7.5 ملايين درهم ستمثل 3.75 مليارات درهم. وهذه أمثلة تخطيطية وليست توقعات أو وعوداً لجمع التمويل أو ادعاءات بالحصول على موافقة تنظيمية.",
"Illustrative UAE launch capacity": "سعة إطلاق توضيحية في الإمارات",
"The current user-interface and software materials do not prove production throughput, transaction capacity, cybersecurity readiness, regulatory authorization, or legal operating capacity. The following table is a business-planning model showing how a controlled UAE platform can reach meaningful represented-asset scale without requiring a large share of the property market.": "لا تثبت مواد واجهة المستخدم والبرمجيات الحالية القدرة الإنتاجية الفعلية أو سعة المعاملات أو الجاهزية للأمن السيبراني أو التفويض التنظيمي أو القدرة القانونية على التشغيل. والجدول التالي نموذج لتخطيط الأعمال يوضح كيف يمكن لمنصة إماراتية منضبطة أن تصل إلى نطاق ذي معنى من قيمة الأصول الممثلة دون الحاجة إلى حصة كبيرة من سوق العقارات.",
"Illustrative UAE represented-asset scenario": "سيناريو توضيحي لقيمة الأصول الممثلة في الإمارات",
"DLD 2033 Dubai tokenized-real-estate projection; not an SRWAE forecast": "توقع DLD لعام 2033 للعقارات المرمزة في دبي؛ وليس توقعاً من SRWAE",
"The likely binding constraint, rather than total property-market size": "القيد المرجح أن يكون حاسماً، بدلاً من الحجم الإجمالي لسوق العقارات",
"Actual capacity depends on software architecture, cloud resources, database design, security testing, operational staffing, UAE legal and regulatory coverage, property-registry integrations, licensed-partner relationships, bank/escrow capacity, valuation and review turnaround, data quality, investor demand, and the number and complexity of each project or offering.": "تعتمد السعة الفعلية على بنية البرمجيات، وموارد السحابة، وتصميم قواعد البيانات، واختبارات الأمان، والكوادر التشغيلية، والتغطية القانونية والتنظيمية في الإمارات، والتكامل مع السجلات العقارية، وعلاقات الشركاء المرخصين، وقدرة البنوك/حسابات الضمان، وسرعة التقييم والمراجعة، وجودة البيانات، وطلب المستثمرين، وعدد وتعقيد كل مشروع أو طرح.",
"From UAE real-world asset to managed digital record": "من أصل حقيقي في الإمارات إلى سجل رقمي مُدار",
"SRWAE UAE is intended to coordinate the work around an asset. It does not replace Dubai Land Department, ADREC or another property registry; issuer/SPV books; licensed custodian or holder records; contracts; professional judgment; bank/escrow records; or required regulatory filings.": "تهدف SRWAE UAE إلى تنسيق العمل المحيط بالأصل. وهي لا تحل محل دائرة الأراضي والأملاك في دبي أو مركز أبوظبي العقاري (ADREC) أو أي سجل عقاري آخر، ولا دفاتر الجهة المصدرة/SPV، ولا سجلات الحفظ أو حاملي الرموز لدى الجهات المرخصة، ولا العقود أو الحكم المهني أو سجلات البنك/حساب الضمان أو الإيداعات التنظيمية المطلوبة.",
"A UAE tokenized real-estate system requires more than buyers and sellers. SRWAE UAE separates public, investor, project, property-record, transaction, custody/holder-record, banking/escrow, legal, compliance, administrative, and reporting responsibilities.": "يتطلب نظام العقارات المرمزة في الإمارات أكثر من مجرد مشترين وبائعين. وتفصل SRWAE UAE بين مسؤوليات الجمهور والمستثمرين والمشروعات والسجلات العقارية والمعاملات والحفظ/سجلات حاملي الرموز والبنوك/حسابات الضمان والشؤون القانونية والامتثال والإدارة والتقارير.",
"Access expands only after verification, eligibility, and jurisdiction approval": "يتوسع الوصول فقط بعد التحقق من الهوية والأهلية والموافقة حسب الولاية القضائية",
"The service and subscription forms use a role-based model. Public access is intentionally limited, while project, investor, professional, property-record, and transaction permissions require additional information, verification, agreements, jurisdiction checks, and approval.": "تستخدم نماذج الخدمة والاشتراك نموذجاً قائماً على الأدوار. ويكون الوصول العام محدوداً عمداً، بينما تتطلب صلاحيات المشروع والمستثمر والمهني والسجل العقاري والمعاملة معلومات إضافية والتحقق واتفاقيات وفحوصاً للولاية القضائية وموافقة.",
"In the UAE, the treatment of each tokenized interest depends on the actual rights, property registry, issuer/SPV records, contracts, investor audience, technology model, payment and transfer method, participants, and jurisdiction. Dubai outside DIFC, DIFC, ADGM, and other Emirates can involve different regulatory frameworks and licensed roles.": "في دولة الإمارات، تعتمد معاملة كل مصلحة مرمزة على الحقوق الفعلية والسجل العقاري وسجلات الجهة المصدرة/SPV والعقود وجمهور المستثمرين ونموذج التقنية وطريقة الدفع والتحويل والمشاركين والولاية القضائية. وقد تخضع دبي خارج DIFC، وDIFC، وADGM، والإمارات الأخرى لأطر تنظيمية وأدوار مرخصة مختلفة.",
"SRWAE UAE is a technology, data, and workflow platform concept. Nothing on this page is legal, regulatory, tax, accounting, financial, brokerage, arranging, custody, escrow, valuation, property-title, or investment advice, and nothing is an offer, solicitation, recommendation, statement of regulatory approval, promise of liquidity, or guarantee of return.": "SRWAE UAE هي منصة تقنية وبيانات ومسارات عمل. ولا يُعد أي شيء في هذه الصفحة استشارة قانونية أو تنظيمية أو ضريبية أو محاسبية أو مالية أو وساطة أو ترتيباً أو حفظاً أو حساب ضمان أو تقييماً أو استشارة بشأن ملكية العقار أو استثماراً، كما لا يمثل عرضاً أو التماساً أو توصية أو بياناً بموافقة تنظيمية أو وعداً بالسيولة أو ضماناً للعائد.",
"Market figures are included to explain scale and direction. Dubai and Abu Dhabi figures measure different periods and categories and should not be added together. Regulatory frameworks differ by jurisdiction. Capacity scenarios on this page were created for SRWAE planning and are not third-party forecasts.": "تُدرج أرقام السوق لشرح الحجم والاتجاه. وتقيس أرقام دبي وأبوظبي فترات وفئات مختلفة ولا ينبغي جمعها معاً. كما تختلف الأطر التنظيمية باختلاف الولاية القضائية. وقد أُنشئت سيناريوهات السعة في هذه الصفحة لأغراض تخطيط SRWAE وليست توقعات صادرة عن جهات خارجية.",
"Research reviewed August 2026": "تمت مراجعة الأبحاث في أغسطس 2026",
"SRWAE uses one global product architecture with market-specific data, legal workflows, roles, access controls, capacity assumptions, risks, and research. Select a country below to view the information prepared for that market.": "تستخدم SRWAE بنية منتج عالمية موحدة مع بيانات ومسارات قانونية وأدوار وضوابط وصول وافتراضات سعة ومخاطر وأبحاث خاصة بكل سوق. اختر دولة أدناه لعرض المعلومات المعدة لذلك السوق.",
"Market selector": "اختيار السوق",
"Choose a country to view its local SRWAE information": "اختر دولة لعرض معلومات SRWAE الخاصة بسوقها المحلي",
"The platform architecture is shared globally, while market data, regulatory pathways, operating assumptions, roles, fees, risks, and research sources change by country. Select a market below. More countries can be added later.": "بنية المنصة مشتركة عالمياً، بينما تختلف بيانات السوق والمسارات التنظيمية وافتراضات التشغيل والأدوار والرسوم والمخاطر ومصادر الأبحاث من دولة إلى أخرى. اختر سوقاً أدناه. ويمكن إضافة دول أخرى لاحقاً.",
"Choose country": "اختر الدولة",
"Additional country markets can be added to this selector as localized content and operating pathways are prepared.": "يمكن إضافة أسواق دول أخرى إلى أداة الاختيار هذه عندما يتم إعداد المحتوى المحلي ومسارات التشغيل الخاصة بها.",
"Selected market overview": "نظرة عامة على السوق المحدد",
"Viewing market": "السوق المعروض",


"Operating stage": "مرحلة التشغيل",
"Active asset or token records": "سجلات الأصول أو الرموز النشطة",
"Illustrative average represented asset value": "متوسط القيمة التوضيحية للأصول الممثلة",
"Illustrative total represented asset value": "إجمالي القيمة التوضيحية للأصول الممثلة",
"Operational meaning": "الدلالة التشغيلية",
"Controlled pilot": "مرحلة تجريبية منضبطة",
"Regional launch": "إطلاق إقليمي",
"Multi-state scale": "توسع عبر عدة ولايات",
"National platform scale": "توسع المنصة على المستوى الوطني",
"Illustrative national represented-asset scenario": "سيناريو توضيحي لقيمة الأصول الممثلة على المستوى الوطني",
"Approximate share of the 2026 Q1 Federal Reserve real estate measure": "الحصة التقريبية من مقياس الاحتياطي الفيدرالي للعقارات للربع الأول من 2026",
"Execution capacity": "القدرة التنفيذية",
"The likely binding constraint, rather than total market size": "القيد المرجح الحاسم، وليس الحجم الإجمالي للسوق",

"Controlled lifecycle": "دورة حياة منضبطة",
"From real-world asset to managed digital record": "من أصل حقيقي إلى سجل رقمي مُدار",
"Discover and classify": "اكتشاف الأصل وتصنيفه",
"Verify ownership and data": "التحقق من الملكية والبيانات",
"Structure the legal interest": "هيكلة المصلحة القانونية",
"Complete professional review": "استكمال المراجعة المهنية",
"Prepare and publish the offering": "إعداد الطرح ونشره",
"Operate and report": "التشغيل وإعداد التقارير",
"Control approved transfers": "التحكم في التحويلات المعتمدة",

"Role ecosystem": "منظومة الأدوار",
"One platform, different responsibilities": "منصة واحدة، مسؤوليات مختلفة",
"Market and investor users": "مستخدمو السوق والمستثمرون",
"Public visitor": "زائر عام",
"Verified investor": "مستثمر تم التحقق منه",
"Sponsor administrator": "مسؤول الراعي",
"Offering administrator": "مسؤول الطرح",
"Marketplace administrator": "مسؤول السوق",
"Project-side users": "مستخدمو جانب المشروع",
"Asset owner": "مالك الأصل",
"Sponsor": "الراعي",
"Issuer": "المُصدر",
"Property manager": "مدير العقار",
"Asset manager": "مدير الأصول",
"Rehabilitation manager": "مدير إعادة التأهيل",
"Transaction and custody users": "مستخدمو المعاملات والحفظ",
"Broker-dealer signer": "الموقّع لدى الوسيط والمتعامل",
"Transfer agent": "وكيل التحويل",
"Token operations user": "مستخدم عمليات الرموز",
"Escrow agent": "وكيل الضمان",
"Escrow administrator": "مسؤول الضمان",
"Professional and control users": "المستخدمون المهنيون ومستخدمو الرقابة",
"Legal counsel": "المستشار القانوني",
"Securities attorney": "محامي الأوراق المالية",
"Compliance reviewer": "مراجع الامتثال",
"Title reviewer": "مراجع الملكية",
"Valuation reviewer": "مراجع التقييم",
"Inspector": "المفتش",
"Financial analyst": "المحلل المالي",
"Tax and audit professional": "متخصص الضرائب والتدقيق",
"Platform and map data administrator": "مسؤول بيانات المنصة والخريطة",

"Access and service model": "نموذج الوصول والخدمات",
"Access expands only after verification and approval": "يتوسع الوصول فقط بعد التحقق والموافقة",
"Public access": "الوصول العام",
"Free and limited": "مجاني ومحدود",
"Verified access": "وصول بعد التحقق",
"Role and eligibility based": "قائم على الدور والأهلية",
"Project-side SaaS service": "خدمة SaaS لأطراف المشروع",
"Monthly service plans": "خطط خدمة شهرية",
"Approved transaction service": "خدمة معاملات معتمدة",
"0.5% after a completed buy or sell": "0.5% بعد إتمام عملية شراء أو بيع",

"Legal and risk discipline": "الانضباط القانوني وإدارة المخاطر",
"Tokenization improves the workflow; it does not remove the risk": "الترميز يحسّن سير العمل؛ لكنه لا يزيل المخاطر",
"Important": "مهم",
"Illustrative SRWAE capacity scenarios": "سيناريوهات توضيحية لقدرة SRWAE",

"A small launch used to validate legal templates, data quality, partner workflows, investor onboarding, reporting, security, and operational controls.": "إطلاق محدود يُستخدم للتحقق من القوالب القانونية وجودة البيانات وسير عمل الشركاء وإعداد المستثمرين والتقارير والأمن والضوابط التشغيلية.",

"A multi-partner operation serving several asset owners, property types, professional reviewers, and approved investor groups in selected states.": "عملية متعددة الشركاء تخدم عدة مالكي أصول وأنواع عقارات ومراجعين مهنيين ومجموعات مستثمرين معتمدة في ولايات مختارة.",

"A scaled service with standardized onboarding, stronger automation, multiple legal and transaction partners, portfolio reporting, and mature support operations.": "خدمة موسعة بإجراءات إعداد موحدة وأتمتة أقوى وعدة شركاء قانونيين وشركاء معاملات وتقارير للمحافظ وعمليات دعم ناضجة.",

"A national operating scenario requiring enterprise architecture, redundancy, independent controls, extensive partner capacity, and state-by-state legal and operational coverage.": "سيناريو تشغيل وطني يتطلب بنية مؤسسية وتكراراً احتياطياً وضوابط مستقلة وقدرة واسعة للشركاء وتغطية قانونية وتشغيلية لكل ولاية.",

"Actual capacity depends on software architecture, cloud resources, database design, security testing, operational staffing, legal coverage, broker-dealer and transfer-agent relationships, escrow capacity, review turnaround, data quality, investor demand, and the number and complexity of each offering.": "تعتمد القدرة الفعلية على بنية البرمجيات وموارد الحوسبة السحابية وتصميم قواعد البيانات واختبارات الأمن والكوادر التشغيلية والتغطية القانونية وعلاقات الوسطاء والمتعاملين ووكلاء التحويل وقدرة الضمان وسرعة المراجعة وجودة البيانات وطلب المستثمرين وعدد الطروحات ومدى تعقيد كل منها.",

"SRWAE is intended to coordinate the work around an asset. It does not replace the county record, legal entity records, issuer books, transfer-agent records, contracts, professional judgment, or required regulatory filings.": "تهدف SRWAE إلى تنسيق الأعمال المحيطة بالأصل. وهي لا تحل محل سجلات المقاطعة أو سجلات الكيان القانوني أو دفاتر المُصدر أو سجلات وكيل التحويل أو العقود أو الحكم المهني أو الإيداعات التنظيمية المطلوبة.",

"Identify the asset, ownership entity, jurisdiction, intended economics, project stage, users, documents, and requested tokenization model.": "تحديد الأصل وكيان الملكية والاختصاص القضائي والهيكل الاقتصادي المقصود ومرحلة المشروع والمستخدمين والمستندات ونموذج الترميز المطلوب.",

"Collect and review title, entity, financial, appraisal, lease, auction, construction, insurance, tax, identity, and source records as applicable.": "جمع ومراجعة سجلات الملكية والكيان والبيانات المالية والتقييم وعقود الإيجار والمزادات والإنشاءات والتأمين والضرائب والهوية والمصادر حسب الاقتضاء.",

"Define the issuer, SPV or series, investor rights, exemptions, restrictions, disclosures, transfer rules, governance, distributions, and risk allocation.": "تحديد المُصدر أو الكيان ذي الغرض الخاص (SPV) أو السلسلة وحقوق المستثمرين والإعفاءات والقيود والإفصاحات وقواعد التحويل والحوكمة والتوزيعات وتخصيص المخاطر.",

"Route the project to assigned legal, compliance, valuation, title, escrow, inspection, financial, tax, and operational reviewers.": "إحالة المشروع إلى المراجعين المعينين للشؤون القانونية والامتثال والتقييم والملكية والضمان والتفتيش والشؤون المالية والضرائب والتشغيل.",

"Create the approved listing, data room, map view, token record, risk information, documents, investor eligibility rules, and subscription workflow.": "إنشاء الإدراج المعتمد وغرفة البيانات وعرض الخريطة وسجل الرمز ومعلومات المخاطر والمستندات وقواعد أهلية المستثمرين وسير عمل الاشتراك.",

"Track funding, escrow, milestones, property activity, income, expenses, reserves, inspections, distributions, documents, and investor communications.": "متابعة التمويل والضمان والمراحل ونشاط العقار والدخل والمصروفات والاحتياطيات وعمليات التفتيش والتوزيعات والمستندات والتواصل مع المستثمرين.",

"Apply holder eligibility, legal restrictions, transfer-agent records, broker-dealer support, approvals, tax records, and audit trails to permitted transfers.": "تطبيق أهلية حاملي الرموز والقيود القانونية وسجلات وكيل التحويل ودعم الوسطاء والمتعاملين والموافقات والسجلات الضريبية ومسارات التدقيق على التحويلات المسموح بها.",

"A tokenized real estate system requires more than buyers and sellers. SRWAE separates public, investor, project, transaction, custody, review, legal, administrative, and reporting responsibilities.": "يتطلب نظام العقارات المرمّزة أكثر من مجرد المشترين والبائعين. تفصل SRWAE بين مسؤوليات الجمهور والمستثمرين والمشروعات والمعاملات والحفظ والمراجعة والشؤون القانونية والإدارية وإعداد التقارير.",

"The service and subscription forms use a role-based model. Public access is intentionally limited, while project, investor, professional, and transaction permissions require additional information and approval.": "تستخدم نماذج الخدمة والاشتراك نموذجاً قائماً على الأدوار. ويكون الوصول العام محدوداً بصورة مقصودة، بينما تتطلب صلاحيات المشروع والمستثمر والمهني والمعاملات معلومات إضافية وموافقة.",

"Public users may view limited listing information and approximate map information without receiving precise locations, complete documents, review requests, or transaction access.": "يمكن للمستخدمين العامين الاطلاع على معلومات محدودة عن الإدراج ومعلومات تقريبية على الخريطة دون الحصول على المواقع الدقيقة أو المستندات الكاملة أو طلبات المراجعة أو صلاحية تنفيذ المعاملات.",

"Verified and approved users may receive broader access according to identity, eligibility, jurisdiction, offering terms, agreements, and assigned permissions.": "يمكن للمستخدمين الذين تم التحقق منهم واعتمادهم الحصول على وصول أوسع وفقاً للهوية والأهلية والاختصاص القضائي وشروط الطرح والاتفاقيات والصلاحيات المخصصة.",

"Asset owners, sponsors, issuers, and operators can select a service plan for active asset, token, listing, data, reporting, and workflow support.": "يمكن لمالكي الأصول والرعاة والمُصدرين والمشغلين اختيار خطة خدمة لدعم الأصول والرموز والإدراجات والبيانات والتقارير وسير العمل النشط.",

"The current service model applies this fee only to an approved broker-dealer signer, transfer agent, or token operations user under applicable agreements and legal requirements.": "يطبق نموذج الخدمة الحالي هذه الرسوم فقط على الموقّع المعتمد لدى الوسيط والمتعامل أو وكيل التحويل أو مستخدم عمليات الرموز، وفقاً للاتفاقيات والمتطلبات القانونية المعمول بها.",

"In the United States, the structure and rights of each tokenized interest must be evaluated based on the actual facts, contracts, issuer records, technology model, participants, and applicable federal and state requirements.": "في الولايات المتحدة، يجب تقييم هيكل وحقوق كل مصلحة مرمّزة استناداً إلى الوقائع الفعلية والعقود وسجلات المُصدر ونموذج التقنية والمشاركين والمتطلبات الفيدرالية ومتطلبات الولايات المعمول بها.",

"Tokenization does not change the legal nature of a security or eliminate registration, exemption, disclosure, custody, recordkeeping, anti-fraud, and investor-protection requirements.": "لا يغيّر الترميز الطبيعة القانونية للورقة المالية ولا يلغي متطلبات التسجيل أو الإعفاء أو الإفصاح أو الحفظ أو حفظ السجلات أو مكافحة الاحتيال أو حماية المستثمرين.",

"A token does not by itself prove title, ownership, valuation, income, collateral, legal compliance, or enforceability of the represented interest.": "لا يثبت الرمز بمفرده سند الملكية أو حق الملكية أو التقييم أو الدخل أو الضمان أو الامتثال القانوني أو قابلية إنفاذ المصلحة الممثلة.",

"Listings, reviews, approvals, risk labels, inspections, and documents reduce information gaps but cannot eliminate investment, property, construction, auction, market, technology, or counterparty risk.": "تساعد الإدراجات والمراجعات والموافقات وتصنيفات المخاطر وعمليات التفتيش والمستندات على تقليل فجوات المعلومات، لكنها لا تستطيع إزالة مخاطر الاستثمار أو العقارات أو الإنشاءات أو المزادات أو السوق أو التقنية أو الطرف المقابل.",

"Liquidity, distributions, appreciation, rental income, refinancing, resale, auction success, and investment returns are never guaranteed.": "لا توجد أي ضمانات للسيولة أو التوزيعات أو ارتفاع القيمة أو دخل الإيجار أو إعادة التمويل أو إعادة البيع أو نجاح المزاد أو عوائد الاستثمار.",

"Each U.S. offering may require federal and state legal analysis, investor eligibility controls, KYC and AML procedures, tax review, transfer restrictions, custody or transfer-agent support, and separate agreements.": "قد يتطلب كل طرح في الولايات المتحدة تحليلاً قانونياً على المستوى الفيدرالي ومستوى الولاية، وضوابط أهلية المستثمرين، وإجراءات KYC وAML، ومراجعة ضريبية، وقيوداً على التحويل، ودعم الحفظ أو وكيل التحويل، واتفاقيات منفصلة.",

"SRWAE is a technology and workflow platform concept. Nothing on this page is legal, tax, accounting, financial, brokerage, valuation, title, custody, or investment advice, and nothing is an offer, solicitation, recommendation, promise of liquidity, or guarantee of return.": "SRWAE هي مفهوم لمنصة تقنية وسير عمل. لا يُعد أي محتوى في هذه الصفحة استشارة قانونية أو ضريبية أو محاسبية أو مالية أو في الوساطة أو التقييم أو الملكية أو الحفظ أو الاستثمار، كما لا يمثل أي محتوى عرضاً أو دعوة أو توصية أو وعداً بالسيولة أو ضماناً للعائد.",

"Market figures are included to explain scale and direction. Forecasts differ in scope, geography, asset classes, definitions, and methodology. The capacity scenarios on this page were created for SRWAE planning and are not third-party forecasts.": "أُدرجت أرقام السوق لتوضيح الحجم والاتجاه. وتختلف التوقعات من حيث النطاق والجغرافيا وفئات الأصول والتعريفات والمنهجية. وقد أُعدت سيناريوهات القدرة في هذه الصفحة لأغراض تخطيط SRWAE وليست توقعات صادرة عن أطراف خارجية.",

"Household and nonprofit real estate market value and related U.S. balance-sheet context.": "القيمة السوقية لعقارات الأسر والمؤسسات غير الربحية والسياق المرتبط بالميزانية العمومية في الولايات المتحدة.",

"U.S. farm real estate value, land values, and recent growth information.": "قيمة العقارات الزراعية والأراضي في الولايات المتحدة ومعلومات النمو الحديثة.",

"National owner-occupied and renter-occupied housing unit estimates.": "تقديرات الوحدات السكنية المشغولة من قبل المالكين والمستأجرين على المستوى الوطني.",

"A commercial real estate scale benchmark based on the second quarter of 2021.": "معيار لحجم سوق العقارات التجارية يستند إلى بيانات الربع الثاني من عام 2021.",

"Forecast for the global tokenized real estate ecosystem through 2035.": "توقعات لمنظومة العقارات المرمّزة عالمياً حتى عام 2035.",

"Forecast and adoption framework for broader tokenized financial assets through 2030.": "إطار للتوقعات والتبني للأصول المالية المرمّزة على نطاق أوسع حتى عام 2030.",

"Current explanation of issuer-sponsored and third-party tokenization models and federal securities-law treatment.": "شرح حالي لنماذج الترميز التي يرعاها المُصدر أو الأطراف الخارجية ولمعاملتها بموجب قوانين الأوراق المالية الفيدرالية.",



"Research basis": "أساس البحث",
"Sources and methodology notes": "المصادر وملاحظات المنهجية",
"Federal Reserve Financial Accounts of the United States, 2026 Q1": "الاحتياطي الفيدرالي — الحسابات المالية للولايات المتحدة، الربع الأول 2026",
"USDA Economic Research Service, Farmland Value": "خدمة البحوث الاقتصادية بوزارة الزراعة الأمريكية (USDA) — قيمة الأراضي الزراعية",
"U.S. Census Bureau, 2024 American Community Survey, Table B25003": "مكتب الإحصاء الأمريكي — مسح المجتمع الأمريكي لعام 2024، الجدول B25003",
"Nareit estimate of the U.S. commercial real estate market": "تقدير Nareit لسوق العقارات التجارية في الولايات المتحدة",
"Deloitte, Tokenized Real Estate": "Deloitte — العقارات المرمّزة",
"McKinsey, From Ripples to Waves": "McKinsey — From Ripples to Waves",
"U.S. Securities and Exchange Commission, Statement on Tokenized Securities": "هيئة الأوراق المالية والبورصات الأمريكية (SEC) — بيان بشأن الأوراق المالية المرمّزة",
"Open source": "فتح المصدر",
"Research reviewed July 2026": "تمت مراجعة البحث في يوليو 2026",

  
            "COMMON EQUITY": "الأسهم العادية",
            "Company or organization name": "اسم الشركة أو المؤسسة",
            "Company, sponsor, issuer, SPV, or external platform name": "اسم الشركة أو الراعي أو الجهة المُصدِرة أو SPV أو المنصة الخارجية",
            "Confirm password": "تأكيد كلمة المرور",
            "Connecticut": "كونيتيكت",
            "Contact": "اتصل بنا",
            "Contact Us": "تواصل معنا",
            "Continue with Apple": "المتابعة باستخدام Apple",
            "Continue with Google": "المتابعة باستخدام Google",
            "Continue with Microsoft": "المتابعة باستخدام Microsoft",
            "Country": "الدولة",
            "Critical": "حرج",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "نشر مخصص ودعم لعميل من فئة المؤسسات. ويجب تحديد مسؤولية المبيعات وعرض المنصة ودعم البيانات ودعم الإدراج ورسوم المعاملات المسموح بها في اتفاقية منفصلة.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "نشر مخصص ودعم لعملاء المؤسسات والمحافظ الأكبر ومسارات العمل المخصصة والاحتياجات التشغيلية المتقدمة.",
            "Custom service setup and enterprise support": "إعداد خدمة مخصصة ودعم للمؤسسات",
            "Customer review code layer": "طبقة رمز مراجعات العملاء",
            "Customer reviews on map/list": "مراجعات العملاء على الخريطة/القائمة",
            "Debt": "دين",
            "DEBT NOTE": "سند دين",
            "Debt structure is easy to understand.": "هيكل الدين واضح وسهل الفهم.",
            "Delaware": "ديلاوير",
            "Designed for growing asset portfolios": "مصممة لمحافظ الأصول المتنامية",
            "Display only": "للعرض فقط",
            "District of Columbia": "مقاطعة كولومبيا",
            "Document upload": "رفع المستندات",
            "Drag and drop files here": "اسحب الملفات وأفلتها هنا",
            "Email is required": "البريد الإلكتروني مطلوب",
            "Enlarged Logo": "الشعار المكبّر",
            "Enter subject": "أدخل الموضوع",
            "Enter the information needed to create or update your access request profile.": "أدخل المعلومات اللازمة لإنشاء ملف طلب الوصول أو تحديثه.",
            "Enter your country": "أدخل دولتك",
            "Enter your email": "أدخل بريدك الإلكتروني",
            "Enter your email address and we will send password reset instructions if the account exists.": "أدخل عنوان بريدك الإلكتروني وسنرسل تعليمات إعادة تعيين كلمة المرور إذا كان الحساب موجوداً.",
            "Enter your first name": "أدخل اسمك الأول",
            "Enter your last name": "أدخل اسم العائلة",
            "Enter your message": "أدخل رسالتك",
            "Enter your password": "أدخل كلمة المرور",
            "Enter your username or email": "أدخل اسم المستخدم أو البريد الإلكتروني",
            "Enterprise / Custom": "المؤسسات / مخصص",
            "Equity": "حقوق ملكية",
            "EQUITY APPRECIATION": "ارتفاع قيمة حقوق الملكية",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20 أو ERC-1400 أو ERC-3643 أو معيار آخر",
            "Escrow agent or escrow administrator": "وكيل حساب الضمان أو مسؤول حساب الضمان",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum أو Polygon أو Avalanche أو شبكة أخرى",
            "Example: RV text for map/list display...": "مثال: نص RV للعرض على الخريطة/القائمة...",
            "example@email.com": "example@email.com",
            "Exit": "خروج",
            "Expanded reporting and workflow support": "دعم موسّع لإعداد التقارير ومسارات العمل",
            "External issuer or platform name": "اسم الجهة المُصدِرة أو المنصة الخارجية",
            "External ledger or cap table reference": "مرجع السجل الخارجي أو جدول هيكل الملكية",
            "External review": "مراجعة خارجية",
            "External token issuer or external token listing partner": "جهة إصدار رمز خارجية أو شريك إدراج رموز خارجي",
            "External token listing information": "معلومات إدراج الرمز الخارجي",
            "First name": "الاسم الأول",
            "Florida": "فلوريدا",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "للمستخدمين المعتمدين لخدمات حساب الضمان الذين يديرون إعداد الحساب والودائع والإفراجات والمبالغ المستردة وحالة مدفوعات التوزيع. لا يمنح هذا الدور وصولاً مباشراً للشراء أو البيع.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "للمستخدمين القانونيين المعتمدين الذين يجوز لهم مراجعة المستندات القانونية والإفصاحات والآراء القانونية وملاحظات الإعفاء وسجلات المراجعة القانونية ذات الصلة واعتمادها أو رفضها أو رفعها.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "للمفتشين ومراجعي التقييم والامتثال والملكية ومصادر المزاد والمحللين الماليين ومراجعي علاقات المستثمرين وغيرهم من مستخدمي المراجعة المهنية المكلّفين.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "للمستخدمين الإداريين الداخليين أو المعتمدين الذين يديرون بيانات المنصة وأدوار المستخدمين وسجلات الخريطة والإدراجات ومسارات المراجعة. ويتطلب التداول المباشر دور مستثمر معتمداً بصورة منفصلة.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "للمستخدمين المرخّصين أو المعتمدين لعمليات المعاملات والتحويل والرموز. ويجب إظهار أي تعويض مرتبط بالمعاملة بصورة منفصلة ومعالجته وفق الاتفاقية السارية والمتطلبات القانونية.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "للمؤسسات التي سبق أن رمّزت أصولاً خارج هذه المنصة وترغب في مراجعة تلك الرموز أو إدراجها أو عرضها أو تمريرها عبر مسارات الوصول إلى المنصة وإعداد التقارير.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "للمستخدمين من جانب المشروع الذين يرغبون في إضافة أصول أو رموز وإنشاء إدراجات وإدارة غرفة بيانات وطلب مراجعات وتنسيق الخدمات المهنية واختيار خطة خدمة للمنصة.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "لإعداد التقارير الضريبية ومسار التدقيق والتسوية وتقارير التوزيع والضوابط المالية أو غيرها من الخدمات المهنية المطلوبة عبر مسارات عمل متعددة.",
            "Forgot your password?": "هل نسيت كلمة المرور؟",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "وصول عام مجاني مع إدراجات محدودة وعرض تقريبي للخريطة، من دون بيانات موقع دقيقة أو مستندات كاملة أو طلب مراجعة أو إجراء شراء أو بيع.",
            "From $5,000 / month": "ابتداءً من 5,000 دولار / شهرياً",
            "funded": "مموّل",
            "Funding progress": "تقدم التمويل",
            "Georgia": "جورجيا",
            "Good location visibility and clean data room.": "وضوح جيد للموقع وغرفة بيانات منظمة.",
            "Good starting point for one asset or a small launch": "نقطة بداية جيدة لأصل واحد أو لإطلاق صغير",
            "Guam": "غوام",
            "Handled under the applicable agreement, approval process, and legal requirements": "تتم المعالجة وفق الاتفاقية السارية وإجراءات الموافقة والمتطلبات القانونية",
            "Hawaii": "هاواي",
            "Hide": "إخفاء",
            "Hide password": "إخفاء كلمة المرور",
            "High": "مرتفع",
            "Home": "الرئيسية",
            "HYBRID": "هجين",
            "Idaho": "أيداهو",
            "Illinois": "إلينوي",
            "Included roles": "الأدوار المشمولة",
            "Income": "الدخل",
            "Indiana": "إنديانا",
            "Invalid email format": "تنسيق البريد الإلكتروني غير صالح",
            "Investable only": "قابل للاستثمار فقط",
            "Investor Login": "تسجيل دخول المستثمر",
            "Iowa": "آيوا",
            "Issuer": "الجهة المُصدِرة",
            "Issuer, sponsor, or originating platform": "الجهة المُصدِرة أو الراعي أو المنصة المنشِئة",
            "Kansas": "كانساس",
            "Kentucky": "كنتاكي",
            "Last name": "اسم العائلة",
            "Legal counsel, securities attorney, or legal administrator": "مستشار قانوني أو محامي أوراق مالية أو مسؤول قانوني",
            "List": "القائمة",
            "Listed": "مدرج",
            "Location": "الموقع",
            "Login": "تسجيل الدخول",
            "Login failed. Please check your username and password.": "تعذّر تسجيل الدخول. يرجى التحقق من اسم المستخدم وكلمة المرور.",
            "LogOut": "تسجيل الخروج",
            "Logout failed. Please try again.": "تعذّر تسجيل الخروج. يرجى المحاولة مرة أخرى.",
            "Louisiana": "لويزيانا",
            "Low": "منخفض",
            "Lower effective cost per token for multiple active tokens": "تكلفة فعلية أقل لكل رمز عند وجود عدة رموز نشطة",
            "Maine": "مين",
            "Map": "الخريطة",
            "Map layers": "طبقات الخريطة",
            "Market access": "الوصول إلى السوق",
            "Marshall Islands": "جزر مارشال",
            "Maryland": "ماريلاند",
            "Massachusetts": "ماساتشوستس",
            "Menu": "القائمة",
            "Message": "الرسالة",
            "Michigan": "ميشيغان",
            "Micronesia": "ميكرونيزيا",
            "min": "الحد الأدنى",
            "Min Investment": "الحد الأدنى للاستثمار",
            "Minnesota": "مينيسوتا",
            "Mississippi": "مسيسيبي",
            "Missouri": "ميزوري",
            "Mixed Use": "استخدام مختلط",
            "Moderate": "متوسط",
            "Montana": "مونتانا",
            "Nebraska": "نبراسكا",
            "Network error. Please check your connection and try again.": "حدث خطأ في الشبكة. يرجى التحقق من الاتصال والمحاولة مرة أخرى.",
            "Nevada": "نيفادا",
            "New access requests are handled through the Pricing & Access Request page.": "تتم معالجة طلبات الوصول الجديدة من خلال صفحة طلب الأسعار والوصول.",
            "New Hampshire": "نيوهامبشير",
            "New Jersey": "نيوجيرسي",
            "New Mexico": "نيو مكسيكو",
            "New York": "نيويورك",
            "No public review yet.": "لا توجد مراجعة عامة حتى الآن.",
            "North Carolina": "كارولاينا الشمالية",
            "North Dakota": "داكوتا الشمالية",
            "Northern Mariana Islands": "جزر ماريانا الشمالية",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "لا تُفرض على الزوار العامين أو مالكي الأصول أو الرعاة أو الجهات المُصدِرة أو المشغّلين ضمن خطط الخدمة الشهرية",
            "Offering status": "حالة الطرح",
            "Offerings": "الطروحات",
            "Ohio": "أوهايو",
            "Oklahoma": "أوكلاهوما",
            "Oops!": "عذراً!",
            "Operator": "المشغّل",
            "or": "أو",
            "or click to choose files": "أو انقر لاختيار الملفات",
            "Oregon": "أوريغون",
            "Other professional services": "خدمات مهنية أخرى",
            "Palau": "بالاو",
            "Parcel / token boundary after zoom 16+": "حدود قطعة الأرض / الرمز بعد مستوى تكبير 16 فأعلى",
            "Password": "كلمة المرور",
            "Password is required": "كلمة المرور مطلوبة",
            "Password reset failed. Please try again.": "تعذّرت إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.",
            "Password reset instructions were sent if this account exists.": "إذا كان هذا الحساب موجوداً، فقد تم إرسال تعليمات إعادة تعيين كلمة المرور.",
            "Pennsylvania": "بنسلفانيا",
            "Phone number": "رقم الهاتف",
            "Platform admin, system admin, map data operator, or map data reviewer": "مسؤول المنصة, مسؤول النظام, مشغّل بيانات الخريطة, أو مراجع بيانات الخريطة",
            "PLATFORM CORE": "النواة الأساسية للمنصة",
            "Platform service plans": "خطط خدمات المنصة",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "يرجى اختيار خطة خدمة لدور مالك الأصل أو الراعي أو الجهة المُصدِرة.",
            "Please select a U.S. state, territory, or related jurisdiction.": "يرجى اختيار ولاية أو إقليماً أمريكياً أو ولاية قضائية ذات صلة.",
            "Please select at least one user type or role.": "يرجى اختيار نوع مستخدم أو دور واحد على الأقل.",
            "Please wait...": "يرجى الانتظار...",
            "Point Only": "نقطة فقط",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "خدمة إدارة SaaS على مستوى المحفظة لما لا يقل عن عشرة رموز نشطة، مع تكلفة فعلية أقل لكل رمز.",
            "POST AUCTION": "ما بعد المزاد",
            "Post-Auction Token": "رمز ما بعد المزاد",
            "PRE AUCTION POOL": "مجمع ما قبل المزاد",
            "PREFERRED EQUITY": "حقوق ملكية ممتازة",
            "Pricing & Access Request": "طلب الأسعار والوصول",
            "Professional": "مهني",
            "Professional review": "مراجعة مهنية",
            "Professional reviewers": "المراجعون المهنيون",
            "Project services": "خدمات المشروع",
            "Public": "عام",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "يمكن للمستخدمين العامين الاطلاع على معلومات محدودة. ويجوز للمستخدمين الموثّقين طلب وصول أوسع وفقاً لدورهم وحالة اعتمادهم.",
            "Public visitor": "زائر عام",
            "Puerto Rico": "بورتوريكو",
            "Real Asset": "أصل حقيقي",
            "Registration and contact information": "معلومات التسجيل والاتصال",
            "Remove": "إزالة",
            "RENT INCOME": "دخل الإيجار",
            "Rental Income": "دخل الإيجار",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "اطلب الوصول إلى خدمات المنصة الخاصة بالإدراج والمراجعة وإدارة المستندات وإعداد التقارير ومسارات العمل المرتبطة بالرموز. يعتمد توافر الوصول والخدمات على التحقق واعتماد الدور والاتفاقيات السارية والمتطلبات القانونية.",
            "Request info only": "طلب معلومات فقط",
            "Requested external listing status": "حالة الإدراج الخارجي المطلوبة",
            "Reset Password": "إعادة تعيين كلمة المرور",
            "REVENUE SHARE": "مشاركة الإيرادات",
            "review": "مراجعة",
            "Review rating": "تقييم المراجعة",
            "Review text": "نص المراجعة",
            "review(s)": "مراجعة/مراجعات",
            "Reviews": "المراجعات",
            "Rhode Island": "رود آيلاند",
            "Risk": "المخاطر",
            "Risk Center": "مركز المخاطر",
            "Risk color": "لون المخاطر",
            "Risk color pins": "دبابيس بألوان المخاطر",
            "SALE PROFIT": "ربح البيع",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "يجب تحديد مسؤولية المبيعات وعرض المنصة ودعم البيانات ودعم الإدراج ورسوم المعاملات المسموح بها في اتفاقية منفصلة",
            "Satellite": "قمر صناعي",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "بحث: \"دخل RI أوستن\"، \"أرض منخفضة المخاطر\"، \"مجمع مزاد\"",
            "Secondary transfer restricted": "التحويل الثانوي مقيّد",
            "Secondary transfers": "التحويلات الثانوية",
            "Select one": "اختر واحداً",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "اختر دوراً واحداً أو أكثر. قد تتطلب بعض الأدوار التحقق من الهوية أو التحقق من الأعمال أو مؤهلات مهنية أو اتفاقيات خدمة أو اعتماد المنصة.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "اختر ولاية أو إقليماً أمريكياً أو ولاية قضائية ذات صلة لطلب الوصول هذا.",
            "Send Message": "إرسال الرسالة",
            "Send Reset Link": "إرسال رابط إعادة التعيين",
            "Service overview": "نظرة عامة على الخدمة",
            "Services": "الخدمات",
            "Show": "إظهار",
            "Show password": "إظهار كلمة المرور",
            "Showing": "يتم عرض",
            "Sign in with an approved username and password or use single sign-on.": "سجّل الدخول باستخدام اسم مستخدم وكلمة مرور معتمدين أو استخدم تسجيل الدخول الموحد.",
            "Signed in as": "تم تسجيل الدخول باسم",
            "Simple listing and platform service support": "دعم مبسّط للإدراج وخدمات المنصة",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "خيارات خدمة مبسطة لمالكي الأصول والرعاة والجهات المُصدِرة والمشغّلين ومستخدمي خدمات المعاملات المعتمدين.",
            "Single sign-on options": "خيارات تسجيل الدخول الموحد",
            "Smart contract address": "عنوان العقد الذكي",
            "Sorry, an unexpected error has occurred.": "نعتذر، حدث خطأ غير متوقع.",
            "South Carolina": "كارولاينا الجنوبية",
            "South Dakota": "داكوتا الجنوبية",
            "Sponsor": "الراعي",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "يمكن للرعاة والجهات المُصدِرة ومشغّلي الأصول وشركاء الإدراج الخارجي طلب خدمات المنصة لمسارات عمل الأصول والرموز.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "البداية",
            "State, territory, or jurisdiction": "الولاية أو الإقليم أو الولاية القضائية",
            "Status": "الحالة",
            "Submit pricing and access request": "إرسال طلب الأسعار والوصول",
            "Subscription": "الاشتراك",
            "Successfully logged in": "تم تسجيل الدخول بنجاح",
            "Successfully logged out": "تم تسجيل الخروج بنجاح",
            "target": "الهدف",
            "Tennessee": "تينيسي",
            "Texas": "تكساس",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "لا تضمن المنصة الرمز الخارجي أو العقد الذكي أو التقييم أو الملكية أو التدفق النقدي أو حالة الامتثال أو التحويلات السابقة ما لم تُستكمل اتفاقية منفصلة للمراجعة وتحديد المسؤولية.",
            "There was an error sending your message. Please try again later.": "حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى لاحقاً.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "خطط الخدمة الشهرية هذه مخصصة للمستخدمين من جانب المشروع الذين يحتاجون إلى خدمات المنصة للأصول والرموز والإدراجات والبيانات وإعداد التقارير ومسارات العمل ذات الصلة.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "يظهر هذا القسم فقط عند اختيار دور مالك الأصل أو الراعي أو الجهة المُصدِرة أو مدير العقار أو مدير الأصل أو مدير إعادة التأهيل.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "تنطبق رسوم الخدمة هذه فقط على المستخدمين المعتمدين لخدمات المعاملات أو التحويل أو عمليات الرموز عند اكتمال عملية شراء أو بيع.",
            "Token": "الرمز",
            "Token details": "تفاصيل الرمز",
            "Token standard": "معيار الرمز",
            "Token type": "نوع الرمز",
            "Tokenized land & real estate offerings": "طروحات الأراضي والعقارات المرمّزة",
            "tokens · Sort by relevant listings": "الرموز · الترتيب حسب الإدراجات ذات الصلة",
            "Transaction service fee": "رسوم خدمة المعاملة",
            "Transfer agent, ledger source, snapshot, or reference URL": "وكيل التحويل أو مصدر السجل أو اللقطة أو رابط URL المرجعي",
            "Type": "النوع",
            "U.S. Minor Outlying Islands": "الجزر النائية الصغرى التابعة للولايات المتحدة",
            "U.S. state or territory": "ولاية أو إقليم أمريكي",
            "U.S. Virgin Islands": "جزر العذراء الأمريكية",
            "Unknown": "غير معروف",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "ارفع مستندات الهوية ومستندات الأعمال والتراخيص المهنية والاتفاقيات ومستندات الملكية وتقارير التقييم ومستندات سند الملكية وتقارير العقود الذكية أو أي ملفات أخرى ذات صلة.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "استخدم هذا القسم عندما يكون الأصل أو الحق الاقتصادي قد تم ترميزه بالفعل خارج هذه المنصة وترغب في طلب خدمات المراجعة أو الإدراج.",
            "User type or role": "نوع المستخدم أو دوره",
            "Username or email": "اسم المستخدم أو البريد الإلكتروني",
            "Username or email is required": "اسم المستخدم أو البريد الإلكتروني مطلوب",
            "Utah": "يوتا",
            "Verified external listing": "إدراج خارجي موثّق",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "مستثمر موثّق أو مسؤول الراعي أو مسؤول الطرح أو مسؤول السوق",
            "Vermont": "فيرمونت",
            "Virginia": "فرجينيا",
            "Washington": "واشنطن",
            "We could not confirm your sign-in session. Please try again.": "تعذّر علينا تأكيد جلسة تسجيل الدخول. يرجى المحاولة مرة أخرى.",
            "We would love to hear from you. Please fill out the form below.": "يسرّنا التواصل معكم. يرجى تعبئة النموذج أدناه.",
            "West Virginia": "فرجينيا الغربية",
            "Wisconsin": "ويسكونسن",
            "Wyoming": "وايومنغ",
            "You are currently signed in.": "أنت مسجّل الدخول حالياً.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "تم استلام طلب الوصول والأسعار. سيقوم فريقنا بمراجعة المعلومات والتواصل معكم بشأن الخطوات التالية.",
            "Your message has been sent successfully. We will respond as soon as possible.": "تم إرسال رسالتكم بنجاح. وسنرد عليكم في أقرب وقت ممكن.",
            "01 System Admin Platform Admin": "النواة الأساسية للمنصة، 01 مسؤول النظام ومسؤول المنصة",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "النواة الأساسية للمنصة، 01 مسؤول النظام ومسؤول المنصة",
            "Platform_USA_Profile": "ملف منصة الولايات المتحدة",
            "PLATFORM_USA_PROFILE": "ملف منصة الولايات المتحدة",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - ملف منصة الولايات المتحدة",
            "Select Stark RWAE Exchange - USA Platform Profile": "اختر Stark RWAE Exchange - ملف منصة الولايات المتحدة",
            "Print of Stark RWAE Exchange - USA Platform Profile": "طباعة Stark RWAE Exchange - ملف منصة الولايات المتحدة",
            "Platform ID": "معرّف المنصة",
            "Enter Platform ID": "أدخل معرّف المنصة",
            "Platform Name": "اسم المنصة",
            "Enter Platform Name": "أدخل اسم المنصة",
            "Platform Display Name": "اسم المنصة العرض",
            "Enter Platform Display Name": "أدخل اسم المنصة العرض",
            "Platform Legal Name": "اسم المنصة قانوني",
            "Enter Platform Legal Name": "أدخل اسم المنصة قانوني",
            "Operating Country": "التشغيل الدولة",
            "Enter Operating Country": "أدخل التشغيل الدولة",
            "Operating Country Locked USA": "دولة التشغيل مقفلة على الولايات المتحدة",
            "Enter Operating Country Locked USA": "أدخل دولة التشغيل مقفلة على الولايات المتحدة",
            "Default Currency": "الافتراضي العملة",
            "Enter Default Currency": "أدخل الافتراضي العملة",
            "ACH Enabled": "تمكين ACH",
            "Enter ACH Enabled": "حدّد حالة تمكين ACH",
            "Wire Enabled": "تمكين التحويل البنكي",
            "Enter Wire Enabled": "حدّد حالة تمكين التحويل البنكي",
            "Card Enabled": "تمكين البطاقة",
            "Enter Card Enabled": "حدّد حالة تمكين البطاقة",
            "Crypto Payments Enabled": "تمكين العملات المشفرة المدفوعات",
            "Enter Crypto Payments Enabled": "حدّد حالة تمكين العملات المشفرة المدفوعات",
            "Primary Regulatory Position": "الوضع التنظيمي الأساسي",
            "Enter Primary Regulatory Position": "أدخل الوضع التنظيمي الأساسي",
            "Default Offering Model": "نموذج الطرح الافتراضي",
            "Enter Default Offering Model": "أدخل نموذج الطرح الافتراضي",
            "Requires KYC AML": "يتطلب KYC وAML",
            "Enter Requires KYC AML": "حدّد حالة اشتراط KYC وAML",
            "Requires Investor Eligibility Check": "يتطلب فحص أهلية المستثمر",
            "Enter Requires Investor Eligibility Check": "حدّد حالة اشتراط فحص أهلية المستثمر",
            "Requires Transfer Restrictions": "يتطلب قيود التحويل",
            "Enter Requires Transfer Restrictions": "حدّد حالة اشتراط قيود التحويل",
            "Platform Status": "حالة المنصة",
            "Enter Platform Status": "أدخل حالة المنصة",
            "Platform Notes": "ملاحظات المنصة",
            "Enter Platform Notes": "أدخل ملاحظات المنصة",
            "Record Status": "حالة السجل",
            "Enter Record Status": "أدخل حالة السجل",
            "Created By": "تم الإنشاء بواسطة",
            "Enter Created By": "أدخل تم الإنشاء بواسطة",
            "Created At": "تم الإنشاء في",
            "Enter Created At": "أدخل تم الإنشاء في",
            "Updated By": "تم التحديث بواسطة",
            "Enter Updated By": "أدخل تم التحديث بواسطة",
            "Updated At": "تم التحديث في",
            "Enter Updated At": "أدخل تم التحديث في",
            "Core_Token_Type_Definition": "تعريف نوع الرمز الأساسي",
            "CORE_TOKEN_TYPE_DEFINITION": "تعريف نوع الرمز الأساسي",
            "Core Token Type Definition": "تعريف نوع الرمز الأساسي",
            "Select Core Token Type Definition": "اختر تعريف نوع الرمز الأساسي",
            "Print of Core Token Type Definition": "طباعة تعريف نوع الرمز الأساسي",
            "Token Type ID": "معرّف نوع الرمز",
            "Enter Token Type ID": "أدخل معرّف نوع الرمز",
            "Token Type Code": "رمز نوع الرمز",
            "Enter Token Type Code": "أدخل رمز نوع الرمز",
            "Token Type Name": "اسم نوع الرمز",
            "Enter Token Type Name": "أدخل اسم نوع الرمز",
            "Token Type Module": "الرمز النوع الوحدة",
            "Enter Token Type Module": "أدخل الرمز النوع الوحدة",
            "Economic Model Category": "فئة النموذج الاقتصادي",
            "Enter Economic Model Category": "أدخل فئة النموذج الاقتصادي",
            "Is Rental Based": "هل الإيجار قائم على",
            "Enter Is Rental Based": "حدّد ما إذا كان الإيجار قائم على",
            "Is Revenue Based": "هل الإيرادات قائم على",
            "Enter Is Revenue Based": "حدّد ما إذا كان الإيرادات قائم على",
            "Is Ownership Based": "هل الملكية قائم على",
            "Enter Is Ownership Based": "حدّد ما إذا كان الملكية قائم على",
            "Is Debt Based": "هل الدين قائم على",
            "Enter Is Debt Based": "حدّد ما إذا كان الدين قائم على",
            "Is Hybrid": "هل هجين",
            "Enter Is Hybrid": "حدّد ما إذا كان هجين",
            "Default Risk Level": "الافتراضي مستوى المخاطر",
            "Enter Default Risk Level": "أدخل الافتراضي مستوى المخاطر",
            "Default Distribution Source": "الافتراضي مصدر التوزيع",
            "Enter Default Distribution Source": "أدخل الافتراضي مصدر التوزيع",
            "Description": "الوصف",
            "Enter Description": "أدخل الوصف",
            "Core_Token_Economic_Model_Master": "السجل الرئيسي للنموذج الاقتصادي الأساسي للرمز",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "السجل الرئيسي للنموذج الاقتصادي الأساسي للرمز",
            "Core Token Economic Model Master": "السجل الرئيسي للنموذج الاقتصادي الأساسي للرمز",
            "Select Core Token Economic Model Master": "اختر السجل الرئيسي للنموذج الاقتصادي الأساسي للرمز",
            "Print of Core Token Economic Model Master": "طباعة السجل الرئيسي للنموذج الاقتصادي الأساسي للرمز",
            "Token Economic Model ID": "معرّف الرمز اقتصادي النموذج",
            "Enter Token Economic Model ID": "أدخل معرّف الرمز اقتصادي النموذج",
            "Token Economic Model": "الرمز اقتصادي النموذج",
            "Enter Token Economic Model": "أدخل الرمز اقتصادي النموذج",
            "Token Ownership Model": "الرمز الملكية النموذج",
            "Enter Token Ownership Model": "أدخل الرمز الملكية النموذج",
            "Distribution Source": "مصدر التوزيع",
            "Enter Distribution Source": "أدخل مصدر التوزيع",
            "Rental Income Allocation Allowed": "دخل الإيجار - السماح بـ التخصيص",
            "Enter Rental Income Allocation Allowed": "حدّد حالة السماح بـ تخصيص دخل الإيجار",
            "Sale Profit Allocation Allowed": "ربح البيع - السماح بـ التخصيص",
            "Enter Sale Profit Allocation Allowed": "حدّد حالة السماح بـ تخصيص ربح البيع",
            "Equity Appreciation Allocation Allowed": "ارتفاع قيمة حقوق الملكية - السماح بـ التخصيص",
            "Enter Equity Appreciation Allocation Allowed": "حدّد حالة السماح بـ تخصيص ارتفاع قيمة حقوق الملكية",
            "Debt Interest Allowed": "السماح بـ فائدة الدين",
            "Enter Debt Interest Allowed": "حدّد حالة السماح بـ فائدة الدين",
            "Preferred Return Allowed": "السماح بـ العائد المفضل",
            "Enter Preferred Return Allowed": "حدّد حالة السماح بـ العائد المفضل",
            "Profit Split Allowed": "السماح بـ تقسيم الأرباح",
            "Enter Profit Split Allowed": "حدّد حالة السماح بـ تقسيم الأرباح",
            "Ownership Percentage Allowed": "السماح بـ نسبة الملكية",
            "Enter Ownership Percentage Allowed": "حدّد حالة السماح بـ نسبة الملكية",
            "NAV Based Valuation Required": "التقييم القائم على NAV مطلوب",
            "Enter NAV Based Valuation Required": "حدّد حالة اشتراط التقييم القائم على NAV",
            "Investor Disclosure Template Link": "رابط قالب إفصاح المستثمر",
            "Enter Investor Disclosure Template Link": "أدخل رابط قالب إفصاح المستثمر",
            "Core_Risk_Color_Matrix": "النواة الأساسية - مصفوفة ألوان المخاطر",
            "CORE_RISK_COLOR_MATRIX": "النواة الأساسية - مصفوفة ألوان المخاطر",
            "Risk Color Matrix": "مصفوفة ألوان المخاطر",
            "Select Risk Color Matrix": "اختر مصفوفة ألوان المخاطر",
            "Print of Risk Color Matrix": "طباعة مصفوفة ألوان المخاطر",
            "Risk Color ID": "معرّف لون المخاطر",
            "Enter Risk Color ID": "أدخل معرّف لون المخاطر",
            "Risk Level Name": "اسم مستوى المخاطر",
            "Enter Risk Level Name": "أدخل اسم مستوى المخاطر",
            "Risk Percentage From": "نسبة المخاطر من",
            "Enter Risk Percentage From": "أدخل نسبة المخاطر من",
            "Risk Percentage To": "نسبة المخاطر إلى",
            "Enter Risk Percentage To": "أدخل نسبة المخاطر إلى",
            "Risk Color Name": "اسم لون المخاطر",
            "Enter Risk Color Name": "أدخل اسم لون المخاطر",
            "Risk Color Hex": "لون المخاطر السداسي",
            "Enter Risk Color Hex": "أدخل لون المخاطر السداسي",
            "Display Order": "العرض الترتيب",
            "Enter Display Order": "أدخل العرض الترتيب",
            "Investor Warning Text": "نص تحذير المستثمر",
            "Enter Investor Warning Text": "أدخل نص تحذير المستثمر",
            "Requires Extra Acknowledgment": "يتطلب إقرار إضافي",
            "Enter Requires Extra Acknowledgment": "حدّد حالة اشتراط إقرار إضافي",
            "Default Action": "الإجراء الافتراضي",
            "Enter Default Action": "أدخل الإجراء الافتراضي",
            "Platform_Module_Config": "إعداد المنصة الوحدة",
            "PLATFORM_MODULE_CONFIG": "المنصة إعداد الوحدة",
            "Platform Module Configuration": "إعدادات وحدات المنصة",
            "Select Platform Module Configuration": "اختر إعدادات وحدات المنصة",
            "Print of Platform Module Configuration": "طباعة إعدادات وحدات المنصة",
            "Module Config ID": "معرّف إعداد الوحدة",
            "Enter Module Config ID": "أدخل معرّف إعداد الوحدة",
            "Module Code": "رمز الوحدة",
            "Enter Module Code": "أدخل رمز الوحدة",
            "Module Name": "اسم الوحدة",
            "Enter Module Name": "أدخل اسم الوحدة",
            "Module Category": "فئة الوحدة",
            "Enter Module Category": "أدخل فئة الوحدة",
            "Enabled": "مُمكّن",
            "Enter Enabled": "حدّد حالة تمكين ",
            "Applies to Rental Income Token": "ينطبق على دخل الإيجار - الرمز",
            "Applies To RENT INCOME TOKEN": "ينطبق على الإيجار الدخل الرمز",
            "Enter Applies To RENT INCOME TOKEN": "أدخل ينطبق على الإيجار الدخل الرمز",
            "Applies To REVENUE SHARE TOKEN": "ينطبق على مشاركة الإيرادات - الرمز",
            "Enter Applies To REVENUE SHARE TOKEN": "أدخل ينطبق على مشاركة الإيرادات - الرمز",
            "Applies To SALE PROFIT TOKEN": "ينطبق على ربح البيع - الرمز",
            "Enter Applies To SALE PROFIT TOKEN": "أدخل ينطبق على ربح البيع - الرمز",
            "Applies To EQUITY APPRECIATION TOKEN": "ينطبق على ارتفاع قيمة حقوق الملكية - الرمز",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "أدخل ينطبق على ارتفاع قيمة حقوق الملكية - الرمز",
            "Applies to Preferred Equity Token": "ينطبق على حقوق الملكية الممتازة - الرمز",
            "Applies To PREFERRED EQUITY TOKEN": "ينطبق على حقوق الملكية الممتازة - الرمز",
            "Enter Applies To PREFERRED EQUITY TOKEN": "أدخل ينطبق على حقوق الملكية الممتازة - الرمز",
            "Applies To COMMON EQUITY TOKEN": "ينطبق على حقوق الملكية العادية - الرمز",
            "Enter Applies To COMMON EQUITY TOKEN": "أدخل ينطبق على حقوق الملكية العادية - الرمز",
            "Applies To DEBT NOTE TOKEN": "ينطبق على سند الدين - الرمز",
            "Enter Applies To DEBT NOTE TOKEN": "أدخل ينطبق على سند الدين - الرمز",
            "Applies To HYBRID TOKEN": "ينطبق على الهجين - الرمز",
            "Enter Applies To HYBRID TOKEN": "أدخل ينطبق على الهجين - الرمز",
            "Applies To PRE AUCTION POOL TOKEN": "ينطبق على قبل المزاد المجمع الرمز",
            "Enter Applies To PRE AUCTION POOL TOKEN": "أدخل ينطبق على قبل المزاد المجمع الرمز",
            "Applies To POST AUCTION TOKENIZATION": "ينطبق على بعد المزاد الترميز",
            "Enter Applies To POST AUCTION TOKENIZATION": "أدخل ينطبق على بعد المزاد الترميز",
            "Requires Admin Approval": "يتطلب اعتماد المسؤول",
            "Enter Requires Admin Approval": "حدّد حالة اشتراط اعتماد المسؤول",
            "Requires Compliance Approval": "يتطلب اعتماد الامتثال",
            "Enter Requires Compliance Approval": "حدّد حالة اشتراط اعتماد الامتثال",
            "Workflow_Definition": "تعريف سير العمل",
            "WORKFLOW_DEFINITION": "تعريف سير العمل",
            "Workflow Definition": "تعريف سير العمل",
            "Select Workflow Definition": "اختر تعريف سير العمل",
            "Print of Workflow Definition": "طباعة تعريف سير العمل",
            "Workflow ID": "معرّف سير العمل",
            "Enter Workflow ID": "أدخل معرّف سير العمل",
            "Workflow Code": "رمز سير العمل",
            "Enter Workflow Code": "أدخل رمز سير العمل",
            "Workflow Name": "اسم سير العمل",
            "Enter Workflow Name": "أدخل اسم سير العمل",
            "Workflow Category": "فئة سير العمل",
            "Enter Workflow Category": "أدخل فئة سير العمل",
            "Start Event": "حدث البدء",
            "Enter Start Event": "أدخل حدث البدء",
            "End Event": "حدث الانتهاء",
            "Enter End Event": "أدخل حدث الانتهاء",
            "SLA Days": "أيام SLA",
            "Enter SLA Days": "أدخل أيام SLA",
            "Requires Escrow": "يتطلب حساب الضمان",
            "Enter Requires Escrow": "حدّد حالة اشتراط حساب الضمان",
            "Requires SPV": "يتطلب SPV",
            "Enter Requires SPV": "حدّد حالة اشتراط SPV",
            "Requires Inspector": "يتطلب المفتش",
            "Enter Requires Inspector": "حدّد حالة اشتراط المفتش",
            "Requires Investor Report": "يتطلب تقرير المستثمر",
            "Enter Requires Investor Report": "حدّد حالة اشتراط تقرير المستثمر",
            "Workflow Status": "حالة سير العمل",
            "Enter Workflow Status": "أدخل حالة سير العمل",
            "Workflow Notes": "ملاحظات سير العمل",
            "Enter Workflow Notes": "أدخل ملاحظات سير العمل",
            "Workflow_Step_Definition": "تعريف خطوة سير العمل",
            "WORKFLOW_STEP_DEFINITION": "تعريف خطوة سير العمل",
            "Workflow Step Definition": "تعريف خطوة سير العمل",
            "Select Workflow Step Definition": "اختر تعريف خطوة سير العمل",
            "Print of Workflow Step Definition": "طباعة تعريف خطوة سير العمل",
            "Workflow Step ID": "معرّف خطوة سير العمل",
            "Enter Workflow Step ID": "أدخل معرّف خطوة سير العمل",
            "Step Number": "رقم الخطوة",
            "Enter Step Number": "أدخل رقم الخطوة",
            "Step Name": "اسم الخطوة",
            "Enter Step Name": "أدخل اسم الخطوة",
            "Step I/O Mapping Type": "نوع تعيين مدخلات/مخرجات الخطوة",
            "Step IO Mapping Type": "نوع تعيين مدخلات/مخرجات الخطوة",
            "Enter Step IO Mapping Type": "أدخل نوع تعيين مدخلات/مخرجات الخطوة",
            "Responsible Stakeholder Type": "نوع صاحب المصلحة المسؤول",
            "Enter Responsible Stakeholder Type": "أدخل نوع صاحب المصلحة المسؤول",
            "Responsible Role": "الدور المسؤول",
            "Enter Responsible Role": "أدخل الدور المسؤول",
            "Input Form Table": "جدول نموذج الإدخال",
            "Enter Input Form Table": "أدخل جدول نموذج الإدخال",
            "Output Form Table": "جدول نموذج الإخراج",
            "Enter Output Form Table": "أدخل جدول نموذج الإخراج",
            "Approval Rule Type": "نوع قاعدة الاعتماد",
            "Enter Approval Rule Type": "أدخل نوع قاعدة الاعتماد",
            "Approval Form Table": "جدول نموذج الاعتماد",
            "Enter Approval Form Table": "أدخل جدول نموذج الاعتماد",
            "Can Reject": "يمكنه الرفض",
            "Enter Can Reject": "حدّد إمكانية الرفض",
            "Can Request Revision": "يمكنه طلب المراجعة",
            "Enter Can Request Revision": "حدّد إمكانية الطلب المراجعة",
            "Blocks Next Step": "يحجب الخطوة التالية",
            "Enter Blocks Next Step": "أدخل يحجب الخطوة التالية",
            "Step SLA Days": "أيام SLA للخطوة",
            "Enter Step SLA Days": "أدخل أيام SLA للخطوة",
            "Escalation Role": "دور التصعيد",
            "Enter Escalation Role": "أدخل دور التصعيد",
            "User_Account": "حساب المستخدم",
            "USER_ACCOUNT": "حساب المستخدم",
            "User Account": "حساب المستخدم",
            "Select User Account": "اختر حساب المستخدم",
            "Print of User Account": "طباعة حساب المستخدم",
            "User ID": "معرّف المستخدم",
            "Enter User ID": "أدخل معرّف المستخدم",
            "Email": "البريد الإلكتروني",
            "Enter Email": "أدخل البريد الإلكتروني",
            "Phone": "الهاتف",
            "Enter Phone": "أدخل الهاتف",
            "First Name": "الاسم الأول",
            "Enter First Name": "أدخل الاسم الأول",
            "Middle Name": "الاسم الأوسط",
            "Enter Middle Name": "أدخل الاسم الأوسط",
            "Last Name": "اسم العائلة",
            "Enter Last Name": "أدخل اسم العائلة",
            "User Type": "نوع المستخدم",
            "Enter User Type": "أدخل نوع المستخدم",
            "Account Status": "حالة الحساب",
            "Enter Account Status": "أدخل حالة الحساب",
            "MFA Enabled": "تمكين MFA",
            "Enter MFA Enabled": "حدّد حالة تمكين MFA",
            "Last Login At": "وقت آخر تسجيل دخول",
            "Enter Last Login At": "أدخل وقت آخر تسجيل دخول",
            "Terms Accepted At": "وقت قبول الشروط",
            "Enter Terms Accepted At": "أدخل وقت قبول الشروط",
            "Role_Definition": "تعريف الدور",
            "ROLE_DEFINITION": "تعريف الدور",
            "Role Definition": "تعريف الدور",
            "Select Role Definition": "اختر تعريف الدور",
            "Print of Role Definition": "طباعة تعريف الدور",
            "Role ID": "معرّف الدور",
            "Enter Role ID": "أدخل معرّف الدور",
            "Role Code": "رمز الدور",
            "Enter Role Code": "أدخل رمز الدور",
            "Role Name": "اسم الدور",
            "Enter Role Name": "أدخل اسم الدور",
            "Role Category": "فئة الدور",
            "Enter Role Category": "أدخل فئة الدور",
            "Is Internal Admin": "هل مسؤول داخلي",
            "Enter Is Internal Admin": "حدّد ما إذا كان مسؤول داخلي",
            "Is External Stakeholder": "هل صاحب مصلحة خارجي",
            "Enter Is External Stakeholder": "حدّد ما إذا كان صاحب مصلحة خارجي",
            "Can Approve": "يمكن اعتماد",
            "Enter Can Approve": "حدّد إمكانية اعتماد",
            "Can Submit": "يمكن إرسال",
            "Enter Can Submit": "حدّد إمكانية إرسال",
            "Can View Investor Data": "يمكن عرض بيانات المستثمر",
            "Enter Can View Investor Data": "حدّد إمكانية عرض بيانات المستثمر",
            "User_Role_Assignment": "تعيين دور المستخدم",
            "USER_ROLE_ASSIGNMENT": "تعيين دور المستخدم",
            "User Role Assignment": "تعيين دور المستخدم",
            "Select User Role Assignment": "اختر تعيين دور المستخدم",
            "Print of User Role Assignment": "طباعة تعيين دور المستخدم",
            "User Role ID": "معرّف دور المستخدم",
            "Enter User Role ID": "أدخل معرّف دور المستخدم",
            "Scope Type": "نوع النطاق",
            "Enter Scope Type": "أدخل نوع النطاق",
            "Asset ID": "معرّف الأصل",
            "Enter Asset ID": "أدخل معرّف الأصل",
            "Offering ID": "معرّف الطرح",
            "Enter Offering ID": "أدخل معرّف الطرح",
            "Organization ID": "معرّف المؤسسة",
            "Enter Organization ID": "أدخل معرّف المؤسسة",
            "Effective From": "ساري من",
            "Enter Effective From": "أدخل ساري من",
            "Effective To": "ساري حتى",
            "Enter Effective To": "أدخل ساري حتى",
            "Active": "نشط",
            "Enter Active": "أدخل نشط",
            "System_Code_List": "قائمة رموز النظام",
            "SYSTEM_CODE_LIST": "قائمة رموز النظام",
            "System Code List": "قائمة رموز النظام",
            "Select System Code List": "اختر قائمة رموز النظام",
            "Print of System Code List": "طباعة قائمة رموز النظام",
            "Code List ID": "معرّف قائمة الرموز",
            "Enter Code List ID": "أدخل معرّف قائمة الرموز",
            "Code Group": "مجموعة الرموز",
            "Enter Code Group": "أدخل مجموعة الرموز",
            "Code Value": "قيمة الرمز",
            "Enter Code Value": "أدخل قيمة الرمز",
            "Code Label": "تسمية الرمز",
            "Enter Code Label": "أدخل تسمية الرمز",
            "Parent Code Value": "قيمة الرمز الأصل",
            "Enter Parent Code Value": "أدخل قيمة الرمز الأصل",
            "02 Organization Stakeholder Onboarding": "النواة الأساسية للمنصة، 02 تهيئة المؤسسة وأصحاب المصلحة",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "النواة الأساسية للمنصة، 02 تهيئة المؤسسة وأصحاب المصلحة",
            "Organization_Profile": "ملف المؤسسة",
            "ORGANIZATION_PROFILE": "ملف المؤسسة",
            "Organization Profile": "ملف المؤسسة",
            "Select Organization Profile": "اختر ملف المؤسسة",
            "Print of Organization Profile": "طباعة ملف المؤسسة",
            "Organization Type": "نوع المؤسسة",
            "Enter Organization Type": "أدخل نوع المؤسسة",
            "Legal Name": "الاسم القانوني",
            "Enter Legal Name": "أدخل الاسم القانوني",
            "DBA Name": "الاسم التجاري DBA",
            "Enter DBA Name": "أدخل الاسم التجاري DBA",
            "EIN Masked": "EIN مخفي جزئياً",
            "Enter EIN Masked": "أدخل EIN مخفي جزئياً",
            "Formation State": "ولاية التأسيس",
            "Enter Formation State": "أدخل ولاية التأسيس",
            "Website": "الموقع الإلكتروني",
            "Enter Website": "أدخل الموقع",
            "Primary Contact Name": "اسم جهة الاتصال الرئيسية",
            "Enter Primary Contact Name": "أدخل اسم جهة الاتصال الرئيسية",
            "Primary Contact Email": "البريد الإلكتروني لجهة الاتصال الرئيسية",
            "Enter Primary Contact Email": "أدخل البريد الإلكتروني لجهة الاتصال الرئيسية",
            "Verification Status": "حالة التحقق",
            "Enter Verification Status": "أدخل حالة التحقق",
            "Stakeholder_Profile": "ملف صاحب المصلحة",
            "STAKEHOLDER_PROFILE": "ملف صاحب المصلحة",
            "Stakeholder Profile": "ملف صاحب المصلحة",
            "Select Stakeholder Profile": "اختر ملف صاحب المصلحة",
            "Print of Stakeholder Profile": "طباعة ملف صاحب المصلحة",
            "Stakeholder ID": "معرّف صاحب المصلحة",
            "Enter Stakeholder ID": "أدخل معرّف صاحب المصلحة",
            "Stakeholder Type": "نوع صاحب المصلحة",
            "Enter Stakeholder Type": "أدخل نوع صاحب المصلحة",
            "Contact Name": "اسم جهة الاتصال",
            "Enter Contact Name": "أدخل اسم جهة الاتصال",
            "Contact Email": "البريد الإلكتروني لجهة الاتصال",
            "Enter Contact Email": "أدخل البريد الإلكتروني لجهة الاتصال",
            "Contact Phone": "هاتف جهة الاتصال",
            "Enter Contact Phone": "أدخل هاتف جهة الاتصال",
            "License Number": "رقم الترخيص",
            "Enter License Number": "أدخل رقم الترخيص",
            "License State": "ولاية الترخيص",
            "Enter License State": "أدخل ولاية الترخيص",
            "License Expiry Date": "تاريخ انتهاء الترخيص",
            "Enter License Expiry Date": "أدخل تاريخ انتهاء الترخيص",
            "Professional Insurance Status": "حالة التأمين المهني",
            "Enter Professional Insurance Status": "أدخل حالة التأمين المهني",
            "KYC / KYB Status": "حالة KYC وKYB",
            "KYC KYB Status": "حالة KYC وKYB",
            "Enter KYC KYB Status": "أدخل حالة KYC وKYB",
            "Background Check Status": "حالة فحص الخلفية",
            "Enter Background Check Status": "أدخل حالة فحص الخلفية",
            "Conflict Of Interest Flag": "مؤشر تضارب المصالح",
            "Enter Conflict Of Interest Flag": "أدخل مؤشر تضارب المصالح",
            "Approved for Platform": "معتمد للمنصة",
            "Approved For Platform": "معتمد للمنصة",
            "Enter Approved For Platform": "أدخل معتمد للمنصة",
            "Approval Notes": "ملاحظات الاعتماد",
            "Enter Approval Notes": "أدخل ملاحظات الاعتماد",
            "03 Investor Onboarding Compliance": "النواة الأساسية للمنصة، 03 تأهيل المستثمر والامتثال",
            "03 INVESTOR ONBOARDING COMPLIANCE": "النواة الأساسية للمنصة، 03 تأهيل المستثمر والامتثال",
            "Investor_Profile": "ملف المستثمر",
            "INVESTOR_PROFILE": "ملف المستثمر",
            "Investor Profile": "ملف المستثمر",
            "Select Investor Profile": "اختر ملف المستثمر",
            "Print of Investor Profile": "طباعة ملف المستثمر",
            "Investor ID": "معرّف المستثمر",
            "Enter Investor ID": "أدخل معرّف المستثمر",
            "Investor Type": "نوع المستثمر",
            "Enter Investor Type": "أدخل نوع المستثمر",
            "Residency State": "ولاية الإقامة",
            "Enter Residency State": "أدخل ولاية الإقامة",
            "US Tax Resident": "مقيم ضريبياً في الولايات المتحدة",
            "Enter US Tax Resident": "أدخل مقيم ضريبياً في الولايات المتحدة",
            "Date of Birth": "تاريخ الميلاد",
            "Date Of Birth": "تاريخ الميلاد",
            "Enter Date Of Birth": "أدخل تاريخ الميلاد",
            "SSN Last4": "آخر 4 أرقام من SSN",
            "Enter SSN Last4": "أدخل آخر 4 أرقام من SSN",
            "Tax ID Type": "نوع المعرّف الضريبي",
            "Enter Tax ID Type": "أدخل نوع المعرّف الضريبي",
            "Annual Income Range": "نطاق الدخل السنوي",
            "Enter Annual Income Range": "أدخل نطاق الدخل السنوي",
            "Net Worth Range": "نطاق صافي الثروة",
            "Enter Net Worth Range": "أدخل نطاق صافي الثروة",
            "Investment Objective": "هدف الاستثمار",
            "Enter Investment Objective": "أدخل هدف الاستثمار",
            "Risk Tolerance": "تحمل المخاطر",
            "Enter Risk Tolerance": "أدخل تحمل المخاطر",
            "Liquidity Need": "الحاجة إلى السيولة",
            "Enter Liquidity Need": "أدخل الحاجة إلى السيولة",
            "Investor Status": "حالة المستثمر",
            "Enter Investor Status": "أدخل حالة المستثمر",
            "Investor_KYC_AML_Check": "فحص KYC وAML للمستثمر",
            "INVESTOR_KYC_AML_CHECK": "فحص KYC وAML للمستثمر",
            "Investor KYC AML Check": "فحص KYC وAML للمستثمر",
            "Select Investor KYC AML Check": "اختر فحص KYC وAML للمستثمر",
            "Print of Investor KYC AML Check": "طباعة فحص KYC وAML للمستثمر",
            "KYC / AML Check ID": "معرّف KYC وAML الفحص",
            "KYC AML Check ID": "معرّف فحص KYC وAML",
            "Enter KYC AML Check ID": "أدخل معرّف فحص KYC وAML",
            "KYC Provider": "مزود KYC",
            "Enter KYC Provider": "أدخل مزود KYC",
            "Provider Reference ID": "معرّف مرجع المزود",
            "Enter Provider Reference ID": "أدخل معرّف مرجع المزود",
            "Identity Status": "حالة الهوية",
            "Enter Identity Status": "أدخل حالة الهوية",
            "Address Status": "حالة العنوان",
            "Enter Address Status": "أدخل حالة العنوان",
            "Document Type": "نوع المستند",
            "Enter Document Type": "أدخل نوع المستند",
            "KYC Result": "نتيجة KYC",
            "Enter KYC Result": "أدخل نتيجة KYC",
            "Sanctions Status": "حالة العقوبات",
            "Enter Sanctions Status": "أدخل حالة العقوبات",
            "PEP Status": "حالة PEP",
            "Enter PEP Status": "أدخل حالة PEP",
            "AML Status": "حالة AML",
            "Enter AML Status": "أدخل حالة AML",
            "Manual Review Required": "مراجعة يدوية مطلوبة",
            "Enter Manual Review Required": "حدّد حالة اشتراط يدوي المراجعة",
            "Manual Review Notes": "ملاحظات المراجعة اليدوية",
            "Enter Manual Review Notes": "أدخل ملاحظات المراجعة اليدوية",
            "Investor_Accreditation_Verification": "التحقق من اعتماد المستثمر",
            "INVESTOR_ACCREDITATION_VERIFICATION": "التحقق من اعتماد المستثمر",
            "Investor Accreditation Verification": "التحقق من اعتماد المستثمر",
            "Select Investor Accreditation Verification": "اختر التحقق من اعتماد المستثمر",
            "Print of Investor Accreditation Verification": "طباعة التحقق من اعتماد المستثمر",
            "Accreditation ID": "معرّف الاعتماد",
            "Enter Accreditation ID": "أدخل معرّف الاعتماد",
            "Accreditation Status": "حالة الاعتماد",
            "Enter Accreditation Status": "أدخل حالة الاعتماد",
            "Verification Method": "طريقة التحقق",
            "Enter Verification Method": "أدخل طريقة التحقق",
            "Verifier Name": "اسم المتحقق",
            "Enter Verifier Name": "أدخل اسم المتحقق",
            "Verifier Type": "نوع المتحقق",
            "Enter Verifier Type": "أدخل نوع المتحقق",
            "Verification Document Link": "رابط مستند التحقق",
            "Enter Verification Document Link": "أدخل رابط مستند التحقق",
            "Effective Date": "تاريخ السريان",
            "Enter Effective Date": "أدخل تاريخ السريان",
            "Expiry Date": "تاريخ الانتهاء",
            "Enter Expiry Date": "أدخل تاريخ الانتهاء",
            "Review Status": "حالة المراجعة",
            "Enter Review Status": "أدخل حالة المراجعة",
            "Investor_Bank_Account": "الحساب المصرفي للمستثمر",
            "INVESTOR_BANK_ACCOUNT": "الحساب المصرفي للمستثمر",
            "Investor Bank Account": "الحساب المصرفي للمستثمر",
            "Select Investor Bank Account": "اختر الحساب المصرفي للمستثمر",
            "Print of Investor Bank Account": "طباعة الحساب المصرفي للمستثمر",
            "Bank Account ID": "معرّف الحساب المصرفي",
            "Enter Bank Account ID": "أدخل معرّف الحساب المصرفي",
            "Account Nickname": "الاسم المختصر للحساب",
            "Enter Account Nickname": "أدخل الاسم المختصر للحساب",
            "Bank Name": "اسم البنك",
            "Enter Bank Name": "أدخل اسم البنك",
            "Routing Number Masked": "رقم التوجيه مخفي جزئياً",
            "Enter Routing Number Masked": "أدخل رقم التوجيه مخفي جزئياً",
            "Account Number Last4": "آخر 4 أرقام من رقم الحساب",
            "Enter Account Number Last4": "أدخل آخر 4 أرقام من رقم الحساب",
            "Account Type": "نوع الحساب",
            "Enter Account Type": "أدخل نوع الحساب",
            "ACH Verification Status": "حالة التحقق من ACH",
            "Enter ACH Verification Status": "أدخل حالة التحقق من ACH",
            "Default For Distributions": "الافتراضي للتوزيعات",
            "Enter Default For Distributions": "أدخل الافتراضي للتوزيعات",
            "Investor_Risk_Acknowledgment": "إقرار المستثمر بالمخاطر",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "إقرار المستثمر بالمخاطر",
            "Investor Risk Acknowledgment": "إقرار المستثمر بالمخاطر",
            "Select Investor Risk Acknowledgment": "اختر إقرار المستثمر بالمخاطر",
            "Print of Investor Risk Acknowledgment": "طباعة إقرار المستثمر بالمخاطر",
            "Risk Acknowledgment ID": "معرّف إقرار بالمخاطر",
            "Enter Risk Acknowledgment ID": "أدخل معرّف إقرار بالمخاطر",
            "Illiquidity Acknowledged": "تم الإقرار بمخاطر ضعف السيولة",
            "Enter Illiquidity Acknowledged": "حدّد حالة الإقرار بـ ضعف السيولة",
            "Loss Risk Acknowledged": "تم الإقرار بمخاطر الخسارة",
            "Enter Loss Risk Acknowledged": "حدّد حالة الإقرار بـ الخسارة المخاطر",
            "No Guaranteed Return Acknowledged": "تم الإقرار بعدم وجود عائد مضمون",
            "Enter No Guaranteed Return Acknowledged": "حدّد حالة الإقرار بـ لا مضمون العائد",
            "Transfer Restriction Acknowledged": "تم الإقرار بقيود التحويل",
            "Enter Transfer Restriction Acknowledged": "حدّد حالة الإقرار بـ التحويل القيد",
            "Construction Risk Acknowledged": "تم الإقرار بمخاطر الإنشاء",
            "Enter Construction Risk Acknowledged": "حدّد حالة الإقرار بـ الإنشاء المخاطر",
            "Auction Risk Acknowledged": "تم الإقرار بمخاطر المزاد",
            "Enter Auction Risk Acknowledged": "حدّد حالة الإقرار بـ المزاد المخاطر",
            "Acknowledged At": "وقت الإقرار",
            "Enter Acknowledged At": "أدخل وقت الإقرار",
            "Signature Hash": "بصمة التوقيع",
            "Enter Signature Hash": "أدخل بصمة التوقيع",
            "04 Asset SPV Due Diligence Legal": "النواة الأساسية للمنصة، 04 الأصل وSPV والعناية الواجبة والشؤون القانونية",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "النواة الأساسية للمنصة، 04 الأصل وSPV والعناية الواجبة والشؤون القانونية",
            "Core_Data_Room": "غرفة البيانات الأساسية",
            "CORE_DATA_ROOM": "غرفة البيانات الأساسية",
            "Core Data Room": "غرفة البيانات الأساسية",
            "Select Core Data Room": "اختر غرفة البيانات الأساسية",
            "Print of Core Data Room": "طباعة غرفة البيانات الأساسية",
            "Data Room ID": "معرّف غرفة البيانات",
            "Enter Data Room ID": "أدخل معرّف غرفة البيانات",
            "Data Room Name": "اسم غرفة البيانات",
            "Enter Data Room Name": "أدخل اسم غرفة البيانات",
            "Public Access Enabled": "تمكين الوصول العام",
            "Enter Public Access Enabled": "حدّد حالة تمكين عام الوصول",
            "Investor Access Enabled": "تمكين وصول المستثمر",
            "Enter Investor Access Enabled": "حدّد حالة تمكين المستثمر الوصول",
            "Compliance Access Enabled": "تمكين وصول الامتثال",
            "Enter Compliance Access Enabled": "حدّد حالة تمكين الامتثال الوصول",
            "Version Locking Enabled": "تمكين قفل الإصدار",
            "Enter Version Locking Enabled": "حدّد حالة تمكين الإصدار القفل",
            "Data Room Status": "حالة غرفة البيانات",
            "Enter Data Room Status": "أدخل حالة غرفة البيانات",
            "Notes": "الملاحظات",
            "Enter Notes": "أدخل الملاحظات",
            "Core_Data_Room_Document": "مستند غرفة البيانات الأساسية",
            "CORE_DATA_ROOM_DOCUMENT": "مستند غرفة البيانات الأساسية",
            "Core Data Room Document": "مستند غرفة البيانات الأساسية",
            "Select Core Data Room Document": "اختر مستند غرفة البيانات الأساسية",
            "Print of Core Data Room Document": "طباعة مستند غرفة البيانات الأساسية",
            "Document ID": "معرّف المستند",
            "Enter Document ID": "أدخل معرّف المستند",
            "Document Category": "فئة المستند",
            "Enter Document Category": "أدخل فئة المستند",
            "Document Title": "عنوان المستند",
            "Enter Document Title": "أدخل عنوان المستند",
            "Document Link": "رابط المستند",
            "Enter Document Link": "أدخل رابط المستند",
            "Version Number": "رقم الإصدار",
            "Enter Version Number": "أدخل رقم الإصدار",
            "Expiration Date": "تاريخ الانتهاء",
            "Enter Expiration Date": "أدخل تاريخ الانتهاء",
            "Document Rule Audience": "جمهور قاعدة المستند",
            "Enter Document Rule Audience": "أدخل جمهور قاعدة المستند",
            "Visibility Level": "مستوى الظهور",
            "Enter Visibility Level": "أدخل مستوى الظهور",
            "Required For Offering": "مطلوب للطرح",
            "Enter Required For Offering": "أدخل مطلوب للطرح",
            "Verified": "موثّق",
            "Enter Verified": "أدخل موثّق",
            "Core_Document_Verification": "التحقق الأساسي من المستند",
            "CORE_DOCUMENT_VERIFICATION": "التحقق الأساسي من المستند",
            "Core Document Verification": "التحقق الأساسي من المستند",
            "Select Core Document Verification": "اختر التحقق الأساسي من المستند",
            "Print of Core Document Verification": "طباعة التحقق الأساسي من المستند",
            "Document Verification ID": "معرّف التحقق من المستند",
            "Enter Document Verification ID": "أدخل معرّف التحقق من المستند",
            "Verifier Stakeholder Type": "نوع صاحب المصلحة المتحقق",
            "Enter Verifier Stakeholder Type": "أدخل نوع صاحب المصلحة المتحقق",
            "Verifier ID": "معرّف المتحقق",
            "Enter Verifier ID": "أدخل معرّف المتحقق",
            "Verification Issue Type": "نوع مشكلة التحقق",
            "Enter Verification Issue Type": "أدخل نوع مشكلة التحقق",
            "Deficiency Found": "تم العثور على نقص",
            "Enter Deficiency Found": "أدخل تم العثور على نقص",
            "Deficiency Description": "وصف النقص",
            "Enter Deficiency Description": "أدخل وصف النقص",
            "Corrective Action Required": "إجراء تصحيحي مطلوب",
            "Enter Corrective Action Required": "حدّد حالة اشتراط تصحيحي الإجراء",
            "Verified At": "وقت التحقق",
            "Enter Verified At": "أدخل وقت التحقق",
            "Core_Title_Search_Report": "تقرير البحث الأساسي في سند الملكية",
            "CORE_TITLE_SEARCH_REPORT": "تقرير البحث الأساسي في سند الملكية",
            "Core Title Search Report": "تقرير البحث الأساسي في سند الملكية",
            "Select Core Title Search Report": "اختر تقرير البحث الأساسي في سند الملكية",
            "Print of Core Title Search Report": "طباعة تقرير البحث الأساسي في سند الملكية",
            "Title Search ID": "معرّف البحث في سند الملكية",
            "Enter Title Search ID": "أدخل معرّف البحث في سند الملكية",
            "Title Company ID": "معرّف شركة سندات الملكية",
            "Enter Title Company ID": "أدخل معرّف شركة سندات الملكية",
            "Search Date": "تاريخ البحث",
            "Enter Search Date": "أدخل تاريخ البحث",
            "Vesting Owner": "المالك المسجّل",
            "Enter Vesting Owner": "أدخل المالك المسجّل",
            "Deed Type": "نوع سند الملكية",
            "Enter Deed Type": "أدخل نوع سند الملكية",
            "Lien Found": "تم العثور على رهن",
            "Enter Lien Found": "أدخل تم العثور على رهن",
            "Lien Count": "عدد الرهون",
            "Enter Lien Count": "أدخل عدد الرهون",
            "Lien Total USD": "إجمالي الرهون بالدولار الأمريكي",
            "Enter Lien Total USD": "أدخل إجمالي الرهون بالدولار الأمريكي",
            "Exception Count": "عدد الاستثناءات",
            "Enter Exception Count": "أدخل عدد الاستثناءات",
            "Title Search Report Link": "رابط تقرير البحث في سند الملكية",
            "Enter Title Search Report Link": "أدخل رابط تقرير البحث في سند الملكية",
            "Title Status": "حالة سند الملكية",
            "Enter Title Status": "أدخل حالة سند الملكية",
            "Core_Appraisal_Report": "تقرير التقييم الأساسي",
            "CORE_APPRAISAL_REPORT": "تقرير التقييم الأساسي",
            "Core Appraisal Report": "تقرير التقييم الأساسي",
            "Select Core Appraisal Report": "اختر تقرير التقييم الأساسي",
            "Print of Core Appraisal Report": "طباعة تقرير التقييم الأساسي",
            "Appraisal ID": "معرّف التقييم",
            "Enter Appraisal ID": "أدخل معرّف التقييم",
            "Appraiser ID": "معرّف المثمّن",
            "Enter Appraiser ID": "أدخل معرّف المثمّن",
            "Appraisal Date": "تاريخ التقييم",
            "Enter Appraisal Date": "أدخل تاريخ التقييم",
            "Appraised Value USD": "القيمة المقدّرة بالدولار الأمريكي",
            "Enter Appraised Value USD": "أدخل القيمة المقدّرة بالدولار الأمريكي",
            "Valuation Method": "طريقة التقييم",
            "Enter Valuation Method": "أدخل طريقة التقييم",
            "Cap Rate": "معدل الرسملة",
            "Enter Cap Rate": "أدخل معدل الرسملة",
            "NOI Used USD": "صافي الدخل التشغيلي المستخدم بالدولار الأمريكي",
            "Enter NOI Used USD": "أدخل صافي الدخل التشغيلي المستخدم بالدولار الأمريكي",
            "Comparable Count": "عدد المقارنة",
            "Enter Comparable Count": "أدخل عدد المقارنة",
            "Report Link": "رابط التقرير",
            "Enter Report Link": "أدخل رابط التقرير",
            "Reviewer Approval Status": "حالة اعتماد المراجع",
            "Enter Reviewer Approval Status": "أدخل حالة اعتماد المراجع",
            "Core_Due_Diligence_Checklist": "النواة الأساسية - قائمة تحقق العناية الواجبة",
            "CORE_DUE_DILIGENCE_CHECKLIST": "النواة الأساسية - العناية الواجبة قائمة التحقق",
            "Core Due Diligence Checklist": "النواة الأساسية - قائمة تحقق العناية الواجبة",
            "Select Core Due Diligence Checklist": "اختر النواة الأساسية - قائمة تحقق العناية الواجبة",
            "Print of Core Due Diligence Checklist": "طباعة النواة الأساسية - قائمة تحقق العناية الواجبة",
            "Due Diligence Checklist ID": "معرّف قائمة تحقق العناية الواجبة",
            "DD Checklist ID": "معرّف قائمة تحقق DD",
            "Enter DD Checklist ID": "أدخل معرّف قائمة تحقق DD",
            "Checklist Item Type": "نوع قائمة التحقق البند",
            "Enter Checklist Item Type": "أدخل نوع قائمة التحقق البند",
            "Title Complete": "سند الملكية مكتمل",
            "Enter Title Complete": "حدّد حالة اكتمال سند الملكية",
            "Appraisal Complete": "التقييم مكتمل",
            "Enter Appraisal Complete": "حدّد حالة اكتمال التقييم",
            "Environmental Complete": "بيئي مكتمل",
            "Enter Environmental Complete": "حدّد حالة اكتمال بيئي",
            "Zoning Complete": "التقسيم التنظيمي مكتمل",
            "Enter Zoning Complete": "حدّد حالة اكتمال التقسيم التنظيمي",
            "Survey Complete": "المسح مكتمل",
            "Enter Survey Complete": "حدّد حالة اكتمال المسح",
            "Insurance Complete": "التأمين مكتمل",
            "Enter Insurance Complete": "حدّد حالة اكتمال التأمين",
            "Tax Review Complete": "الضريبة المراجعة مكتمل",
            "Enter Tax Review Complete": "حدّد حالة اكتمال الضريبة المراجعة",
            "Legal Review Complete": "قانوني المراجعة مكتمل",
            "Enter Legal Review Complete": "حدّد حالة اكتمال قانوني المراجعة",
            "Open Deficiency Count": "عدد فتح النقص",
            "Enter Open Deficiency Count": "أدخل عدد فتح النقص",
            "DD Status": "حالة DD",
            "Enter DD Status": "أدخل حالة DD",
            "Core_Project_SPV": "النواة الأساسية - المشروع SPV",
            "CORE_PROJECT_SPV": "النواة الأساسية - المشروع SPV",
            "Core Project SPV": "النواة الأساسية - المشروع SPV",
            "Select Core Project SPV": "اختر النواة الأساسية - المشروع SPV",
            "Print of Core Project SPV": "طباعة النواة الأساسية - المشروع SPV",
            "SPV ID": "معرّف SPV",
            "Enter SPV ID": "أدخل معرّف SPV",
            "SPV Legal Name": "اسم SPV قانوني",
            "Enter SPV Legal Name": "أدخل اسم SPV قانوني",
            "SPV Type": "نوع SPV",
            "Enter SPV Type": "أدخل نوع SPV",
            "Registered Agent Name": "اسم مسجّل الوكيل",
            "Enter Registered Agent Name": "أدخل اسم مسجّل الوكيل",
            "Operating Agreement Link": "رابط اتفاقية التشغيل",
            "Enter Operating Agreement Link": "أدخل رابط اتفاقية التشغيل",
            "Liability Segregation Confirmed": "الالتزام الفصل مؤكد",
            "Enter Liability Segregation Confirmed": "أدخل الالتزام الفصل مؤكد",
            "SPV Status": "حالة SPV",
            "Enter SPV Status": "أدخل حالة SPV",
            "Core_Legal_Opinion": "النواة الأساسية - قانوني الرأي",
            "CORE_LEGAL_OPINION": "النواة الأساسية - قانوني الرأي",
            "Core Legal Opinion": "النواة الأساسية - قانوني الرأي",
            "Select Core Legal Opinion": "اختر النواة الأساسية - قانوني الرأي",
            "Print of Core Legal Opinion": "طباعة النواة الأساسية - قانوني الرأي",
            "Legal Opinion ID": "معرّف قانوني الرأي",
            "Enter Legal Opinion ID": "أدخل معرّف قانوني الرأي",
            "Legal Counsel ID": "معرّف قانوني المستشار القانوني",
            "Enter Legal Counsel ID": "أدخل معرّف قانوني المستشار القانوني",
            "Opinion Type": "نوع الرأي",
            "Enter Opinion Type": "أدخل نوع الرأي",
            "Securities Law Position": "الأوراق المالية القانون الوضع",
            "Enter Securities Law Position": "أدخل الأوراق المالية القانون الوضع",
            "Exemption Analysis": "الإعفاء التحليل",
            "Enter Exemption Analysis": "أدخل الإعفاء التحليل",
            "Risk Exceptions": "المخاطر الاستثناءات",
            "Enter Risk Exceptions": "أدخل المخاطر الاستثناءات",
            "Opinion Document Link": "رابط الرأي المستند",
            "Enter Opinion Document Link": "أدخل رابط الرأي المستند",
            "Opinion Status": "حالة الرأي",
            "Enter Opinion Status": "أدخل حالة الرأي",
            "05 Escrow Investor Protection Market": "النواة الأساسية للمنصة، 05 حساب الضمان وحماية المستثمر والسوق",
            "05 ESCROW INVESTOR PROTECTION MARKET": "النواة الأساسية للمنصة، 05 حساب الضمان وحماية المستثمر والسوق",
            "Core_Escrow_Account": "النواة الأساسية - حساب الضمان الحساب",
            "CORE_ESCROW_ACCOUNT": "النواة الأساسية - حساب الضمان الحساب",
            "Core Escrow Account": "النواة الأساسية - حساب الضمان الحساب",
            "Select Core Escrow Account": "اختر النواة الأساسية - حساب الضمان الحساب",
            "Print of Core Escrow Account": "طباعة النواة الأساسية - حساب الضمان الحساب",
            "Escrow Account ID": "معرّف حساب الضمان الحساب",
            "Enter Escrow Account ID": "أدخل معرّف حساب الضمان الحساب",
            "Escrow Agent ID": "معرّف حساب الضمان الوكيل",
            "Enter Escrow Agent ID": "أدخل معرّف حساب الضمان الوكيل",
            "Escrow Bank Name": "اسم حساب الضمان البنك",
            "Enter Escrow Bank Name": "أدخل اسم حساب الضمان البنك",
            "Escrow Account Last 4": "حساب الضمان الحساب الأخير 4",
            "Escrow Account Last4": "حساب الضمان الحساب الأخير4",
            "Enter Escrow Account Last4": "أدخل حساب الضمان الحساب الأخير4",
            "Escrow Agreement Link": "رابط اتفاقية حساب الضمان",
            "Enter Escrow Agreement Link": "أدخل رابط اتفاقية حساب الضمان",
            "Current Balance USD": "الحالي الرصيد بالدولار الأمريكي",
            "Enter Current Balance USD": "أدخل الحالي الرصيد بالدولار الأمريكي",
            "Funds Release Method": "طريقة الأموال الإفراج",
            "Enter Funds Release Method": "أدخل طريقة الأموال الإفراج",
            "Dual Approval Required": "اعتماد مزدوج مطلوب",
            "Enter Dual Approval Required": "حدّد حالة اشتراط اعتماد مزدوج",
            "Escrow Status": "حالة حساب الضمان",
            "Enter Escrow Status": "أدخل حالة حساب الضمان",
            "Core_Investor_Protection_Profile": "النواة الأساسية - ملف المستثمر الحماية",
            "CORE_INVESTOR_PROTECTION_PROFILE": "النواة الأساسية - المستثمر الحماية الملف",
            "Core Investor Protection Profile": "النواة الأساسية - ملف المستثمر الحماية",
            "Select Core Investor Protection Profile": "اختر النواة الأساسية - ملف المستثمر الحماية",
            "Print of Core Investor Protection Profile": "طباعة النواة الأساسية - ملف المستثمر الحماية",
            "Protection Profile ID": "معرّف ملف الحماية",
            "Enter Protection Profile ID": "أدخل معرّف ملف الحماية",
            "Protection Level": "مستوى الحماية",
            "Enter Protection Level": "أدخل مستوى الحماية",
            "Escrow Required": "حساب الضمان مطلوب",
            "Enter Escrow Required": "حدّد حالة اشتراط حساب الضمان",
            "Independent Inspection Required": "مستقل الفحص مطلوب",
            "Enter Independent Inspection Required": "حدّد حالة اشتراط مستقل الفحص",
            "Performance Bond Required": "الأداء السند مطلوب",
            "Enter Performance Bond Required": "حدّد حالة اشتراط الأداء السند",
            "Payment Bond Required": "الدفعة السند مطلوب",
            "Enter Payment Bond Required": "حدّد حالة اشتراط الدفعة السند",
            "Reserve Fund Required": "الاحتياطي الصندوق مطلوب",
            "Enter Reserve Fund Required": "حدّد حالة اشتراط الاحتياطي الصندوق",
            "Developer Guarantee Required": "المطور يضمن مطلوب",
            "Enter Developer Guarantee Required": "حدّد حالة اشتراط المطور يضمن",
            "Freeze Delist Rights": "التجميد إلغاء الإدراج الحقوق",
            "Enter Freeze Delist Rights": "أدخل التجميد إلغاء الإدراج الحقوق",
            "Investor Claim Process Link": "رابط المستثمر المطالبة الإجراء",
            "Enter Investor Claim Process Link": "أدخل رابط المستثمر المطالبة الإجراء",
            "Core_Secondary_Market_Config": "النواة الأساسية - إعداد ثانوي السوق",
            "CORE_SECONDARY_MARKET_CONFIG": "النواة الأساسية - ثانوي السوق الإعداد",
            "Core Secondary Market Config": "النواة الأساسية - إعداد ثانوي السوق",
            "Select Core Secondary Market Config": "اختر النواة الأساسية - إعداد ثانوي السوق",
            "Print of Core Secondary Market Config": "طباعة النواة الأساسية - إعداد ثانوي السوق",
            "Secondary Market Config ID": "معرّف إعداد ثانوي السوق",
            "Enter Secondary Market Config ID": "أدخل معرّف إعداد ثانوي السوق",
            "Secondary Trading Enabled": "تمكين ثانوي التداول",
            "Enter Secondary Trading Enabled": "حدّد حالة تمكين ثانوي التداول",
            "Requires ATS": "يتطلب ATS",
            "Enter Requires ATS": "حدّد حالة اشتراط ATS",
            "ATS Partner ID": "معرّف ATS الشريك",
            "Enter ATS Partner ID": "أدخل معرّف ATS الشريك",
            "Transfer Agent ID": "معرّف وكيل التحويل",
            "Enter Transfer Agent ID": "أدخل معرّف وكيل التحويل",
            "Minimum Holding Period Days": "الحد الأدنى الحيازة الفترة الأيام",
            "Enter Minimum Holding Period Days": "أدخل الحد الأدنى الحيازة الفترة الأيام",
            "Eligible Buyer Rule": "مؤهل المشتري القاعدة",
            "Enter Eligible Buyer Rule": "أدخل مؤهل المشتري القاعدة",
            "Secondary Market Status": "حالة ثانوي السوق",
            "Enter Secondary Market Status": "أدخل حالة ثانوي السوق",
            "Core_Governance_Rule_Set": "النواة الأساسية - الحوكمة القاعدة تعيين",
            "CORE_GOVERNANCE_RULE_SET": "النواة الأساسية - الحوكمة القاعدة تعيين",
            "Core Governance Rule Set": "النواة الأساسية - الحوكمة القاعدة تعيين",
            "Select Core Governance Rule Set": "اختر النواة الأساسية - الحوكمة القاعدة تعيين",
            "Print of Core Governance Rule Set": "طباعة النواة الأساسية - الحوكمة القاعدة تعيين",
            "Governance Rule Set ID": "معرّف الحوكمة القاعدة تعيين",
            "Enter Governance Rule Set ID": "أدخل معرّف الحوكمة القاعدة تعيين",
            "Quorum Percentage": "نسبة النصاب",
            "Enter Quorum Percentage": "أدخل نسبة النصاب",
            "Standard Approval Percentage": "نسبة اعتماد المعيار",
            "Enter Standard Approval Percentage": "أدخل نسبة اعتماد المعيار",
            "Major Decision Approval Percentage": "نسبة اعتماد رئيسي القرار",
            "Enter Major Decision Approval Percentage": "أدخل نسبة اعتماد رئيسي القرار",
            "Voting Weight Method": "طريقة التصويت الوزن",
            "Enter Voting Weight Method": "أدخل طريقة التصويت الوزن",
            "Rules Document Link": "رابط القواعد المستند",
            "Enter Rules Document Link": "أدخل رابط القواعد المستند",
            "06 Core Operations Audit Reporting": "النواة الأساسية للمنصة، 06 العمليات الأساسية والتدقيق وإعداد التقارير",
            "06 CORE OPERATIONS AUDIT REPORTING": "النواة الأساسية للمنصة، 06 العمليات الأساسية والتدقيق وإعداد التقارير",
            "Workflow_Instance": "سير العمل الحالة",
            "WORKFLOW_INSTANCE": "سير العمل الحالة",
            "Workflow Instance": "سير العمل الحالة",
            "Select Workflow Instance": "اختر سير العمل الحالة",
            "Print of Workflow Instance": "طباعة سير العمل الحالة",
            "Workflow Instance ID": "معرّف سير العمل الحالة",
            "Enter Workflow Instance ID": "أدخل معرّف سير العمل الحالة",
            "Current Step ID": "معرّف الحالي الخطوة",
            "Enter Current Step ID": "أدخل معرّف الحالي الخطوة",
            "Current Step Name": "اسم الحالي الخطوة",
            "Enter Current Step Name": "أدخل اسم الحالي الخطوة",
            "Current Assignee User ID": "معرّف الحالي المحال إليه المستخدم",
            "Enter Current Assignee User ID": "أدخل معرّف الحالي المحال إليه المستخدم",
            "Started At": "بدأ في",
            "Enter Started At": "أدخل بدأ في",
            "Due At": "مستحق في",
            "Enter Due At": "أدخل مستحق في",
            "Completed At": "مكتمل في",
            "Enter Completed At": "أدخل مكتمل في",
            "Delay Days": "التأخير الأيام",
            "Enter Delay Days": "أدخل التأخير الأيام",
            "Exception Flag": "مؤشر الاستثناء",
            "Enter Exception Flag": "أدخل مؤشر الاستثناء",
            "Exception Reason": "سبب الاستثناء",
            "Enter Exception Reason": "أدخل سبب الاستثناء",
            "Core_Audit_Log": "النواة الأساسية - التدقيق السجل",
            "CORE_AUDIT_LOG": "النواة الأساسية - التدقيق السجل",
            "Core Audit Log": "النواة الأساسية - التدقيق السجل",
            "Select Core Audit Log": "اختر النواة الأساسية - التدقيق السجل",
            "Print of Core Audit Log": "طباعة النواة الأساسية - التدقيق السجل",
            "Audit Log ID": "معرّف التدقيق السجل",
            "Enter Audit Log ID": "أدخل معرّف التدقيق السجل",
            "Action Type": "نوع الإجراء",
            "Enter Action Type": "أدخل نوع الإجراء",
            "Entity Type": "نوع الكيان",
            "Enter Entity Type": "أدخل نوع الكيان",
            "Entity ID": "معرّف الكيان",
            "Enter Entity ID": "أدخل معرّف الكيان",
            "Old Value JSON": "قديم القيمة JSON",
            "Enter Old Value JSON": "أدخل قديم القيمة JSON",
            "New Value JSON": "جديد القيمة JSON",
            "Enter New Value JSON": "أدخل جديد القيمة JSON",
            "IP Address": "IP العنوان",
            "IPAddress": "عنوان IP",
            "Enter IPAddress": "أدخل عنوان IP",
            "User Agent": "المستخدم الوكيل",
            "Enter User Agent": "أدخل المستخدم الوكيل",
            "Immutable Hash": "غير قابل للتغيير البصمة",
            "Enter Immutable Hash": "أدخل غير قابل للتغيير البصمة",
            "Core_Notification": "النواة الأساسية - الإشعار",
            "CORE_NOTIFICATION": "النواة الأساسية - الإشعار",
            "Core Notification": "النواة الأساسية - الإشعار",
            "Select Core Notification": "اختر النواة الأساسية - الإشعار",
            "Print of Core Notification": "طباعة النواة الأساسية - الإشعار",
            "Notification ID": "معرّف الإشعار",
            "Enter Notification ID": "أدخل معرّف الإشعار",
            "Recipient User ID": "معرّف المستلم المستخدم",
            "Enter Recipient User ID": "أدخل معرّف المستلم المستخدم",
            "Related Asset ID": "معرّف مرتبط الأصل",
            "Enter Related Asset ID": "أدخل معرّف مرتبط الأصل",
            "Related Offering ID": "معرّف مرتبط الطرح",
            "Enter Related Offering ID": "أدخل معرّف مرتبط الطرح",
            "Notification Type": "نوع الإشعار",
            "Enter Notification Type": "أدخل نوع الإشعار",
            "Priority": "الأولوية",
            "Enter Priority": "أدخل الأولوية",
            "Subject": "الموضوع",
            "Enter Subject": "أدخل الموضوع",
            "Message Body": "الرسالة الجهة",
            "Enter Message Body": "أدخل الرسالة الجهة",
            "Delivery Channel": "التسليم القناة",
            "Enter Delivery Channel": "أدخل التسليم القناة",
            "Read Status": "حالة القراءة",
            "Enter Read Status": "أدخل حالة القراءة",
            "Sent At": "تم الإرسال في",
            "Enter Sent At": "أدخل تم الإرسال في",
            "Core_Escrow_Release_Request": "النواة الأساسية - طلب الإفراج من حساب الضمان",
            "CORE_ESCROW_RELEASE_REQUEST": "النواة الأساسية - الإفراج من حساب الضمان الطلب",
            "Core Escrow Release Request": "النواة الأساسية - طلب الإفراج من حساب الضمان",
            "Select Core Escrow Release Request": "اختر النواة الأساسية - طلب الإفراج من حساب الضمان",
            "Print of Core Escrow Release Request": "طباعة النواة الأساسية - طلب الإفراج من حساب الضمان",
            "Escrow Release Request ID": "معرّف طلب الإفراج من حساب الضمان",
            "Enter Escrow Release Request ID": "أدخل معرّف طلب الإفراج من حساب الضمان",
            "Milestone ID": "معرّف المعلم",
            "Enter Milestone ID": "أدخل معرّف المعلم",
            "Requested Amount USD": "مبلغ مطلوب بالدولار الأمريكي",
            "Enter Requested Amount USD": "أدخل مبلغ مطلوب بالدولار الأمريكي",
            "Requested By": "مطلوب بواسطة",
            "Enter Requested By": "أدخل مطلوب بواسطة",
            "Request Reason": "سبب الطلب",
            "Enter Request Reason": "أدخل سبب الطلب",
            "Supporting Document Link": "رابط داعم المستند",
            "Enter Supporting Document Link": "أدخل رابط داعم المستند",
            "Release Status": "حالة الإفراج",
            "Enter Release Status": "أدخل حالة الإفراج",
            "Submitted By": "تم الإرسال بواسطة",
            "Enter Submitted By": "أدخل تم الإرسال بواسطة",
            "Submitted At": "تم الإرسال في",
            "Enter Submitted At": "أدخل تم الإرسال في",
            "Reviewed By": "تمت مراجعته بواسطة",
            "Enter Reviewed By": "أدخل تمت مراجعته بواسطة",
            "Reviewed At": "تمت مراجعته في",
            "Enter Reviewed At": "أدخل تمت مراجعته في",
            "Approval Status": "حالة الاعتماد",
            "Enter Approval Status": "أدخل حالة الاعتماد",
            "Core_Tax_Reporting_Package": "النواة الأساسية - الضريبة إعداد التقارير الحزمة",
            "CORE_TAX_REPORTING_PACKAGE": "النواة الأساسية - الضريبة إعداد التقارير الحزمة",
            "Core Tax Reporting Package": "النواة الأساسية - الضريبة إعداد التقارير الحزمة",
            "Select Core Tax Reporting Package": "اختر النواة الأساسية - الضريبة إعداد التقارير الحزمة",
            "Print of Core Tax Reporting Package": "طباعة النواة الأساسية - الضريبة إعداد التقارير الحزمة",
            "Tax Package ID": "معرّف الضريبة الحزمة",
            "Enter Tax Package ID": "أدخل معرّف الضريبة الحزمة",
            "Tax Year": "الضريبة السنة",
            "Enter Tax Year": "أدخل الضريبة السنة",
            "Form Type": "نوع النموذج",
            "Enter Form Type": "أدخل نوع النموذج",
            "Ordinary Income USD": "عادي الدخل بالدولار الأمريكي",
            "Enter Ordinary Income USD": "أدخل عادي الدخل بالدولار الأمريكي",
            "Capital Gain USD": "رأس المال المكسب بالدولار الأمريكي",
            "Enter Capital Gain USD": "أدخل رأس المال المكسب بالدولار الأمريكي",
            "Depreciation Allocation USD": "الاستهلاك التخصيص بالدولار الأمريكي",
            "Enter Depreciation Allocation USD": "أدخل الاستهلاك التخصيص بالدولار الأمريكي",
            "Expense Allocation USD": "المصروف التخصيص بالدولار الأمريكي",
            "Enter Expense Allocation USD": "أدخل المصروف التخصيص بالدولار الأمريكي",
            "Tax Form Link": "رابط الضريبة النموذج",
            "Enter Tax Form Link": "أدخل رابط الضريبة النموذج",
            "Delivery Status": "حالة التسليم",
            "Enter Delivery Status": "أدخل حالة التسليم",
            "Core_Platform_Dashboard": "النواة الأساسية - المنصة لوحة المعلومات",
            "CORE_PLATFORM_DASHBOARD": "النواة الأساسية - المنصة لوحة المعلومات",
            "Core Platform Dashboard": "النواة الأساسية - المنصة لوحة المعلومات",
            "Select Core Platform Dashboard": "اختر النواة الأساسية - المنصة لوحة المعلومات",
            "Print of Core Platform Dashboard": "طباعة النواة الأساسية - المنصة لوحة المعلومات",
            "Dashboard Record ID": "معرّف لوحة المعلومات السجل",
            "Enter Dashboard Record ID": "أدخل معرّف لوحة المعلومات السجل",
            "Dashboard Date": "تاريخ لوحة المعلومات",
            "Enter Dashboard Date": "أدخل تاريخ لوحة المعلومات",
            "Total Assets Onboarded": "الإجمالي الأصول تم تأهيله",
            "Enter Total Assets Onboarded": "أدخل الإجمالي الأصول تم تأهيله",
            "Total Offerings Launched": "الإجمالي الطروحات تم الإطلاق",
            "Enter Total Offerings Launched": "أدخل الإجمالي الطروحات تم الإطلاق",
            "Total Capital Raised USD": "الإجمالي رأس المال تم جمعه بالدولار الأمريكي",
            "Enter Total Capital Raised USD": "أدخل الإجمالي رأس المال تم جمعه بالدولار الأمريكي",
            "Total Investors": "الإجمالي المستثمرون",
            "Enter Total Investors": "أدخل الإجمالي المستثمرون",
            "Average Risk Percentage": "نسبة المتوسط المخاطر",
            "Enter Average Risk Percentage": "أدخل نسبة المتوسط المخاطر",
            "Open Issues Count": "عدد فتح المشكلات",
            "Enter Open Issues Count": "أدخل عدد فتح المشكلات",
            "01 Asset Owner Sponsor Asset Setup": "دخل الإيجار، 01 إعداد الأصل لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "دخل الإيجار، 01 إعداد الأصل لمالك الأصل/الراعي",
            "RENT_Asset_Profile": "ملف الإيجار الأصل",
            "RENT_ASSET_PROFILE": "الإيجار ملف الأصل",
            "Rental Income Asset Profile": "دخل الإيجار - ملف الأصل",
            "Select Rental Income Asset Profile": "اختر دخل الإيجار - ملف الأصل",
            "Print of Rental Income Asset Profile": "طباعة دخل الإيجار - ملف الأصل",
            "Rental Income Token Asset Profile ID": "دخل الإيجار - معرّف ملف أصل الرمز",
            "RENT Asset Profile ID": "معرّف ملف الإيجار الأصل",
            "Enter RENT Asset Profile ID": "أدخل معرّف ملف الإيجار الأصل",
            "Asset Name": "اسم الأصل",
            "Enter Asset Name": "أدخل اسم الأصل",
            "Asset Category": "فئة الأصل",
            "Enter Asset Category": "أدخل فئة الأصل",
            "Asset Subcategory": "الأصل الفئة الفرعية",
            "Enter Asset Subcategory": "أدخل الأصل الفئة الفرعية",
            "Asset Status": "حالة الأصل",
            "Enter Asset Status": "أدخل حالة الأصل",
            "Street Address": "الشارع العنوان",
            "Enter Street Address": "أدخل الشارع العنوان",
            "City": "المدينة",
            "Enter City": "أدخل المدينة",
            "County": "المقاطعة",
            "Enter County": "أدخل المقاطعة",
            "State": "الولاية",
            "Enter State": "أدخل الولاية",
            "ZIP Code": "رمز ZIP",
            "Enter ZIP Code": "أدخل رمز ZIP",
            "Latitude": "خط العرض",
            "Enter Latitude": "أدخل خط العرض",
            "Longitude": "خط الطول",
            "Enter Longitude": "أدخل خط الطول",
            "Current Owner ID": "معرّف الحالي المالك",
            "Enter Current Owner ID": "أدخل معرّف الحالي المالك",
            "Primary Value Source": "مصدر رئيسي القيمة",
            "Enter Primary Value Source": "أدخل مصدر رئيسي القيمة",
            "Asset Use Type": "نوع الأصل استخدام",
            "Enter Asset Use Type": "أدخل نوع الأصل استخدام",
            "Tokenization Readiness Status": "حالة جاهزية الترميز",
            "Enter Tokenization Readiness Status": "أدخل حالة جاهزية الترميز",
            "Map Display Enabled": "تمكين الخريطة العرض",
            "Enter Map Display Enabled": "حدّد حالة تمكين الخريطة العرض",
            "Map Public Visibility": "الخريطة عام الظهور",
            "Enter Map Public Visibility": "أدخل الخريطة عام الظهور",
            "Map Listing Status": "حالة الخريطة الإدراج",
            "Enter Map Listing Status": "أدخل حالة الخريطة الإدراج",
            "Google Map Place ID": "معرّف Google الخريطة المكان",
            "Enter Google Map Place ID": "أدخل معرّف Google الخريطة المكان",
            "Google Maps URL": "رابط خرائط Google",
            "Enter Google Maps URL": "أدخل رابط خرائط Google",
            "Map Display Address": "الخريطة العرض العنوان",
            "Enter Map Display Address": "أدخل الخريطة العرض العنوان",
            "Map Center Latitude": "خط عرض مركز الخريطة",
            "Enter Map Center Latitude": "أدخل خط عرض مركز الخريطة",
            "Map Center Longitude": "خط طول مركز الخريطة",
            "Enter Map Center Longitude": "أدخل خط طول مركز الخريطة",
            "Map Default Zoom": "الخريطة الافتراضي التكبير",
            "Enter Map Default Zoom": "أدخل الخريطة الافتراضي التكبير",
            "Boundary Type": "نوع الحدود",
            "Enter Boundary Type": "أدخل نوع الحدود",
            "Boundary Source": "مصدر الحدود",
            "Enter Boundary Source": "أدخل مصدر الحدود",
            "Boundary Verification Status": "حالة تحقق الحدود",
            "Enter Boundary Verification Status": "أدخل حالة تحقق الحدود",
            "Boundary Geometry Format": "الحدود الهندسة التنسيق",
            "Enter Boundary Geometry Format": "أدخل الحدود الهندسة التنسيق",
            "Boundary GeoJSON": "الحدود GeoJSON",
            "Enter Boundary GeoJSON": "أدخل الحدود GeoJSON",
            "Boundary WKT": "الحدود WKT",
            "Enter Boundary WKT": "أدخل الحدود WKT",
            "Boundary Bounding Box": "الحدود الإحاطة المربع",
            "Enter Boundary Bounding Box": "أدخل الحدود الإحاطة المربع",
            "Parcel ID List": "قطعة الأرض ID القائمة",
            "Enter Parcel ID List": "أدخل قطعة الأرض ID القائمة",
            "Legal Description Link": "رابط وصف قانوني",
            "Enter Legal Description Link": "أدخل رابط وصف قانوني",
            "Survey Document Link": "رابط المسح المستند",
            "Enter Survey Document Link": "أدخل رابط المسح المستند",
            "Boundary Last Verified Date": "تاريخ الحدود الأخير موثّق",
            "Enter Boundary Last Verified Date": "أدخل تاريخ الحدود الأخير موثّق",
            "Boundary Verified By": "الحدود موثّق بواسطة",
            "Enter Boundary Verified By": "أدخل الحدود موثّق بواسطة",
            "Map Disclaimer": "الخريطة إخلاء المسؤولية",
            "Enter Map Disclaimer": "أدخل الخريطة إخلاء المسؤولية",
            "RENT_Property_Management_Agreement": "اتفاقية الإيجار العقار الإدارة",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "الإيجار اتفاقية إدارة العقار",
            "Rental Income Property Management Agreement": "دخل الإيجار - اتفاقية إدارة العقار",
            "Select Rental Income Property Management Agreement": "اختر دخل الإيجار - اتفاقية إدارة العقار",
            "Print of Rental Income Property Management Agreement": "طباعة دخل الإيجار - اتفاقية إدارة العقار",
            "Rental Income Property Management Agreement ID": "دخل الإيجار - معرّف اتفاقية إدارة العقار",
            "RENT PM Agreement ID": "معرّف اتفاقية الإيجار PM",
            "Enter RENT PM Agreement ID": "أدخل معرّف اتفاقية الإيجار PM",
            "Property Manager Stakeholder ID": "معرّف مدير العقار صاحب المصلحة",
            "Enter Property Manager Stakeholder ID": "أدخل معرّف مدير العقار صاحب المصلحة",
            "Agreement Start Date": "تاريخ الاتفاقية البداية",
            "Enter Agreement Start Date": "أدخل تاريخ الاتفاقية البداية",
            "Agreement End Date": "تاريخ الاتفاقية النهاية",
            "Enter Agreement End Date": "أدخل تاريخ الاتفاقية النهاية",
            "Management Fee Type": "نوع الإدارة الرسوم",
            "Enter Management Fee Type": "أدخل نوع الإدارة الرسوم",
            "Management Fee Percentage": "نسبة الإدارة الرسوم",
            "Enter Management Fee Percentage": "أدخل نسبة الإدارة الرسوم",
            "Flat Management Fee USD": "ثابت الإدارة الرسوم بالدولار الأمريكي",
            "Enter Flat Management Fee USD": "أدخل ثابت الإدارة الرسوم بالدولار الأمريكي",
            "Leasing Fee Terms": "التأجير الرسوم الشروط",
            "Enter Leasing Fee Terms": "أدخل التأجير الرسوم الشروط",
            "Maintenance Approval Limit USD": "الصيانة الاعتماد الحد بالدولار الأمريكي",
            "Enter Maintenance Approval Limit USD": "أدخل الصيانة الاعتماد الحد بالدولار الأمريكي",
            "Rent Collection Responsibility": "تحصيل الإيجار المسؤولية",
            "Enter Rent Collection Responsibility": "أدخل تحصيل الإيجار المسؤولية",
            "Reporting Frequency": "إعداد التقارير التكرار",
            "Enter Reporting Frequency": "أدخل إعداد التقارير التكرار",
            "Bank Statement Required": "البنك البيان مطلوب",
            "Enter Bank Statement Required": "حدّد حالة اشتراط البنك البيان",
            "Investor Report Required": "تقرير المستثمر مطلوب",
            "Enter Investor Report Required": "حدّد حالة اشتراط تقرير المستثمر",
            "Agreement Document Link": "رابط الاتفاقية المستند",
            "Enter Agreement Document Link": "أدخل رابط الاتفاقية المستند",
            "Agreement Status": "حالة الاتفاقية",
            "Enter Agreement Status": "أدخل حالة الاتفاقية",
            "Approved By": "معتمد بواسطة",
            "Enter Approved By": "أدخل معتمد بواسطة",
            "Approved At": "معتمد في",
            "Enter Approved At": "أدخل معتمد في",
            "RENT_Unit_Profile": "ملف الإيجار الوحدة",
            "RENT_UNIT_PROFILE": "الإيجار ملف الوحدة",
            "Rental Income Unit Profile": "دخل الإيجار - ملف الوحدة",
            "Select Rental Income Unit Profile": "اختر دخل الإيجار - ملف الوحدة",
            "Print of Rental Income Unit Profile": "طباعة دخل الإيجار - ملف الوحدة",
            "Rental Income Unit Profile ID": "دخل الإيجار - معرّف ملف الوحدة",
            "RENT Unit Profile ID": "معرّف ملف الإيجار الوحدة",
            "Enter RENT Unit Profile ID": "أدخل معرّف ملف الإيجار الوحدة",
            "Unit ID": "معرّف الوحدة",
            "Enter Unit ID": "أدخل معرّف الوحدة",
            "Unit Label": "تسمية الوحدة",
            "Enter Unit Label": "أدخل تسمية الوحدة",
            "Unit Type": "نوع الوحدة",
            "Enter Unit Type": "أدخل نوع الوحدة",
            "Bedrooms Count": "عدد غرف النوم",
            "Enter Bedrooms Count": "أدخل عدد غرف النوم",
            "Bathrooms Count": "عدد الحمامات",
            "Enter Bathrooms Count": "أدخل عدد الحمامات",
            "Square Feet": "مربع قدم",
            "Enter Square Feet": "أدخل مربع قدم",
            "Market Rent USD": "السوق الإيجار بالدولار الأمريكي",
            "Enter Market Rent USD": "أدخل السوق الإيجار بالدولار الأمريكي",
            "Current Lease ID": "معرّف الحالي عقد الإيجار",
            "Enter Current Lease ID": "أدخل معرّف الحالي عقد الإيجار",
            "Occupancy Status RENT": "الإشغال الحالة الإيجار",
            "Enter Occupancy Status RENT": "أدخل الإشغال الحالة الإيجار",
            "Rental Unit Condition Rating": "الإيجار الوحدة الحالة التقييم",
            "Unit Condition Rating RENT": "الوحدة الحالة التقييم الإيجار",
            "Enter Unit Condition Rating RENT": "أدخل الوحدة الحالة التقييم الإيجار",
            "Last Inspection Date": "تاريخ الأخير الفحص",
            "Enter Last Inspection Date": "أدخل تاريخ الأخير الفحص",
            "Unit Status": "حالة الوحدة",
            "Enter Unit Status": "أدخل حالة الوحدة",
            "02 Offering Legal Compliance Readiness": "دخل الإيجار، 02 جاهزية الطرح القانونية والامتثال",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "دخل الإيجار، 02 جاهزية الطرح القانونية والامتثال",
            "RENT_Token_Offering": "الإيجار طرح الرمز",
            "RENT_TOKEN_OFFERING": "الإيجار طرح الرمز",
            "Rental Income Token Offering": "دخل الإيجار - طرح الرمز",
            "Select Rental Income Token Offering": "اختر دخل الإيجار - طرح الرمز",
            "Print of Rental Income Token Offering": "طباعة دخل الإيجار - طرح الرمز",
            "Rental Income Token Offering ID": "دخل الإيجار - معرّف طرح الرمز",
            "RENT Offering ID": "معرّف الإيجار الطرح",
            "Enter RENT Offering ID": "أدخل معرّف الإيجار الطرح",
            "Offering Name": "اسم الطرح",
            "Enter Offering Name": "أدخل اسم الطرح",
            "Offering Type": "نوع الطرح",
            "Enter Offering Type": "أدخل نوع الطرح",
            "SEC Exemption": "SEC الإعفاء",
            "Enter SEC Exemption": "أدخل SEC الإعفاء",
            "Minimum Investment USD": "الحد الأدنى الاستثمار بالدولار الأمريكي",
            "Enter Minimum Investment USD": "أدخل الحد الأدنى الاستثمار بالدولار الأمريكي",
            "Target Offering Amount USD": "مبلغ الهدف الطرح بالدولار الأمريكي",
            "Enter Target Offering Amount USD": "أدخل مبلغ الهدف الطرح بالدولار الأمريكي",
            "Maximum Offering Amount USD": "الحد الأقصى لمبلغ الطرح بالدولار الأمريكي",
            "Enter Maximum Offering Amount USD": "أدخل الحد الأقصى لمبلغ الطرح بالدولار الأمريكي",
            "Token Symbol": "الرمز الرمز",
            "Enter Token Symbol": "أدخل الرمز الرمز",
            "Total Tokens": "الإجمالي الرموز",
            "Enter Total Tokens": "أدخل الإجمالي الرموز",
            "Token Price USD": "الرمز السعر بالدولار الأمريكي",
            "Enter Token Price USD": "أدخل الرمز السعر بالدولار الأمريكي",
            "Offering Start Date": "تاريخ الطرح البداية",
            "Enter Offering Start Date": "أدخل تاريخ الطرح البداية",
            "Offering End Date": "تاريخ الطرح النهاية",
            "Enter Offering End Date": "أدخل تاريخ الطرح النهاية",
            "Offering Status": "حالة الطرح",
            "Enter Offering Status": "أدخل حالة الطرح",
            "Sales Map Listing Enabled": "تمكين إدراج خريطة المبيعات",
            "Enter Sales Map Listing Enabled": "حدّد حالة تمكين إدراج خريطة المبيعات",
            "Sales Map Listing Status": "حالة إدراج خريطة المبيعات",
            "Enter Sales Map Listing Status": "أدخل حالة إدراج خريطة المبيعات",
            "Sales Map First Display Trigger": "المبيعات الخريطة الأول العرض المحفّز",
            "Enter Sales Map First Display Trigger": "أدخل المبيعات الخريطة الأول العرض المحفّز",
            "Sales Map Public Title": "المبيعات الخريطة عام سند الملكية",
            "Enter Sales Map Public Title": "أدخل المبيعات الخريطة عام سند الملكية",
            "Sales Map Public Summary": "المبيعات الخريطة عام الملخص",
            "Enter Sales Map Public Summary": "أدخل المبيعات الخريطة عام الملخص",
            "Sales Map Minimum Data Ready": "المبيعات الخريطة الحد الأدنى البيانات جاهز",
            "Enter Sales Map Minimum Data Ready": "أدخل المبيعات الخريطة الحد الأدنى البيانات جاهز",
            "Sales Map Security Display Level": "مستوى المبيعات الخريطة الأمن العرض",
            "Enter Sales Map Security Display Level": "أدخل مستوى المبيعات الخريطة الأمن العرض",
            "Sales Map Risk Display Level": "مستوى المبيعات الخريطة المخاطر العرض",
            "Enter Sales Map Risk Display Level": "أدخل مستوى المبيعات الخريطة المخاطر العرض",
            "Sales Map Boundary Display Mode": "المبيعات الخريطة الحدود العرض الوضع",
            "Enter Sales Map Boundary Display Mode": "أدخل المبيعات الخريطة الحدود العرض الوضع",
            "Sales Map Call To Action Status": "حالة المبيعات الخريطة طلب إلى الإجراء",
            "Enter Sales Map Call To Action Status": "أدخل حالة المبيعات الخريطة طلب إلى الإجراء",
            "RENT_Token_Class": "الإيجار فئة الرمز",
            "RENT_TOKEN_CLASS": "الإيجار فئة الرمز",
            "Rental Income Token Token Class": "دخل الإيجار - فئة الرمز",
            "Select Rental Income Token Token Class": "اختر دخل الإيجار - فئة الرمز",
            "Print of Rental Income Token Token Class": "طباعة دخل الإيجار - فئة الرمز",
            "Rental Income Token Token Class ID": "دخل الإيجار - معرّف فئة الرمز",
            "RENT Token Class ID": "معرّف الإيجار فئة الرمز",
            "Enter RENT Token Class ID": "أدخل معرّف الإيجار فئة الرمز",
            "Token Class Name": "اسم فئة الرمز",
            "Enter Token Class Name": "أدخل اسم فئة الرمز",
            "Seniority Level": "مستوى الأولوية",
            "Enter Seniority Level": "أدخل مستوى الأولوية",
            "Preferred Return Percentage": "نسبة العائد المفضل",
            "Enter Preferred Return Percentage": "أدخل نسبة العائد المفضل",
            "Debt Interest Rate": "فائدة الدين المعدل",
            "Enter Debt Interest Rate": "أدخل فائدة الدين المعدل",
            "Profit Split Percentage": "نسبة تقسيم الأرباح",
            "Enter Profit Split Percentage": "أدخل نسبة تقسيم الأرباح",
            "Voting Weight": "التصويت الوزن",
            "Enter Voting Weight": "أدخل التصويت الوزن",
            "Transfer Restricted": "التحويل مقيّد",
            "Enter Transfer Restricted": "أدخل التحويل مقيّد",
            "Class Description": "وصف الفئة",
            "Enter Class Description": "أدخل وصف الفئة",
            "RENT_Token_Economics": "الإيجار اقتصاديات الرمز",
            "RENT_TOKEN_ECONOMICS": "الإيجار اقتصاديات الرمز",
            "Rental Income Token Token Economics": "دخل الإيجار - اقتصاديات الرمز",
            "Select Rental Income Token Token Economics": "اختر دخل الإيجار - اقتصاديات الرمز",
            "Print of Rental Income Token Token Economics": "طباعة دخل الإيجار - اقتصاديات الرمز",
            "Rental Income Token Token Economics ID": "دخل الإيجار - معرّف اقتصاديات الرمز",
            "RENT Token Economics ID": "معرّف الإيجار اقتصاديات الرمز",
            "Enter RENT Token Economics ID": "أدخل معرّف الإيجار اقتصاديات الرمز",
            "Token Class ID": "معرّف فئة الرمز",
            "Enter Token Class ID": "أدخل معرّف فئة الرمز",
            "Ownership Component Type": "نوع الملكية المكوّن",
            "Enter Ownership Component Type": "أدخل نوع الملكية المكوّن",
            "Ownership Percentage Per Token": "نسبة الملكية لكل الرمز",
            "Enter Ownership Percentage Per Token": "أدخل نسبة الملكية لكل الرمز",
            "Total Project Ownership Percentage Represented": "الإجمالي المشروع نسبة الملكية ممثّل",
            "Enter Total Project Ownership Percentage Represented": "أدخل الإجمالي المشروع نسبة الملكية ممثّل",
            "Building Ownership Percentage Represented": "نسبة ملكية المبنى الممثلة",
            "Enter Building Ownership Percentage Represented": "أدخل نسبة ملكية المبنى الممثلة",
            "Land Ownership Percentage Represented": "الأرض نسبة الملكية ممثّل",
            "Enter Land Ownership Percentage Represented": "أدخل الأرض نسبة الملكية ممثّل",
            "SPV Ownership Percentage Represented": "SPV نسبة الملكية ممثّل",
            "Enter SPV Ownership Percentage Represented": "أدخل SPV نسبة الملكية ممثّل",
            "Economic Component Type": "نوع اقتصادي المكوّن",
            "Enter Economic Component Type": "أدخل نوع اقتصادي المكوّن",
            "Rental Income Allocation Percentage": "دخل الإيجار - نسبة التخصيص",
            "Enter Rental Income Allocation Percentage": "أدخل دخل الإيجار - نسبة التخصيص",
            "Sale Profit Allocation Percentage": "ربح البيع - نسبة التخصيص",
            "Enter Sale Profit Allocation Percentage": "أدخل ربح البيع - نسبة التخصيص",
            "Equity Appreciation Allocation Percentage": "ارتفاع قيمة حقوق الملكية - نسبة التخصيص",
            "Enter Equity Appreciation Allocation Percentage": "أدخل ارتفاع قيمة حقوق الملكية - نسبة التخصيص",
            "Revenue Share Allocation Percentage": "مشاركة الإيرادات - نسبة التخصيص",
            "Enter Revenue Share Allocation Percentage": "أدخل مشاركة الإيرادات - نسبة التخصيص",
            "Waterfall Component Type": "نوع تسلسل التوزيع المكوّن",
            "Enter Waterfall Component Type": "أدخل نوع تسلسل التوزيع المكوّن",
            "Principal Repayment Priority": "الأصل السداد الأولوية",
            "Enter Principal Repayment Priority": "أدخل الأصل السداد الأولوية",
            "Waterfall Priority": "تسلسل التوزيع الأولوية",
            "Enter Waterfall Priority": "أدخل تسلسل التوزيع الأولوية",
            "Distribution Frequency": "التوزيع التكرار",
            "Enter Distribution Frequency": "أدخل التوزيع التكرار",
            "Calculation Method": "طريقة الحساب",
            "Enter Calculation Method": "أدخل طريقة الحساب",
            "NAV Based": "NAV قائم على",
            "Enter NAV Based": "أدخل NAV قائم على",
            "Investor Disclosure Required": "المستثمر الإفصاح مطلوب",
            "Enter Investor Disclosure Required": "حدّد حالة اشتراط المستثمر الإفصاح",
            "Economic Notes": "ملاحظات اقتصادي",
            "Enter Economic Notes": "أدخل ملاحظات اقتصادي",
            "RENT_Legal_Rights_Matrix": "مصفوفة الإيجار قانوني الحقوق",
            "RENT_LEGAL_RIGHTS_MATRIX": "الإيجار مصفوفة الحقوق القانونية",
            "Rental Income Token Legal Rights Matrix": "دخل الإيجار - مصفوفة الحقوق القانونية للرمز",
            "Select Rental Income Token Legal Rights Matrix": "اختر دخل الإيجار - مصفوفة الحقوق القانونية للرمز",
            "Print of Rental Income Token Legal Rights Matrix": "طباعة دخل الإيجار - مصفوفة الحقوق القانونية للرمز",
            "Rental Income Token Rights Matrix ID": "دخل الإيجار - معرّف مصفوفة حقوق الرمز",
            "RENT Rights Matrix ID": "معرّف مصفوفة الإيجار الحقوق",
            "Enter RENT Rights Matrix ID": "أدخل معرّف مصفوفة الإيجار الحقوق",
            "Legal Right Group": "قانوني الحق المجموعة",
            "Enter Legal Right Group": "أدخل قانوني الحق المجموعة",
            "Ownership Right": "الملكية الحق",
            "Enter Ownership Right": "أدخل الملكية الحق",
            "Rental Income Right": "دخل الإيجار - الحق",
            "Enter Rental Income Right": "أدخل دخل الإيجار - الحق",
            "Revenue Share Right": "مشاركة الإيرادات - الحق",
            "Enter Revenue Share Right": "أدخل مشاركة الإيرادات - الحق",
            "Sale Profit Right": "ربح البيع - الحق",
            "Enter Sale Profit Right": "أدخل ربح البيع - الحق",
            "Equity Appreciation Right": "ارتفاع قيمة حقوق الملكية - الحق",
            "Enter Equity Appreciation Right": "أدخل ارتفاع قيمة حقوق الملكية - الحق",
            "Debt Interest Right": "فائدة الدين الحق",
            "Enter Debt Interest Right": "أدخل فائدة الدين الحق",
            "Preferred Return Right": "العائد المفضل الحق",
            "Enter Preferred Return Right": "أدخل العائد المفضل الحق",
            "Voting Right": "التصويت الحق",
            "Enter Voting Right": "أدخل التصويت الحق",
            "Information Right": "المعلومات الحق",
            "Enter Information Right": "أدخل المعلومات الحق",
            "Redemption Right": "الاسترداد الحق",
            "Enter Redemption Right": "أدخل الاسترداد الحق",
            "Transfer Right": "التحويل الحق",
            "Enter Transfer Right": "أدخل التحويل الحق",
            "Liquidation Priority": "التصفية الأولوية",
            "Enter Liquidation Priority": "أدخل التصفية الأولوية",
            "Restrictions Text": "القيود النص",
            "Enter Restrictions Text": "أدخل القيود النص",
            "RENT_Risk_Score": "درجة الإيجار المخاطر",
            "RENT_RISK_SCORE": "الإيجار درجة المخاطر",
            "Rental Income Token Risk Score": "دخل الإيجار - درجة مخاطر الرمز",
            "Select Rental Income Token Risk Score": "اختر دخل الإيجار - درجة مخاطر الرمز",
            "Print of Rental Income Token Risk Score": "طباعة دخل الإيجار - درجة مخاطر الرمز",
            "Rental Income Token Risk Score ID": "دخل الإيجار - معرّف درجة مخاطر الرمز",
            "RENT Risk Score ID": "معرّف درجة الإيجار المخاطر",
            "Enter RENT Risk Score ID": "أدخل معرّف درجة الإيجار المخاطر",
            "Overall Risk Percentage": "نسبة الإجمالي المخاطر",
            "Enter Overall Risk Percentage": "أدخل نسبة الإجمالي المخاطر",
            "Risk Factor Type": "نوع المخاطر العامل",
            "Enter Risk Factor Type": "أدخل نوع المخاطر العامل",
            "Legal Risk Percentage": "نسبة قانوني المخاطر",
            "Enter Legal Risk Percentage": "أدخل نسبة قانوني المخاطر",
            "Title Risk Percentage": "نسبة سند الملكية المخاطر",
            "Enter Title Risk Percentage": "أدخل نسبة سند الملكية المخاطر",
            "Market Risk Percentage": "نسبة مخاطر السوق",
            "Enter Market Risk Percentage": "أدخل نسبة مخاطر السوق",
            "Liquidity Risk Percentage": "نسبة السيولة المخاطر",
            "Enter Liquidity Risk Percentage": "أدخل نسبة السيولة المخاطر",
            "Income Risk Percentage": "نسبة الدخل المخاطر",
            "Enter Income Risk Percentage": "أدخل نسبة الدخل المخاطر",
            "Construction Risk Percentage": "نسبة الإنشاء المخاطر",
            "Enter Construction Risk Percentage": "أدخل نسبة الإنشاء المخاطر",
            "Developer Risk Percentage": "نسبة المطور المخاطر",
            "Enter Developer Risk Percentage": "أدخل نسبة المطور المخاطر",
            "Auction Risk Percentage": "نسبة المزاد المخاطر",
            "Enter Auction Risk Percentage": "أدخل نسبة المزاد المخاطر",
            "Risk Explanation": "المخاطر التوضيح",
            "Enter Risk Explanation": "أدخل المخاطر التوضيح",
            "03 Investor Subscription Token Issuance": "دخل الإيجار، 03 اكتتاب المستثمر وإصدار الرمز",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "دخل الإيجار، 03 اكتتاب المستثمر وإصدار الرمز",
            "RENT_Subscription_Order": "الإيجار طلب الاكتتاب",
            "RENT_SUBSCRIPTION_ORDER": "الإيجار طلب الاكتتاب",
            "Rental Income Token Subscription Order": "دخل الإيجار - طلب اكتتاب الرمز",
            "Select Rental Income Token Subscription Order": "اختر دخل الإيجار - طلب اكتتاب الرمز",
            "Print of Rental Income Token Subscription Order": "طباعة دخل الإيجار - طلب اكتتاب الرمز",
            "Rental Income Token Subscription ID": "دخل الإيجار - معرّف الرمز الاشتراك",
            "RENT Subscription ID": "معرّف الإيجار الاشتراك",
            "Enter RENT Subscription ID": "أدخل معرّف الإيجار الاشتراك",
            "Approved Amount USD": "مبلغ معتمد بالدولار الأمريكي",
            "Enter Approved Amount USD": "أدخل مبلغ معتمد بالدولار الأمريكي",
            "Token Quantity": "الرمز الكمية",
            "Enter Token Quantity": "أدخل الرمز الكمية",
            "Payment Method": "طريقة الدفع",
            "Enter Payment Method": "أدخل طريقة الدفعة",
            "Payment Status": "حالة الدفعة",
            "Enter Payment Status": "أدخل حالة الدفعة",
            "Escrow Deposit ID": "معرّف حساب الضمان الوديعة",
            "Enter Escrow Deposit ID": "أدخل معرّف حساب الضمان الوديعة",
            "Subscription Status": "حالة الاشتراك",
            "Enter Subscription Status": "أدخل حالة الاشتراك",
            "Risk Acknowledgment Completed": "إقرار بالمخاطر مكتمل",
            "Enter Risk Acknowledgment Completed": "أدخل إقرار بالمخاطر مكتمل",
            "RENT_Token_Ledger": "الإيجار سجل الرموز",
            "RENT_TOKEN_LEDGER": "الإيجار سجل الرموز",
            "Rental Income Token Token Ledger": "دخل الإيجار - سجل الرمز",
            "Select Rental Income Token Token Ledger": "اختر دخل الإيجار - سجل الرمز",
            "Print of Rental Income Token Token Ledger": "طباعة دخل الإيجار - سجل الرمز",
            "Rental Income Token Ledger ID": "دخل الإيجار - معرّف سجل الرموز",
            "RENT Ledger ID": "معرّف الإيجار السجل",
            "Enter RENT Ledger ID": "أدخل معرّف الإيجار السجل",
            "Token Balance": "الرمز الرصيد",
            "Enter Token Balance": "أدخل الرمز الرصيد",
            "Restricted Token Balance": "مقيّد الرمز الرصيد",
            "Enter Restricted Token Balance": "أدخل مقيّد الرمز الرصيد",
            "Available Token Balance": "متاح الرمز الرصيد",
            "Enter Available Token Balance": "أدخل متاح الرمز الرصيد",
            "Ownership Percentage Total": "نسبة الملكية الإجمالي",
            "Enter Ownership Percentage Total": "أدخل نسبة الملكية الإجمالي",
            "Income Allocation Percentage Total": "الدخل التخصيص النسبة الإجمالي",
            "Enter Income Allocation Percentage Total": "أدخل الدخل التخصيص النسبة الإجمالي",
            "Transfer Agent Record ID": "معرّف وكيل التحويل السجل",
            "Enter Transfer Agent Record ID": "أدخل معرّف وكيل التحويل السجل",
            "Last Updated At": "الأخير تم التحديث في",
            "Enter Last Updated At": "أدخل الأخير تم التحديث في",
            "04 Property Manager Rental Operations": "دخل الإيجار، 04 عمليات الإيجار وإدارة العقار",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "دخل الإيجار، 04 عمليات الإيجار وإدارة العقار",
            "RENT_Independent_Inspection_Report": "تقرير الإيجار مستقل الفحص",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "الإيجار تقرير فحص مستقل",
            "Rental Income Token Independent Inspection Report": "دخل الإيجار - تقرير الفحص المستقل للرمز",
            "Select Rental Income Token Independent Inspection Report": "اختر دخل الإيجار - تقرير الفحص المستقل للرمز",
            "Print of Rental Income Token Independent Inspection Report": "طباعة دخل الإيجار - تقرير الفحص المستقل للرمز",
            "Rental Income Token Inspection Report ID": "دخل الإيجار - معرّف تقرير فحص الرمز",
            "RENT Inspection Report ID": "معرّف تقرير الإيجار الفحص",
            "Enter RENT Inspection Report ID": "أدخل معرّف تقرير الإيجار الفحص",
            "Inspector ID": "معرّف المفتش",
            "Enter Inspector ID": "أدخل معرّف المفتش",
            "Inspection Date": "تاريخ الفحص",
            "Enter Inspection Date": "أدخل تاريخ الفحص",
            "Observed Completion Percentage": "نسبة مرصود الإكمال",
            "Enter Observed Completion Percentage": "أدخل نسبة مرصود الإكمال",
            "Quality Rating": "الجودة التقييم",
            "Enter Quality Rating": "أدخل الجودة التقييم",
            "Deficiencies Found": "أوجه النقص تم العثور",
            "Enter Deficiencies Found": "أدخل أوجه النقص تم العثور",
            "Safety Issues Found": "السلامة المشكلات تم العثور",
            "Enter Safety Issues Found": "أدخل السلامة المشكلات تم العثور",
            "Photo Report Link": "رابط تقرير الصورة",
            "Enter Photo Report Link": "أدخل رابط تقرير الصورة",
            "Inspector Recommendation": "المفتش التوصية",
            "Enter Inspector Recommendation": "أدخل المفتش التوصية",
            "Report Notes": "ملاحظات التقرير",
            "Enter Report Notes": "أدخل ملاحظات التقرير",
            "RENT_Lease_Record": "الإيجار سجل عقد الإيجار",
            "RENT_LEASE_RECORD": "الإيجار سجل عقد الإيجار",
            "Rental Income Lease Record": "دخل الإيجار - سجل عقد الإيجار",
            "Select Rental Income Lease Record": "اختر دخل الإيجار - سجل عقد الإيجار",
            "Print of Rental Income Lease Record": "طباعة دخل الإيجار - سجل عقد الإيجار",
            "Rental Income Lease ID": "دخل الإيجار - معرّف عقد الإيجار",
            "RENT Lease ID": "معرّف عقد الإيجار",
            "Enter RENT Lease ID": "أدخل معرّف عقد الإيجار",
            "Tenant Name Masked": "المستأجر الاسم مخفي جزئياً",
            "Enter Tenant Name Masked": "أدخل المستأجر الاسم مخفي جزئياً",
            "Tenant Profile ID": "معرّف ملف المستأجر",
            "Enter Tenant Profile ID": "أدخل معرّف ملف المستأجر",
            "Unit Profile ID": "معرّف ملف الوحدة",
            "Enter Unit Profile ID": "أدخل معرّف ملف الوحدة",
            "Lease Start Date": "تاريخ عقد الإيجار البداية",
            "Enter Lease Start Date": "أدخل تاريخ عقد الإيجار البداية",
            "Lease End Date": "تاريخ عقد الإيجار النهاية",
            "Enter Lease End Date": "أدخل تاريخ عقد الإيجار النهاية",
            "Monthly Rent USD": "شهري الإيجار بالدولار الأمريكي",
            "Enter Monthly Rent USD": "أدخل شهري الإيجار بالدولار الأمريكي",
            "Security Deposit USD": "الأمن الوديعة بالدولار الأمريكي",
            "Enter Security Deposit USD": "أدخل الأمن الوديعة بالدولار الأمريكي",
            "Rent Escalation Type": "نوع زيادة الإيجار",
            "Enter Rent Escalation Type": "أدخل نوع زيادة الإيجار",
            "Rent Escalation Percentage": "نسبة زيادة الإيجار",
            "Enter Rent Escalation Percentage": "أدخل نسبة زيادة الإيجار",
            "Lease Status": "حالة عقد الإيجار",
            "Enter Lease Status": "أدخل حالة عقد الإيجار",
            "Lease Renewal Option": "عقد الإيجار التجديد الخيار",
            "Enter Lease Renewal Option": "أدخل عقد الإيجار التجديد الخيار",
            "Lease Document Link": "رابط عقد الإيجار المستند",
            "Enter Lease Document Link": "أدخل رابط عقد الإيجار المستند",
            "Lease Verification Status": "حالة تحقق عقد الإيجار",
            "Enter Lease Verification Status": "أدخل حالة تحقق عقد الإيجار",
            "RENT_Rent_Collection_Record": "الإيجار سجل تحصيل الإيجار",
            "RENT_RENT_COLLECTION_RECORD": "الإيجار سجل تحصيل الإيجار",
            "Rental Income Rent Collection Record": "دخل الإيجار - سجل تحصيل الإيجار",
            "Select Rental Income Rent Collection Record": "اختر دخل الإيجار - سجل تحصيل الإيجار",
            "Print of Rental Income Rent Collection Record": "طباعة دخل الإيجار - سجل تحصيل الإيجار",
            "Rental Income Rent Collection ID": "دخل الإيجار - معرّف تحصيل الإيجار",
            "RENT Rent Collection ID": "معرّف الإيجار تحصيل الإيجار",
            "Enter RENT Rent Collection ID": "أدخل معرّف الإيجار تحصيل الإيجار",
            "Lease ID": "معرّف عقد الإيجار",
            "Enter Lease ID": "أدخل معرّف عقد الإيجار",
            "Rent Period": "الإيجار الفترة",
            "Enter Rent Period": "أدخل الإيجار الفترة",
            "Rent Due USD": "الإيجار مستحق بالدولار الأمريكي",
            "Enter Rent Due USD": "أدخل الإيجار مستحق بالدولار الأمريكي",
            "Rent Collected USD": "الإيجار مُحصّل بالدولار الأمريكي",
            "Enter Rent Collected USD": "أدخل الإيجار مُحصّل بالدولار الأمريكي",
            "Late Fee USD": "متأخر الرسوم بالدولار الأمريكي",
            "Enter Late Fee USD": "أدخل متأخر الرسوم بالدولار الأمريكي",
            "Collection Date": "تاريخ التحصيل",
            "Enter Collection Date": "أدخل تاريخ التحصيل",
            "Collection Status": "حالة التحصيل",
            "Enter Collection Status": "أدخل حالة التحصيل",
            "Payment Method RENT": "الدفعة الطريقة الإيجار",
            "Enter Payment Method RENT": "أدخل الدفعة الطريقة الإيجار",
            "ACH Trace Reference": "ACH التتبع المرجع",
            "Enter ACH Trace Reference": "أدخل ACH التتبع المرجع",
            "Bank Deposit Date": "تاريخ البنك الوديعة",
            "Enter Bank Deposit Date": "أدخل تاريخ البنك الوديعة",
            "Property Manager Attestation": "مدير العقار الإقرار الرسمي",
            "Enter Property Manager Attestation": "أدخل مدير العقار الإقرار الرسمي",
            "Rent Collection Document Link": "رابط تحصيل الإيجار المستند",
            "Enter Rent Collection Document Link": "أدخل رابط تحصيل الإيجار المستند",
            "RENT_Property_Manager_Report": "تقرير الإيجار مدير العقار",
            "RENT_PROPERTY_MANAGER_REPORT": "الإيجار تقرير مدير العقار",
            "Rental Income Property Manager Report": "دخل الإيجار - تقرير مدير العقار",
            "Select Rental Income Property Manager Report": "اختر دخل الإيجار - تقرير مدير العقار",
            "Print of Rental Income Property Manager Report": "طباعة دخل الإيجار - تقرير مدير العقار",
            "Rental Income PM Report ID": "دخل الإيجار - معرّف تقرير PM",
            "RENT PM Report ID": "معرّف تقرير الإيجار PM",
            "Enter RENT PM Report ID": "أدخل معرّف تقرير الإيجار PM",
            "Report Month": "التقرير شهر",
            "Enter Report Month": "أدخل التقرير شهر",
            "Opening Occupancy Rate": "الافتتاح الإشغال المعدل",
            "Enter Opening Occupancy Rate": "أدخل الافتتاح الإشغال المعدل",
            "Ending Occupancy Rate": "الختامي الإشغال المعدل",
            "Enter Ending Occupancy Rate": "أدخل الختامي الإشغال المعدل",
            "Gross Rent Collected USD": "الإجمالي الإيجار مُحصّل بالدولار الأمريكي",
            "Enter Gross Rent Collected USD": "أدخل الإجمالي الإيجار مُحصّل بالدولار الأمريكي",
            "Operating Expenses USD": "التشغيل المصروفات بالدولار الأمريكي",
            "Enter Operating Expenses USD": "أدخل التشغيل المصروفات بالدولار الأمريكي",
            "NOI USD": "NOI بالدولار الأمريكي",
            "Enter NOI USD": "أدخل NOI بالدولار الأمريكي",
            "Beginning Cash Balance USD": "البداية النقد الرصيد بالدولار الأمريكي",
            "Enter Beginning Cash Balance USD": "أدخل البداية النقد الرصيد بالدولار الأمريكي",
            "Ending Cash Balance USD": "الختامي النقد الرصيد بالدولار الأمريكي",
            "Enter Ending Cash Balance USD": "أدخل الختامي النقد الرصيد بالدولار الأمريكي",
            "Reserve Balance USD": "الاحتياطي الرصيد بالدولار الأمريكي",
            "Enter Reserve Balance USD": "أدخل الاحتياطي الرصيد بالدولار الأمريكي",
            "Maintenance Summary": "الصيانة الملخص",
            "Enter Maintenance Summary": "أدخل الصيانة الملخص",
            "Tenant Issues": "المستأجر المشكلات",
            "Enter Tenant Issues": "أدخل المستأجر المشكلات",
            "Bank Statement Link": "رابط البنك البيان",
            "Enter Bank Statement Link": "أدخل رابط البنك البيان",
            "RENT_Tenant_Profile": "ملف الإيجار المستأجر",
            "RENT_TENANT_PROFILE": "الإيجار ملف المستأجر",
            "Rental Income Tenant Profile": "دخل الإيجار - ملف المستأجر",
            "Select Rental Income Tenant Profile": "اختر دخل الإيجار - ملف المستأجر",
            "Print of Rental Income Tenant Profile": "طباعة دخل الإيجار - ملف المستأجر",
            "Rental Income Tenant Profile ID": "دخل الإيجار - معرّف ملف المستأجر",
            "RENT Tenant Profile ID": "معرّف ملف الإيجار المستأجر",
            "Enter RENT Tenant Profile ID": "أدخل معرّف ملف الإيجار المستأجر",
            "Rental Tenant Type": "نوع مستأجر الإيجار",
            "Tenant Type RENT": "المستأجر النوع الإيجار",
            "Enter Tenant Type RENT": "أدخل المستأجر النوع الإيجار",
            "Tenant Screening Status": "حالة فحص المستأجر",
            "Enter Tenant Screening Status": "أدخل حالة فحص المستأجر",
            "Credit Check Status": "حالة الائتمان الفحص",
            "Enter Credit Check Status": "أدخل حالة الائتمان الفحص",
            "Income Verification Status": "حالة تحقق الدخل",
            "Enter Income Verification Status": "أدخل حالة تحقق الدخل",
            "Move In Date": "تاريخ النقل في",
            "Enter Move In Date": "أدخل تاريخ النقل في",
            "Move Out Date": "تاريخ النقل خارج",
            "Enter Move Out Date": "أدخل تاريخ النقل خارج",
            "Tenant Risk Rating": "المستأجر المخاطر التقييم",
            "Enter Tenant Risk Rating": "أدخل المستأجر المخاطر التقييم",
            "PII Stored Outside Platform": "PII مخزن خارج المنصة",
            "Enter PII Stored Outside Platform": "أدخل PII مخزن خارج المنصة",
            "Tenant Document Link": "رابط المستأجر المستند",
            "Enter Tenant Document Link": "أدخل رابط المستأجر المستند",
            "Tenant Status": "حالة المستأجر",
            "Enter Tenant Status": "أدخل حالة المستأجر",
            "RENT_Rent_Roll_Snapshot": "الإيجار لقطة سجل الإيجارات",
            "RENT_RENT_ROLL_SNAPSHOT": "الإيجار لقطة سجل الإيجارات",
            "Rental Income Rent Roll Snapshot": "دخل الإيجار - لقطة سجل الإيجارات",
            "Select Rental Income Rent Roll Snapshot": "اختر دخل الإيجار - لقطة سجل الإيجارات",
            "Print of Rental Income Rent Roll Snapshot": "طباعة دخل الإيجار - لقطة سجل الإيجارات",
            "Rental Income Rent Roll ID": "دخل الإيجار - معرّف سجل الإيجارات",
            "RENT Rent Roll ID": "معرّف الإيجار سجل الإيجارات",
            "Enter RENT Rent Roll ID": "أدخل معرّف الإيجار سجل الإيجارات",
            "Rent Roll Source": "مصدر سجل الإيجارات",
            "Enter Rent Roll Source": "أدخل مصدر سجل الإيجارات",
            "Contract Rent USD": "العقد الإيجار بالدولار الأمريكي",
            "Enter Contract Rent USD": "أدخل العقد الإيجار بالدولار الأمريكي",
            "Security Deposit Held USD": "الأمن الوديعة محتجز بالدولار الأمريكي",
            "Enter Security Deposit Held USD": "أدخل الأمن الوديعة محتجز بالدولار الأمريكي",
            "Delinquent Amount USD": "مبلغ متأخر السداد بالدولار الأمريكي",
            "Enter Delinquent Amount USD": "أدخل مبلغ متأخر السداد بالدولار الأمريكي",
            "Vacancy Flag": "مؤشر الشغور",
            "Enter Vacancy Flag": "أدخل مؤشر الشغور",
            "Snapshot Total Units": "لقطة الإجمالي الوحدات",
            "Enter Snapshot Total Units": "أدخل لقطة الإجمالي الوحدات",
            "Snapshot Occupied Units": "لقطة مشغول الوحدات",
            "Enter Snapshot Occupied Units": "أدخل لقطة مشغول الوحدات",
            "Snapshot Gross Scheduled Rent USD": "لقطة الإجمالي مجدول الإيجار بالدولار الأمريكي",
            "Enter Snapshot Gross Scheduled Rent USD": "أدخل لقطة الإجمالي مجدول الإيجار بالدولار الأمريكي",
            "Snapshot Status": "حالة لقطة",
            "Enter Snapshot Status": "أدخل حالة لقطة",
            "RENT_Operating_Expense_Record": "الإيجار سجل المصروفات التشغيلية",
            "RENT_OPERATING_EXPENSE_RECORD": "الإيجار سجل المصروفات التشغيلية",
            "Rental Income Operating Expense Record": "دخل الإيجار - سجل المصروفات التشغيلية",
            "Select Rental Income Operating Expense Record": "اختر دخل الإيجار - سجل المصروفات التشغيلية",
            "Print of Rental Income Operating Expense Record": "طباعة دخل الإيجار - سجل المصروفات التشغيلية",
            "Rental Income Expense ID": "دخل الإيجار - معرّف المصروف",
            "RENT Expense ID": "معرّف الإيجار المصروف",
            "Enter RENT Expense ID": "أدخل معرّف الإيجار المصروف",
            "Expense Date": "تاريخ المصروف",
            "Enter Expense Date": "أدخل تاريخ المصروف",
            "Rental Expense Category": "فئة الإيجار المصروف",
            "Expense Category RENT": "المصروف الفئة الإيجار",
            "Enter Expense Category RENT": "أدخل المصروف الفئة الإيجار",
            "Expense Description": "وصف المصروف",
            "Enter Expense Description": "أدخل وصف المصروف",
            "Vendor Stakeholder ID": "معرّف المورّد صاحب المصلحة",
            "Enter Vendor Stakeholder ID": "أدخل معرّف المورّد صاحب المصلحة",
            "Invoice Number": "رقم الفاتورة",
            "Enter Invoice Number": "أدخل رقم الفاتورة",
            "Invoice Amount USD": "مبلغ الفاتورة بالدولار الأمريكي",
            "Enter Invoice Amount USD": "أدخل مبلغ الفاتورة بالدولار الأمريكي",
            "Paid Amount USD": "مبلغ مدفوع بالدولار الأمريكي",
            "Enter Paid Amount USD": "أدخل مبلغ مدفوع بالدولار الأمريكي",
            "Payment Date": "تاريخ الدفعة",
            "Enter Payment Date": "أدخل تاريخ الدفعة",
            "Capital Expense Flag": "مؤشر المصروف الرأسمالي",
            "Enter Capital Expense Flag": "أدخل مؤشر المصروف الرأسمالي",
            "Reserve Funded Flag": "مؤشر الاحتياطي مموّل",
            "Enter Reserve Funded Flag": "أدخل مؤشر الاحتياطي مموّل",
            "Expense Document Link": "رابط المصروف المستند",
            "Enter Expense Document Link": "أدخل رابط المصروف المستند",
            "Expense Approval Status": "حالة اعتماد المصروف",
            "Enter Expense Approval Status": "أدخل حالة اعتماد المصروف",
            "RENT_Reserve_Account_Record": "الإيجار سجل حساب الاحتياطي",
            "RENT_RESERVE_ACCOUNT_RECORD": "الإيجار سجل حساب الاحتياطي",
            "Rental Income Reserve Account Record": "دخل الإيجار - سجل حساب الاحتياطي",
            "Select Rental Income Reserve Account Record": "اختر دخل الإيجار - سجل حساب الاحتياطي",
            "Print of Rental Income Reserve Account Record": "طباعة دخل الإيجار - سجل حساب الاحتياطي",
            "Rental Income Reserve Record ID": "دخل الإيجار - معرّف الاحتياطي السجل",
            "RENT Reserve Record ID": "معرّف الإيجار الاحتياطي السجل",
            "Enter RENT Reserve Record ID": "أدخل معرّف الإيجار الاحتياطي السجل",
            "Reserve Period": "الاحتياطي الفترة",
            "Enter Reserve Period": "أدخل الاحتياطي الفترة",
            "Rental Reserve Type": "نوع الإيجار الاحتياطي",
            "Reserve Type RENT": "الاحتياطي النوع الإيجار",
            "Enter Reserve Type RENT": "أدخل الاحتياطي النوع الإيجار",
            "Opening Reserve Balance USD": "الافتتاح الاحتياطي الرصيد بالدولار الأمريكي",
            "Enter Opening Reserve Balance USD": "أدخل الافتتاح الاحتياطي الرصيد بالدولار الأمريكي",
            "Reserve Contribution USD": "الاحتياطي المساهمة بالدولار الأمريكي",
            "Enter Reserve Contribution USD": "أدخل الاحتياطي المساهمة بالدولار الأمريكي",
            "Reserve Draw USD": "الاحتياطي السحب بالدولار الأمريكي",
            "Enter Reserve Draw USD": "أدخل الاحتياطي السحب بالدولار الأمريكي",
            "Closing Reserve Balance USD": "الإغلاق الاحتياطي الرصيد بالدولار الأمريكي",
            "Enter Closing Reserve Balance USD": "أدخل الإغلاق الاحتياطي الرصيد بالدولار الأمريكي",
            "Minimum Required Reserve USD": "الحد الأدنى مطلوب الاحتياطي بالدولار الأمريكي",
            "Enter Minimum Required Reserve USD": "أدخل الحد الأدنى مطلوب الاحتياطي بالدولار الأمريكي",
            "Reserve Compliance Status": "حالة الاحتياطي الامتثال",
            "Enter Reserve Compliance Status": "أدخل حالة الاحتياطي الامتثال",
            "Reserve Document Link": "رابط الاحتياطي المستند",
            "Enter Reserve Document Link": "أدخل رابط الاحتياطي المستند",
            "RENT_Delinquency_Vacancy_Record": "الإيجار التأخر في السداد الشغور السجل",
            "RENT_DELINQUENCY_VACANCY_RECORD": "الإيجار التأخر في السداد الشغور السجل",
            "Rental Income Delinquency and Vacancy Record": "دخل الإيجار - سجل التأخر في السداد والشغور",
            "Select Rental Income Delinquency and Vacancy Record": "اختر دخل الإيجار - سجل التأخر في السداد والشغور",
            "Print of Rental Income Delinquency and Vacancy Record": "طباعة دخل الإيجار - سجل التأخر في السداد والشغور",
            "Rental Income Delinquency Vacancy ID": "دخل الإيجار - معرّف التأخر في السداد الشغور",
            "RENT Delinquency Vacancy ID": "معرّف الإيجار التأخر في السداد الشغور",
            "Enter RENT Delinquency Vacancy ID": "أدخل معرّف الإيجار التأخر في السداد الشغور",
            "Rental Issue Type": "نوع الإيجار المشكلة",
            "Issue Type RENT": "المشكلة النوع الإيجار",
            "Enter Issue Type RENT": "أدخل المشكلة النوع الإيجار",
            "Days Delinquent": "الأيام متأخر السداد",
            "Enter Days Delinquent": "أدخل الأيام متأخر السداد",
            "Vacancy Start Date": "تاريخ الشغور البداية",
            "Enter Vacancy Start Date": "أدخل تاريخ الشغور البداية",
            "Vacancy End Date": "تاريخ الشغور النهاية",
            "Enter Vacancy End Date": "أدخل تاريخ الشغور النهاية",
            "Lost Rent USD": "مفقود الإيجار بالدولار الأمريكي",
            "Enter Lost Rent USD": "أدخل مفقود الإيجار بالدولار الأمريكي",
            "Mitigation Action": "التخفيف الإجراء",
            "Enter Mitigation Action": "أدخل التخفيف الإجراء",
            "Legal Action Required": "قانوني الإجراء مطلوب",
            "Enter Legal Action Required": "حدّد حالة اشتراط قانوني الإجراء",
            "Collection Action Status": "حالة التحصيل الإجراء",
            "Enter Collection Action Status": "أدخل حالة التحصيل الإجراء",
            "Resolution Status": "حالة المعالجة",
            "Enter Resolution Status": "أدخل حالة المعالجة",
            "05 Finance Escrow Distribution Reporting": "دخل الإيجار، 05 التمويل وحساب الضمان والتوزيع وإعداد التقارير",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "دخل الإيجار، 05 التمويل وحساب الضمان والتوزيع وإعداد التقارير",
            "RENT_Escrow_Release_Package": "الإيجار حزمة الإفراج من حساب الضمان",
            "RENT_ESCROW_RELEASE_PACKAGE": "الإيجار حزمة الإفراج من حساب الضمان",
            "Rental Income Token Escrow Release Package": "دخل الإيجار - حزمة الإفراج من حساب الضمان للرمز",
            "Select Rental Income Token Escrow Release Package": "اختر دخل الإيجار - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Rental Income Token Escrow Release Package": "طباعة دخل الإيجار - حزمة الإفراج من حساب الضمان للرمز",
            "Rental Income Token Escrow Release Package ID": "دخل الإيجار - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "RENT Escrow Release Package ID": "معرّف الإيجار حزمة الإفراج من حساب الضمان",
            "Enter RENT Escrow Release Package ID": "أدخل معرّف الإيجار حزمة الإفراج من حساب الضمان",
            "Inspection Report ID": "معرّف تقرير الفحص",
            "Enter Inspection Report ID": "أدخل معرّف تقرير الفحص",
            "Requested Release Amount USD": "مبلغ مطلوب الإفراج بالدولار الأمريكي",
            "Enter Requested Release Amount USD": "أدخل مبلغ مطلوب الإفراج بالدولار الأمريكي",
            "Approved Release Amount USD": "مبلغ معتمد الإفراج بالدولار الأمريكي",
            "Enter Approved Release Amount USD": "أدخل مبلغ معتمد الإفراج بالدولار الأمريكي",
            "Lien Waivers Complete": "الرهن الإعفاءات مكتمل",
            "Enter Lien Waivers Complete": "حدّد حالة اكتمال الرهن الإعفاءات",
            "Budget Variance Acceptable": "الميزانية الانحراف مقبول",
            "Enter Budget Variance Acceptable": "أدخل الميزانية الانحراف مقبول",
            "Investor Notice Link": "رابط المستثمر الإشعار",
            "Enter Investor Notice Link": "أدخل رابط المستثمر الإشعار",
            "Release Recommendation": "الإفراج التوصية",
            "Enter Release Recommendation": "أدخل الإفراج التوصية",
            "RENT_Investor_Report": "تقرير الإيجار المستثمر",
            "RENT_INVESTOR_REPORT": "الإيجار تقرير المستثمر",
            "Rental Income Token Investor Report": "دخل الإيجار - تقرير المستثمر للرمز",
            "Select Rental Income Token Investor Report": "اختر دخل الإيجار - تقرير المستثمر للرمز",
            "Print of Rental Income Token Investor Report": "طباعة دخل الإيجار - تقرير المستثمر للرمز",
            "Rental Income Token Investor Report ID": "دخل الإيجار - معرّف تقرير المستثمر للرمز",
            "RENT Investor Report ID": "معرّف تقرير الإيجار المستثمر",
            "Enter RENT Investor Report ID": "أدخل معرّف تقرير الإيجار المستثمر",
            "Report Period": "التقرير الفترة",
            "Enter Report Period": "أدخل التقرير الفترة",
            "Report Line Type": "نوع التقرير السطر",
            "Enter Report Line Type": "أدخل نوع التقرير السطر",
            "Gross Distribution USD": "الإجمالي التوزيع بالدولار الأمريكي",
            "Enter Gross Distribution USD": "أدخل الإجمالي التوزيع بالدولار الأمريكي",
            "Fees USD": "الرسوم بالدولار الأمريكي",
            "Enter Fees USD": "أدخل الرسوم بالدولار الأمريكي",
            "Net Distribution USD": "الصافي التوزيع بالدولار الأمريكي",
            "Enter Net Distribution USD": "أدخل الصافي التوزيع بالدولار الأمريكي",
            "Estimated Current Value USD": "التقديري الحالي القيمة بالدولار الأمريكي",
            "Enter Estimated Current Value USD": "أدخل التقديري الحالي القيمة بالدولار الأمريكي",
            "Current Risk Percentage": "نسبة الحالي المخاطر",
            "Enter Current Risk Percentage": "أدخل نسبة الحالي المخاطر",
            "Key Update": "تحديث المفتاح",
            "Enter Key Update": "أدخل تحديث المفتاح",
            "Delivered At": "تم التسليم في",
            "Enter Delivered At": "أدخل تم التسليم في",
            "RENT_Distribution_Calculation": "الإيجار حساب التوزيع",
            "RENT_DISTRIBUTION_CALCULATION": "الإيجار حساب التوزيع",
            "Rental Income Token Distribution Calculation": "دخل الإيجار - حساب توزيعات الرمز",
            "Select Rental Income Token Distribution Calculation": "اختر دخل الإيجار - حساب توزيعات الرمز",
            "Print of Rental Income Token Distribution Calculation": "طباعة دخل الإيجار - حساب توزيعات الرمز",
            "Rental Income Token Distribution ID": "دخل الإيجار - معرّف الرمز التوزيع",
            "RENT Distribution ID": "معرّف الإيجار التوزيع",
            "Enter RENT Distribution ID": "أدخل معرّف الإيجار التوزيع",
            "Distribution Period Start": "التوزيع الفترة البداية",
            "Enter Distribution Period Start": "أدخل التوزيع الفترة البداية",
            "Distribution Period End": "التوزيع الفترة النهاية",
            "Enter Distribution Period End": "أدخل التوزيع الفترة النهاية",
            "PM Report ID": "معرّف تقرير PM",
            "Enter PM Report ID": "أدخل معرّف تقرير PM",
            "Rent Roll ID": "معرّف سجل الإيجارات",
            "Enter Rent Roll ID": "أدخل معرّف سجل الإيجارات",
            "Reserve Record ID": "معرّف الاحتياطي السجل",
            "Enter Reserve Record ID": "أدخل معرّف الاحتياطي السجل",
            "Distribution Component Type": "نوع التوزيع المكوّن",
            "Enter Distribution Component Type": "أدخل نوع التوزيع المكوّن",
            "Gross Source Amount USD": "مبلغ مصدر الإجمالي بالدولار الأمريكي",
            "Enter Gross Source Amount USD": "أدخل مبلغ مصدر الإجمالي بالدولار الأمريكي",
            "Debt Service USD": "الدين الخدمة بالدولار الأمريكي",
            "Enter Debt Service USD": "أدخل الدين الخدمة بالدولار الأمريكي",
            "Preferred Return USD": "العائد المفضل بالدولار الأمريكي",
            "Enter Preferred Return USD": "أدخل العائد المفضل بالدولار الأمريكي",
            "Net Distributable Income USD": "الصافي قابل للتوزيع الدخل بالدولار الأمريكي",
            "Enter Net Distributable Income USD": "أدخل الصافي قابل للتوزيع الدخل بالدولار الأمريكي",
            "Distribution Per Token USD": "التوزيع لكل الرمز بالدولار الأمريكي",
            "Enter Distribution Per Token USD": "أدخل التوزيع لكل الرمز بالدولار الأمريكي",
            "Distribution Approval ID": "معرّف اعتماد التوزيع",
            "Enter Distribution Approval ID": "أدخل معرّف اعتماد التوزيع",
            "Calculation Report Link": "رابط تقرير الحساب",
            "Enter Calculation Report Link": "أدخل رابط تقرير الحساب",
            "RENT_Distribution_Approval": "اعتماد الإيجار التوزيع",
            "RENT_DISTRIBUTION_APPROVAL": "الإيجار اعتماد التوزيع",
            "Rental Income Distribution Approval": "دخل الإيجار - اعتماد التوزيع",
            "Select Rental Income Distribution Approval": "اختر دخل الإيجار - اعتماد التوزيع",
            "Print of Rental Income Distribution Approval": "طباعة دخل الإيجار - اعتماد التوزيع",
            "Rental Income Distribution Approval ID": "دخل الإيجار - معرّف اعتماد التوزيع",
            "RENT Distribution Approval ID": "معرّف اعتماد الإيجار التوزيع",
            "Enter RENT Distribution Approval ID": "أدخل معرّف اعتماد الإيجار التوزيع",
            "Distribution ID": "معرّف التوزيع",
            "Enter Distribution ID": "أدخل معرّف التوزيع",
            "Property Manager Report ID": "معرّف تقرير مدير العقار",
            "Calculated Distribution USD": "محسوب التوزيع بالدولار الأمريكي",
            "Enter Calculated Distribution USD": "أدخل محسوب التوزيع بالدولار الأمريكي",
            "Approved Distribution USD": "معتمد التوزيع بالدولار الأمريكي",
            "Enter Approved Distribution USD": "أدخل معتمد التوزيع بالدولار الأمريكي",
            "Withheld Reserve USD": "محتجز الاحتياطي بالدولار الأمريكي",
            "Enter Withheld Reserve USD": "أدخل محتجز الاحتياطي بالدولار الأمريكي",
            "Rental Distribution Approval Decision": "الإيجار اعتماد التوزيع القرار",
            "Approval Decision RENT": "الاعتماد القرار الإيجار",
            "Enter Approval Decision RENT": "أدخل الاعتماد القرار الإيجار",
            "Compliance Reviewer ID": "معرّف الامتثال المراجع",
            "Enter Compliance Reviewer ID": "أدخل معرّف الامتثال المراجع",
            "Financial Reviewer ID": "معرّف المراجع المالي",
            "Enter Financial Reviewer ID": "أدخل معرّف المراجع المالي",
            "06 Asset Manager Lifecycle Exit": "دخل الإيجار، 06 إدارة الأصل ودورة الحياة والخروج",
            "06 ASSET MANAGER LIFECYCLE EXIT": "دخل الإيجار، 06 إدارة الأصل ودورة الحياة والخروج",
            "RENT_Lifecycle_Milestone": "الإيجار مرحلة دورة الحياة",
            "RENT_LIFECYCLE_MILESTONE": "الإيجار مرحلة دورة الحياة",
            "Rental Income Token Lifecycle Milestone": "دخل الإيجار - مرحلة دورة حياة الرمز",
            "Select Rental Income Token Lifecycle Milestone": "اختر دخل الإيجار - مرحلة دورة حياة الرمز",
            "Print of Rental Income Token Lifecycle Milestone": "طباعة دخل الإيجار - مرحلة دورة حياة الرمز",
            "Rental Income Token Milestone ID": "دخل الإيجار - معرّف مرحلة الرمز",
            "RENT Milestone ID": "معرّف مرحلة دخل الإيجار",
            "Enter RENT Milestone ID": "أدخل معرّف مرحلة دخل الإيجار",
            "Milestone Name": "اسم المعلم",
            "Enter Milestone Name": "أدخل اسم المعلم",
            "Milestone Type": "نوع المرحلة",
            "Enter Milestone Type": "أدخل نوع المرحلة",
            "Milestone Order": "المعلم الترتيب",
            "Enter Milestone Order": "أدخل المعلم الترتيب",
            "Planned Start Date": "تاريخ مخطط البداية",
            "Enter Planned Start Date": "أدخل تاريخ مخطط البداية",
            "Planned End Date": "تاريخ مخطط النهاية",
            "Enter Planned End Date": "أدخل تاريخ مخطط النهاية",
            "Actual Start Date": "الفعلي تاريخ البدء",
            "Enter Actual Start Date": "أدخل الفعلي تاريخ البدء",
            "Actual End Date": "الفعلي تاريخ الانتهاء",
            "Enter Actual End Date": "أدخل الفعلي تاريخ الانتهاء",
            "Required Completion Percentage": "نسبة مطلوب الإكمال",
            "Enter Required Completion Percentage": "أدخل نسبة مطلوب الإكمال",
            "Current Completion Percentage": "نسبة الحالي الإكمال",
            "Enter Current Completion Percentage": "أدخل نسبة الحالي الإكمال",
            "Milestone Status": "حالة المعلم",
            "Enter Milestone Status": "أدخل حالة المعلم",
            "RENT_Exit_Strategy": "الإيجار استراتيجية الخروج",
            "RENT_EXIT_STRATEGY": "الإيجار استراتيجية الخروج",
            "Rental Income Token Exit Strategy": "دخل الإيجار - استراتيجية خروج الرمز",
            "Select Rental Income Token Exit Strategy": "اختر دخل الإيجار - استراتيجية خروج الرمز",
            "Print of Rental Income Token Exit Strategy": "طباعة دخل الإيجار - استراتيجية خروج الرمز",
            "Rental Income Token Exit Strategy ID": "دخل الإيجار - معرّف استراتيجية خروج الرمز",
            "RENT Exit Strategy ID": "معرّف الإيجار استراتيجية الخروج",
            "Enter RENT Exit Strategy ID": "أدخل معرّف الإيجار استراتيجية الخروج",
            "Primary Exit Strategy": "رئيسي استراتيجية الخروج",
            "Enter Primary Exit Strategy": "أدخل رئيسي استراتيجية الخروج",
            "Expected Hold Period Months": "متوقع الاحتفاظ الفترة أشهر",
            "Enter Expected Hold Period Months": "أدخل متوقع الاحتفاظ الفترة أشهر",
            "Target Sale Price USD": "الهدف البيع السعر بالدولار الأمريكي",
            "Enter Target Sale Price USD": "أدخل الهدف البيع السعر بالدولار الأمريكي",
            "Target IRR": "الهدف IRR",
            "Enter Target IRR": "أدخل الهدف IRR",
            "Refinance Allowed": "السماح بـ إعادة التمويل",
            "Enter Refinance Allowed": "حدّد حالة السماح بـ إعادة التمويل",
            "Buyback Option Allowed": "السماح بـ إعادة الشراء الخيار",
            "Enter Buyback Option Allowed": "حدّد حالة السماح بـ إعادة الشراء الخيار",
            "Token Holder Vote Required": "الرمز الحامل التصويت مطلوب",
            "Enter Token Holder Vote Required": "حدّد حالة اشتراط الرمز الحامل التصويت",
            "Exit Waterfall Text": "الخروج تسلسل التوزيع النص",
            "Enter Exit Waterfall Text": "أدخل الخروج تسلسل التوزيع النص",
            "01 Asset Owner Sponsor Revenue Setup": "مشاركة الإيرادات، 01 إعداد الإيرادات لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "مشاركة الإيرادات، 01 إعداد الإيرادات لمالك الأصل/الراعي",
            "REVSHARE_Asset_Profile": "ملف مشاركة الإيرادات الأصل",
            "REVSHARE_ASSET_PROFILE": "مشاركة الإيرادات ملف الأصل",
            "Revenue Share Asset Profile": "مشاركة الإيرادات - ملف الأصل",
            "Select Revenue Share Asset Profile": "اختر مشاركة الإيرادات - ملف الأصل",
            "Print of Revenue Share Asset Profile": "طباعة مشاركة الإيرادات - ملف الأصل",
            "Revenue Share Token Asset Profile ID": "مشاركة الإيرادات - معرّف ملف أصل الرمز",
            "REVSHARE Asset Profile ID": "معرّف ملف مشاركة الإيرادات الأصل",
            "Enter REVSHARE Asset Profile ID": "أدخل معرّف ملف مشاركة الإيرادات الأصل",
            "REVSHARE_Revenue_Source": "مصدر مشاركة الإيرادات الإيرادات",
            "REVSHARE_REVENUE_SOURCE": "مشاركة الإيرادات مصدر الإيرادات",
            "Revenue Share Revenue Source": "مشاركة الإيرادات - مصدر الإيرادات",
            "Select Revenue Share Revenue Source": "اختر مشاركة الإيرادات - مصدر الإيرادات",
            "Print of Revenue Share Revenue Source": "طباعة مشاركة الإيرادات - مصدر الإيرادات",
            "Revenue Share Source ID": "مشاركة الإيرادات - معرّف المصدر",
            "REVSHARE Revenue Source ID": "معرّف مصدر مشاركة الإيرادات الإيرادات",
            "Enter REVSHARE Revenue Source ID": "أدخل معرّف مصدر مشاركة الإيرادات الإيرادات",
            "Revenue Source Type": "نوع مصدر الإيرادات",
            "Enter Revenue Source Type": "أدخل نوع مصدر الإيرادات",
            "Revenue Source Name": "اسم مصدر الإيرادات",
            "Enter Revenue Source Name": "أدخل اسم مصدر الإيرادات",
            "Gross Revenue Definition": "تعريف الإجمالي الإيرادات",
            "Enter Gross Revenue Definition": "أدخل تعريف الإجمالي الإيرادات",
            "Net Revenue Definition": "تعريف الصافي الإيرادات",
            "Enter Net Revenue Definition": "أدخل تعريف الصافي الإيرادات",
            "Excluded Revenue Items": "مستبعد الإيرادات البنود",
            "Enter Excluded Revenue Items": "أدخل مستبعد الإيرادات البنود",
            "Revenue Verification Method": "طريقة التحقق من الإيرادات",
            "Enter Revenue Verification Method": "أدخل طريقة التحقق من الإيرادات",
            "Revenue Source Status": "حالة مصدر الإيرادات",
            "Enter Revenue Source Status": "أدخل حالة مصدر الإيرادات",
            "02 Offering Legal Compliance Readiness": "مشاركة الإيرادات، 02 جاهزية الطرح القانونية والامتثال",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "مشاركة الإيرادات، 02 جاهزية الطرح القانونية والامتثال",
            "REVSHARE_Token_Offering": "مشاركة الإيرادات طرح الرمز",
            "REVSHARE_TOKEN_OFFERING": "مشاركة الإيرادات طرح الرمز",
            "Revenue Share Token Offering": "مشاركة الإيرادات - طرح الرمز",
            "Select Revenue Share Token Offering": "اختر مشاركة الإيرادات - طرح الرمز",
            "Print of Revenue Share Token Offering": "طباعة مشاركة الإيرادات - طرح الرمز",
            "Revenue Share Token Offering ID": "مشاركة الإيرادات - معرّف طرح الرمز",
            "REVSHARE Offering ID": "معرّف مشاركة الإيرادات الطرح",
            "Enter REVSHARE Offering ID": "أدخل معرّف مشاركة الإيرادات الطرح",
            "REVSHARE_Token_Class": "مشاركة الإيرادات فئة الرمز",
            "REVSHARE_TOKEN_CLASS": "مشاركة الإيرادات فئة الرمز",
            "Revenue Share Token Token Class": "مشاركة الإيرادات - فئة الرمز",
            "Select Revenue Share Token Token Class": "اختر مشاركة الإيرادات - فئة الرمز",
            "Print of Revenue Share Token Token Class": "طباعة مشاركة الإيرادات - فئة الرمز",
            "Revenue Share Token Token Class ID": "مشاركة الإيرادات - معرّف فئة الرمز",
            "REVSHARE Token Class ID": "معرّف مشاركة الإيرادات فئة الرمز",
            "Enter REVSHARE Token Class ID": "أدخل معرّف مشاركة الإيرادات فئة الرمز",
            "REVSHARE_Token_Economics": "مشاركة الإيرادات اقتصاديات الرمز",
            "REVSHARE_TOKEN_ECONOMICS": "مشاركة الإيرادات اقتصاديات الرمز",
            "Revenue Share Token Token Economics": "مشاركة الإيرادات - اقتصاديات الرمز",
            "Select Revenue Share Token Token Economics": "اختر مشاركة الإيرادات - اقتصاديات الرمز",
            "Print of Revenue Share Token Token Economics": "طباعة مشاركة الإيرادات - اقتصاديات الرمز",
            "Revenue Share Token Token Economics ID": "مشاركة الإيرادات - معرّف اقتصاديات الرمز",
            "REVSHARE Token Economics ID": "معرّف مشاركة الإيرادات اقتصاديات الرمز",
            "Enter REVSHARE Token Economics ID": "أدخل معرّف مشاركة الإيرادات اقتصاديات الرمز",
            "REVSHARE_Legal_Rights_Matrix": "مصفوفة مشاركة الإيرادات قانوني الحقوق",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "مشاركة الإيرادات مصفوفة الحقوق القانونية",
            "Revenue Share Token Legal Rights Matrix": "مشاركة الإيرادات - مصفوفة الحقوق القانونية للرمز",
            "Select Revenue Share Token Legal Rights Matrix": "اختر مشاركة الإيرادات - مصفوفة الحقوق القانونية للرمز",
            "Print of Revenue Share Token Legal Rights Matrix": "طباعة مشاركة الإيرادات - مصفوفة الحقوق القانونية للرمز",
            "Revenue Share Token Rights Matrix ID": "مشاركة الإيرادات - معرّف مصفوفة حقوق الرمز",
            "REVSHARE Rights Matrix ID": "معرّف مصفوفة مشاركة الإيرادات الحقوق",
            "Enter REVSHARE Rights Matrix ID": "أدخل معرّف مصفوفة مشاركة الإيرادات الحقوق",
            "REVSHARE_Risk_Score": "درجة مشاركة الإيرادات المخاطر",
            "REVSHARE_RISK_SCORE": "مشاركة الإيرادات درجة المخاطر",
            "Revenue Share Token Risk Score": "مشاركة الإيرادات - درجة مخاطر الرمز",
            "Select Revenue Share Token Risk Score": "اختر مشاركة الإيرادات - درجة مخاطر الرمز",
            "Print of Revenue Share Token Risk Score": "طباعة مشاركة الإيرادات - درجة مخاطر الرمز",
            "Revenue Share Token Risk Score ID": "مشاركة الإيرادات - معرّف درجة مخاطر الرمز",
            "REVSHARE Risk Score ID": "معرّف درجة مشاركة الإيرادات المخاطر",
            "Enter REVSHARE Risk Score ID": "أدخل معرّف درجة مشاركة الإيرادات المخاطر",
            "03 Investor Subscription Token Issuance": "مشاركة الإيرادات، 03 اكتتاب المستثمر وإصدار الرمز",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "مشاركة الإيرادات، 03 اكتتاب المستثمر وإصدار الرمز",
            "REVSHARE_Subscription_Order": "مشاركة الإيرادات طلب الاكتتاب",
            "REVSHARE_SUBSCRIPTION_ORDER": "مشاركة الإيرادات طلب الاكتتاب",
            "Revenue Share Token Subscription Order": "مشاركة الإيرادات - طلب اكتتاب الرمز",
            "Select Revenue Share Token Subscription Order": "اختر مشاركة الإيرادات - طلب اكتتاب الرمز",
            "Print of Revenue Share Token Subscription Order": "طباعة مشاركة الإيرادات - طلب اكتتاب الرمز",
            "Revenue Share Token Subscription ID": "مشاركة الإيرادات - معرّف الرمز الاشتراك",
            "REVSHARE Subscription ID": "معرّف مشاركة الإيرادات الاشتراك",
            "Enter REVSHARE Subscription ID": "أدخل معرّف مشاركة الإيرادات الاشتراك",
            "REVSHARE_Token_Ledger": "مشاركة الإيرادات سجل الرموز",
            "REVSHARE_TOKEN_LEDGER": "مشاركة الإيرادات سجل الرموز",
            "Revenue Share Token Token Ledger": "مشاركة الإيرادات - سجل الرمز",
            "Select Revenue Share Token Token Ledger": "اختر مشاركة الإيرادات - سجل الرمز",
            "Print of Revenue Share Token Token Ledger": "طباعة مشاركة الإيرادات - سجل الرمز",
            "Revenue Share Token Ledger ID": "مشاركة الإيرادات - معرّف سجل الرموز",
            "REVSHARE Ledger ID": "معرّف مشاركة الإيرادات السجل",
            "Enter REVSHARE Ledger ID": "أدخل معرّف مشاركة الإيرادات السجل",
            "04 Revenue Operator Verifier Operations": "مشاركة الإيرادات، 04 عمليات الإيرادات والمشغّل والتحقق",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "مشاركة الإيرادات، 04 عمليات الإيرادات والمشغّل والتحقق",
            "REVSHARE_Independent_Inspection_Report": "تقرير مشاركة الإيرادات مستقل الفحص",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "مشاركة الإيرادات تقرير فحص مستقل",
            "Revenue Share Token Independent Inspection Report": "مشاركة الإيرادات - تقرير الفحص المستقل للرمز",
            "Select Revenue Share Token Independent Inspection Report": "اختر مشاركة الإيرادات - تقرير الفحص المستقل للرمز",
            "Print of Revenue Share Token Independent Inspection Report": "طباعة مشاركة الإيرادات - تقرير الفحص المستقل للرمز",
            "Revenue Share Token Inspection Report ID": "مشاركة الإيرادات - معرّف تقرير فحص الرمز",
            "REVSHARE Inspection Report ID": "معرّف تقرير مشاركة الإيرادات الفحص",
            "Enter REVSHARE Inspection Report ID": "أدخل معرّف تقرير مشاركة الإيرادات الفحص",
            "REVSHARE_Revenue_Verification_Report": "تقرير التحقق من إيرادات مشاركة الإيرادات",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "التحقق من إيرادات مشاركة الإيرادات التقرير",
            "Revenue Share Revenue Verification Report": "مشاركة الإيرادات - تقرير التحقق من الإيرادات",
            "Select Revenue Share Revenue Verification Report": "اختر مشاركة الإيرادات - تقرير التحقق من الإيرادات",
            "Print of Revenue Share Revenue Verification Report": "طباعة مشاركة الإيرادات - تقرير التحقق من الإيرادات",
            "Revenue Share Verification ID": "مشاركة الإيرادات - معرّف التحقق",
            "REVSHARE Revenue Verification ID": "معرّف التحقق من إيرادات مشاركة الإيرادات",
            "Enter REVSHARE Revenue Verification ID": "أدخل معرّف التحقق من إيرادات مشاركة الإيرادات",
            "Revenue Source ID": "معرّف مصدر الإيرادات",
            "Enter Revenue Source ID": "أدخل معرّف مصدر الإيرادات",
            "Reported Gross Revenue USD": "مُبلغ عنه الإجمالي الإيرادات بالدولار الأمريكي",
            "Enter Reported Gross Revenue USD": "أدخل مُبلغ عنه الإجمالي الإيرادات بالدولار الأمريكي",
            "Verified Gross Revenue USD": "موثّق الإجمالي الإيرادات بالدولار الأمريكي",
            "Enter Verified Gross Revenue USD": "أدخل موثّق الإجمالي الإيرادات بالدولار الأمريكي",
            "Allowable Deductions USD": "مسموح الخصومات بالدولار الأمريكي",
            "Enter Allowable Deductions USD": "أدخل مسموح الخصومات بالدولار الأمريكي",
            "Net Revenue USD": "الصافي الإيرادات بالدولار الأمريكي",
            "Enter Net Revenue USD": "أدخل الصافي الإيرادات بالدولار الأمريكي",
            "Variance USD": "الانحراف بالدولار الأمريكي",
            "Enter Variance USD": "أدخل الانحراف بالدولار الأمريكي",
            "Verification Report Link": "رابط تقرير التحقق",
            "Enter Verification Report Link": "أدخل رابط تقرير التحقق",
            "05 Finance Escrow Distribution Reporting": "مشاركة الإيرادات، 05 التمويل وحساب الضمان والتوزيع وإعداد التقارير",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "مشاركة الإيرادات، 05 التمويل وحساب الضمان والتوزيع وإعداد التقارير",
            "REVSHARE_Escrow_Release_Package": "مشاركة الإيرادات حزمة الإفراج من حساب الضمان",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "مشاركة الإيرادات حزمة الإفراج من حساب الضمان",
            "Revenue Share Token Escrow Release Package": "مشاركة الإيرادات - حزمة الإفراج من حساب الضمان للرمز",
            "Select Revenue Share Token Escrow Release Package": "اختر مشاركة الإيرادات - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Revenue Share Token Escrow Release Package": "طباعة مشاركة الإيرادات - حزمة الإفراج من حساب الضمان للرمز",
            "Revenue Share Token Escrow Release Package ID": "مشاركة الإيرادات - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "REVSHARE Escrow Release Package ID": "معرّف مشاركة الإيرادات حزمة الإفراج من حساب الضمان",
            "Enter REVSHARE Escrow Release Package ID": "أدخل معرّف مشاركة الإيرادات حزمة الإفراج من حساب الضمان",
            "REVSHARE_Distribution_Calculation": "مشاركة الإيرادات حساب التوزيع",
            "REVSHARE_DISTRIBUTION_CALCULATION": "مشاركة الإيرادات حساب التوزيع",
            "Revenue Share Token Distribution Calculation": "مشاركة الإيرادات - حساب توزيعات الرمز",
            "Select Revenue Share Token Distribution Calculation": "اختر مشاركة الإيرادات - حساب توزيعات الرمز",
            "Print of Revenue Share Token Distribution Calculation": "طباعة مشاركة الإيرادات - حساب توزيعات الرمز",
            "Revenue Share Token Distribution ID": "مشاركة الإيرادات - معرّف الرمز التوزيع",
            "REVSHARE Distribution ID": "معرّف مشاركة الإيرادات التوزيع",
            "Enter REVSHARE Distribution ID": "أدخل معرّف مشاركة الإيرادات التوزيع",
            "REVSHARE_Investor_Report": "تقرير مشاركة الإيرادات المستثمر",
            "REVSHARE_INVESTOR_REPORT": "مشاركة الإيرادات تقرير المستثمر",
            "Revenue Share Token Investor Report": "مشاركة الإيرادات - تقرير المستثمر للرمز",
            "Select Revenue Share Token Investor Report": "اختر مشاركة الإيرادات - تقرير المستثمر للرمز",
            "Print of Revenue Share Token Investor Report": "طباعة مشاركة الإيرادات - تقرير المستثمر للرمز",
            "Revenue Share Token Investor Report ID": "مشاركة الإيرادات - معرّف تقرير المستثمر للرمز",
            "REVSHARE Investor Report ID": "معرّف تقرير مشاركة الإيرادات المستثمر",
            "Enter REVSHARE Investor Report ID": "أدخل معرّف تقرير مشاركة الإيرادات المستثمر",
            "06 Sponsor Governance Lifecycle Exit": "مشاركة الإيرادات، 06 حوكمة الراعي ودورة الحياة والخروج",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "مشاركة الإيرادات، 06 حوكمة الراعي ودورة الحياة والخروج",
            "REVSHARE_Lifecycle_Milestone": "مشاركة الإيرادات مرحلة دورة الحياة",
            "REVSHARE_LIFECYCLE_MILESTONE": "مشاركة الإيرادات مرحلة دورة الحياة",
            "Revenue Share Token Lifecycle Milestone": "مشاركة الإيرادات - مرحلة دورة حياة الرمز",
            "Select Revenue Share Token Lifecycle Milestone": "اختر مشاركة الإيرادات - مرحلة دورة حياة الرمز",
            "Print of Revenue Share Token Lifecycle Milestone": "طباعة مشاركة الإيرادات - مرحلة دورة حياة الرمز",
            "Revenue Share Token Milestone ID": "مشاركة الإيرادات - معرّف مرحلة الرمز",
            "REVSHARE Milestone ID": "معرّف مشاركة الإيرادات المعلم",
            "Enter REVSHARE Milestone ID": "أدخل معرّف مشاركة الإيرادات المعلم",
            "REVSHARE_Exit_Strategy": "مشاركة الإيرادات استراتيجية الخروج",
            "REVSHARE_EXIT_STRATEGY": "مشاركة الإيرادات استراتيجية الخروج",
            "Revenue Share Token Exit Strategy": "مشاركة الإيرادات - استراتيجية خروج الرمز",
            "Select Revenue Share Token Exit Strategy": "اختر مشاركة الإيرادات - استراتيجية خروج الرمز",
            "Print of Revenue Share Token Exit Strategy": "طباعة مشاركة الإيرادات - استراتيجية خروج الرمز",
            "Revenue Share Token Exit Strategy ID": "مشاركة الإيرادات - معرّف استراتيجية خروج الرمز",
            "REVSHARE Exit Strategy ID": "معرّف مشاركة الإيرادات استراتيجية الخروج",
            "Enter REVSHARE Exit Strategy ID": "أدخل معرّف مشاركة الإيرادات استراتيجية الخروج",
            "01 Asset Owner Sponsor Asset Exit Setup": "ربح البيع، 01 إعداد الأصل والخروج لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "ربح البيع، 01 إعداد الأصل والخروج لمالك الأصل/الراعي",
            "SALEPROFIT_Asset_Profile": "ملف ربح البيع الأصل",
            "SALEPROFIT_ASSET_PROFILE": "ربح البيع ملف الأصل",
            "Sale Profit Asset Profile": "ربح البيع - ملف الأصل",
            "Select Sale Profit Asset Profile": "اختر ربح البيع - ملف الأصل",
            "Print of Sale Profit Asset Profile": "طباعة ربح البيع - ملف الأصل",
            "Sale Profit Token Asset Profile ID": "ربح البيع - معرّف ملف أصل الرمز",
            "SALEPROFIT Asset Profile ID": "معرّف ملف ربح البيع الأصل",
            "Enter SALEPROFIT Asset Profile ID": "أدخل معرّف ملف ربح البيع الأصل",
            "SALEPROFIT_Exit_Strategy": "ربح البيع استراتيجية الخروج",
            "SALEPROFIT_EXIT_STRATEGY": "ربح البيع استراتيجية الخروج",
            "Sale Profit Token Exit Strategy": "ربح البيع - استراتيجية خروج الرمز",
            "Select Sale Profit Token Exit Strategy": "اختر ربح البيع - استراتيجية خروج الرمز",
            "Print of Sale Profit Token Exit Strategy": "طباعة ربح البيع - استراتيجية خروج الرمز",
            "Sale Profit Token Exit Strategy ID": "ربح البيع - معرّف استراتيجية خروج الرمز",
            "SALEPROFIT Exit Strategy ID": "معرّف ربح البيع استراتيجية الخروج",
            "Enter SALEPROFIT Exit Strategy ID": "أدخل معرّف ربح البيع استراتيجية الخروج",
            "02 Offering Legal Compliance Readiness": "ربح البيع، 02 جاهزية الطرح القانونية والامتثال",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "ربح البيع، 02 جاهزية الطرح القانونية والامتثال",
            "SALEPROFIT_Token_Offering": "ربح البيع طرح الرمز",
            "SALEPROFIT_TOKEN_OFFERING": "ربح البيع طرح الرمز",
            "Sale Profit Token Offering": "ربح البيع - طرح الرمز",
            "Select Sale Profit Token Offering": "اختر ربح البيع - طرح الرمز",
            "Print of Sale Profit Token Offering": "طباعة ربح البيع - طرح الرمز",
            "Sale Profit Token Offering ID": "ربح البيع - معرّف طرح الرمز",
            "SALEPROFIT Offering ID": "معرّف ربح البيع الطرح",
            "Enter SALEPROFIT Offering ID": "أدخل معرّف ربح البيع الطرح",
            "SALEPROFIT_Token_Class": "ربح البيع فئة الرمز",
            "SALEPROFIT_TOKEN_CLASS": "ربح البيع فئة الرمز",
            "Sale Profit Token Token Class": "ربح البيع - فئة الرمز",
            "Select Sale Profit Token Token Class": "اختر ربح البيع - فئة الرمز",
            "Print of Sale Profit Token Token Class": "طباعة ربح البيع - فئة الرمز",
            "Sale Profit Token Token Class ID": "ربح البيع - معرّف فئة الرمز",
            "SALEPROFIT Token Class ID": "معرّف ربح البيع فئة الرمز",
            "Enter SALEPROFIT Token Class ID": "أدخل معرّف ربح البيع فئة الرمز",
            "SALEPROFIT_Token_Economics": "ربح البيع اقتصاديات الرمز",
            "SALEPROFIT_TOKEN_ECONOMICS": "ربح البيع اقتصاديات الرمز",
            "Sale Profit Token Token Economics": "ربح البيع - اقتصاديات الرمز",
            "Select Sale Profit Token Token Economics": "اختر ربح البيع - اقتصاديات الرمز",
            "Print of Sale Profit Token Token Economics": "طباعة ربح البيع - اقتصاديات الرمز",
            "Sale Profit Token Token Economics ID": "ربح البيع - معرّف اقتصاديات الرمز",
            "SALEPROFIT Token Economics ID": "معرّف ربح البيع اقتصاديات الرمز",
            "Enter SALEPROFIT Token Economics ID": "أدخل معرّف ربح البيع اقتصاديات الرمز",
            "SALEPROFIT_Legal_Rights_Matrix": "مصفوفة ربح البيع قانوني الحقوق",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "ربح البيع مصفوفة الحقوق القانونية",
            "Sale Profit Token Legal Rights Matrix": "ربح البيع - مصفوفة الحقوق القانونية للرمز",
            "Select Sale Profit Token Legal Rights Matrix": "اختر ربح البيع - مصفوفة الحقوق القانونية للرمز",
            "Print of Sale Profit Token Legal Rights Matrix": "طباعة ربح البيع - مصفوفة الحقوق القانونية للرمز",
            "Sale Profit Token Rights Matrix ID": "ربح البيع - معرّف مصفوفة حقوق الرمز",
            "SALEPROFIT Rights Matrix ID": "معرّف مصفوفة ربح البيع الحقوق",
            "Enter SALEPROFIT Rights Matrix ID": "أدخل معرّف مصفوفة ربح البيع الحقوق",
            "SALEPROFIT_Risk_Score": "درجة ربح البيع المخاطر",
            "SALEPROFIT_RISK_SCORE": "ربح البيع درجة المخاطر",
            "Sale Profit Token Risk Score": "ربح البيع - درجة مخاطر الرمز",
            "Select Sale Profit Token Risk Score": "اختر ربح البيع - درجة مخاطر الرمز",
            "Print of Sale Profit Token Risk Score": "طباعة ربح البيع - درجة مخاطر الرمز",
            "Sale Profit Token Risk Score ID": "ربح البيع - معرّف درجة مخاطر الرمز",
            "SALEPROFIT Risk Score ID": "معرّف درجة ربح البيع المخاطر",
            "Enter SALEPROFIT Risk Score ID": "أدخل معرّف درجة ربح البيع المخاطر",
            "SALEPROFIT_Independent_Inspection_Report": "تقرير ربح البيع مستقل الفحص",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "ربح البيع تقرير فحص مستقل",
            "Sale Profit Token Independent Inspection Report": "ربح البيع - تقرير الفحص المستقل للرمز",
            "Select Sale Profit Token Independent Inspection Report": "اختر ربح البيع - تقرير الفحص المستقل للرمز",
            "Print of Sale Profit Token Independent Inspection Report": "طباعة ربح البيع - تقرير الفحص المستقل للرمز",
            "Sale Profit Token Inspection Report ID": "ربح البيع - معرّف تقرير فحص الرمز",
            "SALEPROFIT Inspection Report ID": "معرّف تقرير ربح البيع الفحص",
            "Enter SALEPROFIT Inspection Report ID": "أدخل معرّف تقرير ربح البيع الفحص",
            "03 Investor Subscription Token Issuance": "ربح البيع، 03 اكتتاب المستثمر وإصدار الرمز",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "ربح البيع، 03 اكتتاب المستثمر وإصدار الرمز",
            "SALEPROFIT_Subscription_Order": "ربح البيع طلب الاكتتاب",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "ربح البيع طلب الاكتتاب",
            "Sale Profit Token Subscription Order": "ربح البيع - طلب اكتتاب الرمز",
            "Select Sale Profit Token Subscription Order": "اختر ربح البيع - طلب اكتتاب الرمز",
            "Print of Sale Profit Token Subscription Order": "طباعة ربح البيع - طلب اكتتاب الرمز",
            "Sale Profit Token Subscription ID": "ربح البيع - معرّف الرمز الاشتراك",
            "SALEPROFIT Subscription ID": "معرّف ربح البيع الاشتراك",
            "Enter SALEPROFIT Subscription ID": "أدخل معرّف ربح البيع الاشتراك",
            "SALEPROFIT_Token_Ledger": "ربح البيع سجل الرموز",
            "SALEPROFIT_TOKEN_LEDGER": "ربح البيع سجل الرموز",
            "Sale Profit Token Token Ledger": "ربح البيع - سجل الرمز",
            "Select Sale Profit Token Token Ledger": "اختر ربح البيع - سجل الرمز",
            "Print of Sale Profit Token Token Ledger": "طباعة ربح البيع - سجل الرمز",
            "Sale Profit Token Ledger ID": "ربح البيع - معرّف سجل الرموز",
            "SALEPROFIT Ledger ID": "معرّف ربح البيع السجل",
            "Enter SALEPROFIT Ledger ID": "أدخل معرّف ربح البيع السجل",
            "04 Asset Manager Sale Process Execution": "ربح البيع، 04 إدارة الأصل وتنفيذ عملية البيع",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "ربح البيع، 04 إدارة الأصل وتنفيذ عملية البيع",
            "SALEPROFIT_Lifecycle_Milestone": "ربح البيع مرحلة دورة الحياة",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "ربح البيع مرحلة دورة الحياة",
            "Sale Profit Token Lifecycle Milestone": "ربح البيع - مرحلة دورة حياة الرمز",
            "Select Sale Profit Token Lifecycle Milestone": "اختر ربح البيع - مرحلة دورة حياة الرمز",
            "Print of Sale Profit Token Lifecycle Milestone": "طباعة ربح البيع - مرحلة دورة حياة الرمز",
            "Sale Profit Token Milestone ID": "ربح البيع - معرّف مرحلة الرمز",
            "SALEPROFIT Milestone ID": "معرّف ربح البيع المعلم",
            "Enter SALEPROFIT Milestone ID": "أدخل معرّف ربح البيع المعلم",
            "SALEPROFIT_Sale_Process": "ربح البيع عملية البيع",
            "SALEPROFIT_SALE_PROCESS": "ربح البيع عملية البيع",
            "Sale Profit Sale Process": "ربح البيع - عملية البيع",
            "Select Sale Profit Sale Process": "اختر ربح البيع - عملية البيع",
            "Print of Sale Profit Sale Process": "طباعة ربح البيع - عملية البيع",
            "Sale Profit Sale Process ID": "ربح البيع - معرّف عملية البيع",
            "SALEPROFIT Sale Process ID": "معرّف ربح البيع عملية البيع",
            "Enter SALEPROFIT Sale Process ID": "أدخل معرّف ربح البيع عملية البيع",
            "Broker ID": "معرّف الوسيط",
            "Enter Broker ID": "أدخل معرّف الوسيط",
            "Listing Date": "تاريخ الإدراج",
            "Enter Listing Date": "أدخل تاريخ الإدراج",
            "Asking Price USD": "المطلوب السعر بالدولار الأمريكي",
            "Enter Asking Price USD": "أدخل المطلوب السعر بالدولار الأمريكي",
            "Offer Received USD": "العرض تم الاستلام بالدولار الأمريكي",
            "Enter Offer Received USD": "أدخل العرض تم الاستلام بالدولار الأمريكي",
            "Accepted Offer USD": "مقبول العرض بالدولار الأمريكي",
            "Enter Accepted Offer USD": "أدخل مقبول العرض بالدولار الأمريكي",
            "Closing Date": "تاريخ الإغلاق",
            "Enter Closing Date": "أدخل تاريخ الإغلاق",
            "Sale Status": "حالة البيع",
            "Enter Sale Status": "أدخل حالة البيع",
            "05 Finance Escrow Profit Distribution": "ربح البيع، 05 التمويل وحساب الضمان وتوزيع الأرباح",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "ربح البيع، 05 التمويل وحساب الضمان وتوزيع الأرباح",
            "SALEPROFIT_Profit_Waterfall": "ربح البيع الربح تسلسل التوزيع",
            "SALEPROFIT_PROFIT_WATERFALL": "ربح البيع الربح تسلسل التوزيع",
            "Sale Profit Waterfall": "ربح البيع - تسلسل التوزيع",
            "Select Sale Profit Waterfall": "اختر ربح البيع - تسلسل التوزيع",
            "Print of Sale Profit Waterfall": "طباعة ربح البيع - تسلسل التوزيع",
            "Sale Profit Waterfall ID": "ربح البيع - معرّف تسلسل التوزيع",
            "SALEPROFIT Profit Waterfall ID": "معرّف ربح البيع الربح تسلسل التوزيع",
            "Enter SALEPROFIT Profit Waterfall ID": "أدخل معرّف ربح البيع الربح تسلسل التوزيع",
            "Gross Sale Proceeds USD": "إجمالي متحصلات البيع بالدولار الأمريكي",
            "Enter Gross Sale Proceeds USD": "أدخل إجمالي متحصلات البيع بالدولار الأمريكي",
            "Closing Costs USD": "الإغلاق التكاليف بالدولار الأمريكي",
            "Enter Closing Costs USD": "أدخل الإغلاق التكاليف بالدولار الأمريكي",
            "Debt Payoff USD": "الدين السداد بالدولار الأمريكي",
            "Enter Debt Payoff USD": "أدخل الدين السداد بالدولار الأمريكي",
            "Reserve Release USD": "الاحتياطي الإفراج بالدولار الأمريكي",
            "Enter Reserve Release USD": "أدخل الاحتياطي الإفراج بالدولار الأمريكي",
            "Net Sale Profit USD": "صافي ربح البيع بالدولار الأمريكي",
            "Enter Net Sale Profit USD": "أدخل صافي ربح البيع بالدولار الأمريكي",
            "Waterfall Calculation Link": "رابط تسلسل التوزيع الحساب",
            "Enter Waterfall Calculation Link": "أدخل رابط تسلسل التوزيع الحساب",
            "SALEPROFIT_Distribution_Calculation": "ربح البيع حساب التوزيع",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "ربح البيع حساب التوزيع",
            "Sale Profit Token Distribution Calculation": "ربح البيع - حساب توزيعات الرمز",
            "Select Sale Profit Token Distribution Calculation": "اختر ربح البيع - حساب توزيعات الرمز",
            "Print of Sale Profit Token Distribution Calculation": "طباعة ربح البيع - حساب توزيعات الرمز",
            "Sale Profit Token Distribution ID": "ربح البيع - معرّف الرمز التوزيع",
            "SALEPROFIT Distribution ID": "معرّف ربح البيع التوزيع",
            "Enter SALEPROFIT Distribution ID": "أدخل معرّف ربح البيع التوزيع",
            "SALEPROFIT_Escrow_Release_Package": "ربح البيع حزمة الإفراج من حساب الضمان",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "ربح البيع حزمة الإفراج من حساب الضمان",
            "Sale Profit Token Escrow Release Package": "ربح البيع - حزمة الإفراج من حساب الضمان للرمز",
            "Select Sale Profit Token Escrow Release Package": "اختر ربح البيع - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Sale Profit Token Escrow Release Package": "طباعة ربح البيع - حزمة الإفراج من حساب الضمان للرمز",
            "Sale Profit Token Escrow Release Package ID": "ربح البيع - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "SALEPROFIT Escrow Release Package ID": "معرّف ربح البيع حزمة الإفراج من حساب الضمان",
            "Enter SALEPROFIT Escrow Release Package ID": "أدخل معرّف ربح البيع حزمة الإفراج من حساب الضمان",
            "06 Investor Relations Tax Closeout": "ربح البيع، 06 علاقات المستثمرين والضرائب والإقفال",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "ربح البيع، 06 علاقات المستثمرين والضرائب والإقفال",
            "SALEPROFIT_Investor_Report": "تقرير ربح البيع المستثمر",
            "SALEPROFIT_INVESTOR_REPORT": "ربح البيع تقرير المستثمر",
            "Sale Profit Token Investor Report": "ربح البيع - تقرير المستثمر للرمز",
            "Select Sale Profit Token Investor Report": "اختر ربح البيع - تقرير المستثمر للرمز",
            "Print of Sale Profit Token Investor Report": "طباعة ربح البيع - تقرير المستثمر للرمز",
            "Sale Profit Token Investor Report ID": "ربح البيع - معرّف تقرير المستثمر للرمز",
            "SALEPROFIT Investor Report ID": "معرّف تقرير ربح البيع المستثمر",
            "Enter SALEPROFIT Investor Report ID": "أدخل معرّف تقرير ربح البيع المستثمر",
            "01 Asset Owner Sponsor NAV Asset Setup": "ارتفاع قيمة حقوق الملكية، 01 إعداد الأصل وNAV لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "ارتفاع قيمة حقوق الملكية، 01 إعداد الأصل وNAV لمالك الأصل/الراعي",
            "EQAPP_Asset_Profile": "ملف ارتفاع قيمة حقوق الملكية الأصل",
            "EQAPP_ASSET_PROFILE": "ارتفاع قيمة حقوق الملكية ملف الأصل",
            "Equity Appreciation Asset Profile": "ارتفاع قيمة حقوق الملكية - ملف الأصل",
            "Select Equity Appreciation Asset Profile": "اختر ارتفاع قيمة حقوق الملكية - ملف الأصل",
            "Print of Equity Appreciation Asset Profile": "طباعة ارتفاع قيمة حقوق الملكية - ملف الأصل",
            "Equity Appreciation Token Asset Profile ID": "ارتفاع قيمة حقوق الملكية - معرّف ملف أصل الرمز",
            "EQAPP Asset Profile ID": "معرّف ملف ارتفاع قيمة حقوق الملكية الأصل",
            "Enter EQAPP Asset Profile ID": "أدخل معرّف ملف ارتفاع قيمة حقوق الملكية الأصل",
            "02 Offering NAV Legal Compliance Readiness": "ارتفاع قيمة حقوق الملكية، 02 جاهزية الطرح وNAV والشؤون القانونية والامتثال",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "ارتفاع قيمة حقوق الملكية، 02 جاهزية الطرح وNAV والشؤون القانونية والامتثال",
            "EQAPP_Token_Offering": "ارتفاع قيمة حقوق الملكية طرح الرمز",
            "EQAPP_TOKEN_OFFERING": "ارتفاع قيمة حقوق الملكية طرح الرمز",
            "Equity Appreciation Token Offering": "ارتفاع قيمة حقوق الملكية - طرح الرمز",
            "Select Equity Appreciation Token Offering": "اختر ارتفاع قيمة حقوق الملكية - طرح الرمز",
            "Print of Equity Appreciation Token Offering": "طباعة ارتفاع قيمة حقوق الملكية - طرح الرمز",
            "Equity Appreciation Token Offering ID": "ارتفاع قيمة حقوق الملكية - معرّف طرح الرمز",
            "EQAPP Offering ID": "معرّف ارتفاع قيمة حقوق الملكية الطرح",
            "Enter EQAPP Offering ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية الطرح",
            "EQAPP_Token_Class": "ارتفاع قيمة حقوق الملكية فئة الرمز",
            "EQAPP_TOKEN_CLASS": "ارتفاع قيمة حقوق الملكية فئة الرمز",
            "Equity Appreciation Token Token Class": "ارتفاع قيمة حقوق الملكية - فئة الرمز",
            "Select Equity Appreciation Token Token Class": "اختر ارتفاع قيمة حقوق الملكية - فئة الرمز",
            "Print of Equity Appreciation Token Token Class": "طباعة ارتفاع قيمة حقوق الملكية - فئة الرمز",
            "Equity Appreciation Token Token Class ID": "ارتفاع قيمة حقوق الملكية - معرّف فئة الرمز",
            "EQAPP Token Class ID": "معرّف ارتفاع قيمة حقوق الملكية فئة الرمز",
            "Enter EQAPP Token Class ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية فئة الرمز",
            "EQAPP_Token_Economics": "ارتفاع قيمة حقوق الملكية اقتصاديات الرمز",
            "EQAPP_TOKEN_ECONOMICS": "ارتفاع قيمة حقوق الملكية اقتصاديات الرمز",
            "Equity Appreciation Token Token Economics": "ارتفاع قيمة حقوق الملكية - اقتصاديات الرمز",
            "Select Equity Appreciation Token Token Economics": "اختر ارتفاع قيمة حقوق الملكية - اقتصاديات الرمز",
            "Print of Equity Appreciation Token Token Economics": "طباعة ارتفاع قيمة حقوق الملكية - اقتصاديات الرمز",
            "Equity Appreciation Token Token Economics ID": "ارتفاع قيمة حقوق الملكية - معرّف اقتصاديات الرمز",
            "EQAPP Token Economics ID": "معرّف ارتفاع قيمة حقوق الملكية اقتصاديات الرمز",
            "Enter EQAPP Token Economics ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية اقتصاديات الرمز",
            "EQAPP_Legal_Rights_Matrix": "مصفوفة ارتفاع قيمة حقوق الملكية قانوني الحقوق",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "ارتفاع قيمة حقوق الملكية مصفوفة الحقوق القانونية",
            "Equity Appreciation Token Legal Rights Matrix": "ارتفاع قيمة حقوق الملكية - مصفوفة الحقوق القانونية للرمز",
            "Select Equity Appreciation Token Legal Rights Matrix": "اختر ارتفاع قيمة حقوق الملكية - مصفوفة الحقوق القانونية للرمز",
            "Print of Equity Appreciation Token Legal Rights Matrix": "طباعة ارتفاع قيمة حقوق الملكية - مصفوفة الحقوق القانونية للرمز",
            "Equity Appreciation Token Rights Matrix ID": "ارتفاع قيمة حقوق الملكية - معرّف مصفوفة حقوق الرمز",
            "EQAPP Rights Matrix ID": "معرّف مصفوفة ارتفاع قيمة حقوق الملكية الحقوق",
            "Enter EQAPP Rights Matrix ID": "أدخل معرّف مصفوفة ارتفاع قيمة حقوق الملكية الحقوق",
            "EQAPP_NAV_Valuation_Report": "تقرير ارتفاع قيمة حقوق الملكية NAV التقييم",
            "EQAPP_NAV_VALUATION_REPORT": "ارتفاع قيمة حقوق الملكية تقرير تقييم NAV",
            "Equity Appreciation NAV Valuation Report": "ارتفاع قيمة حقوق الملكية - تقرير تقييم NAV",
            "Select Equity Appreciation NAV Valuation Report": "اختر ارتفاع قيمة حقوق الملكية - تقرير تقييم NAV",
            "Print of Equity Appreciation NAV Valuation Report": "طباعة ارتفاع قيمة حقوق الملكية - تقرير تقييم NAV",
            "Equity Appreciation NAV Report ID": "ارتفاع قيمة حقوق الملكية - معرّف تقرير NAV",
            "EQAPP NAV Report ID": "معرّف تقرير ارتفاع قيمة حقوق الملكية NAV",
            "Enter EQAPP NAV Report ID": "أدخل معرّف تقرير ارتفاع قيمة حقوق الملكية NAV",
            "Valuation Date": "تاريخ التقييم",
            "Enter Valuation Date": "أدخل تاريخ التقييم",
            "Prior NAV USD": "سابق NAV بالدولار الأمريكي",
            "Enter Prior NAV USD": "أدخل سابق NAV بالدولار الأمريكي",
            "Current NAV USD": "الحالي NAV بالدولار الأمريكي",
            "Enter Current NAV USD": "أدخل الحالي NAV بالدولار الأمريكي",
            "NAV Per Token USD": "NAV لكل الرمز بالدولار الأمريكي",
            "Enter NAV Per Token USD": "أدخل NAV لكل الرمز بالدولار الأمريكي",
            "Equity Appreciation USD": "ارتفاع قيمة حقوق الملكية - USD",
            "Enter Equity Appreciation USD": "أدخل ارتفاع قيمة حقوق الملكية - USD",
            "Valuation Notes": "ملاحظات التقييم",
            "Enter Valuation Notes": "أدخل ملاحظات التقييم",
            "EQAPP_Appreciation_Calculation": "ارتفاع قيمة حقوق الملكية ارتفاع القيمة الحساب",
            "EQAPP_APPRECIATION_CALCULATION": "ارتفاع قيمة حقوق الملكية ارتفاع القيمة الحساب",
            "Equity Appreciation Calculation": "ارتفاع قيمة حقوق الملكية - الحساب",
            "Select Equity Appreciation Calculation": "اختر ارتفاع قيمة حقوق الملكية - الحساب",
            "Print of Equity Appreciation Calculation": "طباعة ارتفاع قيمة حقوق الملكية - الحساب",
            "Equity Appreciation Calculation ID": "ارتفاع قيمة حقوق الملكية - معرّف الحساب",
            "EQAPP Appreciation Calc ID": "معرّف ارتفاع قيمة حقوق الملكية ارتفاع القيمة الحساب",
            "Enter EQAPP Appreciation Calc ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية ارتفاع القيمة الحساب",
            "Opening Asset Value USD": "الافتتاح الأصل القيمة بالدولار الأمريكي",
            "Enter Opening Asset Value USD": "أدخل الافتتاح الأصل القيمة بالدولار الأمريكي",
            "Current Asset Value USD": "الحالي الأصل القيمة بالدولار الأمريكي",
            "Enter Current Asset Value USD": "أدخل الحالي الأصل القيمة بالدولار الأمريكي",
            "Debt Balance USD": "الدين الرصيد بالدولار الأمريكي",
            "Enter Debt Balance USD": "أدخل الدين الرصيد بالدولار الأمريكي",
            "Net Equity Value USD": "الصافي حقوق الملكية القيمة بالدولار الأمريكي",
            "Enter Net Equity Value USD": "أدخل الصافي حقوق الملكية القيمة بالدولار الأمريكي",
            "Appreciation Amount USD": "مبلغ ارتفاع القيمة بالدولار الأمريكي",
            "Enter Appreciation Amount USD": "أدخل مبلغ ارتفاع القيمة بالدولار الأمريكي",
            "Appreciation Percentage": "نسبة ارتفاع القيمة",
            "Enter Appreciation Percentage": "أدخل نسبة ارتفاع القيمة",
            "Allocation To Tokens USD": "التخصيص إلى الرموز بالدولار الأمريكي",
            "Enter Allocation To Tokens USD": "أدخل التخصيص إلى الرموز بالدولار الأمريكي",
            "EQAPP_Risk_Score": "درجة ارتفاع قيمة حقوق الملكية المخاطر",
            "EQAPP_RISK_SCORE": "ارتفاع قيمة حقوق الملكية درجة المخاطر",
            "Equity Appreciation Token Risk Score": "ارتفاع قيمة حقوق الملكية - درجة مخاطر الرمز",
            "Select Equity Appreciation Token Risk Score": "اختر ارتفاع قيمة حقوق الملكية - درجة مخاطر الرمز",
            "Print of Equity Appreciation Token Risk Score": "طباعة ارتفاع قيمة حقوق الملكية - درجة مخاطر الرمز",
            "Equity Appreciation Token Risk Score ID": "ارتفاع قيمة حقوق الملكية - معرّف درجة مخاطر الرمز",
            "EQAPP Risk Score ID": "معرّف درجة ارتفاع قيمة حقوق الملكية المخاطر",
            "Enter EQAPP Risk Score ID": "أدخل معرّف درجة ارتفاع قيمة حقوق الملكية المخاطر",
            "EQAPP_Independent_Inspection_Report": "تقرير ارتفاع قيمة حقوق الملكية مستقل الفحص",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "ارتفاع قيمة حقوق الملكية تقرير فحص مستقل",
            "Equity Appreciation Token Independent Inspection Report": "ارتفاع قيمة حقوق الملكية - تقرير الفحص المستقل للرمز",
            "Select Equity Appreciation Token Independent Inspection Report": "اختر ارتفاع قيمة حقوق الملكية - تقرير الفحص المستقل للرمز",
            "Print of Equity Appreciation Token Independent Inspection Report": "طباعة ارتفاع قيمة حقوق الملكية - تقرير الفحص المستقل للرمز",
            "Equity Appreciation Token Inspection Report ID": "ارتفاع قيمة حقوق الملكية - معرّف تقرير فحص الرمز",
            "EQAPP Inspection Report ID": "معرّف تقرير ارتفاع قيمة حقوق الملكية الفحص",
            "Enter EQAPP Inspection Report ID": "أدخل معرّف تقرير ارتفاع قيمة حقوق الملكية الفحص",
            "03 Investor Subscription Token Issuance": "ارتفاع قيمة حقوق الملكية، 03 اكتتاب المستثمر وإصدار الرمز",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "ارتفاع قيمة حقوق الملكية، 03 اكتتاب المستثمر وإصدار الرمز",
            "EQAPP_Subscription_Order": "ارتفاع قيمة حقوق الملكية طلب الاكتتاب",
            "EQAPP_SUBSCRIPTION_ORDER": "ارتفاع قيمة حقوق الملكية طلب الاكتتاب",
            "Equity Appreciation Token Subscription Order": "ارتفاع قيمة حقوق الملكية - طلب اكتتاب الرمز",
            "Select Equity Appreciation Token Subscription Order": "اختر ارتفاع قيمة حقوق الملكية - طلب اكتتاب الرمز",
            "Print of Equity Appreciation Token Subscription Order": "طباعة ارتفاع قيمة حقوق الملكية - طلب اكتتاب الرمز",
            "Equity Appreciation Token Subscription ID": "ارتفاع قيمة حقوق الملكية - معرّف الرمز الاشتراك",
            "EQAPP Subscription ID": "معرّف ارتفاع قيمة حقوق الملكية الاشتراك",
            "Enter EQAPP Subscription ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية الاشتراك",
            "EQAPP_Token_Ledger": "ارتفاع قيمة حقوق الملكية سجل الرموز",
            "EQAPP_TOKEN_LEDGER": "ارتفاع قيمة حقوق الملكية سجل الرموز",
            "Equity Appreciation Token Token Ledger": "ارتفاع قيمة حقوق الملكية - سجل الرمز",
            "Select Equity Appreciation Token Token Ledger": "اختر ارتفاع قيمة حقوق الملكية - سجل الرمز",
            "Print of Equity Appreciation Token Token Ledger": "طباعة ارتفاع قيمة حقوق الملكية - سجل الرمز",
            "Equity Appreciation Token Ledger ID": "ارتفاع قيمة حقوق الملكية - معرّف سجل الرموز",
            "EQAPP Ledger ID": "معرّف ارتفاع قيمة حقوق الملكية السجل",
            "Enter EQAPP Ledger ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية السجل",
            "04 Asset Manager NAV Lifecycle Monitoring": "ارتفاع قيمة حقوق الملكية، 04 إدارة الأصل وNAV ومراقبة دورة الحياة",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "ارتفاع قيمة حقوق الملكية، 04 إدارة الأصل وNAV ومراقبة دورة الحياة",
            "EQAPP_Lifecycle_Milestone": "ارتفاع قيمة حقوق الملكية مرحلة دورة الحياة",
            "EQAPP_LIFECYCLE_MILESTONE": "ارتفاع قيمة حقوق الملكية مرحلة دورة الحياة",
            "Equity Appreciation Token Lifecycle Milestone": "ارتفاع قيمة حقوق الملكية - مرحلة دورة حياة الرمز",
            "Select Equity Appreciation Token Lifecycle Milestone": "اختر ارتفاع قيمة حقوق الملكية - مرحلة دورة حياة الرمز",
            "Print of Equity Appreciation Token Lifecycle Milestone": "طباعة ارتفاع قيمة حقوق الملكية - مرحلة دورة حياة الرمز",
            "Equity Appreciation Token Milestone ID": "ارتفاع قيمة حقوق الملكية - معرّف مرحلة الرمز",
            "EQAPP Milestone ID": "معرّف ارتفاع قيمة حقوق الملكية المعلم",
            "Enter EQAPP Milestone ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية المعلم",
            "05 Finance Escrow Appreciation Distribution": "ارتفاع قيمة حقوق الملكية، 05 التمويل وحساب الضمان وتوزيع عوائد ارتفاع القيمة",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "ارتفاع قيمة حقوق الملكية، 05 التمويل وحساب الضمان وتوزيع عوائد ارتفاع القيمة",
            "EQAPP_Distribution_Calculation": "ارتفاع قيمة حقوق الملكية حساب التوزيع",
            "EQAPP_DISTRIBUTION_CALCULATION": "ارتفاع قيمة حقوق الملكية حساب التوزيع",
            "Equity Appreciation Token Distribution Calculation": "ارتفاع قيمة حقوق الملكية - حساب توزيعات الرمز",
            "Select Equity Appreciation Token Distribution Calculation": "اختر ارتفاع قيمة حقوق الملكية - حساب توزيعات الرمز",
            "Print of Equity Appreciation Token Distribution Calculation": "طباعة ارتفاع قيمة حقوق الملكية - حساب توزيعات الرمز",
            "Equity Appreciation Token Distribution ID": "ارتفاع قيمة حقوق الملكية - معرّف الرمز التوزيع",
            "EQAPP Distribution ID": "معرّف ارتفاع قيمة حقوق الملكية التوزيع",
            "Enter EQAPP Distribution ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية التوزيع",
            "EQAPP_Escrow_Release_Package": "ارتفاع قيمة حقوق الملكية حزمة الإفراج من حساب الضمان",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "ارتفاع قيمة حقوق الملكية حزمة الإفراج من حساب الضمان",
            "Equity Appreciation Token Escrow Release Package": "ارتفاع قيمة حقوق الملكية - حزمة الإفراج من حساب الضمان للرمز",
            "Select Equity Appreciation Token Escrow Release Package": "اختر ارتفاع قيمة حقوق الملكية - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Equity Appreciation Token Escrow Release Package": "طباعة ارتفاع قيمة حقوق الملكية - حزمة الإفراج من حساب الضمان للرمز",
            "Equity Appreciation Token Escrow Release Package ID": "ارتفاع قيمة حقوق الملكية - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "EQAPP Escrow Release Package ID": "معرّف ارتفاع قيمة حقوق الملكية حزمة الإفراج من حساب الضمان",
            "Enter EQAPP Escrow Release Package ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية حزمة الإفراج من حساب الضمان",
            "06 Investor Relations Tax Exit": "ارتفاع قيمة حقوق الملكية، 06 علاقات المستثمرين والضرائب والخروج",
            "06 INVESTOR RELATIONS TAX EXIT": "ارتفاع قيمة حقوق الملكية، 06 علاقات المستثمرين والضرائب والخروج",
            "EQAPP_Investor_Report": "تقرير ارتفاع قيمة حقوق الملكية المستثمر",
            "EQAPP_INVESTOR_REPORT": "ارتفاع قيمة حقوق الملكية تقرير المستثمر",
            "Equity Appreciation Token Investor Report": "ارتفاع قيمة حقوق الملكية - تقرير المستثمر للرمز",
            "Select Equity Appreciation Token Investor Report": "اختر ارتفاع قيمة حقوق الملكية - تقرير المستثمر للرمز",
            "Print of Equity Appreciation Token Investor Report": "طباعة ارتفاع قيمة حقوق الملكية - تقرير المستثمر للرمز",
            "Equity Appreciation Token Investor Report ID": "ارتفاع قيمة حقوق الملكية - معرّف تقرير المستثمر للرمز",
            "EQAPP Investor Report ID": "معرّف تقرير ارتفاع قيمة حقوق الملكية المستثمر",
            "Enter EQAPP Investor Report ID": "أدخل معرّف تقرير ارتفاع قيمة حقوق الملكية المستثمر",
            "EQAPP_Exit_Strategy": "ارتفاع قيمة حقوق الملكية استراتيجية الخروج",
            "EQAPP_EXIT_STRATEGY": "ارتفاع قيمة حقوق الملكية استراتيجية الخروج",
            "Equity Appreciation Token Exit Strategy": "ارتفاع قيمة حقوق الملكية - استراتيجية خروج الرمز",
            "Select Equity Appreciation Token Exit Strategy": "اختر ارتفاع قيمة حقوق الملكية - استراتيجية خروج الرمز",
            "Print of Equity Appreciation Token Exit Strategy": "طباعة ارتفاع قيمة حقوق الملكية - استراتيجية خروج الرمز",
            "Equity Appreciation Token Exit Strategy ID": "ارتفاع قيمة حقوق الملكية - معرّف استراتيجية خروج الرمز",
            "EQAPP Exit Strategy ID": "معرّف ارتفاع قيمة حقوق الملكية استراتيجية الخروج",
            "Enter EQAPP Exit Strategy ID": "أدخل معرّف ارتفاع قيمة حقوق الملكية استراتيجية الخروج",
            "01 Asset Owner Sponsor Preferred Equity Setup": "حقوق الملكية الممتازة، 01 إعداد حقوق الملكية الممتازة لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "حقوق الملكية الممتازة، 01 إعداد حقوق الملكية الممتازة لمالك الأصل/الراعي",
            "PREFEQ_Asset_Profile": "ملف حقوق الملكية الممتازة الأصل",
            "PREFEQ_ASSET_PROFILE": "حقوق الملكية الممتازة ملف الأصل",
            "Preferred Equity Asset Profile": "حقوق الملكية الممتازة - ملف الأصل",
            "Select Preferred Equity Asset Profile": "اختر حقوق الملكية الممتازة - ملف الأصل",
            "Print of Preferred Equity Asset Profile": "طباعة حقوق الملكية الممتازة - ملف الأصل",
            "Preferred Equity Token Asset Profile ID": "حقوق الملكية الممتازة - معرّف ملف أصل الرمز",
            "PREFEQ Asset Profile ID": "معرّف ملف حقوق الملكية الممتازة الأصل",
            "Enter PREFEQ Asset Profile ID": "أدخل معرّف ملف حقوق الملكية الممتازة الأصل",
            "PREFEQ_Token_Offering": "حقوق الملكية الممتازة طرح الرمز",
            "PREFEQ_TOKEN_OFFERING": "حقوق الملكية الممتازة طرح الرمز",
            "Preferred Equity Token Offering": "حقوق الملكية الممتازة - طرح الرمز",
            "Select Preferred Equity Token Offering": "اختر حقوق الملكية الممتازة - طرح الرمز",
            "Print of Preferred Equity Token Offering": "طباعة حقوق الملكية الممتازة - طرح الرمز",
            "Preferred Equity Token Offering ID": "حقوق الملكية الممتازة - معرّف طرح الرمز",
            "PREFEQ Offering ID": "معرّف حقوق الملكية الممتازة الطرح",
            "Enter PREFEQ Offering ID": "أدخل معرّف حقوق الملكية الممتازة الطرح",
            "02 Offering Legal Preferred Waterfall Readiness": "حقوق الملكية الممتازة، 02 جاهزية الطرح القانونية وتسلسل العائد المفضل",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "حقوق الملكية الممتازة، 02 جاهزية الطرح القانونية وتسلسل العائد المفضل",
            "PREFEQ_Token_Class": "حقوق الملكية الممتازة فئة الرمز",
            "PREFEQ_TOKEN_CLASS": "حقوق الملكية الممتازة فئة الرمز",
            "Preferred Equity Token Token Class": "حقوق الملكية الممتازة - فئة الرمز",
            "Select Preferred Equity Token Token Class": "اختر حقوق الملكية الممتازة - فئة الرمز",
            "Print of Preferred Equity Token Token Class": "طباعة حقوق الملكية الممتازة - فئة الرمز",
            "Preferred Equity Token Token Class ID": "حقوق الملكية الممتازة - معرّف فئة الرمز",
            "PREFEQ Token Class ID": "معرّف حقوق الملكية الممتازة فئة الرمز",
            "Enter PREFEQ Token Class ID": "أدخل معرّف حقوق الملكية الممتازة فئة الرمز",
            "PREFEQ_Token_Economics": "حقوق الملكية الممتازة اقتصاديات الرمز",
            "PREFEQ_TOKEN_ECONOMICS": "حقوق الملكية الممتازة اقتصاديات الرمز",
            "Preferred Equity Token Token Economics": "حقوق الملكية الممتازة - اقتصاديات الرمز",
            "Select Preferred Equity Token Token Economics": "اختر حقوق الملكية الممتازة - اقتصاديات الرمز",
            "Print of Preferred Equity Token Token Economics": "طباعة حقوق الملكية الممتازة - اقتصاديات الرمز",
            "Preferred Equity Token Token Economics ID": "حقوق الملكية الممتازة - معرّف اقتصاديات الرمز",
            "PREFEQ Token Economics ID": "معرّف حقوق الملكية الممتازة اقتصاديات الرمز",
            "Enter PREFEQ Token Economics ID": "أدخل معرّف حقوق الملكية الممتازة اقتصاديات الرمز",
            "PREFEQ_Preferred_Return_Waterfall": "حقوق الملكية الممتازة العائد المفضل تسلسل التوزيع",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "حقوق الملكية الممتازة العائد المفضل تسلسل التوزيع",
            "Preferred Equity Return Waterfall": "حقوق الملكية الممتازة - تسلسل العائد",
            "Select Preferred Equity Return Waterfall": "اختر حقوق الملكية الممتازة - تسلسل العائد",
            "Print of Preferred Equity Return Waterfall": "طباعة حقوق الملكية الممتازة - تسلسل العائد",
            "Preferred Equity Waterfall ID": "حقوق الملكية الممتازة - معرّف تسلسل التوزيع",
            "PREFEQ Waterfall ID": "معرّف حقوق الملكية الممتازة تسلسل التوزيع",
            "Enter PREFEQ Waterfall ID": "أدخل معرّف حقوق الملكية الممتازة تسلسل التوزيع",
            "Accrued Preferred Return USD": "مستحق العائد المفضل بالدولار الأمريكي",
            "Enter Accrued Preferred Return USD": "أدخل مستحق العائد المفضل بالدولار الأمريكي",
            "Paid Preferred Return USD": "مدفوع العائد المفضل بالدولار الأمريكي",
            "Enter Paid Preferred Return USD": "أدخل مدفوع العائد المفضل بالدولار الأمريكي",
            "Unpaid Preferred Return USD": "غير مدفوع العائد المفضل بالدولار الأمريكي",
            "Enter Unpaid Preferred Return USD": "أدخل غير مدفوع العائد المفضل بالدولار الأمريكي",
            "Catch Up Required": "المعالجة أعلى مطلوب",
            "Enter Catch Up Required": "حدّد حالة اشتراط المعالجة أعلى",
            "Waterfall Report Link": "رابط تقرير تسلسل التوزيع",
            "Enter Waterfall Report Link": "أدخل رابط تقرير تسلسل التوزيع",
            "PREFEQ_Legal_Rights_Matrix": "مصفوفة حقوق الملكية الممتازة قانوني الحقوق",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "حقوق الملكية الممتازة مصفوفة الحقوق القانونية",
            "Preferred Equity Token Legal Rights Matrix": "حقوق الملكية الممتازة - مصفوفة الحقوق القانونية للرمز",
            "Select Preferred Equity Token Legal Rights Matrix": "اختر حقوق الملكية الممتازة - مصفوفة الحقوق القانونية للرمز",
            "Print of Preferred Equity Token Legal Rights Matrix": "طباعة حقوق الملكية الممتازة - مصفوفة الحقوق القانونية للرمز",
            "Preferred Equity Token Rights Matrix ID": "حقوق الملكية الممتازة - معرّف مصفوفة حقوق الرمز",
            "PREFEQ Rights Matrix ID": "معرّف مصفوفة حقوق الملكية الممتازة الحقوق",
            "Enter PREFEQ Rights Matrix ID": "أدخل معرّف مصفوفة حقوق الملكية الممتازة الحقوق",
            "PREFEQ_Risk_Score": "درجة حقوق الملكية الممتازة المخاطر",
            "PREFEQ_RISK_SCORE": "حقوق الملكية الممتازة درجة المخاطر",
            "Preferred Equity Token Risk Score": "حقوق الملكية الممتازة - درجة مخاطر الرمز",
            "Select Preferred Equity Token Risk Score": "اختر حقوق الملكية الممتازة - درجة مخاطر الرمز",
            "Print of Preferred Equity Token Risk Score": "طباعة حقوق الملكية الممتازة - درجة مخاطر الرمز",
            "Preferred Equity Token Risk Score ID": "حقوق الملكية الممتازة - معرّف درجة مخاطر الرمز",
            "PREFEQ Risk Score ID": "معرّف درجة حقوق الملكية الممتازة المخاطر",
            "Enter PREFEQ Risk Score ID": "أدخل معرّف درجة حقوق الملكية الممتازة المخاطر",
            "03 Investor Subscription Token Issuance": "حقوق الملكية الممتازة، 03 اكتتاب المستثمر وإصدار الرمز",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "حقوق الملكية الممتازة، 03 اكتتاب المستثمر وإصدار الرمز",
            "PREFEQ_Subscription_Order": "حقوق الملكية الممتازة طلب الاكتتاب",
            "PREFEQ_SUBSCRIPTION_ORDER": "حقوق الملكية الممتازة طلب الاكتتاب",
            "Preferred Equity Token Subscription Order": "حقوق الملكية الممتازة - طلب اكتتاب الرمز",
            "Select Preferred Equity Token Subscription Order": "اختر حقوق الملكية الممتازة - طلب اكتتاب الرمز",
            "Print of Preferred Equity Token Subscription Order": "طباعة حقوق الملكية الممتازة - طلب اكتتاب الرمز",
            "Preferred Equity Token Subscription ID": "حقوق الملكية الممتازة - معرّف الرمز الاشتراك",
            "PREFEQ Subscription ID": "معرّف حقوق الملكية الممتازة الاشتراك",
            "Enter PREFEQ Subscription ID": "أدخل معرّف حقوق الملكية الممتازة الاشتراك",
            "PREFEQ_Token_Ledger": "حقوق الملكية الممتازة سجل الرموز",
            "PREFEQ_TOKEN_LEDGER": "حقوق الملكية الممتازة سجل الرموز",
            "Preferred Equity Token Token Ledger": "حقوق الملكية الممتازة - سجل الرمز",
            "Select Preferred Equity Token Token Ledger": "اختر حقوق الملكية الممتازة - سجل الرمز",
            "Print of Preferred Equity Token Token Ledger": "طباعة حقوق الملكية الممتازة - سجل الرمز",
            "Preferred Equity Token Ledger ID": "حقوق الملكية الممتازة - معرّف سجل الرموز",
            "PREFEQ Ledger ID": "معرّف حقوق الملكية الممتازة السجل",
            "Enter PREFEQ Ledger ID": "أدخل معرّف حقوق الملكية الممتازة السجل",
            "PREFEQ_Capital_Account": "حقوق الملكية الممتازة حساب رأس المال",
            "PREFEQ_CAPITAL_ACCOUNT": "حقوق الملكية الممتازة حساب رأس المال",
            "Preferred Equity Capital Account": "حقوق الملكية الممتازة - حساب رأس المال",
            "Select Preferred Equity Capital Account": "اختر حقوق الملكية الممتازة - حساب رأس المال",
            "Print of Preferred Equity Capital Account": "طباعة حقوق الملكية الممتازة - حساب رأس المال",
            "Preferred Equity Capital Account ID": "حقوق الملكية الممتازة - معرّف حساب رأس المال",
            "PREFEQ Capital Account ID": "معرّف حقوق الملكية الممتازة حساب رأس المال",
            "Enter PREFEQ Capital Account ID": "أدخل معرّف حقوق الملكية الممتازة حساب رأس المال",
            "Opening Capital Balance USD": "الافتتاح رأس المال الرصيد بالدولار الأمريكي",
            "Enter Opening Capital Balance USD": "أدخل الافتتاح رأس المال الرصيد بالدولار الأمريكي",
            "Capital Contribution USD": "رأس المال المساهمة بالدولار الأمريكي",
            "Enter Capital Contribution USD": "أدخل رأس المال المساهمة بالدولار الأمريكي",
            "Preferred Return Accrued USD": "العائد المفضل مستحق بالدولار الأمريكي",
            "Enter Preferred Return Accrued USD": "أدخل العائد المفضل مستحق بالدولار الأمريكي",
            "Distributions Paid USD": "التوزيعات مدفوع بالدولار الأمريكي",
            "Enter Distributions Paid USD": "أدخل التوزيعات مدفوع بالدولار الأمريكي",
            "Ending Capital Balance USD": "الختامي رأس المال الرصيد بالدولار الأمريكي",
            "Enter Ending Capital Balance USD": "أدخل الختامي رأس المال الرصيد بالدولار الأمريكي",
            "Capital Account Status": "حالة حساب رأس المال",
            "Enter Capital Account Status": "أدخل حالة حساب رأس المال",
            "04 Inspection Escrow Capital Release": "حقوق الملكية الممتازة، 04 الفحص وحساب الضمان والإفراج عن رأس المال",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "حقوق الملكية الممتازة، 04 الفحص وحساب الضمان والإفراج عن رأس المال",
            "PREFEQ_Independent_Inspection_Report": "تقرير حقوق الملكية الممتازة مستقل الفحص",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "حقوق الملكية الممتازة تقرير فحص مستقل",
            "Preferred Equity Token Independent Inspection Report": "حقوق الملكية الممتازة - تقرير الفحص المستقل للرمز",
            "Select Preferred Equity Token Independent Inspection Report": "اختر حقوق الملكية الممتازة - تقرير الفحص المستقل للرمز",
            "Print of Preferred Equity Token Independent Inspection Report": "طباعة حقوق الملكية الممتازة - تقرير الفحص المستقل للرمز",
            "Preferred Equity Token Inspection Report ID": "حقوق الملكية الممتازة - معرّف تقرير فحص الرمز",
            "PREFEQ Inspection Report ID": "معرّف تقرير حقوق الملكية الممتازة الفحص",
            "Enter PREFEQ Inspection Report ID": "أدخل معرّف تقرير حقوق الملكية الممتازة الفحص",
            "PREFEQ_Escrow_Release_Package": "حقوق الملكية الممتازة حزمة الإفراج من حساب الضمان",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "حقوق الملكية الممتازة حزمة الإفراج من حساب الضمان",
            "Preferred Equity Token Escrow Release Package": "حقوق الملكية الممتازة - حزمة الإفراج من حساب الضمان للرمز",
            "Select Preferred Equity Token Escrow Release Package": "اختر حقوق الملكية الممتازة - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Preferred Equity Token Escrow Release Package": "طباعة حقوق الملكية الممتازة - حزمة الإفراج من حساب الضمان للرمز",
            "Preferred Equity Token Escrow Release Package ID": "حقوق الملكية الممتازة - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "PREFEQ Escrow Release Package ID": "معرّف حقوق الملكية الممتازة حزمة الإفراج من حساب الضمان",
            "Enter PREFEQ Escrow Release Package ID": "أدخل معرّف حقوق الملكية الممتازة حزمة الإفراج من حساب الضمان",
            "05 Finance Preferred Return Distribution": "حقوق الملكية الممتازة، 05 التمويل وتوزيع العائد المفضل",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "حقوق الملكية الممتازة، 05 التمويل وتوزيع العائد المفضل",
            "PREFEQ_Distribution_Calculation": "حقوق الملكية الممتازة حساب التوزيع",
            "PREFEQ_DISTRIBUTION_CALCULATION": "حقوق الملكية الممتازة حساب التوزيع",
            "Preferred Equity Token Distribution Calculation": "حقوق الملكية الممتازة - حساب توزيعات الرمز",
            "Select Preferred Equity Token Distribution Calculation": "اختر حقوق الملكية الممتازة - حساب توزيعات الرمز",
            "Print of Preferred Equity Token Distribution Calculation": "طباعة حقوق الملكية الممتازة - حساب توزيعات الرمز",
            "Preferred Equity Token Distribution ID": "حقوق الملكية الممتازة - معرّف الرمز التوزيع",
            "PREFEQ Distribution ID": "معرّف حقوق الملكية الممتازة التوزيع",
            "Enter PREFEQ Distribution ID": "أدخل معرّف حقوق الملكية الممتازة التوزيع",
            "06 Investor Relations Tax Reporting": "حقوق الملكية الممتازة، 06 علاقات المستثمرين والضرائب وإعداد التقارير",
            "06 INVESTOR RELATIONS TAX REPORTING": "حقوق الملكية الممتازة، 06 علاقات المستثمرين والضرائب وإعداد التقارير",
            "PREFEQ_Investor_Report": "تقرير حقوق الملكية الممتازة المستثمر",
            "PREFEQ_INVESTOR_REPORT": "حقوق الملكية الممتازة تقرير المستثمر",
            "Preferred Equity Token Investor Report": "حقوق الملكية الممتازة - تقرير المستثمر للرمز",
            "Select Preferred Equity Token Investor Report": "اختر حقوق الملكية الممتازة - تقرير المستثمر للرمز",
            "Print of Preferred Equity Token Investor Report": "طباعة حقوق الملكية الممتازة - تقرير المستثمر للرمز",
            "Preferred Equity Token Investor Report ID": "حقوق الملكية الممتازة - معرّف تقرير المستثمر للرمز",
            "PREFEQ Investor Report ID": "معرّف تقرير حقوق الملكية الممتازة المستثمر",
            "Enter PREFEQ Investor Report ID": "أدخل معرّف تقرير حقوق الملكية الممتازة المستثمر",
            "07 Asset Manager Lifecycle Exit": "حقوق الملكية الممتازة، 07 إدارة الأصل ودورة الحياة والخروج",
            "07 ASSET MANAGER LIFECYCLE EXIT": "حقوق الملكية الممتازة، 07 إدارة الأصل ودورة الحياة والخروج",
            "PREFEQ_Lifecycle_Milestone": "حقوق الملكية الممتازة مرحلة دورة الحياة",
            "PREFEQ_LIFECYCLE_MILESTONE": "حقوق الملكية الممتازة مرحلة دورة الحياة",
            "Preferred Equity Token Lifecycle Milestone": "حقوق الملكية الممتازة - مرحلة دورة حياة الرمز",
            "Select Preferred Equity Token Lifecycle Milestone": "اختر حقوق الملكية الممتازة - مرحلة دورة حياة الرمز",
            "Print of Preferred Equity Token Lifecycle Milestone": "طباعة حقوق الملكية الممتازة - مرحلة دورة حياة الرمز",
            "Preferred Equity Token Milestone ID": "حقوق الملكية الممتازة - معرّف مرحلة الرمز",
            "PREFEQ Milestone ID": "معرّف حقوق الملكية الممتازة المعلم",
            "Enter PREFEQ Milestone ID": "أدخل معرّف حقوق الملكية الممتازة المعلم",
            "PREFEQ_Exit_Strategy": "حقوق الملكية الممتازة استراتيجية الخروج",
            "PREFEQ_EXIT_STRATEGY": "حقوق الملكية الممتازة استراتيجية الخروج",
            "Preferred Equity Token Exit Strategy": "حقوق الملكية الممتازة - استراتيجية خروج الرمز",
            "Select Preferred Equity Token Exit Strategy": "اختر حقوق الملكية الممتازة - استراتيجية خروج الرمز",
            "Print of Preferred Equity Token Exit Strategy": "طباعة حقوق الملكية الممتازة - استراتيجية خروج الرمز",
            "Preferred Equity Token Exit Strategy ID": "حقوق الملكية الممتازة - معرّف استراتيجية خروج الرمز",
            "PREFEQ Exit Strategy ID": "معرّف حقوق الملكية الممتازة استراتيجية الخروج",
            "Enter PREFEQ Exit Strategy ID": "أدخل معرّف حقوق الملكية الممتازة استراتيجية الخروج",
            "01 Asset Owner Sponsor Equity Setup": "حقوق الملكية العادية، 01 إعداد حقوق الملكية لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "حقوق الملكية العادية، 01 إعداد حقوق الملكية لمالك الأصل/الراعي",
            "COMEQ_Asset_Profile": "ملف حقوق الملكية العادية الأصل",
            "COMEQ_ASSET_PROFILE": "حقوق الملكية العادية ملف الأصل",
            "Common Equity Asset Profile": "حقوق الملكية العادية - ملف الأصل",
            "Select Common Equity Asset Profile": "اختر حقوق الملكية العادية - ملف الأصل",
            "Print of Common Equity Asset Profile": "طباعة حقوق الملكية العادية - ملف الأصل",
            "Common Equity Token Asset Profile ID": "حقوق الملكية العادية - معرّف ملف أصل الرمز",
            "COMEQ Asset Profile ID": "معرّف ملف حقوق الملكية العادية الأصل",
            "Enter COMEQ Asset Profile ID": "أدخل معرّف ملف حقوق الملكية العادية الأصل",
            "02 Offering Legal Compliance Readiness": "حقوق الملكية العادية، 02 جاهزية الطرح القانونية والامتثال",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "حقوق الملكية العادية، 02 جاهزية الطرح القانونية والامتثال",
            "COMEQ_Token_Offering": "حقوق الملكية العادية طرح الرمز",
            "COMEQ_TOKEN_OFFERING": "حقوق الملكية العادية طرح الرمز",
            "Common Equity Token Offering": "حقوق الملكية العادية - طرح الرمز",
            "Select Common Equity Token Offering": "اختر حقوق الملكية العادية - طرح الرمز",
            "Print of Common Equity Token Offering": "طباعة حقوق الملكية العادية - طرح الرمز",
            "Common Equity Token Offering ID": "حقوق الملكية العادية - معرّف طرح الرمز",
            "COMEQ Offering ID": "معرّف حقوق الملكية العادية الطرح",
            "Enter COMEQ Offering ID": "أدخل معرّف حقوق الملكية العادية الطرح",
            "COMEQ_Token_Class": "حقوق الملكية العادية فئة الرمز",
            "COMEQ_TOKEN_CLASS": "حقوق الملكية العادية فئة الرمز",
            "Common Equity Token Token Class": "حقوق الملكية العادية - فئة الرمز",
            "Select Common Equity Token Token Class": "اختر حقوق الملكية العادية - فئة الرمز",
            "Print of Common Equity Token Token Class": "طباعة حقوق الملكية العادية - فئة الرمز",
            "Common Equity Token Token Class ID": "حقوق الملكية العادية - معرّف فئة الرمز",
            "COMEQ Token Class ID": "معرّف حقوق الملكية العادية فئة الرمز",
            "Enter COMEQ Token Class ID": "أدخل معرّف حقوق الملكية العادية فئة الرمز",
            "COMEQ_Token_Economics": "حقوق الملكية العادية اقتصاديات الرمز",
            "COMEQ_TOKEN_ECONOMICS": "حقوق الملكية العادية اقتصاديات الرمز",
            "Common Equity Token Token Economics": "حقوق الملكية العادية - اقتصاديات الرمز",
            "Select Common Equity Token Token Economics": "اختر حقوق الملكية العادية - اقتصاديات الرمز",
            "Print of Common Equity Token Token Economics": "طباعة حقوق الملكية العادية - اقتصاديات الرمز",
            "Common Equity Token Token Economics ID": "حقوق الملكية العادية - معرّف اقتصاديات الرمز",
            "COMEQ Token Economics ID": "معرّف حقوق الملكية العادية اقتصاديات الرمز",
            "Enter COMEQ Token Economics ID": "أدخل معرّف حقوق الملكية العادية اقتصاديات الرمز",
            "COMEQ_Legal_Rights_Matrix": "مصفوفة حقوق الملكية العادية قانوني الحقوق",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "حقوق الملكية العادية مصفوفة الحقوق القانونية",
            "Common Equity Token Legal Rights Matrix": "حقوق الملكية العادية - مصفوفة الحقوق القانونية للرمز",
            "Select Common Equity Token Legal Rights Matrix": "اختر حقوق الملكية العادية - مصفوفة الحقوق القانونية للرمز",
            "Print of Common Equity Token Legal Rights Matrix": "طباعة حقوق الملكية العادية - مصفوفة الحقوق القانونية للرمز",
            "Common Equity Token Rights Matrix ID": "حقوق الملكية العادية - معرّف مصفوفة حقوق الرمز",
            "COMEQ Rights Matrix ID": "معرّف مصفوفة حقوق الملكية العادية الحقوق",
            "Enter COMEQ Rights Matrix ID": "أدخل معرّف مصفوفة حقوق الملكية العادية الحقوق",
            "COMEQ_Risk_Score": "درجة حقوق الملكية العادية المخاطر",
            "COMEQ_RISK_SCORE": "حقوق الملكية العادية درجة المخاطر",
            "Common Equity Token Risk Score": "حقوق الملكية العادية - درجة مخاطر الرمز",
            "Select Common Equity Token Risk Score": "اختر حقوق الملكية العادية - درجة مخاطر الرمز",
            "Print of Common Equity Token Risk Score": "طباعة حقوق الملكية العادية - درجة مخاطر الرمز",
            "Common Equity Token Risk Score ID": "حقوق الملكية العادية - معرّف درجة مخاطر الرمز",
            "COMEQ Risk Score ID": "معرّف درجة حقوق الملكية العادية المخاطر",
            "Enter COMEQ Risk Score ID": "أدخل معرّف درجة حقوق الملكية العادية المخاطر",
            "03 Investor Subscription Token Issuance": "حقوق الملكية العادية، 03 اكتتاب المستثمر وإصدار الرمز",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "حقوق الملكية العادية، 03 اكتتاب المستثمر وإصدار الرمز",
            "COMEQ_Subscription_Order": "حقوق الملكية العادية طلب الاكتتاب",
            "COMEQ_SUBSCRIPTION_ORDER": "حقوق الملكية العادية طلب الاكتتاب",
            "Common Equity Token Subscription Order": "حقوق الملكية العادية - طلب اكتتاب الرمز",
            "Select Common Equity Token Subscription Order": "اختر حقوق الملكية العادية - طلب اكتتاب الرمز",
            "Print of Common Equity Token Subscription Order": "طباعة حقوق الملكية العادية - طلب اكتتاب الرمز",
            "Common Equity Token Subscription ID": "حقوق الملكية العادية - معرّف الرمز الاشتراك",
            "COMEQ Subscription ID": "معرّف حقوق الملكية العادية الاشتراك",
            "Enter COMEQ Subscription ID": "أدخل معرّف حقوق الملكية العادية الاشتراك",
            "COMEQ_Token_Ledger": "حقوق الملكية العادية سجل الرموز",
            "COMEQ_TOKEN_LEDGER": "حقوق الملكية العادية سجل الرموز",
            "Common Equity Token Token Ledger": "حقوق الملكية العادية - سجل الرمز",
            "Select Common Equity Token Token Ledger": "اختر حقوق الملكية العادية - سجل الرمز",
            "Print of Common Equity Token Token Ledger": "طباعة حقوق الملكية العادية - سجل الرمز",
            "Common Equity Token Ledger ID": "حقوق الملكية العادية - معرّف سجل الرموز",
            "COMEQ Ledger ID": "معرّف حقوق الملكية العادية السجل",
            "Enter COMEQ Ledger ID": "أدخل معرّف حقوق الملكية العادية السجل",
            "COMEQ_Cap_Table": "حقوق الملكية العادية جدول هيكل الملكية",
            "COMEQ_CAP_TABLE": "حقوق الملكية العادية جدول هيكل الملكية",
            "Common Equity Cap Table": "حقوق الملكية العادية - جدول هيكل الملكية",
            "Select Common Equity Cap Table": "اختر حقوق الملكية العادية - جدول هيكل الملكية",
            "Print of Common Equity Cap Table": "طباعة حقوق الملكية العادية - جدول هيكل الملكية",
            "Common Equity Cap Table ID": "حقوق الملكية العادية - معرّف جدول هيكل الملكية",
            "COMEQ Cap Table ID": "معرّف حقوق الملكية العادية جدول هيكل الملكية",
            "Enter COMEQ Cap Table ID": "أدخل معرّف حقوق الملكية العادية جدول هيكل الملكية",
            "Dilution Adjustment Factor": "التخفيف التعديل العامل",
            "Enter Dilution Adjustment Factor": "أدخل التخفيف التعديل العامل",
            "Cap Table Status": "حالة جدول هيكل الملكية",
            "Enter Cap Table Status": "أدخل حالة جدول هيكل الملكية",
            "04 Equity Ownership Governance Management": "حقوق الملكية العادية، 04 إدارة ملكية حقوق الملكية والحوكمة",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "حقوق الملكية العادية، 04 إدارة ملكية حقوق الملكية والحوكمة",
            "COMEQ_Lifecycle_Milestone": "حقوق الملكية العادية مرحلة دورة الحياة",
            "COMEQ_LIFECYCLE_MILESTONE": "حقوق الملكية العادية مرحلة دورة الحياة",
            "Common Equity Token Lifecycle Milestone": "حقوق الملكية العادية - مرحلة دورة حياة الرمز",
            "Select Common Equity Token Lifecycle Milestone": "اختر حقوق الملكية العادية - مرحلة دورة حياة الرمز",
            "Print of Common Equity Token Lifecycle Milestone": "طباعة حقوق الملكية العادية - مرحلة دورة حياة الرمز",
            "Common Equity Token Milestone ID": "حقوق الملكية العادية - معرّف مرحلة الرمز",
            "COMEQ Milestone ID": "معرّف حقوق الملكية العادية المعلم",
            "Enter COMEQ Milestone ID": "أدخل معرّف حقوق الملكية العادية المعلم",
            "COMEQ_Independent_Inspection_Report": "تقرير حقوق الملكية العادية مستقل الفحص",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "حقوق الملكية العادية تقرير فحص مستقل",
            "Common Equity Token Independent Inspection Report": "حقوق الملكية العادية - تقرير الفحص المستقل للرمز",
            "Select Common Equity Token Independent Inspection Report": "اختر حقوق الملكية العادية - تقرير الفحص المستقل للرمز",
            "Print of Common Equity Token Independent Inspection Report": "طباعة حقوق الملكية العادية - تقرير الفحص المستقل للرمز",
            "Common Equity Token Inspection Report ID": "حقوق الملكية العادية - معرّف تقرير فحص الرمز",
            "COMEQ Inspection Report ID": "معرّف تقرير حقوق الملكية العادية الفحص",
            "Enter COMEQ Inspection Report ID": "أدخل معرّف تقرير حقوق الملكية العادية الفحص",
            "05 Finance Escrow Distribution Reporting": "حقوق الملكية العادية، 05 التمويل وحساب الضمان والتوزيع وإعداد التقارير",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "حقوق الملكية العادية، 05 التمويل وحساب الضمان والتوزيع وإعداد التقارير",
            "COMEQ_Equity_Distribution_Waterfall": "حقوق الملكية العادية حقوق الملكية تسلسل التوزيع",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "حقوق الملكية العادية حقوق الملكية تسلسل التوزيع",
            "Common Equity Distribution Waterfall": "حقوق الملكية العادية - تسلسل التوزيع",
            "Select Common Equity Distribution Waterfall": "اختر حقوق الملكية العادية - تسلسل التوزيع",
            "Print of Common Equity Distribution Waterfall": "طباعة حقوق الملكية العادية - تسلسل التوزيع",
            "Common Equity Waterfall ID": "حقوق الملكية العادية - معرّف تسلسل التوزيع",
            "COMEQ Waterfall ID": "معرّف حقوق الملكية العادية تسلسل التوزيع",
            "Enter COMEQ Waterfall ID": "أدخل معرّف حقوق الملكية العادية تسلسل التوزيع",
            "Available Cash USD": "متاح النقد بالدولار الأمريكي",
            "Enter Available Cash USD": "أدخل متاح النقد بالدولار الأمريكي",
            "Preferred Return Paid USD": "العائد المفضل مدفوع بالدولار الأمريكي",
            "Enter Preferred Return Paid USD": "أدخل العائد المفضل مدفوع بالدولار الأمريكي",
            "Common Equity Distributable USD": "حقوق الملكية العادية - قابل للتوزيع بالدولار الأمريكي",
            "Enter Common Equity Distributable USD": "أدخل حقوق الملكية العادية - قابل للتوزيع بالدولار الأمريكي",
            "COMEQ_Distribution_Calculation": "حقوق الملكية العادية حساب التوزيع",
            "COMEQ_DISTRIBUTION_CALCULATION": "حقوق الملكية العادية حساب التوزيع",
            "Common Equity Token Distribution Calculation": "حقوق الملكية العادية - حساب توزيعات الرمز",
            "Select Common Equity Token Distribution Calculation": "اختر حقوق الملكية العادية - حساب توزيعات الرمز",
            "Print of Common Equity Token Distribution Calculation": "طباعة حقوق الملكية العادية - حساب توزيعات الرمز",
            "Common Equity Token Distribution ID": "حقوق الملكية العادية - معرّف الرمز التوزيع",
            "COMEQ Distribution ID": "معرّف حقوق الملكية العادية التوزيع",
            "Enter COMEQ Distribution ID": "أدخل معرّف حقوق الملكية العادية التوزيع",
            "COMEQ_Escrow_Release_Package": "حقوق الملكية العادية حزمة الإفراج من حساب الضمان",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "حقوق الملكية العادية حزمة الإفراج من حساب الضمان",
            "Common Equity Token Escrow Release Package": "حقوق الملكية العادية - حزمة الإفراج من حساب الضمان للرمز",
            "Select Common Equity Token Escrow Release Package": "اختر حقوق الملكية العادية - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Common Equity Token Escrow Release Package": "طباعة حقوق الملكية العادية - حزمة الإفراج من حساب الضمان للرمز",
            "Common Equity Token Escrow Release Package ID": "حقوق الملكية العادية - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "COMEQ Escrow Release Package ID": "معرّف حقوق الملكية العادية حزمة الإفراج من حساب الضمان",
            "Enter COMEQ Escrow Release Package ID": "أدخل معرّف حقوق الملكية العادية حزمة الإفراج من حساب الضمان",
            "COMEQ_Investor_Report": "تقرير حقوق الملكية العادية المستثمر",
            "COMEQ_INVESTOR_REPORT": "حقوق الملكية العادية تقرير المستثمر",
            "Common Equity Token Investor Report": "حقوق الملكية العادية - تقرير المستثمر للرمز",
            "Select Common Equity Token Investor Report": "اختر حقوق الملكية العادية - تقرير المستثمر للرمز",
            "Print of Common Equity Token Investor Report": "طباعة حقوق الملكية العادية - تقرير المستثمر للرمز",
            "Common Equity Token Investor Report ID": "حقوق الملكية العادية - معرّف تقرير المستثمر للرمز",
            "COMEQ Investor Report ID": "معرّف تقرير حقوق الملكية العادية المستثمر",
            "Enter COMEQ Investor Report ID": "أدخل معرّف تقرير حقوق الملكية العادية المستثمر",
            "06 Asset Manager Lifecycle Exit": "حقوق الملكية العادية، 06 إدارة الأصل ودورة الحياة والخروج",
            "06 ASSET MANAGER LIFECYCLE EXIT": "حقوق الملكية العادية، 06 إدارة الأصل ودورة الحياة والخروج",
            "COMEQ_Exit_Strategy": "حقوق الملكية العادية استراتيجية الخروج",
            "COMEQ_EXIT_STRATEGY": "حقوق الملكية العادية استراتيجية الخروج",
            "Common Equity Token Exit Strategy": "حقوق الملكية العادية - استراتيجية خروج الرمز",
            "Select Common Equity Token Exit Strategy": "اختر حقوق الملكية العادية - استراتيجية خروج الرمز",
            "Print of Common Equity Token Exit Strategy": "طباعة حقوق الملكية العادية - استراتيجية خروج الرمز",
            "Common Equity Token Exit Strategy ID": "حقوق الملكية العادية - معرّف استراتيجية خروج الرمز",
            "COMEQ Exit Strategy ID": "معرّف حقوق الملكية العادية استراتيجية الخروج",
            "Enter COMEQ Exit Strategy ID": "أدخل معرّف حقوق الملكية العادية استراتيجية الخروج",
            "01 Asset Owner Sponsor Collateral Setup": "سند الدين، 01 إعداد الضمان لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "سند الدين، 01 إعداد الضمان لمالك الأصل/الراعي",
            "DEBT_Asset_Profile": "ملف الدين الأصل",
            "DEBT_ASSET_PROFILE": "الدين ملف الأصل",
            "Debt Note Collateral Asset Profile": "سند الدين - ملف أصل الضمان",
            "Select Debt Note Collateral Asset Profile": "اختر سند الدين - ملف أصل الضمان",
            "Print of Debt Note Collateral Asset Profile": "طباعة سند الدين - ملف أصل الضمان",
            "Debt Note Token Asset Profile ID": "سند الدين - معرّف ملف أصل الرمز",
            "DEBT Asset Profile ID": "معرّف ملف الدين الأصل",
            "Enter DEBT Asset Profile ID": "أدخل معرّف ملف الدين الأصل",
            "DEBT_Token_Offering": "الدين طرح الرمز",
            "DEBT_TOKEN_OFFERING": "الدين طرح الرمز",
            "Debt Note Token Offering": "سند الدين - طرح الرمز",
            "Select Debt Note Token Offering": "اختر سند الدين - طرح الرمز",
            "Print of Debt Note Token Offering": "طباعة سند الدين - طرح الرمز",
            "Debt Note Token Offering ID": "سند الدين - معرّف طرح الرمز",
            "DEBT Offering ID": "معرّف الدين الطرح",
            "Enter DEBT Offering ID": "أدخل معرّف الدين الطرح",
            "DEBT_Note_Terms": "سند الدين - الشروط",
            "DEBT_NOTE_TERMS": "سند الدين - الشروط",
            "Debt Note Terms": "سند الدين - الشروط",
            "Select Debt Note Terms": "اختر سند الدين - الشروط",
            "Print of Debt Note Terms": "طباعة سند الدين - الشروط",
            "Debt Note Terms ID": "سند الدين - معرّف الشروط",
            "DEBT Note Terms ID": "سند الدين - معرّف الشروط",
            "Enter DEBT Note Terms ID": "أدخل سند الدين - معرّف الشروط",
            "Principal Amount USD": "مبلغ الأصل بالدولار الأمريكي",
            "Enter Principal Amount USD": "أدخل مبلغ الأصل بالدولار الأمريكي",
            "Interest Type": "نوع الفائدة",
            "Enter Interest Type": "أدخل نوع الفائدة",
            "Payment Frequency": "الدفعة التكرار",
            "Enter Payment Frequency": "أدخل الدفعة التكرار",
            "Maturity Date": "تاريخ الاستحقاق",
            "Enter Maturity Date": "أدخل تاريخ الاستحقاق",
            "Amortization Type": "نوع الإطفاء",
            "Enter Amortization Type": "أدخل نوع الإطفاء",
            "Collateral Asset ID": "معرّف الضمان الأصل",
            "Enter Collateral Asset ID": "أدخل معرّف الضمان الأصل",
            "Lien Position": "الرهن الوضع",
            "Enter Lien Position": "أدخل الرهن الوضع",
            "Default Interest Rate": "الافتراضي الفائدة المعدل",
            "Enter Default Interest Rate": "أدخل الافتراضي الفائدة المعدل",
            "Debt Covenants": "الدين التعهدات",
            "Enter Debt Covenants": "أدخل الدين التعهدات",
            "02 Debt Structuring Legal Risk Readiness": "سند الدين، 02 هيكلة الدين والجاهزية القانونية والمخاطر",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "سند الدين، 02 هيكلة الدين والجاهزية القانونية والمخاطر",
            "DEBT_Token_Class": "الدين فئة الرمز",
            "DEBT_TOKEN_CLASS": "الدين فئة الرمز",
            "Debt Note Token Token Class": "سند الدين - فئة الرمز",
            "Select Debt Note Token Token Class": "اختر سند الدين - فئة الرمز",
            "Print of Debt Note Token Token Class": "طباعة سند الدين - فئة الرمز",
            "Debt Note Token Token Class ID": "سند الدين - معرّف فئة الرمز",
            "DEBT Token Class ID": "معرّف الدين فئة الرمز",
            "Enter DEBT Token Class ID": "أدخل معرّف الدين فئة الرمز",
            "DEBT_Token_Economics": "الدين اقتصاديات الرمز",
            "DEBT_TOKEN_ECONOMICS": "الدين اقتصاديات الرمز",
            "Debt Note Token Token Economics": "سند الدين - اقتصاديات الرمز",
            "Select Debt Note Token Token Economics": "اختر سند الدين - اقتصاديات الرمز",
            "Print of Debt Note Token Token Economics": "طباعة سند الدين - اقتصاديات الرمز",
            "Debt Note Token Token Economics ID": "سند الدين - معرّف اقتصاديات الرمز",
            "DEBT Token Economics ID": "معرّف الدين اقتصاديات الرمز",
            "Enter DEBT Token Economics ID": "أدخل معرّف الدين اقتصاديات الرمز",
            "DEBT_Payment_Schedule": "الدين جدول السداد",
            "DEBT_PAYMENT_SCHEDULE": "الدين جدول السداد",
            "Debt Payment Schedule": "الدين جدول السداد",
            "Select Debt Payment Schedule": "اختر الدين جدول السداد",
            "Print of Debt Payment Schedule": "طباعة الدين جدول السداد",
            "Debt Payment Schedule ID": "معرّف الدين جدول السداد",
            "DEBT Payment Schedule ID": "معرّف الدين جدول السداد",
            "Enter DEBT Payment Schedule ID": "أدخل معرّف الدين جدول السداد",
            "Payment Number": "رقم الدفعة",
            "Enter Payment Number": "أدخل رقم الدفعة",
            "Payment Due Date": "تاريخ الدفعة مستحق",
            "Enter Payment Due Date": "أدخل تاريخ الدفعة مستحق",
            "Scheduled Principal USD": "أصل الدين المجدول بالدولار الأمريكي",
            "Enter Scheduled Principal USD": "أدخل أصل الدين المجدول بالدولار الأمريكي",
            "Scheduled Interest USD": "مجدول الفائدة بالدولار الأمريكي",
            "Enter Scheduled Interest USD": "أدخل مجدول الفائدة بالدولار الأمريكي",
            "Total Scheduled Payment USD": "الإجمالي مجدول الدفعة بالدولار الأمريكي",
            "Enter Total Scheduled Payment USD": "أدخل الإجمالي مجدول الدفعة بالدولار الأمريكي",
            "Actual Payment USD": "الفعلي الدفعة بالدولار الأمريكي",
            "Enter Actual Payment USD": "أدخل الفعلي الدفعة بالدولار الأمريكي",
            "DEBT_Legal_Rights_Matrix": "مصفوفة الدين قانوني الحقوق",
            "DEBT_LEGAL_RIGHTS_MATRIX": "الدين مصفوفة الحقوق القانونية",
            "Debt Note Token Legal Rights Matrix": "سند الدين - مصفوفة الحقوق القانونية للرمز",
            "Select Debt Note Token Legal Rights Matrix": "اختر سند الدين - مصفوفة الحقوق القانونية للرمز",
            "Print of Debt Note Token Legal Rights Matrix": "طباعة سند الدين - مصفوفة الحقوق القانونية للرمز",
            "Debt Note Token Rights Matrix ID": "سند الدين - معرّف مصفوفة حقوق الرمز",
            "DEBT Rights Matrix ID": "معرّف مصفوفة الدين الحقوق",
            "Enter DEBT Rights Matrix ID": "أدخل معرّف مصفوفة الدين الحقوق",
            "DEBT_Risk_Score": "درجة مخاطر الدين",
            "DEBT_RISK_SCORE": "الدين درجة المخاطر",
            "Debt Note Token Risk Score": "سند الدين - درجة مخاطر الرمز",
            "Select Debt Note Token Risk Score": "اختر سند الدين - درجة مخاطر الرمز",
            "Print of Debt Note Token Risk Score": "طباعة سند الدين - درجة مخاطر الرمز",
            "Debt Note Token Risk Score ID": "سند الدين - معرّف درجة مخاطر الرمز",
            "DEBT Risk Score ID": "معرّف درجة مخاطر الدين",
            "Enter DEBT Risk Score ID": "أدخل معرّف درجة مخاطر الدين",
            "DEBT_Independent_Inspection_Report": "تقرير الدين مستقل الفحص",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "الدين تقرير فحص مستقل",
            "Debt Note Token Independent Inspection Report": "سند الدين - تقرير الفحص المستقل للرمز",
            "Select Debt Note Token Independent Inspection Report": "اختر سند الدين - تقرير الفحص المستقل للرمز",
            "Print of Debt Note Token Independent Inspection Report": "طباعة سند الدين - تقرير الفحص المستقل للرمز",
            "Debt Note Token Inspection Report ID": "سند الدين - معرّف تقرير فحص الرمز",
            "DEBT Inspection Report ID": "معرّف تقرير الدين الفحص",
            "Enter DEBT Inspection Report ID": "أدخل معرّف تقرير الدين الفحص",
            "03 Investor Subscription Token Issuance": "سند الدين، 03 اكتتاب المستثمر وإصدار الرمز",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "سند الدين، 03 اكتتاب المستثمر وإصدار الرمز",
            "DEBT_Subscription_Order": "الدين طلب الاكتتاب",
            "DEBT_SUBSCRIPTION_ORDER": "الدين طلب الاكتتاب",
            "Debt Note Token Subscription Order": "سند الدين - طلب اكتتاب الرمز",
            "Select Debt Note Token Subscription Order": "اختر سند الدين - طلب اكتتاب الرمز",
            "Print of Debt Note Token Subscription Order": "طباعة سند الدين - طلب اكتتاب الرمز",
            "Debt Note Token Subscription ID": "سند الدين - معرّف الرمز الاشتراك",
            "DEBT Subscription ID": "معرّف الدين الاشتراك",
            "Enter DEBT Subscription ID": "أدخل معرّف الدين الاشتراك",
            "DEBT_Token_Ledger": "الدين سجل الرموز",
            "DEBT_TOKEN_LEDGER": "الدين سجل الرموز",
            "Debt Note Token Token Ledger": "سند الدين - سجل الرمز",
            "Select Debt Note Token Token Ledger": "اختر سند الدين - سجل الرمز",
            "Print of Debt Note Token Token Ledger": "طباعة سند الدين - سجل الرمز",
            "Debt Note Token Ledger ID": "سند الدين - معرّف سجل الرموز",
            "DEBT Ledger ID": "معرّف الدين السجل",
            "Enter DEBT Ledger ID": "أدخل معرّف الدين السجل",
            "04 Debt Servicing Interest Payment Management": "سند الدين، 04 خدمة الدين وإدارة الفوائد والمدفوعات",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "سند الدين، 04 خدمة الدين وإدارة الفوائد والمدفوعات",
            "DEBT_Interest_Accrual": "الدين استحقاق الفائدة",
            "DEBT_INTEREST_ACCRUAL": "الدين استحقاق الفائدة",
            "Debt Interest Accrual": "الدين استحقاق الفائدة",
            "Select Debt Interest Accrual": "اختر الدين استحقاق الفائدة",
            "Print of Debt Interest Accrual": "طباعة الدين استحقاق الفائدة",
            "Debt Interest Accrual ID": "معرّف الدين استحقاق الفائدة",
            "DEBT Interest Accrual ID": "معرّف الدين استحقاق الفائدة",
            "Enter DEBT Interest Accrual ID": "أدخل معرّف الدين استحقاق الفائدة",
            "Accrual Period Start": "الاستحقاق الفترة البداية",
            "Enter Accrual Period Start": "أدخل الاستحقاق الفترة البداية",
            "Accrual Period End": "الاستحقاق الفترة النهاية",
            "Enter Accrual Period End": "أدخل الاستحقاق الفترة النهاية",
            "Principal Balance USD": "الأصل الرصيد بالدولار الأمريكي",
            "Enter Principal Balance USD": "أدخل الأصل الرصيد بالدولار الأمريكي",
            "Interest Accrued USD": "الفائدة مستحق بالدولار الأمريكي",
            "Enter Interest Accrued USD": "أدخل الفائدة مستحق بالدولار الأمريكي",
            "Interest Paid USD": "الفائدة مدفوع بالدولار الأمريكي",
            "Enter Interest Paid USD": "أدخل الفائدة مدفوع بالدولار الأمريكي",
            "Accrual Status": "حالة الاستحقاق",
            "Enter Accrual Status": "أدخل حالة الاستحقاق",
            "DEBT_Distribution_Calculation": "الدين حساب التوزيع",
            "DEBT_DISTRIBUTION_CALCULATION": "الدين حساب التوزيع",
            "Debt Note Token Distribution Calculation": "سند الدين - حساب توزيعات الرمز",
            "Select Debt Note Token Distribution Calculation": "اختر سند الدين - حساب توزيعات الرمز",
            "Print of Debt Note Token Distribution Calculation": "طباعة سند الدين - حساب توزيعات الرمز",
            "Debt Note Token Distribution ID": "سند الدين - معرّف الرمز التوزيع",
            "DEBT Distribution ID": "معرّف الدين التوزيع",
            "Enter DEBT Distribution ID": "أدخل معرّف الدين التوزيع",
            "05 Finance Escrow Investor Reporting": "سند الدين، 05 التمويل وحساب الضمان وتقارير المستثمرين",
            "05 FINANCE ESCROW INVESTOR REPORTING": "سند الدين، 05 التمويل وحساب الضمان وتقارير المستثمرين",
            "DEBT_Escrow_Release_Package": "الدين حزمة الإفراج من حساب الضمان",
            "DEBT_ESCROW_RELEASE_PACKAGE": "الدين حزمة الإفراج من حساب الضمان",
            "Debt Note Token Escrow Release Package": "سند الدين - حزمة الإفراج من حساب الضمان للرمز",
            "Select Debt Note Token Escrow Release Package": "اختر سند الدين - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Debt Note Token Escrow Release Package": "طباعة سند الدين - حزمة الإفراج من حساب الضمان للرمز",
            "Debt Note Token Escrow Release Package ID": "سند الدين - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "DEBT Escrow Release Package ID": "معرّف الدين حزمة الإفراج من حساب الضمان",
            "Enter DEBT Escrow Release Package ID": "أدخل معرّف الدين حزمة الإفراج من حساب الضمان",
            "DEBT_Investor_Report": "تقرير الدين المستثمر",
            "DEBT_INVESTOR_REPORT": "الدين تقرير المستثمر",
            "Debt Note Token Investor Report": "سند الدين - تقرير المستثمر للرمز",
            "Select Debt Note Token Investor Report": "اختر سند الدين - تقرير المستثمر للرمز",
            "Print of Debt Note Token Investor Report": "طباعة سند الدين - تقرير المستثمر للرمز",
            "Debt Note Token Investor Report ID": "سند الدين - معرّف تقرير المستثمر للرمز",
            "DEBT Investor Report ID": "معرّف تقرير الدين المستثمر",
            "Enter DEBT Investor Report ID": "أدخل معرّف تقرير الدين المستثمر",
            "06 Lifecycle Default Maturity Exit": "سند الدين، 06 دورة الحياة والتعثر والاستحقاق والخروج",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "سند الدين، 06 دورة الحياة والتعثر والاستحقاق والخروج",
            "DEBT_Lifecycle_Milestone": "الدين مرحلة دورة الحياة",
            "DEBT_LIFECYCLE_MILESTONE": "الدين مرحلة دورة الحياة",
            "Debt Note Token Lifecycle Milestone": "سند الدين - مرحلة دورة حياة الرمز",
            "Select Debt Note Token Lifecycle Milestone": "اختر سند الدين - مرحلة دورة حياة الرمز",
            "Print of Debt Note Token Lifecycle Milestone": "طباعة سند الدين - مرحلة دورة حياة الرمز",
            "Debt Note Token Milestone ID": "سند الدين - معرّف مرحلة الرمز",
            "DEBT Milestone ID": "معرّف الدين المعلم",
            "Enter DEBT Milestone ID": "أدخل معرّف الدين المعلم",
            "DEBT_Exit_Strategy": "الدين استراتيجية الخروج",
            "DEBT_EXIT_STRATEGY": "الدين استراتيجية الخروج",
            "Debt Note Token Exit Strategy": "سند الدين - استراتيجية خروج الرمز",
            "Select Debt Note Token Exit Strategy": "اختر سند الدين - استراتيجية خروج الرمز",
            "Print of Debt Note Token Exit Strategy": "طباعة سند الدين - استراتيجية خروج الرمز",
            "Debt Note Token Exit Strategy ID": "سند الدين - معرّف استراتيجية خروج الرمز",
            "DEBT Exit Strategy ID": "معرّف الدين استراتيجية الخروج",
            "Enter DEBT Exit Strategy ID": "أدخل معرّف الدين استراتيجية الخروج",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "الهجين، 01 إعداد الأصل الهجين لمالك الأصل/الراعي",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "الهجين، 01 إعداد الأصل الهجين لمالك الأصل/الراعي",
            "HYBRID_Asset_Profile": "الهجين - ملف الأصل",
            "HYBRID_ASSET_PROFILE": "الهجين - ملف الأصل",
            "Hybrid Asset Profile": "الهجين - ملف الأصل",
            "Select Hybrid Asset Profile": "اختر الهجين - ملف الأصل",
            "Print of Hybrid Asset Profile": "طباعة الهجين - ملف الأصل",
            "Hybrid Token Asset Profile ID": "الهجين - معرّف ملف أصل الرمز",
            "HYBRID Asset Profile ID": "الهجين - معرّف ملف الأصل",
            "Enter HYBRID Asset Profile ID": "أدخل الهجين - معرّف ملف الأصل",
            "02 Offering Structuring Hybrid Model Setup": "الهجين، 02 هيكلة الطرح وإعداد النموذج الهجين",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "الهجين، 02 هيكلة الطرح وإعداد النموذج الهجين",
            "HYBRID_Token_Offering": "الهجين - طرح الرمز",
            "HYBRID_TOKEN_OFFERING": "الهجين - طرح الرمز",
            "Hybrid Token Offering": "الهجين - طرح الرمز",
            "Select Hybrid Token Offering": "اختر الهجين - طرح الرمز",
            "Print of Hybrid Token Offering": "طباعة الهجين - طرح الرمز",
            "Hybrid Token Offering ID": "الهجين - معرّف طرح الرمز",
            "HYBRID Offering ID": "الهجين - معرّف الطرح",
            "Enter HYBRID Offering ID": "أدخل الهجين - معرّف الطرح",
            "HYBRID_Component_Mix": "الهجين - مزيج المكونات",
            "HYBRID_COMPONENT_MIX": "الهجين - مزيج المكونات",
            "Hybrid Component Mix": "الهجين - مزيج المكونات",
            "Select Hybrid Component Mix": "اختر الهجين - مزيج المكونات",
            "Print of Hybrid Component Mix": "طباعة الهجين - مزيج المكونات",
            "Hybrid Component Mix ID": "الهجين - معرّف مزيج المكونات",
            "HYBRID Component Mix ID": "الهجين - معرّف مزيج المكونات",
            "Enter HYBRID Component Mix ID": "أدخل الهجين - معرّف مزيج المكونات",
            "Hybrid Component Type": "الهجين - نوع المكوّن",
            "Enter Hybrid Component Type": "أدخل الهجين - نوع المكوّن",
            "Rental Income Component Percentage": "دخل الإيجار - نسبة المكوّن",
            "Enter Rental Income Component Percentage": "أدخل دخل الإيجار - نسبة المكوّن",
            "Revenue Share Component Percentage": "مشاركة الإيرادات - نسبة المكوّن",
            "Enter Revenue Share Component Percentage": "أدخل مشاركة الإيرادات - نسبة المكوّن",
            "Sale Profit Component Percentage": "ربح البيع - نسبة المكوّن",
            "Enter Sale Profit Component Percentage": "أدخل ربح البيع - نسبة المكوّن",
            "Equity Appreciation Component Percentage": "ارتفاع قيمة حقوق الملكية - نسبة المكوّن",
            "Enter Equity Appreciation Component Percentage": "أدخل ارتفاع قيمة حقوق الملكية - نسبة المكوّن",
            "Preferred Equity Component Percentage": "حقوق الملكية الممتازة - نسبة المكوّن",
            "Enter Preferred Equity Component Percentage": "أدخل حقوق الملكية الممتازة - نسبة المكوّن",
            "Debt Note Component Percentage": "سند الدين - نسبة المكوّن",
            "Enter Debt Note Component Percentage": "أدخل سند الدين - نسبة المكوّن",
            "Common Equity Component Percentage": "حقوق الملكية العادية - نسبة المكوّن",
            "Enter Common Equity Component Percentage": "أدخل حقوق الملكية العادية - نسبة المكوّن",
            "Component Total Percentage": "نسبة المكوّن الإجمالي",
            "Enter Component Total Percentage": "أدخل نسبة المكوّن الإجمالي",
            "Hybrid Model Description": "الهجين - وصف النموذج",
            "Enter Hybrid Model Description": "أدخل الهجين - وصف النموذج",
            "HYBRID_Token_Class": "الهجين - فئة الرمز",
            "HYBRID_TOKEN_CLASS": "الهجين - فئة الرمز",
            "Hybrid Token Token Class": "الهجين - فئة الرمز",
            "Select Hybrid Token Token Class": "اختر الهجين - فئة الرمز",
            "Print of Hybrid Token Token Class": "طباعة الهجين - فئة الرمز",
            "Hybrid Token Token Class ID": "الهجين - معرّف فئة الرمز",
            "HYBRID Token Class ID": "الهجين - معرّف فئة الرمز",
            "Enter HYBRID Token Class ID": "أدخل الهجين - معرّف فئة الرمز",
            "HYBRID_Token_Economics": "الهجين - اقتصاديات الرمز",
            "HYBRID_TOKEN_ECONOMICS": "الهجين - اقتصاديات الرمز",
            "Hybrid Token Token Economics": "الهجين - اقتصاديات الرمز",
            "Select Hybrid Token Token Economics": "اختر الهجين - اقتصاديات الرمز",
            "Print of Hybrid Token Token Economics": "طباعة الهجين - اقتصاديات الرمز",
            "Hybrid Token Token Economics ID": "الهجين - معرّف اقتصاديات الرمز",
            "HYBRID Token Economics ID": "الهجين - معرّف اقتصاديات الرمز",
            "Enter HYBRID Token Economics ID": "أدخل الهجين - معرّف اقتصاديات الرمز",
            "03 Legal Risk Escrow Readiness": "الهجين، 03 الجاهزية القانونية والمخاطر وحساب الضمان",
            "03 LEGAL RISK ESCROW READINESS": "الهجين، 03 الجاهزية القانونية والمخاطر وحساب الضمان",
            "HYBRID_Legal_Rights_Matrix": "الهجين - مصفوفة الحقوق القانونية",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "الهجين - مصفوفة الحقوق القانونية",
            "Hybrid Token Legal Rights Matrix": "الهجين - مصفوفة الحقوق القانونية للرمز",
            "Select Hybrid Token Legal Rights Matrix": "اختر الهجين - مصفوفة الحقوق القانونية للرمز",
            "Print of Hybrid Token Legal Rights Matrix": "طباعة الهجين - مصفوفة الحقوق القانونية للرمز",
            "Hybrid Token Rights Matrix ID": "الهجين - معرّف مصفوفة حقوق الرمز",
            "HYBRID Rights Matrix ID": "الهجين - معرّف مصفوفة الحقوق",
            "Enter HYBRID Rights Matrix ID": "أدخل الهجين - معرّف مصفوفة الحقوق",
            "HYBRID_Risk_Score": "الهجين - درجة المخاطر",
            "HYBRID_RISK_SCORE": "الهجين - درجة المخاطر",
            "Hybrid Token Risk Score": "الهجين - درجة مخاطر الرمز",
            "Select Hybrid Token Risk Score": "اختر الهجين - درجة مخاطر الرمز",
            "Print of Hybrid Token Risk Score": "طباعة الهجين - درجة مخاطر الرمز",
            "Hybrid Token Risk Score ID": "الهجين - معرّف درجة مخاطر الرمز",
            "HYBRID Risk Score ID": "الهجين - معرّف درجة المخاطر",
            "Enter HYBRID Risk Score ID": "أدخل الهجين - معرّف درجة المخاطر",
            "HYBRID_Independent_Inspection_Report": "الهجين - تقرير فحص مستقل",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "الهجين - تقرير فحص مستقل",
            "Hybrid Token Independent Inspection Report": "الهجين - تقرير الفحص المستقل للرمز",
            "Select Hybrid Token Independent Inspection Report": "اختر الهجين - تقرير الفحص المستقل للرمز",
            "Print of Hybrid Token Independent Inspection Report": "طباعة الهجين - تقرير الفحص المستقل للرمز",
            "Hybrid Token Inspection Report ID": "الهجين - معرّف تقرير فحص الرمز",
            "HYBRID Inspection Report ID": "الهجين - معرّف تقرير الفحص",
            "Enter HYBRID Inspection Report ID": "أدخل الهجين - معرّف تقرير الفحص",
            "04 Investor Subscription Token Issuance": "الهجين، 04 اكتتاب المستثمر وإصدار الرمز",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "الهجين، 04 اكتتاب المستثمر وإصدار الرمز",
            "HYBRID_Subscription_Order": "الهجين - طلب الاكتتاب",
            "HYBRID_SUBSCRIPTION_ORDER": "الهجين - طلب الاكتتاب",
            "Hybrid Token Subscription Order": "الهجين - طلب اكتتاب الرمز",
            "Select Hybrid Token Subscription Order": "اختر الهجين - طلب اكتتاب الرمز",
            "Print of Hybrid Token Subscription Order": "طباعة الهجين - طلب اكتتاب الرمز",
            "Hybrid Token Subscription ID": "الهجين - معرّف الرمز الاشتراك",
            "HYBRID Subscription ID": "الهجين - معرّف الاشتراك",
            "Enter HYBRID Subscription ID": "أدخل الهجين - معرّف الاشتراك",
            "HYBRID_Token_Ledger": "الهجين - سجل الرموز",
            "HYBRID_TOKEN_LEDGER": "الهجين - سجل الرموز",
            "Hybrid Token Token Ledger": "الهجين - سجل الرمز",
            "Select Hybrid Token Token Ledger": "اختر الهجين - سجل الرمز",
            "Print of Hybrid Token Token Ledger": "طباعة الهجين - سجل الرمز",
            "Hybrid Token Ledger ID": "الهجين - معرّف سجل الرموز",
            "HYBRID Ledger ID": "الهجين - معرّف السجل",
            "Enter HYBRID Ledger ID": "أدخل الهجين - معرّف السجل",
            "05 Finance Waterfall Distribution Reporting": "الهجين، 05 التمويل وتسلسل التوزيع وإعداد التقارير",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "الهجين، 05 التمويل وتسلسل التوزيع وإعداد التقارير",
            "HYBRID_Distribution_Calculation": "الهجين - حساب التوزيع",
            "HYBRID_DISTRIBUTION_CALCULATION": "الهجين - حساب التوزيع",
            "Hybrid Token Distribution Calculation": "الهجين - حساب توزيعات الرمز",
            "Select Hybrid Token Distribution Calculation": "اختر الهجين - حساب توزيعات الرمز",
            "Print of Hybrid Token Distribution Calculation": "طباعة الهجين - حساب توزيعات الرمز",
            "Hybrid Token Distribution ID": "الهجين - معرّف الرمز التوزيع",
            "HYBRID Distribution ID": "الهجين - معرّف التوزيع",
            "Enter HYBRID Distribution ID": "أدخل الهجين - معرّف التوزيع",
            "HYBRID_Combined_Distribution_Waterfall": "الهجين - تسلسل التوزيع المجمّع",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "الهجين - تسلسل التوزيع المجمّع",
            "Hybrid Combined Distribution Waterfall": "الهجين - تسلسل التوزيع المجمّع",
            "Select Hybrid Combined Distribution Waterfall": "اختر الهجين - تسلسل التوزيع المجمّع",
            "Print of Hybrid Combined Distribution Waterfall": "طباعة الهجين - تسلسل التوزيع المجمّع",
            "Hybrid Waterfall ID": "الهجين - معرّف تسلسل التوزيع",
            "HYBRID Waterfall ID": "الهجين - معرّف تسلسل التوزيع",
            "Enter HYBRID Waterfall ID": "أدخل الهجين - معرّف تسلسل التوزيع",
            "Rental Income Amount USD": "دخل الإيجار - المبلغ بالدولار الأمريكي",
            "Enter Rental Income Amount USD": "أدخل دخل الإيجار - المبلغ بالدولار الأمريكي",
            "Revenue Share Amount USD": "مشاركة الإيرادات - المبلغ بالدولار الأمريكي",
            "Enter Revenue Share Amount USD": "أدخل مشاركة الإيرادات - المبلغ بالدولار الأمريكي",
            "Sale Profit Amount USD": "ربح البيع - المبلغ بالدولار الأمريكي",
            "Enter Sale Profit Amount USD": "أدخل ربح البيع - المبلغ بالدولار الأمريكي",
            "Equity Appreciation Amount USD": "ارتفاع قيمة حقوق الملكية - المبلغ بالدولار الأمريكي",
            "Enter Equity Appreciation Amount USD": "أدخل ارتفاع قيمة حقوق الملكية - المبلغ بالدولار الأمريكي",
            "Debt Interest Amount USD": "مبلغ فائدة الدين بالدولار الأمريكي",
            "Enter Debt Interest Amount USD": "أدخل مبلغ فائدة الدين بالدولار الأمريكي",
            "Preferred Return Amount USD": "مبلغ العائد المفضل بالدولار الأمريكي",
            "Enter Preferred Return Amount USD": "أدخل مبلغ العائد المفضل بالدولار الأمريكي",
            "Common Equity Amount USD": "حقوق الملكية العادية - المبلغ بالدولار الأمريكي",
            "Enter Common Equity Amount USD": "أدخل حقوق الملكية العادية - المبلغ بالدولار الأمريكي",
            "Total Distributable Amount USD": "مبلغ الإجمالي قابل للتوزيع بالدولار الأمريكي",
            "Enter Total Distributable Amount USD": "أدخل مبلغ الإجمالي قابل للتوزيع بالدولار الأمريكي",
            "HYBRID_Escrow_Release_Package": "الهجين - حزمة الإفراج من حساب الضمان",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "الهجين - حزمة الإفراج من حساب الضمان",
            "Hybrid Token Escrow Release Package": "الهجين - حزمة الإفراج من حساب الضمان للرمز",
            "Select Hybrid Token Escrow Release Package": "اختر الهجين - حزمة الإفراج من حساب الضمان للرمز",
            "Print of Hybrid Token Escrow Release Package": "طباعة الهجين - حزمة الإفراج من حساب الضمان للرمز",
            "Hybrid Token Escrow Release Package ID": "الهجين - معرّف حزمة الإفراج من حساب الضمان للرمز",
            "HYBRID Escrow Release Package ID": "الهجين - معرّف حزمة الإفراج من حساب الضمان",
            "Enter HYBRID Escrow Release Package ID": "أدخل الهجين - معرّف حزمة الإفراج من حساب الضمان",
            "HYBRID_Investor_Report": "الهجين - تقرير المستثمر",
            "HYBRID_INVESTOR_REPORT": "الهجين - تقرير المستثمر",
            "Hybrid Token Investor Report": "الهجين - تقرير المستثمر للرمز",
            "Select Hybrid Token Investor Report": "اختر الهجين - تقرير المستثمر للرمز",
            "Print of Hybrid Token Investor Report": "طباعة الهجين - تقرير المستثمر للرمز",
            "Hybrid Token Investor Report ID": "الهجين - معرّف تقرير المستثمر للرمز",
            "HYBRID Investor Report ID": "الهجين - معرّف تقرير المستثمر",
            "Enter HYBRID Investor Report ID": "أدخل الهجين - معرّف تقرير المستثمر",
            "06 Asset Manager Lifecycle Exit": "الهجين، 06 إدارة الأصل ودورة الحياة والخروج",
            "06 ASSET MANAGER LIFECYCLE EXIT": "الهجين، 06 إدارة الأصل ودورة الحياة والخروج",
            "HYBRID_Lifecycle_Milestone": "الهجين - مرحلة دورة الحياة",
            "HYBRID_LIFECYCLE_MILESTONE": "الهجين - مرحلة دورة الحياة",
            "Hybrid Token Lifecycle Milestone": "الهجين - مرحلة دورة حياة الرمز",
            "Select Hybrid Token Lifecycle Milestone": "اختر الهجين - مرحلة دورة حياة الرمز",
            "Print of Hybrid Token Lifecycle Milestone": "طباعة الهجين - مرحلة دورة حياة الرمز",
            "Hybrid Token Milestone ID": "الهجين - معرّف مرحلة الرمز",
            "HYBRID Milestone ID": "الهجين - معرّف المعلم",
            "Enter HYBRID Milestone ID": "أدخل الهجين - معرّف المعلم",
            "HYBRID_Exit_Strategy": "الهجين - استراتيجية الخروج",
            "HYBRID_EXIT_STRATEGY": "الهجين - استراتيجية الخروج",
            "Hybrid Token Exit Strategy": "الهجين - استراتيجية خروج الرمز",
            "Select Hybrid Token Exit Strategy": "اختر الهجين - استراتيجية خروج الرمز",
            "Print of Hybrid Token Exit Strategy": "طباعة الهجين - استراتيجية خروج الرمز",
            "Hybrid Token Exit Strategy ID": "الهجين - معرّف استراتيجية خروج الرمز",
            "HYBRID Exit Strategy ID": "الهجين - معرّف استراتيجية الخروج",
            "Enter HYBRID Exit Strategy ID": "أدخل الهجين - معرّف استراتيجية الخروج",
            "01 Sponsor Auction Opportunity Intake": "مجمع ما قبل المزاد، 01 استلام فرصة المزاد من الراعي",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "مجمع ما قبل المزاد، 01 استلام فرصة المزاد من الراعي",
            "PREAUCT_Auction_Opportunity": "ما قبل المزاد فرصة المزاد",
            "PREAUCT_AUCTION_OPPORTUNITY": "ما قبل المزاد فرصة المزاد",
            "Pre-Auction Auction Opportunity": "ما قبل المزاد - فرصة المزاد",
            "Select Pre-Auction Auction Opportunity": "اختر ما قبل المزاد - فرصة المزاد",
            "Print of Pre-Auction Auction Opportunity": "طباعة ما قبل المزاد - فرصة المزاد",
            "Pre-Auction Opportunity ID": "ما قبل المزاد - معرّف الفرصة",
            "PREAUCT Auction Opportunity ID": "معرّف ما قبل المزاد فرصة المزاد",
            "Enter PREAUCT Auction Opportunity ID": "أدخل معرّف ما قبل المزاد فرصة المزاد",
            "Auction Source": "مصدر مزاد",
            "Enter Auction Source": "أدخل مصدر مزاد",
            "Auction Source Link": "رابط مصدر مزاد",
            "Enter Auction Source Link": "أدخل رابط مصدر مزاد",
            "Auction Type": "نوع مزاد",
            "Enter Auction Type": "أدخل نوع مزاد",
            "Auction Status": "حالة مزاد",
            "Enter Auction Status": "أدخل حالة مزاد",
            "Auction Date": "تاريخ مزاد",
            "Enter Auction Date": "أدخل تاريخ مزاد",
            "Bid Deadline": "العطاء الموعد النهائي",
            "Enter Bid Deadline": "أدخل العطاء الموعد النهائي",
            "Opening Bid USD": "الافتتاح العطاء بالدولار الأمريكي",
            "Enter Opening Bid USD": "أدخل الافتتاح العطاء بالدولار الأمريكي",
            "Estimated Value USD": "التقديري القيمة بالدولار الأمريكي",
            "Enter Estimated Value USD": "أدخل التقديري القيمة بالدولار الأمريكي",
            "Deposit Required USD": "الوديعة مطلوب بالدولار الأمريكي",
            "Enter Deposit Required USD": "أدخل الوديعة مطلوب بالدولار الأمريكي",
            "Opportunity Notes": "ملاحظات الفرصة",
            "Enter Opportunity Notes": "أدخل ملاحظات الفرصة",
            "PREAUCT_Auction_Source_Verification": "تحقق مصدر ما قبل المزاد المزاد",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "ما قبل المزاد المزاد التحقق من المصدر",
            "Pre-Auction Source Verification": "ما قبل المزاد - التحقق من المصدر",
            "Select Pre-Auction Source Verification": "اختر ما قبل المزاد - التحقق من المصدر",
            "Print of Pre-Auction Source Verification": "طباعة ما قبل المزاد - التحقق من المصدر",
            "Pre-Auction Source Verification ID": "ما قبل المزاد - معرّف التحقق من المصدر",
            "PREAUCT Source Verification ID": "معرّف تحقق مصدر ما قبل المزاد",
            "Enter PREAUCT Source Verification ID": "أدخل معرّف تحقق مصدر ما قبل المزاد",
            "Source Verified": "المصدر موثّق",
            "Enter Source Verified": "أدخل المصدر موثّق",
            "Source Verification Method": "طريقة التحقق من المصدر",
            "Enter Source Verification Method": "أدخل طريقة التحقق من المصدر",
            "Auctioneer Name": "اسم منظّم المزاد",
            "Enter Auctioneer Name": "أدخل اسم منظّم المزاد",
            "Auctioneer License Number": "رقم منظّم المزاد الترخيص",
            "Enter Auctioneer License Number": "أدخل رقم منظّم المزاد الترخيص",
            "Auctioneer Contact Email": "منظّم المزاد البريد الإلكتروني لجهة الاتصال",
            "Enter Auctioneer Contact Email": "أدخل منظّم المزاد البريد الإلكتروني لجهة الاتصال",
            "Auctioneer Contact Phone": "منظّم المزاد هاتف جهة الاتصال",
            "Enter Auctioneer Contact Phone": "أدخل منظّم المزاد هاتف جهة الاتصال",
            "Auction Terms Link": "رابط المزاد الشروط",
            "Enter Auction Terms Link": "أدخل رابط المزاد الشروط",
            "Registration Requirement": "التسجيل المتطلب",
            "Enter Registration Requirement": "أدخل التسجيل المتطلب",
            "Bid Deposit Requirement": "العطاء الوديعة المتطلب",
            "Enter Bid Deposit Requirement": "أدخل العطاء الوديعة المتطلب",
            "Source Verification Status": "حالة التحقق من المصدر",
            "Enter Source Verification Status": "أدخل حالة التحقق من المصدر",
            "02 Due Diligence Title Risk Max Bid": "مجمع ما قبل المزاد، 02 العناية الواجبة وسند الملكية والمخاطر والحد الأقصى للعطاء",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "مجمع ما قبل المزاد، 02 العناية الواجبة وسند الملكية والمخاطر والحد الأقصى للعطاء",
            "PREAUCT_Pre_Auction_Due_Diligence": "ما قبل المزاد قبل المزاد العناية الواجبة",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "ما قبل المزاد قبل المزاد العناية الواجبة",
            "Pre-Auction Due Diligence": "ما قبل المزاد - العناية الواجبة",
            "Select Pre-Auction Due Diligence": "اختر ما قبل المزاد - العناية الواجبة",
            "Print of Pre-Auction Due Diligence": "طباعة ما قبل المزاد - العناية الواجبة",
            "Pre-Auction Due Diligence ID": "ما قبل المزاد - معرّف العناية الواجبة",
            "PREAUCT DD ID": "معرّف ما قبل المزاد DD",
            "Enter PREAUCT DD ID": "أدخل معرّف ما قبل المزاد DD",
            "DD Start Date": "تاريخ DD البداية",
            "Enter DD Start Date": "أدخل تاريخ DD البداية",
            "DD Target Completion Date": "تاريخ DD الهدف الإكمال",
            "Enter DD Target Completion Date": "أدخل تاريخ DD الهدف الإكمال",
            "Title Defect Risk": "سند الملكية العيب المخاطر",
            "Enter Title Defect Risk": "أدخل سند الملكية العيب المخاطر",
            "Hidden Lien Risk": "مخفي الرهن المخاطر",
            "Enter Hidden Lien Risk": "أدخل مخفي الرهن المخاطر",
            "Tax Delinquency Risk": "الضريبة التأخر في السداد المخاطر",
            "Enter Tax Delinquency Risk": "أدخل الضريبة التأخر في السداد المخاطر",
            "Redemption Period Risk": "الاسترداد الفترة المخاطر",
            "Enter Redemption Period Risk": "أدخل الاسترداد الفترة المخاطر",
            "Eviction Risk": "مخاطر الإخلاء",
            "Enter Eviction Risk": "أدخل مخاطر الإخلاء",
            "Repair Risk": "الإصلاح المخاطر",
            "Enter Repair Risk": "أدخل الإصلاح المخاطر",
            "Market Risk Level": "مستوى مخاطر السوق",
            "Enter Market Risk Level": "أدخل مستوى مخاطر السوق",
            "Legal Counsel Review Status": "حالة قانوني المستشار القانوني المراجعة",
            "Enter Legal Counsel Review Status": "أدخل حالة قانوني المستشار القانوني المراجعة",
            "DD Report Link": "رابط تقرير DD",
            "Enter DD Report Link": "أدخل رابط تقرير DD",
            "Cleared For Pool": "مجاز للانضمام إلى المجمع",
            "Enter Cleared For Pool": "أدخل مجاز للانضمام إلى المجمع",
            "PREAUCT_Title_Lien_Precheck": "ما قبل المزاد سند الملكية الرهن الفحص المسبق",
            "PREAUCT_TITLE_LIEN_PRECHECK": "ما قبل المزاد سند الملكية الرهن الفحص المسبق",
            "Pre-Auction Title and Lien Precheck": "ما قبل المزاد - فحص مسبق لسند الملكية والرهون",
            "Select Pre-Auction Title and Lien Precheck": "اختر ما قبل المزاد - فحص مسبق لسند الملكية والرهون",
            "Print of Pre-Auction Title and Lien Precheck": "طباعة ما قبل المزاد - فحص مسبق لسند الملكية والرهون",
            "Pre-Auction Title/Lien Precheck ID": "ما قبل المزاد - معرّف سند الملكية/الرهن الفحص المسبق",
            "PREAUCT Title Lien Precheck ID": "معرّف ما قبل المزاد سند الملكية الرهن الفحص المسبق",
            "Enter PREAUCT Title Lien Precheck ID": "أدخل معرّف ما قبل المزاد سند الملكية الرهن الفحص المسبق",
            "Parcel Number": "رقم قطعة الأرض",
            "Enter Parcel Number": "أدخل رقم قطعة الأرض",
            "Preliminary Title Source": "مصدر أولي سند الملكية",
            "Enter Preliminary Title Source": "أدخل مصدر أولي سند الملكية",
            "Owner of Record": "المالك لـ السجل",
            "Owner Of Record": "المالك لـ السجل",
            "Enter Owner Of Record": "أدخل المالك لـ السجل",
            "Lien Search Completed": "الرهن البحث مكتمل",
            "Enter Lien Search Completed": "أدخل الرهن البحث مكتمل",
            "Known Lien Count": "عدد معروف الرهن",
            "Enter Known Lien Count": "أدخل عدد معروف الرهن",
            "Known Lien Total USD": "معروف الرهن الإجمالي بالدولار الأمريكي",
            "Enter Known Lien Total USD": "أدخل معروف الرهن الإجمالي بالدولار الأمريكي",
            "Tax Delinquent Amount USD": "مبلغ الضريبة متأخر السداد بالدولار الأمريكي",
            "Enter Tax Delinquent Amount USD": "أدخل مبلغ الضريبة متأخر السداد بالدولار الأمريكي",
            "Title Exception Notes": "ملاحظات سند الملكية الاستثناء",
            "Enter Title Exception Notes": "أدخل ملاحظات سند الملكية الاستثناء",
            "Precheck Report Link": "رابط تقرير الفحص المسبق",
            "Enter Precheck Report Link": "أدخل رابط تقرير الفحص المسبق",
            "Precheck Status": "حالة الفحص المسبق",
            "Enter Precheck Status": "أدخل حالة الفحص المسبق",
            "PREAUCT_Auction_Risk_Assessment": "ما قبل المزاد المزاد تقييم المخاطر",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "ما قبل المزاد المزاد تقييم المخاطر",
            "Pre-Auction Risk Assessment": "ما قبل المزاد - تقييم المخاطر",
            "Select Pre-Auction Risk Assessment": "اختر ما قبل المزاد - تقييم المخاطر",
            "Print of Pre-Auction Risk Assessment": "طباعة ما قبل المزاد - تقييم المخاطر",
            "Pre-Auction Risk Assessment ID": "ما قبل المزاد - معرّف تقييم المخاطر",
            "PREAUCT Risk Assessment ID": "معرّف ما قبل المزاد تقييم المخاطر",
            "Enter PREAUCT Risk Assessment ID": "أدخل معرّف ما قبل المزاد تقييم المخاطر",
            "Refund Risk Percentage": "نسبة المبلغ المسترد المخاطر",
            "Enter Refund Risk Percentage": "أدخل نسبة المبلغ المسترد المخاطر",
            "Redemption Risk Percentage": "نسبة الاسترداد المخاطر",
            "Enter Redemption Risk Percentage": "أدخل نسبة الاسترداد المخاطر",
            "Occupancy Risk Percentage": "نسبة الإشغال المخاطر",
            "Enter Occupancy Risk Percentage": "أدخل نسبة الإشغال المخاطر",
            "Repair Risk Percentage": "نسبة الإصلاح المخاطر",
            "Enter Repair Risk Percentage": "أدخل نسبة الإصلاح المخاطر",
            "Risk Assessment Status": "حالة تقييم المخاطر",
            "Enter Risk Assessment Status": "أدخل حالة تقييم المخاطر",
            "PREAUCT_Max_Bid_Analysis": "ما قبل المزاد تحليل الحد الأقصى للعطاء",
            "PREAUCT_MAX_BID_ANALYSIS": "ما قبل المزاد تحليل الحد الأقصى للعطاء",
            "Pre-Auction Maximum Bid Analysis": "ما قبل المزاد - تحليل الحد الأقصى للعطاء",
            "Select Pre-Auction Maximum Bid Analysis": "اختر ما قبل المزاد - تحليل الحد الأقصى للعطاء",
            "Print of Pre-Auction Maximum Bid Analysis": "طباعة ما قبل المزاد - تحليل الحد الأقصى للعطاء",
            "Pre-Auction Max Bid Analysis ID": "ما قبل المزاد - معرّف تحليل الحد الأقصى للعطاء",
            "PREAUCT Max Bid Analysis ID": "معرّف ما قبل المزاد تحليل الحد الأقصى للعطاء",
            "Enter PREAUCT Max Bid Analysis ID": "أدخل معرّف ما قبل المزاد تحليل الحد الأقصى للعطاء",
            "Estimated As Is Value USD": "التقديري كـ القيمة بالدولار الأمريكي",
            "Enter Estimated As Is Value USD": "أدخل التقديري كـ القيمة بالدولار الأمريكي",
            "Estimated After Repair Value USD": "التقديري بعد الإصلاح القيمة بالدولار الأمريكي",
            "Enter Estimated After Repair Value USD": "أدخل التقديري بعد الإصلاح القيمة بالدولار الأمريكي",
            "Estimated Repair Cost USD": "التقديري الإصلاح التكلفة بالدولار الأمريكي",
            "Enter Estimated Repair Cost USD": "أدخل التقديري الإصلاح التكلفة بالدولار الأمريكي",
            "Estimated Closing Cost USD": "التقديري الإغلاق التكلفة بالدولار الأمريكي",
            "Enter Estimated Closing Cost USD": "أدخل التقديري الإغلاق التكلفة بالدولار الأمريكي",
            "Estimated Carrying Cost USD": "التقديري الحمل التكلفة بالدولار الأمريكي",
            "Enter Estimated Carrying Cost USD": "أدخل التقديري الحمل التكلفة بالدولار الأمريكي",
            "Required Reserve USD": "مطلوب الاحتياطي بالدولار الأمريكي",
            "Enter Required Reserve USD": "أدخل مطلوب الاحتياطي بالدولار الأمريكي",
            "Target Return Percentage": "نسبة الهدف العائد",
            "Enter Target Return Percentage": "أدخل نسبة الهدف العائد",
            "Recommended Max Bid USD": "موصى به الحد الأقصى العطاء بالدولار الأمريكي",
            "Enter Recommended Max Bid USD": "أدخل موصى به الحد الأقصى العطاء بالدولار الأمريكي",
            "Authorized Max Bid USD": "مصرح الحد الأقصى العطاء بالدولار الأمريكي",
            "Enter Authorized Max Bid USD": "أدخل مصرح الحد الأقصى العطاء بالدولار الأمريكي",
            "Bid Strategy": "العطاء الاستراتيجية",
            "Enter Bid Strategy": "أدخل العطاء الاستراتيجية",
            "Analysis Report Link": "رابط تقرير التحليل",
            "Enter Analysis Report Link": "أدخل رابط تقرير التحليل",
            "03 Pool Structuring Escrow Compliance": "مجمع ما قبل المزاد، 03 هيكلة المجمع وحساب الضمان والامتثال",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "مجمع ما قبل المزاد، 03 هيكلة المجمع وحساب الضمان والامتثال",
            "PREAUCT_Pre_Auction_Pool": "ما قبل المزاد قبل المزاد المجمع",
            "PREAUCT_PRE_AUCTION_POOL": "ما قبل المزاد قبل المزاد المجمع",
            "Pre-Auction Pool": "مجمع ما قبل المزاد",
            "Select Pre-Auction Pool": "اختر مجمع ما قبل المزاد",
            "Print of Pre-Auction Pool": "طباعة مجمع ما قبل المزاد",
            "Pre-Auction Pool ID": "ما قبل المزاد - معرّف المجمع",
            "PREAUCT Pre Auction Pool ID": "معرّف ما قبل المزاد قبل المزاد المجمع",
            "Enter PREAUCT Pre Auction Pool ID": "أدخل معرّف ما قبل المزاد قبل المزاد المجمع",
            "Pool Name": "اسم المجمع",
            "Enter Pool Name": "أدخل اسم المجمع",
            "Pool Target Amount USD": "مبلغ المجمع الهدف بالدولار الأمريكي",
            "Enter Pool Target Amount USD": "أدخل مبلغ المجمع الهدف بالدولار الأمريكي",
            "Pool Max Amount USD": "مبلغ المجمع الحد الأقصى بالدولار الأمريكي",
            "Enter Pool Max Amount USD": "أدخل مبلغ المجمع الحد الأقصى بالدولار الأمريكي",
            "Minimum Pledge USD": "الحد الأدنى الرهن بالدولار الأمريكي",
            "Enter Minimum Pledge USD": "أدخل الحد الأدنى الرهن بالدولار الأمريكي",
            "Maximum Pledge USD": "الحد الأقصى الرهن بالدولار الأمريكي",
            "Enter Maximum Pledge USD": "أدخل الحد الأقصى الرهن بالدولار الأمريكي",
            "Investor Funds Held in Escrow": "المستثمر الأموال محتجز في حساب الضمان",
            "Investor Funds Held In Escrow": "المستثمر الأموال محتجز في حساب الضمان",
            "Enter Investor Funds Held In Escrow": "أدخل المستثمر الأموال محتجز في حساب الضمان",
            "Refund If Not Won": "استرداد المبلغ في حال عدم الفوز",
            "Enter Refund If Not Won": "أدخل استرداد المبلغ في حال عدم الفوز",
            "Winning Bid Required For Tokenization": "العطاء الفائز مطلوب لإتمام الترميز",
            "Enter Winning Bid Required For Tokenization": "أدخل العطاء الفائز مطلوب لإتمام الترميز",
            "Pool Open Date": "تاريخ المجمع فتح",
            "Enter Pool Open Date": "أدخل تاريخ المجمع فتح",
            "Pool Close Date": "تاريخ المجمع الإغلاق",
            "Enter Pool Close Date": "أدخل تاريخ المجمع الإغلاق",
            "Pool Status": "حالة المجمع",
            "Enter Pool Status": "أدخل حالة المجمع",
            "PREAUCT_Pool_Escrow_Setup": "ما قبل المزاد إعداد حساب ضمان المجمع",
            "PREAUCT_POOL_ESCROW_SETUP": "ما قبل المزاد إعداد حساب ضمان المجمع",
            "Pre-Auction Pool Escrow Setup": "ما قبل المزاد - إعداد حساب ضمان المجمع",
            "Select Pre-Auction Pool Escrow Setup": "اختر ما قبل المزاد - إعداد حساب ضمان المجمع",
            "Print of Pre-Auction Pool Escrow Setup": "طباعة ما قبل المزاد - إعداد حساب ضمان المجمع",
            "Pre-Auction Pool Escrow ID": "ما قبل المزاد - معرّف المجمع حساب الضمان",
            "PREAUCT Pool Escrow ID": "معرّف ما قبل المزاد المجمع حساب الضمان",
            "Enter PREAUCT Pool Escrow ID": "أدخل معرّف ما قبل المزاد المجمع حساب الضمان",
            "Refund Rules": "المبلغ المسترد القواعد",
            "Enter Refund Rules": "أدخل المبلغ المسترد القواعد",
            "Release Conditions": "الإفراج الشروط",
            "Enter Release Conditions": "أدخل الإفراج الشروط",
            "PREAUCT_Compliance_Review": "ما قبل المزاد مراجعة الامتثال",
            "PREAUCT_COMPLIANCE_REVIEW": "ما قبل المزاد مراجعة الامتثال",
            "Pre-Auction Compliance Review": "ما قبل المزاد - مراجعة الامتثال",
            "Select Pre-Auction Compliance Review": "اختر ما قبل المزاد - مراجعة الامتثال",
            "Print of Pre-Auction Compliance Review": "طباعة ما قبل المزاد - مراجعة الامتثال",
            "Pre-Auction Compliance Review ID": "ما قبل المزاد - معرّف مراجعة الامتثال",
            "PREAUCT Compliance Review ID": "معرّف ما قبل المزاد مراجعة الامتثال",
            "Enter PREAUCT Compliance Review ID": "أدخل معرّف ما قبل المزاد مراجعة الامتثال",
            "KYC/AML Requirement Confirmed": "KYC/AML المتطلب مؤكد",
            "KYC AML Requirement Confirmed": "KYC وAML المتطلب مؤكد",
            "Enter KYC AML Requirement Confirmed": "أدخل KYC وAML المتطلب مؤكد",
            "Investor Eligibility Rules Confirmed": "المستثمر الأهلية القواعد مؤكد",
            "Enter Investor Eligibility Rules Confirmed": "أدخل المستثمر الأهلية القواعد مؤكد",
            "Escrow Compliance Confirmed": "حساب الضمان الامتثال مؤكد",
            "Enter Escrow Compliance Confirmed": "أدخل حساب الضمان الامتثال مؤكد",
            "Disclosure Package Approved": "الإفصاح الحزمة معتمد",
            "Enter Disclosure Package Approved": "حدّد حالة اعتماد الإفصاح الحزمة",
            "Refund Process Approved": "عملية استرداد المبلغ معتمد",
            "Enter Refund Process Approved": "حدّد حالة اعتماد عملية استرداد المبلغ",
            "Marketing Materials Approved": "التسويق المواد معتمد",
            "Enter Marketing Materials Approved": "حدّد حالة اعتماد التسويق المواد",
            "Compliance Risk Level": "مستوى الامتثال المخاطر",
            "Enter Compliance Risk Level": "أدخل مستوى الامتثال المخاطر",
            "Compliance Review Status": "حالة مراجعة الامتثال",
            "Enter Compliance Review Status": "أدخل حالة مراجعة الامتثال",
            "04 Investor Pledge Escrow Funding": "مجمع ما قبل المزاد، 04 تعهد المستثمر وتمويل حساب الضمان",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "مجمع ما قبل المزاد، 04 تعهد المستثمر وتمويل حساب الضمان",
            "PREAUCT_Investor_Pledge": "ما قبل المزاد تعهد المستثمر",
            "PREAUCT_INVESTOR_PLEDGE": "ما قبل المزاد تعهد المستثمر",
            "Pre-Auction Investor Pledge": "ما قبل المزاد - تعهد المستثمر",
            "Select Pre-Auction Investor Pledge": "اختر ما قبل المزاد - تعهد المستثمر",
            "Print of Pre-Auction Investor Pledge": "طباعة ما قبل المزاد - تعهد المستثمر",
            "Pre-Auction Pledge ID": "ما قبل المزاد - معرّف الرهن",
            "PREAUCT Pledge ID": "معرّف ما قبل المزاد الرهن",
            "Enter PREAUCT Pledge ID": "أدخل معرّف ما قبل المزاد الرهن",
            "Pledge Amount USD": "مبلغ الرهن بالدولار الأمريكي",
            "Enter Pledge Amount USD": "أدخل مبلغ الرهن بالدولار الأمريكي",
            "Refund Status": "حالة المبلغ المسترد",
            "Enter Refund Status": "أدخل حالة المبلغ المسترد",
            "Risk Acknowledged": "تم الإقرار بـ المخاطر",
            "Enter Risk Acknowledged": "حدّد حالة الإقرار بـ المخاطر",
            "Conditional Nature Acknowledged": "تم الإقرار بـ مشروط الطبيعة",
            "Enter Conditional Nature Acknowledged": "حدّد حالة الإقرار بـ مشروط الطبيعة",
            "No Token Until Winning Bid Acknowledged": "تم الإقرار بـ لا الرمز حتى العطاء الفائز",
            "Enter No Token Until Winning Bid Acknowledged": "حدّد حالة الإقرار بـ لا الرمز حتى العطاء الفائز",
            "Pledge Status": "حالة الرهن",
            "Enter Pledge Status": "أدخل حالة الرهن",
            "PREAUCT_Investor_Risk_Acknowledgment": "ما قبل المزاد إقرار المستثمر بالمخاطر",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "ما قبل المزاد إقرار المستثمر بالمخاطر",
            "Pre-Auction Investor Risk Acknowledgment": "ما قبل المزاد - إقرار المستثمر بالمخاطر",
            "Select Pre-Auction Investor Risk Acknowledgment": "اختر ما قبل المزاد - إقرار المستثمر بالمخاطر",
            "Print of Pre-Auction Investor Risk Acknowledgment": "طباعة ما قبل المزاد - إقرار المستثمر بالمخاطر",
            "Pre-Auction Risk Acknowledgment ID": "ما قبل المزاد - معرّف إقرار بالمخاطر",
            "PREAUCT Risk Acknowledgment ID": "معرّف ما قبل المزاد إقرار بالمخاطر",
            "Enter PREAUCT Risk Acknowledgment ID": "أدخل معرّف ما قبل المزاد إقرار بالمخاطر",
            "Auction Not Won Risk Acknowledged": "تم الإقرار بمخاطر عدم الفوز بالمزاد",
            "Enter Auction Not Won Risk Acknowledged": "حدّد حالة الإقرار بـ المزاد غير تم الفوز المخاطر",
            "Refund Timing Risk Acknowledged": "تم الإقرار بـ المبلغ المسترد التوقيت المخاطر",
            "Enter Refund Timing Risk Acknowledged": "حدّد حالة الإقرار بـ المبلغ المسترد التوقيت المخاطر",
            "Title Lien Risk Acknowledged": "تم الإقرار بـ سند الملكية الرهن المخاطر",
            "Enter Title Lien Risk Acknowledged": "حدّد حالة الإقرار بـ سند الملكية الرهن المخاطر",
            "Redemption Period Risk Acknowledged": "تم الإقرار بـ الاسترداد الفترة المخاطر",
            "Enter Redemption Period Risk Acknowledged": "حدّد حالة الإقرار بـ الاسترداد الفترة المخاطر",
            "Occupancy/Eviction Risk Acknowledged": "تم الإقرار بمخاطر الإشغال/الإخلاء",
            "Occupancy Eviction Risk Acknowledged": "تم الإقرار بـ الإشغال مخاطر الإخلاء",
            "Enter Occupancy Eviction Risk Acknowledged": "حدّد حالة الإقرار بـ الإشغال مخاطر الإخلاء",
            "Repair Cost Risk Acknowledged": "تم الإقرار بـ الإصلاح التكلفة المخاطر",
            "Enter Repair Cost Risk Acknowledged": "حدّد حالة الإقرار بـ الإصلاح التكلفة المخاطر",
            "No Guaranteed Tokenization Acknowledged": "تم الإقرار بـ لا مضمون الترميز",
            "Enter No Guaranteed Tokenization Acknowledged": "حدّد حالة الإقرار بـ لا مضمون الترميز",
            "05 Bid Authorization Submission Result": "مجمع ما قبل المزاد، 05 تفويض العطاء وتقديمه ونتيجته",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "مجمع ما قبل المزاد، 05 تفويض العطاء وتقديمه ونتيجته",
            "PREAUCT_Bid_Authorization": "ما قبل المزاد تفويض تقديم العطاء",
            "PREAUCT_BID_AUTHORIZATION": "ما قبل المزاد تفويض تقديم العطاء",
            "Pre-Auction Bid Authorization": "ما قبل المزاد - تفويض تقديم العطاء",
            "Select Pre-Auction Bid Authorization": "اختر ما قبل المزاد - تفويض تقديم العطاء",
            "Print of Pre-Auction Bid Authorization": "طباعة ما قبل المزاد - تفويض تقديم العطاء",
            "Pre-Auction Bid Authorization ID": "ما قبل المزاد - معرّف تفويض تقديم العطاء",
            "PREAUCT Bid Authorization ID": "معرّف ما قبل المزاد تفويض تقديم العطاء",
            "Enter PREAUCT Bid Authorization ID": "أدخل معرّف ما قبل المزاد تفويض تقديم العطاء",
            "Bidder Name": "اسم المزايد",
            "Enter Bidder Name": "أدخل اسم المزايد",
            "Bidder Entity ID": "معرّف المزايد الكيان",
            "Enter Bidder Entity ID": "أدخل معرّف المزايد الكيان",
            "Bid Deposit Confirmed": "العطاء الوديعة مؤكد",
            "Enter Bid Deposit Confirmed": "أدخل العطاء الوديعة مؤكد",
            "Bid Deposit Amount USD": "مبلغ العطاء الوديعة بالدولار الأمريكي",
            "Enter Bid Deposit Amount USD": "أدخل مبلغ العطاء الوديعة بالدولار الأمريكي",
            "Authorization Document Link": "رابط التفويض المستند",
            "Enter Authorization Document Link": "أدخل رابط التفويض المستند",
            "Bid Authorization Status": "حالة تفويض تقديم العطاء",
            "Enter Bid Authorization Status": "أدخل حالة تفويض تقديم العطاء",
            "PREAUCT_Auction_Bid_Submission": "ما قبل المزاد المزاد تقديم العطاء",
            "PREAUCT_AUCTION_BID_SUBMISSION": "ما قبل المزاد المزاد تقديم العطاء",
            "Pre-Auction Bid Submission": "ما قبل المزاد - تقديم العطاء",
            "Select Pre-Auction Bid Submission": "اختر ما قبل المزاد - تقديم العطاء",
            "Print of Pre-Auction Bid Submission": "طباعة ما قبل المزاد - تقديم العطاء",
            "Pre-Auction Bid Submission ID": "ما قبل المزاد - معرّف تقديم العطاء",
            "PREAUCT Bid Submission ID": "معرّف ما قبل المزاد تقديم العطاء",
            "Enter PREAUCT Bid Submission ID": "أدخل معرّف ما قبل المزاد تقديم العطاء",
            "Bid Submitted USD": "العطاء تم الإرسال بالدولار الأمريكي",
            "Enter Bid Submitted USD": "أدخل العطاء تم الإرسال بالدولار الأمريكي",
            "Bid Submission DateTime": "تقديم العطاء التاريخ والوقت",
            "Enter Bid Submission DateTime": "أدخل تقديم العطاء التاريخ والوقت",
            "Bid Submitted By": "العطاء تم الإرسال بواسطة",
            "Enter Bid Submitted By": "أدخل العطاء تم الإرسال بواسطة",
            "Bid Confirmation Number": "رقم العطاء التأكيد",
            "Enter Bid Confirmation Number": "أدخل رقم العطاء التأكيد",
            "Bid Confirmation Link": "رابط العطاء التأكيد",
            "Enter Bid Confirmation Link": "أدخل رابط العطاء التأكيد",
            "Bid Submission Status": "حالة تقديم العطاء",
            "Enter Bid Submission Status": "أدخل حالة تقديم العطاء",
            "PREAUCT_Auction_Result": "نتيجة ما قبل المزاد المزاد",
            "PREAUCT_AUCTION_RESULT": "ما قبل المزاد نتيجة المزاد",
            "Pre-Auction Auction Result": "ما قبل المزاد - نتيجة المزاد",
            "Select Pre-Auction Auction Result": "اختر ما قبل المزاد - نتيجة المزاد",
            "Print of Pre-Auction Auction Result": "طباعة ما قبل المزاد - نتيجة المزاد",
            "Pre-Auction Auction Result ID": "ما قبل المزاد - معرّف نتيجة المزاد",
            "PREAUCT Auction Result ID": "معرّف نتيجة ما قبل المزاد المزاد",
            "Enter PREAUCT Auction Result ID": "أدخل معرّف نتيجة ما قبل المزاد المزاد",
            "Winning Bid USD": "العطاء الفائز بالدولار الأمريكي",
            "Enter Winning Bid USD": "أدخل العطاء الفائز بالدولار الأمريكي",
            "Won Auction": "تم الفوز بالمزاد",
            "Enter Won Auction": "أدخل تم الفوز بالمزاد",
            "Result Date": "تاريخ النتيجة",
            "Enter Result Date": "أدخل تاريخ النتيجة",
            "Auction Result Document Link": "رابط نتيجة المزاد المستند",
            "Enter Auction Result Document Link": "أدخل رابط نتيجة المزاد المستند",
            "Next Action": "التالي الإجراء",
            "Enter Next Action": "أدخل التالي الإجراء",
            "Result Status": "حالة النتيجة",
            "Enter Result Status": "أدخل حالة النتيجة",
            "06 Refund Transition Reporting Closeout": "مجمع ما قبل المزاد، 06 الاسترداد والانتقال وإعداد التقارير والإقفال",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "مجمع ما قبل المزاد، 06 الاسترداد والانتقال وإعداد التقارير والإقفال",
            "PREAUCT_Refund_Process": "ما قبل المزاد عملية استرداد المبلغ",
            "PREAUCT_REFUND_PROCESS": "ما قبل المزاد عملية استرداد المبلغ",
            "Pre-Auction Refund Process": "ما قبل المزاد - عملية استرداد المبلغ",
            "Select Pre-Auction Refund Process": "اختر ما قبل المزاد - عملية استرداد المبلغ",
            "Print of Pre-Auction Refund Process": "طباعة ما قبل المزاد - عملية استرداد المبلغ",
            "Pre-Auction Refund ID": "ما قبل المزاد - معرّف المبلغ المسترد",
            "PREAUCT Refund ID": "معرّف ما قبل المزاد المبلغ المسترد",
            "Enter PREAUCT Refund ID": "أدخل معرّف ما قبل المزاد المبلغ المسترد",
            "Refund Reason": "سبب المبلغ المسترد",
            "Enter Refund Reason": "أدخل سبب المبلغ المسترد",
            "Refund Amount USD": "مبلغ المبلغ المسترد بالدولار الأمريكي",
            "Enter Refund Amount USD": "أدخل مبلغ المبلغ المسترد بالدولار الأمريكي",
            "Refund Method": "طريقة المبلغ المسترد",
            "Enter Refund Method": "أدخل طريقة المبلغ المسترد",
            "Refund Date": "تاريخ استرداد المبلغ",
            "Enter Refund Date": "أدخل تاريخ استرداد المبلغ",
            "Refund Reference": "المبلغ المسترد المرجع",
            "Enter Refund Reference": "أدخل المبلغ المسترد المرجع",
            "PREAUCT_Winning_Bid_Transition": "ما قبل المزاد انتقال العطاء الفائز",
            "PREAUCT_WINNING_BID_TRANSITION": "ما قبل المزاد انتقال العطاء الفائز",
            "Pre-Auction Winning Bid Transition": "ما قبل المزاد - انتقال العطاء الفائز",
            "Select Pre-Auction Winning Bid Transition": "اختر ما قبل المزاد - انتقال العطاء الفائز",
            "Print of Pre-Auction Winning Bid Transition": "طباعة ما قبل المزاد - انتقال العطاء الفائز",
            "Pre-Auction Winning Bid Transition ID": "ما قبل المزاد - معرّف انتقال العطاء الفائز",
            "PREAUCT Winning Bid Transition ID": "معرّف ما قبل المزاد انتقال العطاء الفائز",
            "Enter PREAUCT Winning Bid Transition ID": "أدخل معرّف ما قبل المزاد انتقال العطاء الفائز",
            "Transition Target": "الانتقال الهدف",
            "Enter Transition Target": "أدخل الانتقال الهدف",
            "Post-Auction Record Created": "ما بعد المزاد - السجل تم الإنشاء",
            "Post Auction Record Created": "بعد المزاد السجل تم الإنشاء",
            "Enter Post Auction Record Created": "أدخل بعد المزاد السجل تم الإنشاء",
            "POSTAUCT Post Auction Tokenization ID": "معرّف ما بعد المزاد بعد المزاد الترميز",
            "Enter POSTAUCT Post Auction Tokenization ID": "أدخل معرّف ما بعد المزاد بعد المزاد الترميز",
            "Acquisition Process Started": "الاستحواذ الإجراء بدأ",
            "Enter Acquisition Process Started": "أدخل الاستحواذ الإجراء بدأ",
            "Escrow Funds Transfer Required": "حساب الضمان الأموال التحويل مطلوب",
            "Enter Escrow Funds Transfer Required": "حدّد حالة اشتراط حساب الضمان الأموال التحويل",
            "Escrow Funds Transferred USD": "حساب الضمان الأموال تم التحويل بالدولار الأمريكي",
            "Enter Escrow Funds Transferred USD": "أدخل حساب الضمان الأموال تم التحويل بالدولار الأمريكي",
            "Investor Notice Sent": "المستثمر الإشعار تم الإرسال",
            "Enter Investor Notice Sent": "أدخل المستثمر الإشعار تم الإرسال",
            "Transition Status": "حالة الانتقال",
            "Enter Transition Status": "أدخل حالة الانتقال",
            "PREAUCT_Investor_Update_Report": "تقرير تحديث ما قبل المزاد المستثمر",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "ما قبل المزاد تقرير تحديث المستثمر",
            "Pre-Auction Investor Update Report": "ما قبل المزاد - تقرير تحديث المستثمر",
            "Select Pre-Auction Investor Update Report": "اختر ما قبل المزاد - تقرير تحديث المستثمر",
            "Print of Pre-Auction Investor Update Report": "طباعة ما قبل المزاد - تقرير تحديث المستثمر",
            "Pre-Auction Investor Update ID": "ما قبل المزاد - معرّف تحديث المستثمر",
            "PREAUCT Investor Update ID": "معرّف تحديث ما قبل المزاد المستثمر",
            "Enter PREAUCT Investor Update ID": "أدخل معرّف تحديث ما قبل المزاد المستثمر",
            "Amount Pledged USD": "المبلغ مرهون بالدولار الأمريكي",
            "Enter Amount Pledged USD": "أدخل المبلغ مرهون بالدولار الأمريكي",
            "Investor Count": "عدد المستثمر",
            "Enter Investor Count": "أدخل عدد المستثمر",
            "Auction Status Update": "تحديث حالة مزاد",
            "Enter Auction Status Update": "أدخل تحديث حالة مزاد",
            "Risk Update": "تحديث المخاطر",
            "Enter Risk Update": "أدخل تحديث المخاطر",
            "Next Milestone": "التالي المعلم",
            "Enter Next Milestone": "أدخل التالي المعلم",
            "Investor Report Link": "رابط تقرير المستثمر",
            "Enter Investor Report Link": "أدخل رابط تقرير المستثمر",
            "PREAUCT_Final_Pool_Closeout": "ما قبل المزاد الإقفال النهائي للمجمع",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "ما قبل المزاد الإقفال النهائي للمجمع",
            "Pre-Auction Final Pool Closeout": "ما قبل المزاد - الإقفال النهائي للمجمع",
            "Select Pre-Auction Final Pool Closeout": "اختر ما قبل المزاد - الإقفال النهائي للمجمع",
            "Print of Pre-Auction Final Pool Closeout": "طباعة ما قبل المزاد - الإقفال النهائي للمجمع",
            "Pre-Auction Final Closeout ID": "ما قبل المزاد - معرّف نهائي الإقفال",
            "PREAUCT Final Closeout ID": "معرّف ما قبل المزاد نهائي الإقفال",
            "Enter PREAUCT Final Closeout ID": "أدخل معرّف ما قبل المزاد نهائي الإقفال",
            "Total Pledged USD": "الإجمالي مرهون بالدولار الأمريكي",
            "Enter Total Pledged USD": "أدخل الإجمالي مرهون بالدولار الأمريكي",
            "Total Collected USD": "الإجمالي مُحصّل بالدولار الأمريكي",
            "Enter Total Collected USD": "أدخل الإجمالي مُحصّل بالدولار الأمريكي",
            "Total Refunded USD": "الإجمالي تم ردّه بالدولار الأمريكي",
            "Enter Total Refunded USD": "أدخل الإجمالي تم ردّه بالدولار الأمريكي",
            "Total Transferred To Post Auction USD": "الإجمالي تم التحويل إلى بعد المزاد بالدولار الأمريكي",
            "Enter Total Transferred To Post Auction USD": "أدخل الإجمالي تم التحويل إلى بعد المزاد بالدولار الأمريكي",
            "Refund Exception Count": "عدد المبلغ المسترد الاستثناء",
            "Enter Refund Exception Count": "أدخل عدد المبلغ المسترد الاستثناء",
            "Closeout Report Link": "رابط تقرير الإقفال",
            "Enter Closeout Report Link": "أدخل رابط تقرير الإقفال",
            "Closeout Status": "حالة الإقفال",
            "Enter Closeout Status": "أدخل حالة الإقفال",
            "01 Sponsor Auction Result Intake Closing": "ما بعد المزاد، 01 استلام نتيجة المزاد من الراعي والإغلاق",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "ما بعد المزاد، 01 استلام نتيجة المزاد من الراعي والإغلاق",
            "POSTAUCT_Auction_Result_Intake": "ما بعد المزاد نتيجة المزاد الاستقبال",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "ما بعد المزاد نتيجة المزاد الاستقبال",
            "Post-Auction Result Intake": "ما بعد المزاد - استلام النتيجة",
            "Select Post-Auction Result Intake": "اختر ما بعد المزاد - استلام النتيجة",
            "Print of Post-Auction Result Intake": "طباعة ما بعد المزاد - استلام النتيجة",
            "Post-Auction Result Intake ID": "ما بعد المزاد - معرّف استلام النتيجة",
            "POSTAUCT Result Intake ID": "معرّف ما بعد المزاد استلام النتيجة",
            "Enter POSTAUCT Result Intake ID": "أدخل معرّف ما بعد المزاد استلام النتيجة",
            "Auction Opportunity ID": "معرّف فرصة المزاد",
            "Enter Auction Opportunity ID": "أدخل معرّف فرصة المزاد",
            "Auction Result Date": "تاريخ نتيجة المزاد",
            "Enter Auction Result Date": "أدخل تاريخ نتيجة المزاد",
            "Winning Bidder Name": "اسم الفائز المزايد",
            "Enter Winning Bidder Name": "أدخل اسم الفائز المزايد",
            "Result Verified": "النتيجة موثّق",
            "Enter Result Verified": "أدخل النتيجة موثّق",
            "Intake Status": "حالة الاستقبال",
            "Enter Intake Status": "أدخل حالة الاستقبال",
            "POSTAUCT_Acquisition_Closing": "ما بعد المزاد إغلاق الاستحواذ",
            "POSTAUCT_ACQUISITION_CLOSING": "ما بعد المزاد إغلاق الاستحواذ",
            "Post-Auction Acquisition Closing": "ما بعد المزاد - إغلاق الاستحواذ",
            "Select Post-Auction Acquisition Closing": "اختر ما بعد المزاد - إغلاق الاستحواذ",
            "Print of Post-Auction Acquisition Closing": "طباعة ما بعد المزاد - إغلاق الاستحواذ",
            "Post-Auction Acquisition Closing ID": "ما بعد المزاد - معرّف إغلاق الاستحواذ",
            "POSTAUCT Acquisition Closing ID": "معرّف ما بعد المزاد إغلاق الاستحواذ",
            "Enter POSTAUCT Acquisition Closing ID": "أدخل معرّف ما بعد المزاد إغلاق الاستحواذ",
            "Total Acquisition Cost USD": "الإجمالي الاستحواذ التكلفة بالدولار الأمريكي",
            "Enter Total Acquisition Cost USD": "أدخل الإجمالي الاستحواذ التكلفة بالدولار الأمريكي",
            "Acquisition Date": "تاريخ الاستحواذ",
            "Enter Acquisition Date": "أدخل تاريخ الاستحواذ",
            "Closing Statement Link": "رابط الإغلاق البيان",
            "Enter Closing Statement Link": "أدخل رابط الإغلاق البيان",
            "Closing Status": "حالة الإغلاق",
            "Enter Closing Status": "أدخل حالة الإغلاق",
            "02 Legal Title Lien Redemption Clearance": "ما بعد المزاد، 02 الشؤون القانونية وسند الملكية والرهون والاسترداد والتصفية",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "ما بعد المزاد، 02 الشؤون القانونية وسند الملكية والرهون والاسترداد والتصفية",
            "POSTAUCT_Post_Auction_Title_Cure": "ما بعد المزاد بعد المزاد معالجة مشكلات سند الملكية",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "ما بعد المزاد بعد المزاد معالجة مشكلات سند الملكية",
            "Post-Auction Title Cure": "ما بعد المزاد - معالجة مشكلات سند الملكية",
            "Select Post-Auction Title Cure": "اختر ما بعد المزاد - معالجة مشكلات سند الملكية",
            "Print of Post-Auction Title Cure": "طباعة ما بعد المزاد - معالجة مشكلات سند الملكية",
            "Post-Auction Title Cure ID": "ما بعد المزاد - معرّف معالجة مشكلات سند الملكية",
            "POSTAUCT Title Cure ID": "معرّف ما بعد المزاد معالجة مشكلات سند الملكية",
            "Enter POSTAUCT Title Cure ID": "أدخل معرّف ما بعد المزاد معالجة مشكلات سند الملكية",
            "Title Issue Type": "نوع سند الملكية المشكلة",
            "Enter Title Issue Type": "أدخل نوع سند الملكية المشكلة",
            "Issue Description": "وصف المشكلة",
            "Enter Issue Description": "أدخل وصف المشكلة",
            "Estimated Cure Cost USD": "التقديري المعالجة التكلفة بالدولار الأمريكي",
            "Enter Estimated Cure Cost USD": "أدخل التقديري المعالجة التكلفة بالدولار الأمريكي",
            "Actual Cure Cost USD": "الفعلي المعالجة التكلفة بالدولار الأمريكي",
            "Enter Actual Cure Cost USD": "أدخل الفعلي المعالجة التكلفة بالدولار الأمريكي",
            "Cure Completion Date": "تاريخ المعالجة الإكمال",
            "Enter Cure Completion Date": "أدخل تاريخ المعالجة الإكمال",
            "Cure Document Link": "رابط المعالجة المستند",
            "Enter Cure Document Link": "أدخل رابط المعالجة المستند",
            "Cure Status": "حالة المعالجة",
            "Enter Cure Status": "أدخل حالة المعالجة",
            "POSTAUCT_Lien_Tax_Clearance": "ما بعد المزاد الرهن التصفية الضريبية",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "ما بعد المزاد الرهن التصفية الضريبية",
            "Post-Auction Lien and Tax Clearance": "ما بعد المزاد - تصفية الرهون والضرائب",
            "Select Post-Auction Lien and Tax Clearance": "اختر ما بعد المزاد - تصفية الرهون والضرائب",
            "Print of Post-Auction Lien and Tax Clearance": "طباعة ما بعد المزاد - تصفية الرهون والضرائب",
            "Post-Auction Lien/Tax Clearance ID": "ما بعد المزاد - معرّف الرهن/التصفية الضريبية",
            "POSTAUCT Lien Tax Clearance ID": "معرّف ما بعد المزاد الرهن التصفية الضريبية",
            "Enter POSTAUCT Lien Tax Clearance ID": "أدخل معرّف ما بعد المزاد الرهن التصفية الضريبية",
            "Lien Clearance Status": "حالة الرهن التخليص",
            "Enter Lien Clearance Status": "أدخل حالة الرهن التخليص",
            "Tax Clearance Status": "حالة التصفية الضريبية",
            "Enter Tax Clearance Status": "أدخل حالة التصفية الضريبية",
            "Clearance Document Link": "رابط التخليص المستند",
            "Enter Clearance Document Link": "أدخل رابط التخليص المستند",
            "Final Clearance Status": "حالة نهائي التخليص",
            "Enter Final Clearance Status": "أدخل حالة نهائي التخليص",
            "POSTAUCT_Redemption_Period_Review": "ما بعد المزاد مراجعة فترة الاسترداد",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "ما بعد المزاد مراجعة فترة الاسترداد",
            "Post-Auction Redemption Period Review": "ما بعد المزاد - مراجعة فترة الاسترداد",
            "Select Post-Auction Redemption Period Review": "اختر ما بعد المزاد - مراجعة فترة الاسترداد",
            "Print of Post-Auction Redemption Period Review": "طباعة ما بعد المزاد - مراجعة فترة الاسترداد",
            "Post-Auction Redemption Review ID": "ما بعد المزاد - معرّف الاسترداد المراجعة",
            "POSTAUCT Redemption Review ID": "معرّف ما بعد المزاد الاسترداد المراجعة",
            "Enter POSTAUCT Redemption Review ID": "أدخل معرّف ما بعد المزاد الاسترداد المراجعة",
            "Redemption Period Applies": "انطباق فترة الاسترداد",
            "Enter Redemption Period Applies": "أدخل انطباق فترة الاسترداد",
            "Redemption Start Date": "تاريخ الاسترداد البداية",
            "Enter Redemption Start Date": "أدخل تاريخ الاسترداد البداية",
            "Redemption End Date": "تاريخ الاسترداد النهاية",
            "Enter Redemption End Date": "أدخل تاريخ الاسترداد النهاية",
            "Redemption Amount USD": "مبلغ الاسترداد بالدولار الأمريكي",
            "Enter Redemption Amount USD": "أدخل مبلغ الاسترداد بالدولار الأمريكي",
            "Review Document Link": "رابط المراجعة المستند",
            "Enter Review Document Link": "أدخل رابط المراجعة المستند",
            "Redemption Review Status": "حالة الاسترداد المراجعة",
            "Enter Redemption Review Status": "أدخل حالة الاسترداد المراجعة",
            "03 Property Control Condition Rehab Appraisal": "ما بعد المزاد، 03 السيطرة على العقار وحالته وإعادة التأهيل والتقييم",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "ما بعد المزاد، 03 السيطرة على العقار وحالته وإعادة التأهيل والتقييم",
            "POSTAUCT_Occupancy_Eviction_Status": "حالة ما بعد المزاد الإشغال الإخلاء",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "ما بعد المزاد الإشغال الإخلاء الحالة",
            "Post-Auction Occupancy and Eviction Status": "ما بعد المزاد - حالة الإشغال والإخلاء",
            "Select Post-Auction Occupancy and Eviction Status": "اختر ما بعد المزاد - حالة الإشغال والإخلاء",
            "Print of Post-Auction Occupancy and Eviction Status": "طباعة ما بعد المزاد - حالة الإشغال والإخلاء",
            "Post-Auction Occupancy/Eviction ID": "ما بعد المزاد - معرّف الإشغال/الإخلاء",
            "POSTAUCT Occupancy Eviction ID": "معرّف ما بعد المزاد الإشغال الإخلاء",
            "Enter POSTAUCT Occupancy Eviction ID": "أدخل معرّف ما بعد المزاد الإشغال الإخلاء",
            "Occupancy Status": "حالة الإشغال",
            "Enter Occupancy Status": "أدخل حالة الإشغال",
            "Tenant or Occupant Type": "نوع المستأجر أو الشاغل",
            "Tenant Or Occupant Type": "نوع المستأجر أو الشاغل",
            "Enter Tenant Or Occupant Type": "أدخل نوع المستأجر أو الشاغل",
            "Legal Possession Confirmed": "قانوني الحيازة مؤكد",
            "Enter Legal Possession Confirmed": "أدخل قانوني الحيازة مؤكد",
            "Eviction Required": "الإخلاء مطلوب",
            "Enter Eviction Required": "حدّد حالة اشتراط الإخلاء",
            "Estimated Eviction Cost USD": "التقديري الإخلاء التكلفة بالدولار الأمريكي",
            "Enter Estimated Eviction Cost USD": "أدخل التقديري الإخلاء التكلفة بالدولار الأمريكي",
            "Estimated Eviction Timeline Days": "التقديري الإخلاء الجدول الزمني الأيام",
            "Enter Estimated Eviction Timeline Days": "أدخل التقديري الإخلاء الجدول الزمني الأيام",
            "Eviction Counsel ID": "معرّف الإخلاء المستشار القانوني",
            "Enter Eviction Counsel ID": "أدخل معرّف الإخلاء المستشار القانوني",
            "Occupancy Report Link": "رابط تقرير الإشغال",
            "Enter Occupancy Report Link": "أدخل رابط تقرير الإشغال",
            "Occupancy Clearance Status": "حالة الإشغال التخليص",
            "Enter Occupancy Clearance Status": "أدخل حالة الإشغال التخليص",
            "POSTAUCT_Property_Condition_Assessment": "ما بعد المزاد تقييم حالة العقار",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "ما بعد المزاد تقييم حالة العقار",
            "Post-Auction Property Condition Assessment": "ما بعد المزاد - تقييم حالة العقار",
            "Select Post-Auction Property Condition Assessment": "اختر ما بعد المزاد - تقييم حالة العقار",
            "Print of Post-Auction Property Condition Assessment": "طباعة ما بعد المزاد - تقييم حالة العقار",
            "Post-Auction Condition Assessment ID": "ما بعد المزاد - معرّف تقييم الحالة",
            "POSTAUCT Condition Assessment ID": "معرّف ما بعد المزاد تقييم الحالة",
            "Enter POSTAUCT Condition Assessment ID": "أدخل معرّف ما بعد المزاد تقييم الحالة",
            "Property Condition Rating": "العقار الحالة التقييم",
            "Enter Property Condition Rating": "أدخل العقار الحالة التقييم",
            "Immediate Safety Issues": "فوري السلامة المشكلات",
            "Enter Immediate Safety Issues": "أدخل فوري السلامة المشكلات",
            "Deferred Maintenance USD": "مؤجل الصيانة بالدولار الأمريكي",
            "Enter Deferred Maintenance USD": "أدخل مؤجل الصيانة بالدولار الأمريكي",
            "Condition Report Link": "رابط تقرير الحالة",
            "Enter Condition Report Link": "أدخل رابط تقرير الحالة",
            "Assessment Status": "حالة التقييم",
            "Enter Assessment Status": "أدخل حالة التقييم",
            "POSTAUCT_Rehab_Budget": "ما بعد المزاد ميزانية إعادة التأهيل",
            "POSTAUCT_REHAB_BUDGET": "ما بعد المزاد ميزانية إعادة التأهيل",
            "Post-Auction Rehab Budget": "ما بعد المزاد - ميزانية إعادة التأهيل",
            "Select Post-Auction Rehab Budget": "اختر ما بعد المزاد - ميزانية إعادة التأهيل",
            "Print of Post-Auction Rehab Budget": "طباعة ما بعد المزاد - ميزانية إعادة التأهيل",
            "Post-Auction Rehab Budget ID": "ما بعد المزاد - معرّف ميزانية إعادة التأهيل",
            "POSTAUCT Rehab Budget ID": "معرّف ما بعد المزاد ميزانية إعادة التأهيل",
            "Enter POSTAUCT Rehab Budget ID": "أدخل معرّف ما بعد المزاد ميزانية إعادة التأهيل",
            "Contractor ID": "معرّف المقاول",
            "Enter Contractor ID": "أدخل معرّف المقاول",
            "Rehab Scope": "إعادة التأهيل النطاق",
            "Enter Rehab Scope": "أدخل إعادة التأهيل النطاق",
            "Estimated Rehab Cost USD": "التقديري إعادة التأهيل التكلفة بالدولار الأمريكي",
            "Enter Estimated Rehab Cost USD": "أدخل التقديري إعادة التأهيل التكلفة بالدولار الأمريكي",
            "Contingency USD": "الطوارئ بالدولار الأمريكي",
            "Enter Contingency USD": "أدخل الطوارئ بالدولار الأمريكي",
            "Total Rehab Budget USD": "الإجمالي ميزانية إعادة التأهيل بالدولار الأمريكي",
            "Enter Total Rehab Budget USD": "أدخل الإجمالي ميزانية إعادة التأهيل بالدولار الأمريكي",
            "Expected Start Date": "تاريخ متوقع البداية",
            "Enter Expected Start Date": "أدخل تاريخ متوقع البداية",
            "Expected Completion Date": "تاريخ متوقع الإكمال",
            "Enter Expected Completion Date": "أدخل تاريخ متوقع الإكمال",
            "Rehab Plan Link": "رابط إعادة التأهيل الخطة",
            "Enter Rehab Plan Link": "أدخل رابط إعادة التأهيل الخطة",
            "Budget Status": "حالة الميزانية",
            "Enter Budget Status": "أدخل حالة الميزانية",
            "POSTAUCT_Post_Auction_Appraisal": "ما بعد المزاد بعد المزاد التقييم",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "ما بعد المزاد بعد المزاد التقييم",
            "Post-Auction Appraisal": "ما بعد المزاد - التقييم",
            "Select Post-Auction Appraisal": "اختر ما بعد المزاد - التقييم",
            "Print of Post-Auction Appraisal": "طباعة ما بعد المزاد - التقييم",
            "Post-Auction Appraisal ID": "ما بعد المزاد - معرّف التقييم",
            "POSTAUCT Appraisal ID": "معرّف ما بعد المزاد التقييم",
            "Enter POSTAUCT Appraisal ID": "أدخل معرّف ما بعد المزاد التقييم",
            "As-Is Value USD": "القيمة بحالتها الراهنة بالدولار الأمريكي",
            "As Is Value USD": "كـ القيمة بالدولار الأمريكي",
            "Enter As Is Value USD": "أدخل كـ القيمة بالدولار الأمريكي",
            "After Repair Value USD": "بعد الإصلاح القيمة بالدولار الأمريكي",
            "Enter After Repair Value USD": "أدخل بعد الإصلاح القيمة بالدولار الأمريكي",
            "Stabilized Value USD": "مستقر القيمة بالدولار الأمريكي",
            "Enter Stabilized Value USD": "أدخل مستقر القيمة بالدولار الأمريكي",
            "Appraisal Report Link": "رابط تقرير التقييم",
            "Enter Appraisal Report Link": "أدخل رابط تقرير التقييم",
            "04 SPV Transfer Readiness Risk": "ما بعد المزاد، 04 نقل SPV والجاهزية والمخاطر",
            "04 SPV TRANSFER READINESS RISK": "ما بعد المزاد، 04 نقل SPV والجاهزية والمخاطر",
            "POSTAUCT_SPV_Asset_Transfer": "ما بعد المزاد نقل الأصل إلى SPV",
            "POSTAUCT_SPV_ASSET_TRANSFER": "ما بعد المزاد نقل الأصل إلى SPV",
            "Post-Auction SPV Asset Transfer": "ما بعد المزاد - نقل الأصل إلى SPV",
            "Select Post-Auction SPV Asset Transfer": "اختر ما بعد المزاد - نقل الأصل إلى SPV",
            "Print of Post-Auction SPV Asset Transfer": "طباعة ما بعد المزاد - نقل الأصل إلى SPV",
            "Post-Auction SPV Asset Transfer ID": "ما بعد المزاد - معرّف نقل الأصل إلى SPV",
            "POSTAUCT SPV Asset Transfer ID": "معرّف ما بعد المزاد نقل الأصل إلى SPV",
            "Enter POSTAUCT SPV Asset Transfer ID": "أدخل معرّف ما بعد المزاد نقل الأصل إلى SPV",
            "Transferor Name": "اسم المحيل",
            "Enter Transferor Name": "أدخل اسم المحيل",
            "Transferee Name": "اسم المحال إليه",
            "Enter Transferee Name": "أدخل اسم المحال إليه",
            "Transfer Date": "تاريخ التحويل",
            "Enter Transfer Date": "أدخل تاريخ التحويل",
            "Recorded Deed Link": "رابط مسجل سند الملكية",
            "Enter Recorded Deed Link": "أدخل رابط مسجل سند الملكية",
            "Title Insurance Status": "حالة سند الملكية التأمين",
            "Enter Title Insurance Status": "أدخل حالة سند الملكية التأمين",
            "Transfer Status": "حالة التحويل",
            "Enter Transfer Status": "أدخل حالة التحويل",
            "POSTAUCT_Tokenization_Readiness_Checklist": "قائمة تحقق ما بعد المزاد جاهزية الترميز",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "ما بعد المزاد قائمة التحقق من جاهزية الترميز",
            "Post-Auction Tokenization Readiness Checklist": "ما بعد المزاد - قائمة التحقق من جاهزية الترميز",
            "Select Post-Auction Tokenization Readiness Checklist": "اختر ما بعد المزاد - قائمة التحقق من جاهزية الترميز",
            "Print of Post-Auction Tokenization Readiness Checklist": "طباعة ما بعد المزاد - قائمة التحقق من جاهزية الترميز",
            "Post-Auction Readiness Checklist ID": "ما بعد المزاد - معرّف قائمة تحقق الجاهزية",
            "POSTAUCT Readiness Checklist ID": "معرّف قائمة تحقق ما بعد المزاد الجاهزية",
            "Enter POSTAUCT Readiness Checklist ID": "أدخل معرّف قائمة تحقق ما بعد المزاد الجاهزية",
            "Title Cleared": "سند الملكية مُصفّى",
            "Enter Title Cleared": "أدخل سند الملكية مُصفّى",
            "Liens Cleared": "الرهون مُصفّى",
            "Enter Liens Cleared": "أدخل الرهون مُصفّى",
            "Tax Clearance Confirmed": "التصفية الضريبية مؤكد",
            "Enter Tax Clearance Confirmed": "أدخل التصفية الضريبية مؤكد",
            "Redemption Reviewed": "الاسترداد تمت مراجعته",
            "Enter Redemption Reviewed": "أدخل الاسترداد تمت مراجعته",
            "Occupancy Cleared": "الإشغال مُصفّى",
            "Enter Occupancy Cleared": "أدخل الإشغال مُصفّى",
            "Condition Assessment Complete": "تقييم الحالة مكتمل",
            "Enter Condition Assessment Complete": "حدّد حالة اكتمال تقييم الحالة",
            "Appraisal Approved": "التقييم معتمد",
            "Enter Appraisal Approved": "حدّد حالة اعتماد التقييم",
            "Risk Score Approved": "درجة المخاطر معتمد",
            "Enter Risk Score Approved": "حدّد حالة اعتماد درجة المخاطر",
            "Investor Disclosure Ready": "المستثمر الإفصاح جاهز",
            "Enter Investor Disclosure Ready": "أدخل المستثمر الإفصاح جاهز",
            "Ready To Tokenize": "جاهز إلى ترميز",
            "Enter Ready To Tokenize": "أدخل جاهز إلى ترميز",
            "POSTAUCT_Post_Auction_Risk_Score": "درجة ما بعد المزاد بعد المزاد المخاطر",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "ما بعد المزاد بعد المزاد درجة المخاطر",
            "Post-Auction Risk Score": "ما بعد المزاد - درجة المخاطر",
            "Select Post-Auction Risk Score": "اختر ما بعد المزاد - درجة المخاطر",
            "Print of Post-Auction Risk Score": "طباعة ما بعد المزاد - درجة المخاطر",
            "Post-Auction Risk Score ID": "ما بعد المزاد - معرّف درجة المخاطر",
            "POSTAUCT Risk Score ID": "معرّف درجة ما بعد المزاد المخاطر",
            "Enter POSTAUCT Risk Score ID": "أدخل معرّف درجة ما بعد المزاد المخاطر",
            "05 Offering Disclosure Compliance Approval": "ما بعد المزاد، 05 الطرح والإفصاح والامتثال والاعتماد",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "ما بعد المزاد، 05 الطرح والإفصاح والامتثال والاعتماد",
            "POSTAUCT_Offering_Readiness": "ما بعد المزاد جاهزية الطرح",
            "POSTAUCT_OFFERING_READINESS": "ما بعد المزاد جاهزية الطرح",
            "Post-Auction Offering Readiness": "ما بعد المزاد - جاهزية الطرح",
            "Select Post-Auction Offering Readiness": "اختر ما بعد المزاد - جاهزية الطرح",
            "Print of Post-Auction Offering Readiness": "طباعة ما بعد المزاد - جاهزية الطرح",
            "Post-Auction Offering Readiness ID": "ما بعد المزاد - معرّف جاهزية الطرح",
            "POSTAUCT Offering Readiness ID": "معرّف ما بعد المزاد جاهزية الطرح",
            "Enter POSTAUCT Offering Readiness ID": "أدخل معرّف ما بعد المزاد جاهزية الطرح",
            "POSTAUCT_Investor_Disclosure_Package": "ما بعد المزاد حزمة إفصاح المستثمر",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "ما بعد المزاد حزمة إفصاح المستثمر",
            "Post-Auction Investor Disclosure Package": "ما بعد المزاد - حزمة إفصاح المستثمر",
            "Select Post-Auction Investor Disclosure Package": "اختر ما بعد المزاد - حزمة إفصاح المستثمر",
            "Print of Post-Auction Investor Disclosure Package": "طباعة ما بعد المزاد - حزمة إفصاح المستثمر",
            "Post-Auction Disclosure Package ID": "ما بعد المزاد - معرّف الإفصاح الحزمة",
            "POSTAUCT Disclosure Package ID": "معرّف ما بعد المزاد الإفصاح الحزمة",
            "Enter POSTAUCT Disclosure Package ID": "أدخل معرّف ما بعد المزاد الإفصاح الحزمة",
            "Auction Result Disclosure Link": "رابط نتيجة المزاد الإفصاح",
            "Enter Auction Result Disclosure Link": "أدخل رابط نتيجة المزاد الإفصاح",
            "Title Risk Disclosure Link": "رابط سند الملكية المخاطر الإفصاح",
            "Enter Title Risk Disclosure Link": "أدخل رابط سند الملكية المخاطر الإفصاح",
            "Redemption Risk Disclosure Link": "رابط الاسترداد المخاطر الإفصاح",
            "Enter Redemption Risk Disclosure Link": "أدخل رابط الاسترداد المخاطر الإفصاح",
            "Occupancy Risk Disclosure Link": "رابط إفصاح مخاطر الإشغال",
            "Enter Occupancy Risk Disclosure Link": "أدخل رابط إفصاح مخاطر الإشغال",
            "Repair Risk Disclosure Link": "رابط الإصلاح المخاطر الإفصاح",
            "Enter Repair Risk Disclosure Link": "أدخل رابط الإصلاح المخاطر الإفصاح",
            "Offering Document Link": "رابط الطرح المستند",
            "Enter Offering Document Link": "أدخل رابط الطرح المستند",
            "Disclosure Approval Status": "حالة اعتماد الإفصاح",
            "Enter Disclosure Approval Status": "أدخل حالة اعتماد الإفصاح",
            "POSTAUCT_Final_Tokenization_Approval": "اعتماد ما بعد المزاد نهائي الترميز",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "ما بعد المزاد الاعتماد النهائي للترميز",
            "Post-Auction Final Tokenization Approval": "ما بعد المزاد - الاعتماد النهائي للترميز",
            "Select Post-Auction Final Tokenization Approval": "اختر ما بعد المزاد - الاعتماد النهائي للترميز",
            "Print of Post-Auction Final Tokenization Approval": "طباعة ما بعد المزاد - الاعتماد النهائي للترميز",
            "Post-Auction Final Tokenization Approval ID": "ما بعد المزاد - معرّف الاعتماد النهائي للترميز",
            "POSTAUCT Final Tokenization Approval ID": "معرّف اعتماد ما بعد المزاد نهائي الترميز",
            "Enter POSTAUCT Final Tokenization Approval ID": "أدخل معرّف اعتماد ما بعد المزاد نهائي الترميز",
            "Readiness Checklist ID": "معرّف قائمة تحقق الجاهزية",
            "Enter Readiness Checklist ID": "أدخل معرّف قائمة تحقق الجاهزية",
            "Legal Approved": "قانوني معتمد",
            "Enter Legal Approved": "حدّد حالة اعتماد قانوني",
            "Compliance Approved": "الامتثال معتمد",
            "Enter Compliance Approved": "حدّد حالة اعتماد الامتثال",
            "Risk Approved": "اعتماد المخاطر",
            "Enter Risk Approved": "حدّد حالة اعتماد المخاطر",
            "Escrow Approved": "حساب الضمان معتمد",
            "Enter Escrow Approved": "حدّد حالة اعتماد حساب الضمان",
            "Disclosure Approved": "الإفصاح معتمد",
            "Enter Disclosure Approved": "حدّد حالة اعتماد الإفصاح",
            "Token Issuance Approved": "الرمز الإصدار معتمد",
            "Enter Token Issuance Approved": "حدّد حالة اعتماد الرمز الإصدار",
            "Final Tokenization Decision": "نهائي الترميز القرار",
            "Enter Final Tokenization Decision": "أدخل نهائي الترميز القرار",
            "Decision Notes": "ملاحظات القرار",
            "Enter Decision Notes": "أدخل ملاحظات القرار",
            "06 Investor Relations Update Reporting": "ما بعد المزاد، 06 علاقات المستثمرين والتحديث وإعداد التقارير",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "ما بعد المزاد، 06 علاقات المستثمرين والتحديث وإعداد التقارير",
            "POSTAUCT_Investor_Update_Report": "تقرير تحديث ما بعد المزاد المستثمر",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "ما بعد المزاد تقرير تحديث المستثمر",
            "Post-Auction Investor Update Report": "ما بعد المزاد - تقرير تحديث المستثمر",
            "Select Post-Auction Investor Update Report": "اختر ما بعد المزاد - تقرير تحديث المستثمر",
            "Print of Post-Auction Investor Update Report": "طباعة ما بعد المزاد - تقرير تحديث المستثمر",
            "Post-Auction Investor Update ID": "ما بعد المزاد - معرّف تحديث المستثمر",
            "POSTAUCT Investor Update ID": "معرّف تحديث ما بعد المزاد المستثمر",
            "Enter POSTAUCT Investor Update ID": "أدخل معرّف تحديث ما بعد المزاد المستثمر",
            "Acquisition Status Update": "تحديث حالة الاستحواذ",
            "Enter Acquisition Status Update": "أدخل تحديث حالة الاستحواذ",
            "Title Cure Update": "تحديث معالجة مشكلات سند الملكية",
            "Enter Title Cure Update": "أدخل تحديث معالجة مشكلات سند الملكية",
            "Rehab Update": "تحديث إعادة التأهيل",
            "Enter Rehab Update": "أدخل تحديث إعادة التأهيل",
            "Tokenization Readiness Update": "تحديث جاهزية الترميز",
            "Enter Tokenization Readiness Update": "أدخل تحديث جاهزية الترميز"
        }
    },
    "de": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Beschreibung",
            "Enter Description": "Beschreibung eingeben",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "E-Mail",
            "Enter Email": "E-Mail eingeben",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Vorname",
            "Enter First Name": "Vornamen eingeben",
            "Middle Name": "Zweiter Vorname",
            "Enter Middle Name": "Geben Sie den zweiten Vornamen ein",
            "Last Name": "Nachname",
            "Enter Last Name": "Nachname eingeben",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Webseite",
            "Enter Website": "Website aufrufen",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Geburtsdatum",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Priorität",
            "Enter Priority": "Priorität eingeben",
            "Subject": "Betreff",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Zahlungsmethode",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "nl": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Beschrijving",
            "Enter Description": "Voer beschrijving in",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "E-mailadres",
            "Enter Email": "E-mailadres invoeren",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Voornaam",
            "Enter First Name": "Voer voornaam in",
            "Middle Name": "Middelste naam",
            "Enter Middle Name": "Voer middelste naam in",
            "Last Name": "Achternaam",
            "Enter Last Name": "Voer achternaam in",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Website",
            "Enter Website": "Ga naar de website",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Geboortedatum",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Prioriteit",
            "Enter Priority": "Prioriteit invoeren",
            "Subject": "Onderwerp",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Betalingswijze",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "ja": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "説明",
            "Enter Description": "説明を入力してください",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "電子メール",
            "Enter Email": "メールを入力してください",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "名",
            "Enter First Name": "名を入力してください",
            "Middle Name": "ミドルネーム",
            "Enter Middle Name": "ミドルネームを入力してください",
            "Last Name": "姓",
            "Enter Last Name": "姓を入力してください",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "ウェブサイト",
            "Enter Website": "ウェブサイトに入ります",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "生年月日",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "優先度",
            "Enter Priority": "優先度を入力",
            "Subject": "件名",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "支払い方法",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "ko": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "설명",
            "Enter Description": "설명 입력",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "이메일",
            "Enter Email": "이메일 입력",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "이름",
            "Enter First Name": "이름 입력",
            "Middle Name": "중간 이름",
            "Enter Middle Name": "중간 이름 입력",
            "Last Name": "성",
            "Enter Last Name": "성 입력",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "웹사이트",
            "Enter Website": "웹사이트 입력",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "생년월일",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "우선 순위",
            "Enter Priority": "우선 순위 입력",
            "Subject": "제목",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "결제 방법",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "zh": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "描述",
            "Enter Description": "输入描述",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "电子邮件",
            "Enter Email": "输入电子邮件",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "名字",
            "Enter First Name": "输入名字",
            "Middle Name": "中间名",
            "Enter Middle Name": "输入中间名",
            "Last Name": "姓氏",
            "Enter Last Name": "输入姓氏",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "网站",
            "Enter Website": "进入网站",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "出生日期",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "优先级",
            "Enter Priority": "输入优先级",
            "Subject": "主题",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "付款方式",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "hi": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "विवरण",
            "Enter Description": "विवरण दर्ज करें",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "ईमेल",
            "Enter Email": "ईमेल दर्ज करें",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "पहला नाम",
            "Enter First Name": "प्रथम नाम दर्ज करें",
            "Middle Name": "मध्य नाम",
            "Enter Middle Name": "मध्य नाम दर्ज करें",
            "Last Name": "अंतिम नाम",
            "Enter Last Name": "अंतिम नाम दर्ज करें",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "वेबसाइट",
            "Enter Website": "वेबसाइट दर्ज करें",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "जन्म तिथि",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "प्राथमिकता",
            "Enter Priority": "प्राथमिकता दर्ज करें",
            "Subject": "विषय",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "भुगतान का तरीका",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "pt-BR": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Descrição",
            "Enter Description": "Inserir descrição",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "E-mail",
            "Enter Email": "Digite o e-mail",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Nome",
            "Enter First Name": "Digite o primeiro nome",
            "Middle Name": "Nome do meio",
            "Enter Middle Name": "Digite o nome do meio",
            "Last Name": "Sobrenome",
            "Enter Last Name": "Digite o sobrenome",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Local na rede Internet",
            "Enter Website": "Entrar no site",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Data de nascimento",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Prioridade",
            "Enter Priority": "Digite a prioridade",
            "Subject": "Assunto",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Forma de pagamento",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "es-MX": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Descripción",
            "Enter Description": "Ingrese la descripción",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "Correo electrónico",
            "Enter Email": "Ingrese el correo electrónico",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Nombre",
            "Enter First Name": "Ingrese el nombre",
            "Middle Name": "Segundo nombre",
            "Enter Middle Name": "Ingrese el segundo nombre",
            "Last Name": "Apellido",
            "Enter Last Name": "Ingrese el apellido",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Sitio web",
            "Enter Website": "Entrar en el sitio web",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Fecha de nacimiento",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Prioridad",
            "Enter Priority": "Introducir prioridad",
            "Subject": "Asunto",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Método de pago",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "vi": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Mô tả",
            "Enter Description": "Nhập mô tả",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "Email",
            "Enter Email": "Nhập email",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Tên",
            "Enter First Name": "Nhập tên",
            "Middle Name": "Tên đệm",
            "Enter Middle Name": "Nhập tên đệm",
            "Last Name": "Họ",
            "Enter Last Name": "Nhập họ",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Trang web",
            "Enter Website": "Vào trang web",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Ngày sinh",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Ưu tiên",
            "Enter Priority": "Nhập mức độ ưu tiên",
            "Subject": "Đối tượng",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Phương thức thanh toán",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "ru": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Описание",
            "Enter Description": "Введите описание",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "Электронная почта",
            "Enter Email": "Введите email",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Имя",
            "Enter First Name": "Введите имя",
            "Middle Name": "Отчество",
            "Enter Middle Name": "Введите второе имя,",
            "Last Name": "Фамилия",
            "Enter Last Name": "Введите фамилию",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Сайт",
            "Enter Website": "Войти на сайт",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "дата рождения",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Приоритет",
            "Enter Priority": "Enter Priority",
            "Subject": "Тема",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "способ оплаты",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "id": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Deskripsi",
            "Enter Description": "Masukkan Deskripsi",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "Email",
            "Enter Email": "Masukkan Email",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Nama Depan",
            "Enter First Name": "Masukkan Nama Depan",
            "Middle Name": "Nama Tengah",
            "Enter Middle Name": "Masukkan nama tengah",
            "Last Name": "Nama Belakang",
            "Enter Last Name": "Masukkan Nama Belakang",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Situs web",
            "Enter Website": "Masuk ke Situs Web",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Tanggal Lahir",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Prioritas",
            "Enter Priority": "Masukkan Prioritas",
            "Subject": "Subjek",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Metode Pembayaran",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "ms": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Deskripsi",
            "Enter Description": "Masukkan Deskripsi",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "Email",
            "Enter Email": "Masukkan Email",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Nama Depan",
            "Enter First Name": "Masukkan Nama Depan",
            "Middle Name": "Nama Tengah",
            "Enter Middle Name": "Masukkan nama tengah",
            "Last Name": "Nama Belakang",
            "Enter Last Name": "Masukkan Nama Belakang",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Situs web",
            "Enter Website": "Masuk ke Situs Web",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Tanggal Lahir",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Prioritas",
            "Enter Priority": "Masukkan Prioritas",
            "Subject": "Subjek",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Metode Pembayaran",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "it": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Descrizione",
            "Enter Description": "Inserisci la descrizione",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "E-mail",
            "Enter Email": "Inserisci l'e-mail",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "Nome",
            "Enter First Name": "Inserisci il nome",
            "Middle Name": "Secondo nome",
            "Enter Middle Name": "Inserisci il secondo nome",
            "Last Name": "Cognome",
            "Enter Last Name": "Inserisci il cognome",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "Sito web",
            "Enter Website": "Entra nel sito web",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Data di nascita",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Priorità",
            "Enter Priority": "Inserisci la priorità",
            "Subject": "Oggetto",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Metodo di pagamento",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "tr": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "Açıklama",
            "Enter Description": "Açıklamayı girin",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "E-posta",
            "Enter Email": "E-posta Girin",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "İsim",
            "Enter First Name": "Adı Girin",
            "Middle Name": "İkinci Ad",
            "Enter Middle Name": "İkinci Adı Girin",
            "Last Name": "Soyadı",
            "Enter Last Name": "Soyadı girin",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "İnternet Sitesi",
            "Enter Website": "Web Sitesine Girin",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "Doğum tarihi",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "Öncelik",
            "Enter Priority": "Önceliği Girin",
            "Subject": "Konu",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "Ödeme Şekli",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    },
    "fa": {
        "translation": {
            "Logo": "Logo",
            "$3,500 / month / 10 tokens": "$3,500 / month / 10 tokens",
            "$500 / month / token": "$500 / month / token",
            "▣ Layers": "▣ Layers",
            "☰ Filters": "☰ Filters",
            "♡ Save search": "♡ Save search",
            "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.": "A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.",
            "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.": "A secondary transfer means a token transfer after the original issuance, such as a transfer from one approved holder to another. Secondary transfers may require additional approval, transfer restrictions, legal review, broker-dealer support, transfer agent support, or other compliance steps.",
            "About": "About",
            "Active listing": "Active listing",
            "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.": "Add any details about your role, project, asset, token, service needs, agreements, payment method, or secondary transfer request.",
            "Add review": "Add review",
            "Additional notes": "Additional notes",
            "Address pending": "Address pending",
            "Advanced data, listing, reporting, and operational workflow support": "Advanced data, listing, reporting, and operational workflow support",
            "after completed buy or sell transaction": "after completed buy or sell transaction",
            "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.": "After identity verification and eligibility review, approved users may view full listing details, request reviews, and perform allowed buy or sell actions within the limits of each offering.",
            "Alabama": "Alabama",
            "Alaska": "Alaska",
            "All": "All",
            "American Samoa": "American Samoa",
            "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.": "Approved professionals may support review, legal, escrow, compliance, valuation, reporting, and other assigned service workflows.",
            "Arizona": "Arizona",
            "Arkansas": "Arkansas",
            "Asset class": "Asset class",
            "Asset owner": "Asset owner",
            "Asset owner, sponsor, issuer, or operator service plan": "Asset owner, sponsor, issuer, or operator service plan",
            "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager": "Asset owner, sponsor, issuer, property manager, asset manager, or rehab manager",
            "Auction": "Auction",
            "Authentication options": "Authentication options",
            "Back to login": "Back to login",
            "Basic asset and token workflow access": "Basic asset and token workflow access",
            "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.": "Basic SaaS management service for each active token. Suitable for a small number of assets or an initial launch.",
            "Blockchain network": "Blockchain network",
            "Boundary": "Boundary",
            "Broker-dealer signer, transfer agent, or token operations user": "Broker-dealer signer, transfer agent, or token operations user",
            "Buy Tokens": "Buy Tokens",
            "California": "California",
            "Charged only after a completed purchase or sale": "Charged only after a completed purchase or sale",
            "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user": "Charged only to an approved Broker-dealer signer, transfer agent, or token operations user",
            "Checking your session...": "Checking your session...",
            "Close details": "Close details",
            "Colorado": "Colorado",
            "COMMON EQUITY": "COMMON EQUITY",
            "Company or organization name": "Company or organization name",
            "Company, sponsor, issuer, SPV, or external platform name": "Company, sponsor, issuer, SPV, or external platform name",
            "Confirm password": "Confirm password",
            "Connecticut": "Connecticut",
            "Contact": "Contact",
            "Contact Us": "Contact Us",
            "Continue with Apple": "Continue with Apple",
            "Continue with Google": "Continue with Google",
            "Continue with Microsoft": "Continue with Microsoft",
            "Country": "Country",
            "Critical": "Critical",
            "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.": "Custom deployment and support for an enterprise customer. Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement.",
            "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.": "Custom deployment and support for enterprise customers, larger portfolios, custom workflows, and advanced operational needs.",
            "Custom service setup and enterprise support": "Custom service setup and enterprise support",
            "Customer review code layer": "Customer review code layer",
            "Customer reviews on map/list": "Customer reviews on map/list",
            "Debt": "Debt",
            "DEBT NOTE": "DEBT NOTE",
            "Debt structure is easy to understand.": "Debt structure is easy to understand.",
            "Delaware": "Delaware",
            "Designed for growing asset portfolios": "Designed for growing asset portfolios",
            "Display only": "Display only",
            "District of Columbia": "District of Columbia",
            "Document upload": "Document upload",
            "Drag and drop files here": "Drag and drop files here",
            "Email is required": "Email is required",
            "Enlarged Logo": "Enlarged Logo",
            "Enter subject": "Enter subject",
            "Enter the information needed to create or update your access request profile.": "Enter the information needed to create or update your access request profile.",
            "Enter your country": "Enter your country",
            "Enter your email": "Enter your email",
            "Enter your email address and we will send password reset instructions if the account exists.": "Enter your email address and we will send password reset instructions if the account exists.",
            "Enter your first name": "Enter your first name",
            "Enter your last name": "Enter your last name",
            "Enter your message": "Enter your message",
            "Enter your password": "Enter your password",
            "Enter your username or email": "Enter your username or email",
            "Enterprise / Custom": "Enterprise / Custom",
            "Equity": "Equity",
            "EQUITY APPRECIATION": "EQUITY APPRECIATION",
            "ERC-20, ERC-1400, ERC-3643, or another standard": "ERC-20, ERC-1400, ERC-3643, or another standard",
            "Escrow agent or escrow administrator": "Escrow agent or escrow administrator",
            "Ethereum, Polygon, Avalanche, or another network": "Ethereum, Polygon, Avalanche, or another network",
            "Example: RV text for map/list display...": "Example: RV text for map/list display...",
            "example@email.com": "example@email.com",
            "Exit": "Exit",
            "Expanded reporting and workflow support": "Expanded reporting and workflow support",
            "External issuer or platform name": "External issuer or platform name",
            "External ledger or cap table reference": "External ledger or cap table reference",
            "External review": "External review",
            "External token issuer or external token listing partner": "External token issuer or external token listing partner",
            "External token listing information": "External token listing information",
            "First name": "First name",
            "Florida": "Florida",
            "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.": "For approved escrow service users who manage escrow setup, deposits, releases, refunds, and distribution payment status. This role does not provide direct buy or sell access.",
            "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.": "For approved legal users who may review, approve, reject, or upload legal documents, disclosures, legal opinions, exemption notes, and related legal review records.",
            "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.": "For inspectors, valuation reviewers, compliance reviewers, title reviewers, auction source reviewers, financial analysts, investor relations reviewers, and other assigned professional review users.",
            "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.": "For internal or approved administrative users who manage platform data, user roles, map records, listings, and review workflows. Direct trading requires a separate approved investor role.",
            "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.": "For licensed or approved transaction, transfer, and token operation users. Any transaction-related compensation must be shown separately and handled under the applicable agreement and legal requirements.",
            "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.": "For organizations that already tokenized assets outside this platform and want those tokens to be reviewed, listed, displayed, or routed through platform access and reporting workflows.",
            "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.": "For project-side users who want to add assets or tokens, create listings, manage a data room, request reviews, coordinate professional services, and select a platform service plan.",
            "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.": "For tax reporting, audit trail, reconciliation, distribution reporting, financial controls, or other professional services required across multiple workflows.",
            "Forgot your password?": "Forgot your password?",
            "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.": "Free public access with limited listings, approximate map view, no precise location data, no full documents, no review request, and no buy or sell action.",
            "From $5,000 / month": "From $5,000 / month",
            "funded": "funded",
            "Funding progress": "Funding progress",
            "Georgia": "Georgia",
            "Good location visibility and clean data room.": "Good location visibility and clean data room.",
            "Good starting point for one asset or a small launch": "Good starting point for one asset or a small launch",
            "Guam": "Guam",
            "Handled under the applicable agreement, approval process, and legal requirements": "Handled under the applicable agreement, approval process, and legal requirements",
            "Hawaii": "Hawaii",
            "Hide": "Hide",
            "Hide password": "Hide password",
            "High": "High",
            "Home": "Home",
            "HYBRID": "HYBRID",
            "Idaho": "Idaho",
            "Illinois": "Illinois",
            "Included roles": "Included roles",
            "Income": "Income",
            "Indiana": "Indiana",
            "Invalid email format": "Invalid email format",
            "Investable only": "Investable only",
            "Investor Login": "Investor Login",
            "Iowa": "Iowa",
            "Issuer": "Issuer",
            "Issuer, sponsor, or originating platform": "Issuer, sponsor, or originating platform",
            "Kansas": "Kansas",
            "Kentucky": "Kentucky",
            "Last name": "Last name",
            "Legal counsel, securities attorney, or legal administrator": "Legal counsel, securities attorney, or legal administrator",
            "List": "List",
            "Listed": "Listed",
            "Location": "Location",
            "Login": "Login",
            "Login failed. Please check your username and password.": "Login failed. Please check your username and password.",
            "LogOut": "LogOut",
            "Logout failed. Please try again.": "Logout failed. Please try again.",
            "Louisiana": "Louisiana",
            "Low": "Low",
            "Lower effective cost per token for multiple active tokens": "Lower effective cost per token for multiple active tokens",
            "Maine": "Maine",
            "Map": "Map",
            "Map layers": "Map layers",
            "Market access": "Market access",
            "Marshall Islands": "Marshall Islands",
            "Maryland": "Maryland",
            "Massachusetts": "Massachusetts",
            "Menu": "Menu",
            "Message": "Message",
            "Michigan": "Michigan",
            "Micronesia": "Micronesia",
            "min": "min",
            "Min Investment": "Min Investment",
            "Minnesota": "Minnesota",
            "Mississippi": "Mississippi",
            "Missouri": "Missouri",
            "Mixed Use": "Mixed Use",
            "Moderate": "Moderate",
            "Montana": "Montana",
            "Nebraska": "Nebraska",
            "Network error. Please check your connection and try again.": "Network error. Please check your connection and try again.",
            "Nevada": "Nevada",
            "New access requests are handled through the Pricing & Access Request page.": "New access requests are handled through the Pricing & Access Request page.",
            "New Hampshire": "New Hampshire",
            "New Jersey": "New Jersey",
            "New Mexico": "New Mexico",
            "New York": "New York",
            "No public review yet.": "No public review yet.",
            "North Carolina": "North Carolina",
            "North Dakota": "North Dakota",
            "Northern Mariana Islands": "Northern Mariana Islands",
            "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans": "Not charged to public visitors, asset owners, sponsors, issuers, or operators under the monthly service plans",
            "Offering status": "Offering status",
            "Offerings": "Offerings",
            "Ohio": "Ohio",
            "Oklahoma": "Oklahoma",
            "Oops!": "Oops!",
            "Operator": "Operator",
            "or": "or",
            "or click to choose files": "or click to choose files",
            "Oregon": "Oregon",
            "Other professional services": "Other professional services",
            "Palau": "Palau",
            "Parcel / token boundary after zoom 16+": "Parcel / token boundary after zoom 16+",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password reset failed. Please try again.": "Password reset failed. Please try again.",
            "Password reset instructions were sent if this account exists.": "Password reset instructions were sent if this account exists.",
            "Pennsylvania": "Pennsylvania",
            "Phone number": "Phone number",
            "Platform admin, system admin, map data operator, or map data reviewer": "Platform admin, system admin, map data operator, or map data reviewer",
            "PLATFORM CORE": "PLATFORM CORE",
            "Platform service plans": "Platform service plans",
            "Please select a service plan for the asset owner, sponsor, or issuer role.": "Please select a service plan for the asset owner, sponsor, or issuer role.",
            "Please select a U.S. state, territory, or related jurisdiction.": "Please select a U.S. state, territory, or related jurisdiction.",
            "Please select at least one user type or role.": "Please select at least one user type or role.",
            "Please wait...": "Please wait...",
            "Point Only": "Point Only",
            "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.": "Portfolio-level SaaS management service for a minimum of ten active tokens with a lower effective cost per token.",
            "POST AUCTION": "POST AUCTION",
            "Post-Auction Token": "Post-Auction Token",
            "PRE AUCTION POOL": "PRE AUCTION POOL",
            "PREFERRED EQUITY": "PREFERRED EQUITY",
            "Pricing & Access Request": "Pricing & Access Request",
            "Professional": "Professional",
            "Professional review": "Professional review",
            "Professional reviewers": "Professional reviewers",
            "Project services": "Project services",
            "Public": "Public",
            "Public users can view limited information. Verified users may request broader access based on their role and approval status.": "Public users can view limited information. Verified users may request broader access based on their role and approval status.",
            "Public visitor": "Public visitor",
            "Puerto Rico": "Puerto Rico",
            "Real Asset": "Real Asset",
            "Registration and contact information": "Registration and contact information",
            "Remove": "Remove",
            "RENT INCOME": "RENT INCOME",
            "Rental Income": "Rental Income",
            "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.": "Request access to platform services for listing, review, document management, reporting, and token-related workflows. Access and service availability depend on verification, role approval, applicable agreements, and legal requirements.",
            "Request info only": "Request info only",
            "Requested external listing status": "Requested external listing status",
            "Reset Password": "Reset Password",
            "REVENUE SHARE": "REVENUE SHARE",
            "review": "review",
            "Review rating": "Review rating",
            "Review text": "Review text",
            "review(s)": "review(s)",
            "Reviews": "Reviews",
            "Rhode Island": "Rhode Island",
            "Risk": "Risk",
            "Risk Center": "Risk Center",
            "Risk color": "Risk color",
            "Risk color pins": "Risk color pins",
            "SALE PROFIT": "SALE PROFIT",
            "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement": "Sales responsibility, platform display, data support, listing support, and allowed transaction fees must be defined in a separate agreement",
            "Satellite": "Satellite",
            "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"": "Search: \"RI income Austin\", \"low risk land\", \"auction pool\"",
            "Secondary transfer restricted": "Secondary transfer restricted",
            "Secondary transfers": "Secondary transfers",
            "Select one": "Select one",
            "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.": "Select one or more roles. Some roles may require identity verification, business verification, professional credentials, service agreements, or platform approval.",
            "Select one U.S. state, territory, or related jurisdiction for this access request.": "Select one U.S. state, territory, or related jurisdiction for this access request.",
            "Send Message": "Send Message",
            "Send Reset Link": "Send Reset Link",
            "Service overview": "Service overview",
            "Services": "Services",
            "Show": "Show",
            "Show password": "Show password",
            "Showing": "Showing",
            "Sign in with an approved username and password or use single sign-on.": "Sign in with an approved username and password or use single sign-on.",
            "Signed in as": "Signed in as",
            "Simple listing and platform service support": "Simple listing and platform service support",
            "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.": "Simple service options for asset owners, sponsors, issuers, operators, and approved transaction service users.",
            "Single sign-on options": "Single sign-on options",
            "Smart contract address": "Smart contract address",
            "Sorry, an unexpected error has occurred.": "Sorry, an unexpected error has occurred.",
            "South Carolina": "South Carolina",
            "South Dakota": "South Dakota",
            "Sponsor": "Sponsor",
            "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.": "Sponsors, issuers, asset operators, and external listing partners can request platform services for asset and token workflows.",
            "Stark RWA Exchange": "Stark RWA Exchange",
            "Stark RWAE Exchange": "Stark RWAE Exchange",
            "Starter": "Starter",
            "State, territory, or jurisdiction": "State, territory, or jurisdiction",
            "Status": "Status",
            "Submit pricing and access request": "Submit pricing and access request",
            "Subscription": "Subscription",
            "Successfully logged in": "Successfully logged in",
            "Successfully logged out": "Successfully logged out",
            "target": "target",
            "Tennessee": "Tennessee",
            "Texas": "Texas",
            "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.": "The platform does not guarantee the external token, smart contract, valuation, ownership, cash flow, compliance status, or prior transfers unless a separate review and responsibility agreement is completed.",
            "There was an error sending your message. Please try again later.": "There was an error sending your message. Please try again later.",
            "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.": "These monthly service plans are for project-side users who need platform services for assets, tokens, listings, data, reporting, and related workflows.",
            "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.": "This section appears only when the asset owner, sponsor, issuer, property manager, asset manager, or rehab manager role is selected.",
            "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.": "This service fee applies only to approved transaction, transfer, or token operations service users when a purchase or sale is completed.",
            "Token": "Token",
            "Token details": "Token details",
            "Token standard": "Token standard",
            "Token type": "Token type",
            "Tokenized land & real estate offerings": "Tokenized land & real estate offerings",
            "tokens · Sort by relevant listings": "tokens · Sort by relevant listings",
            "Transaction service fee": "Transaction service fee",
            "Transfer agent, ledger source, snapshot, or reference URL": "Transfer agent, ledger source, snapshot, or reference URL",
            "Type": "Type",
            "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
            "U.S. state or territory": "U.S. state or territory",
            "U.S. Virgin Islands": "U.S. Virgin Islands",
            "Unknown": "Unknown",
            "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.": "Upload identity documents, business documents, professional licenses, agreements, ownership documents, appraisal reports, title documents, smart contract reports, or other relevant files.",
            "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.": "Use this section when the asset or economic interest has already been tokenized outside this platform and you want to request review or listing services.",
            "User type or role": "User type or role",
            "Username or email": "Username or email",
            "Username or email is required": "Username or email is required",
            "Utah": "Utah",
            "Verified external listing": "Verified external listing",
            "Verified investor, sponsor admin, offering admin, or marketplace admin": "Verified investor, sponsor admin, offering admin, or marketplace admin",
            "Vermont": "Vermont",
            "Virginia": "Virginia",
            "Washington": "Washington",
            "We could not confirm your sign-in session. Please try again.": "We could not confirm your sign-in session. Please try again.",
            "We would love to hear from you. Please fill out the form below.": "We would love to hear from you. Please fill out the form below.",
            "West Virginia": "West Virginia",
            "Wisconsin": "Wisconsin",
            "Wyoming": "Wyoming",
            "You are currently signed in.": "You are currently signed in.",
            "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.": "Your access and pricing request has been received. Our team will review the information and contact you with the next steps.",
            "Your message has been sent successfully. We will respond as soon as possible.": "Your message has been sent successfully. We will respond as soon as possible.",
            "01 System Admin Platform Admin": "01 System Admin Platform Admin",
            "01 SYSTEM ADMIN PLATFORM ADMIN": "01 SYSTEM ADMIN PLATFORM ADMIN",
            "Platform_USA_Profile": "Platform_USA_Profile",
            "PLATFORM_USA_PROFILE": "PLATFORM_USA_PROFILE",
            "Stark RWAE Exchange - USA Platform Profile": "Stark RWAE Exchange - USA Platform Profile",
            "Select Stark RWAE Exchange - USA Platform Profile": "Select Stark RWAE Exchange - USA Platform Profile",
            "Print of Stark RWAE Exchange - USA Platform Profile": "Print of Stark RWAE Exchange - USA Platform Profile",
            "Platform ID": "Platform ID",
            "Enter Platform ID": "Enter Platform ID",
            "Platform Name": "Platform Name",
            "Enter Platform Name": "Enter Platform Name",
            "Platform Display Name": "Platform Display Name",
            "Enter Platform Display Name": "Enter Platform Display Name",
            "Platform Legal Name": "Platform Legal Name",
            "Enter Platform Legal Name": "Enter Platform Legal Name",
            "Operating Country": "Operating Country",
            "Enter Operating Country": "Enter Operating Country",
            "Operating Country Locked USA": "Operating Country Locked USA",
            "Enter Operating Country Locked USA": "Enter Operating Country Locked USA",
            "Default Currency": "Default Currency",
            "Enter Default Currency": "Enter Default Currency",
            "ACH Enabled": "ACH Enabled",
            "Enter ACH Enabled": "Enter ACH Enabled",
            "Wire Enabled": "Wire Enabled",
            "Enter Wire Enabled": "Enter Wire Enabled",
            "Card Enabled": "Card Enabled",
            "Enter Card Enabled": "Enter Card Enabled",
            "Crypto Payments Enabled": "Crypto Payments Enabled",
            "Enter Crypto Payments Enabled": "Enter Crypto Payments Enabled",
            "Primary Regulatory Position": "Primary Regulatory Position",
            "Enter Primary Regulatory Position": "Enter Primary Regulatory Position",
            "Default Offering Model": "Default Offering Model",
            "Enter Default Offering Model": "Enter Default Offering Model",
            "Requires KYC AML": "Requires KYC AML",
            "Enter Requires KYC AML": "Enter Requires KYC AML",
            "Requires Investor Eligibility Check": "Requires Investor Eligibility Check",
            "Enter Requires Investor Eligibility Check": "Enter Requires Investor Eligibility Check",
            "Requires Transfer Restrictions": "Requires Transfer Restrictions",
            "Enter Requires Transfer Restrictions": "Enter Requires Transfer Restrictions",
            "Platform Status": "Platform Status",
            "Enter Platform Status": "Enter Platform Status",
            "Platform Notes": "Platform Notes",
            "Enter Platform Notes": "Enter Platform Notes",
            "Record Status": "Record Status",
            "Enter Record Status": "Enter Record Status",
            "Created By": "Created By",
            "Enter Created By": "Enter Created By",
            "Created At": "Created At",
            "Enter Created At": "Enter Created At",
            "Updated By": "Updated By",
            "Enter Updated By": "Enter Updated By",
            "Updated At": "Updated At",
            "Enter Updated At": "Enter Updated At",
            "Core_Token_Type_Definition": "Core_Token_Type_Definition",
            "CORE_TOKEN_TYPE_DEFINITION": "CORE_TOKEN_TYPE_DEFINITION",
            "Core Token Type Definition": "Core Token Type Definition",
            "Select Core Token Type Definition": "Select Core Token Type Definition",
            "Print of Core Token Type Definition": "Print of Core Token Type Definition",
            "Token Type ID": "Token Type ID",
            "Enter Token Type ID": "Enter Token Type ID",
            "Token Type Code": "Token Type Code",
            "Enter Token Type Code": "Enter Token Type Code",
            "Token Type Name": "Token Type Name",
            "Enter Token Type Name": "Enter Token Type Name",
            "Token Type Module": "Token Type Module",
            "Enter Token Type Module": "Enter Token Type Module",
            "Economic Model Category": "Economic Model Category",
            "Enter Economic Model Category": "Enter Economic Model Category",
            "Is Rental Based": "Is Rental Based",
            "Enter Is Rental Based": "Enter Is Rental Based",
            "Is Revenue Based": "Is Revenue Based",
            "Enter Is Revenue Based": "Enter Is Revenue Based",
            "Is Ownership Based": "Is Ownership Based",
            "Enter Is Ownership Based": "Enter Is Ownership Based",
            "Is Debt Based": "Is Debt Based",
            "Enter Is Debt Based": "Enter Is Debt Based",
            "Is Hybrid": "Is Hybrid",
            "Enter Is Hybrid": "Enter Is Hybrid",
            "Default Risk Level": "Default Risk Level",
            "Enter Default Risk Level": "Enter Default Risk Level",
            "Default Distribution Source": "Default Distribution Source",
            "Enter Default Distribution Source": "Enter Default Distribution Source",
            "Description": "توضیحات",
            "Enter Description": "توضیحات را وارد کنید",
            "Core_Token_Economic_Model_Master": "Core_Token_Economic_Model_Master",
            "CORE_TOKEN_ECONOMIC_MODEL_MASTER": "CORE_TOKEN_ECONOMIC_MODEL_MASTER",
            "Core Token Economic Model Master": "Core Token Economic Model Master",
            "Select Core Token Economic Model Master": "Select Core Token Economic Model Master",
            "Print of Core Token Economic Model Master": "Print of Core Token Economic Model Master",
            "Token Economic Model ID": "Token Economic Model ID",
            "Enter Token Economic Model ID": "Enter Token Economic Model ID",
            "Token Economic Model": "Token Economic Model",
            "Enter Token Economic Model": "Enter Token Economic Model",
            "Token Ownership Model": "Token Ownership Model",
            "Enter Token Ownership Model": "Enter Token Ownership Model",
            "Distribution Source": "Distribution Source",
            "Enter Distribution Source": "Enter Distribution Source",
            "Rental Income Allocation Allowed": "Rental Income Allocation Allowed",
            "Enter Rental Income Allocation Allowed": "Enter Rental Income Allocation Allowed",
            "Sale Profit Allocation Allowed": "Sale Profit Allocation Allowed",
            "Enter Sale Profit Allocation Allowed": "Enter Sale Profit Allocation Allowed",
            "Equity Appreciation Allocation Allowed": "Equity Appreciation Allocation Allowed",
            "Enter Equity Appreciation Allocation Allowed": "Enter Equity Appreciation Allocation Allowed",
            "Debt Interest Allowed": "Debt Interest Allowed",
            "Enter Debt Interest Allowed": "Enter Debt Interest Allowed",
            "Preferred Return Allowed": "Preferred Return Allowed",
            "Enter Preferred Return Allowed": "Enter Preferred Return Allowed",
            "Profit Split Allowed": "Profit Split Allowed",
            "Enter Profit Split Allowed": "Enter Profit Split Allowed",
            "Ownership Percentage Allowed": "Ownership Percentage Allowed",
            "Enter Ownership Percentage Allowed": "Enter Ownership Percentage Allowed",
            "NAV Based Valuation Required": "NAV Based Valuation Required",
            "Enter NAV Based Valuation Required": "Enter NAV Based Valuation Required",
            "Investor Disclosure Template Link": "Investor Disclosure Template Link",
            "Enter Investor Disclosure Template Link": "Enter Investor Disclosure Template Link",
            "Core_Risk_Color_Matrix": "Core_Risk_Color_Matrix",
            "CORE_RISK_COLOR_MATRIX": "CORE_RISK_COLOR_MATRIX",
            "Risk Color Matrix": "Risk Color Matrix",
            "Select Risk Color Matrix": "Select Risk Color Matrix",
            "Print of Risk Color Matrix": "Print of Risk Color Matrix",
            "Risk Color ID": "Risk Color ID",
            "Enter Risk Color ID": "Enter Risk Color ID",
            "Risk Level Name": "Risk Level Name",
            "Enter Risk Level Name": "Enter Risk Level Name",
            "Risk Percentage From": "Risk Percentage From",
            "Enter Risk Percentage From": "Enter Risk Percentage From",
            "Risk Percentage To": "Risk Percentage To",
            "Enter Risk Percentage To": "Enter Risk Percentage To",
            "Risk Color Name": "Risk Color Name",
            "Enter Risk Color Name": "Enter Risk Color Name",
            "Risk Color Hex": "Risk Color Hex",
            "Enter Risk Color Hex": "Enter Risk Color Hex",
            "Display Order": "Display Order",
            "Enter Display Order": "Enter Display Order",
            "Investor Warning Text": "Investor Warning Text",
            "Enter Investor Warning Text": "Enter Investor Warning Text",
            "Requires Extra Acknowledgment": "Requires Extra Acknowledgment",
            "Enter Requires Extra Acknowledgment": "Enter Requires Extra Acknowledgment",
            "Default Action": "Default Action",
            "Enter Default Action": "Enter Default Action",
            "Platform_Module_Config": "Platform_Module_Config",
            "PLATFORM_MODULE_CONFIG": "PLATFORM_MODULE_CONFIG",
            "Platform Module Configuration": "Platform Module Configuration",
            "Select Platform Module Configuration": "Select Platform Module Configuration",
            "Print of Platform Module Configuration": "Print of Platform Module Configuration",
            "Module Config ID": "Module Config ID",
            "Enter Module Config ID": "Enter Module Config ID",
            "Module Code": "Module Code",
            "Enter Module Code": "Enter Module Code",
            "Module Name": "Module Name",
            "Enter Module Name": "Enter Module Name",
            "Module Category": "Module Category",
            "Enter Module Category": "Enter Module Category",
            "Enabled": "Enabled",
            "Enter Enabled": "Enter Enabled",
            "Applies to Rental Income Token": "Applies to Rental Income Token",
            "Applies To RENT INCOME TOKEN": "Applies To RENT INCOME TOKEN",
            "Enter Applies To RENT INCOME TOKEN": "Enter Applies To RENT INCOME TOKEN",
            "Applies To REVENUE SHARE TOKEN": "Applies To REVENUE SHARE TOKEN",
            "Enter Applies To REVENUE SHARE TOKEN": "Enter Applies To REVENUE SHARE TOKEN",
            "Applies To SALE PROFIT TOKEN": "Applies To SALE PROFIT TOKEN",
            "Enter Applies To SALE PROFIT TOKEN": "Enter Applies To SALE PROFIT TOKEN",
            "Applies To EQUITY APPRECIATION TOKEN": "Applies To EQUITY APPRECIATION TOKEN",
            "Enter Applies To EQUITY APPRECIATION TOKEN": "Enter Applies To EQUITY APPRECIATION TOKEN",
            "Applies to Preferred Equity Token": "Applies to Preferred Equity Token",
            "Applies To PREFERRED EQUITY TOKEN": "Applies To PREFERRED EQUITY TOKEN",
            "Enter Applies To PREFERRED EQUITY TOKEN": "Enter Applies To PREFERRED EQUITY TOKEN",
            "Applies To COMMON EQUITY TOKEN": "Applies To COMMON EQUITY TOKEN",
            "Enter Applies To COMMON EQUITY TOKEN": "Enter Applies To COMMON EQUITY TOKEN",
            "Applies To DEBT NOTE TOKEN": "Applies To DEBT NOTE TOKEN",
            "Enter Applies To DEBT NOTE TOKEN": "Enter Applies To DEBT NOTE TOKEN",
            "Applies To HYBRID TOKEN": "Applies To HYBRID TOKEN",
            "Enter Applies To HYBRID TOKEN": "Enter Applies To HYBRID TOKEN",
            "Applies To PRE AUCTION POOL TOKEN": "Applies To PRE AUCTION POOL TOKEN",
            "Enter Applies To PRE AUCTION POOL TOKEN": "Enter Applies To PRE AUCTION POOL TOKEN",
            "Applies To POST AUCTION TOKENIZATION": "Applies To POST AUCTION TOKENIZATION",
            "Enter Applies To POST AUCTION TOKENIZATION": "Enter Applies To POST AUCTION TOKENIZATION",
            "Requires Admin Approval": "Requires Admin Approval",
            "Enter Requires Admin Approval": "Enter Requires Admin Approval",
            "Requires Compliance Approval": "Requires Compliance Approval",
            "Enter Requires Compliance Approval": "Enter Requires Compliance Approval",
            "Workflow_Definition": "Workflow_Definition",
            "WORKFLOW_DEFINITION": "WORKFLOW_DEFINITION",
            "Workflow Definition": "Workflow Definition",
            "Select Workflow Definition": "Select Workflow Definition",
            "Print of Workflow Definition": "Print of Workflow Definition",
            "Workflow ID": "Workflow ID",
            "Enter Workflow ID": "Enter Workflow ID",
            "Workflow Code": "Workflow Code",
            "Enter Workflow Code": "Enter Workflow Code",
            "Workflow Name": "Workflow Name",
            "Enter Workflow Name": "Enter Workflow Name",
            "Workflow Category": "Workflow Category",
            "Enter Workflow Category": "Enter Workflow Category",
            "Start Event": "Start Event",
            "Enter Start Event": "Enter Start Event",
            "End Event": "End Event",
            "Enter End Event": "Enter End Event",
            "SLA Days": "SLA Days",
            "Enter SLA Days": "Enter SLA Days",
            "Requires Escrow": "Requires Escrow",
            "Enter Requires Escrow": "Enter Requires Escrow",
            "Requires SPV": "Requires SPV",
            "Enter Requires SPV": "Enter Requires SPV",
            "Requires Inspector": "Requires Inspector",
            "Enter Requires Inspector": "Enter Requires Inspector",
            "Requires Investor Report": "Requires Investor Report",
            "Enter Requires Investor Report": "Enter Requires Investor Report",
            "Workflow Status": "Workflow Status",
            "Enter Workflow Status": "Enter Workflow Status",
            "Workflow Notes": "Workflow Notes",
            "Enter Workflow Notes": "Enter Workflow Notes",
            "Workflow_Step_Definition": "Workflow_Step_Definition",
            "WORKFLOW_STEP_DEFINITION": "WORKFLOW_STEP_DEFINITION",
            "Workflow Step Definition": "Workflow Step Definition",
            "Select Workflow Step Definition": "Select Workflow Step Definition",
            "Print of Workflow Step Definition": "Print of Workflow Step Definition",
            "Workflow Step ID": "Workflow Step ID",
            "Enter Workflow Step ID": "Enter Workflow Step ID",
            "Step Number": "Step Number",
            "Enter Step Number": "Enter Step Number",
            "Step Name": "Step Name",
            "Enter Step Name": "Enter Step Name",
            "Step I/O Mapping Type": "Step I/O Mapping Type",
            "Step IO Mapping Type": "Step IO Mapping Type",
            "Enter Step IO Mapping Type": "Enter Step IO Mapping Type",
            "Responsible Stakeholder Type": "Responsible Stakeholder Type",
            "Enter Responsible Stakeholder Type": "Enter Responsible Stakeholder Type",
            "Responsible Role": "Responsible Role",
            "Enter Responsible Role": "Enter Responsible Role",
            "Input Form Table": "Input Form Table",
            "Enter Input Form Table": "Enter Input Form Table",
            "Output Form Table": "Output Form Table",
            "Enter Output Form Table": "Enter Output Form Table",
            "Approval Rule Type": "Approval Rule Type",
            "Enter Approval Rule Type": "Enter Approval Rule Type",
            "Approval Form Table": "Approval Form Table",
            "Enter Approval Form Table": "Enter Approval Form Table",
            "Can Reject": "Can Reject",
            "Enter Can Reject": "Enter Can Reject",
            "Can Request Revision": "Can Request Revision",
            "Enter Can Request Revision": "Enter Can Request Revision",
            "Blocks Next Step": "Blocks Next Step",
            "Enter Blocks Next Step": "Enter Blocks Next Step",
            "Step SLA Days": "Step SLA Days",
            "Enter Step SLA Days": "Enter Step SLA Days",
            "Escalation Role": "Escalation Role",
            "Enter Escalation Role": "Enter Escalation Role",
            "User_Account": "User_Account",
            "USER_ACCOUNT": "USER_ACCOUNT",
            "User Account": "User Account",
            "Select User Account": "Select User Account",
            "Print of User Account": "Print of User Account",
            "User ID": "User ID",
            "Enter User ID": "Enter User ID",
            "Email": "ایمیل",
            "Enter Email": "ایمیل را وارد کنید",
            "Phone": "Phone",
            "Enter Phone": "Enter Phone",
            "First Name": "نام",
            "Enter First Name": "نام کوچک را وارد کنید",
            "Middle Name": "نام میانی",
            "Enter Middle Name": "نام میانی را وارد کنید",
            "Last Name": "نام خانوادگی",
            "Enter Last Name": "نام خانوادگی را وارد کنید",
            "User Type": "User Type",
            "Enter User Type": "Enter User Type",
            "Account Status": "Account Status",
            "Enter Account Status": "Enter Account Status",
            "MFA Enabled": "MFA Enabled",
            "Enter MFA Enabled": "Enter MFA Enabled",
            "Last Login At": "Last Login At",
            "Enter Last Login At": "Enter Last Login At",
            "Terms Accepted At": "Terms Accepted At",
            "Enter Terms Accepted At": "Enter Terms Accepted At",
            "Role_Definition": "Role_Definition",
            "ROLE_DEFINITION": "ROLE_DEFINITION",
            "Role Definition": "Role Definition",
            "Select Role Definition": "Select Role Definition",
            "Print of Role Definition": "Print of Role Definition",
            "Role ID": "Role ID",
            "Enter Role ID": "Enter Role ID",
            "Role Code": "Role Code",
            "Enter Role Code": "Enter Role Code",
            "Role Name": "Role Name",
            "Enter Role Name": "Enter Role Name",
            "Role Category": "Role Category",
            "Enter Role Category": "Enter Role Category",
            "Is Internal Admin": "Is Internal Admin",
            "Enter Is Internal Admin": "Enter Is Internal Admin",
            "Is External Stakeholder": "Is External Stakeholder",
            "Enter Is External Stakeholder": "Enter Is External Stakeholder",
            "Can Approve": "Can Approve",
            "Enter Can Approve": "Enter Can Approve",
            "Can Submit": "Can Submit",
            "Enter Can Submit": "Enter Can Submit",
            "Can View Investor Data": "Can View Investor Data",
            "Enter Can View Investor Data": "Enter Can View Investor Data",
            "User_Role_Assignment": "User_Role_Assignment",
            "USER_ROLE_ASSIGNMENT": "USER_ROLE_ASSIGNMENT",
            "User Role Assignment": "User Role Assignment",
            "Select User Role Assignment": "Select User Role Assignment",
            "Print of User Role Assignment": "Print of User Role Assignment",
            "User Role ID": "User Role ID",
            "Enter User Role ID": "Enter User Role ID",
            "Scope Type": "Scope Type",
            "Enter Scope Type": "Enter Scope Type",
            "Asset ID": "Asset ID",
            "Enter Asset ID": "Enter Asset ID",
            "Offering ID": "Offering ID",
            "Enter Offering ID": "Enter Offering ID",
            "Organization ID": "Organization ID",
            "Enter Organization ID": "Enter Organization ID",
            "Effective From": "Effective From",
            "Enter Effective From": "Enter Effective From",
            "Effective To": "Effective To",
            "Enter Effective To": "Enter Effective To",
            "Active": "Active",
            "Enter Active": "Enter Active",
            "System_Code_List": "System_Code_List",
            "SYSTEM_CODE_LIST": "SYSTEM_CODE_LIST",
            "System Code List": "System Code List",
            "Select System Code List": "Select System Code List",
            "Print of System Code List": "Print of System Code List",
            "Code List ID": "Code List ID",
            "Enter Code List ID": "Enter Code List ID",
            "Code Group": "Code Group",
            "Enter Code Group": "Enter Code Group",
            "Code Value": "Code Value",
            "Enter Code Value": "Enter Code Value",
            "Code Label": "Code Label",
            "Enter Code Label": "Enter Code Label",
            "Parent Code Value": "Parent Code Value",
            "Enter Parent Code Value": "Enter Parent Code Value",
            "02 Organization Stakeholder Onboarding": "02 Organization Stakeholder Onboarding",
            "02 ORGANIZATION STAKEHOLDER ONBOARDING": "02 ORGANIZATION STAKEHOLDER ONBOARDING",
            "Organization_Profile": "Organization_Profile",
            "ORGANIZATION_PROFILE": "ORGANIZATION_PROFILE",
            "Organization Profile": "Organization Profile",
            "Select Organization Profile": "Select Organization Profile",
            "Print of Organization Profile": "Print of Organization Profile",
            "Organization Type": "Organization Type",
            "Enter Organization Type": "Enter Organization Type",
            "Legal Name": "Legal Name",
            "Enter Legal Name": "Enter Legal Name",
            "DBA Name": "DBA Name",
            "Enter DBA Name": "Enter DBA Name",
            "EIN Masked": "EIN Masked",
            "Enter EIN Masked": "Enter EIN Masked",
            "Formation State": "Formation State",
            "Enter Formation State": "Enter Formation State",
            "Website": "وب سایت",
            "Enter Website": "وارد کردن وب سایت",
            "Primary Contact Name": "Primary Contact Name",
            "Enter Primary Contact Name": "Enter Primary Contact Name",
            "Primary Contact Email": "Primary Contact Email",
            "Enter Primary Contact Email": "Enter Primary Contact Email",
            "Verification Status": "Verification Status",
            "Enter Verification Status": "Enter Verification Status",
            "Stakeholder_Profile": "Stakeholder_Profile",
            "STAKEHOLDER_PROFILE": "STAKEHOLDER_PROFILE",
            "Stakeholder Profile": "Stakeholder Profile",
            "Select Stakeholder Profile": "Select Stakeholder Profile",
            "Print of Stakeholder Profile": "Print of Stakeholder Profile",
            "Stakeholder ID": "Stakeholder ID",
            "Enter Stakeholder ID": "Enter Stakeholder ID",
            "Stakeholder Type": "Stakeholder Type",
            "Enter Stakeholder Type": "Enter Stakeholder Type",
            "Contact Name": "Contact Name",
            "Enter Contact Name": "Enter Contact Name",
            "Contact Email": "Contact Email",
            "Enter Contact Email": "Enter Contact Email",
            "Contact Phone": "Contact Phone",
            "Enter Contact Phone": "Enter Contact Phone",
            "License Number": "License Number",
            "Enter License Number": "Enter License Number",
            "License State": "License State",
            "Enter License State": "Enter License State",
            "License Expiry Date": "License Expiry Date",
            "Enter License Expiry Date": "Enter License Expiry Date",
            "Professional Insurance Status": "Professional Insurance Status",
            "Enter Professional Insurance Status": "Enter Professional Insurance Status",
            "KYC / KYB Status": "KYC / KYB Status",
            "KYC KYB Status": "KYC KYB Status",
            "Enter KYC KYB Status": "Enter KYC KYB Status",
            "Background Check Status": "Background Check Status",
            "Enter Background Check Status": "Enter Background Check Status",
            "Conflict Of Interest Flag": "Conflict Of Interest Flag",
            "Enter Conflict Of Interest Flag": "Enter Conflict Of Interest Flag",
            "Approved for Platform": "Approved for Platform",
            "Approved For Platform": "Approved For Platform",
            "Enter Approved For Platform": "Enter Approved For Platform",
            "Approval Notes": "Approval Notes",
            "Enter Approval Notes": "Enter Approval Notes",
            "03 Investor Onboarding Compliance": "03 Investor Onboarding Compliance",
            "03 INVESTOR ONBOARDING COMPLIANCE": "03 INVESTOR ONBOARDING COMPLIANCE",
            "Investor_Profile": "Investor_Profile",
            "INVESTOR_PROFILE": "INVESTOR_PROFILE",
            "Investor Profile": "Investor Profile",
            "Select Investor Profile": "Select Investor Profile",
            "Print of Investor Profile": "Print of Investor Profile",
            "Investor ID": "Investor ID",
            "Enter Investor ID": "Enter Investor ID",
            "Investor Type": "Investor Type",
            "Enter Investor Type": "Enter Investor Type",
            "Residency State": "Residency State",
            "Enter Residency State": "Enter Residency State",
            "US Tax Resident": "US Tax Resident",
            "Enter US Tax Resident": "Enter US Tax Resident",
            "Date of Birth": "تاریخ تولد",
            "Date Of Birth": "Date Of Birth",
            "Enter Date Of Birth": "Enter Date Of Birth",
            "SSN Last4": "SSN Last4",
            "Enter SSN Last4": "Enter SSN Last4",
            "Tax ID Type": "Tax ID Type",
            "Enter Tax ID Type": "Enter Tax ID Type",
            "Annual Income Range": "Annual Income Range",
            "Enter Annual Income Range": "Enter Annual Income Range",
            "Net Worth Range": "Net Worth Range",
            "Enter Net Worth Range": "Enter Net Worth Range",
            "Investment Objective": "Investment Objective",
            "Enter Investment Objective": "Enter Investment Objective",
            "Risk Tolerance": "Risk Tolerance",
            "Enter Risk Tolerance": "Enter Risk Tolerance",
            "Liquidity Need": "Liquidity Need",
            "Enter Liquidity Need": "Enter Liquidity Need",
            "Investor Status": "Investor Status",
            "Enter Investor Status": "Enter Investor Status",
            "Investor_KYC_AML_Check": "Investor_KYC_AML_Check",
            "INVESTOR_KYC_AML_CHECK": "INVESTOR_KYC_AML_CHECK",
            "Investor KYC AML Check": "Investor KYC AML Check",
            "Select Investor KYC AML Check": "Select Investor KYC AML Check",
            "Print of Investor KYC AML Check": "Print of Investor KYC AML Check",
            "KYC / AML Check ID": "KYC / AML Check ID",
            "KYC AML Check ID": "KYC AML Check ID",
            "Enter KYC AML Check ID": "Enter KYC AML Check ID",
            "KYC Provider": "KYC Provider",
            "Enter KYC Provider": "Enter KYC Provider",
            "Provider Reference ID": "Provider Reference ID",
            "Enter Provider Reference ID": "Enter Provider Reference ID",
            "Identity Status": "Identity Status",
            "Enter Identity Status": "Enter Identity Status",
            "Address Status": "Address Status",
            "Enter Address Status": "Enter Address Status",
            "Document Type": "Document Type",
            "Enter Document Type": "Enter Document Type",
            "KYC Result": "KYC Result",
            "Enter KYC Result": "Enter KYC Result",
            "Sanctions Status": "Sanctions Status",
            "Enter Sanctions Status": "Enter Sanctions Status",
            "PEP Status": "PEP Status",
            "Enter PEP Status": "Enter PEP Status",
            "AML Status": "AML Status",
            "Enter AML Status": "Enter AML Status",
            "Manual Review Required": "Manual Review Required",
            "Enter Manual Review Required": "Enter Manual Review Required",
            "Manual Review Notes": "Manual Review Notes",
            "Enter Manual Review Notes": "Enter Manual Review Notes",
            "Investor_Accreditation_Verification": "Investor_Accreditation_Verification",
            "INVESTOR_ACCREDITATION_VERIFICATION": "INVESTOR_ACCREDITATION_VERIFICATION",
            "Investor Accreditation Verification": "Investor Accreditation Verification",
            "Select Investor Accreditation Verification": "Select Investor Accreditation Verification",
            "Print of Investor Accreditation Verification": "Print of Investor Accreditation Verification",
            "Accreditation ID": "Accreditation ID",
            "Enter Accreditation ID": "Enter Accreditation ID",
            "Accreditation Status": "Accreditation Status",
            "Enter Accreditation Status": "Enter Accreditation Status",
            "Verification Method": "Verification Method",
            "Enter Verification Method": "Enter Verification Method",
            "Verifier Name": "Verifier Name",
            "Enter Verifier Name": "Enter Verifier Name",
            "Verifier Type": "Verifier Type",
            "Enter Verifier Type": "Enter Verifier Type",
            "Verification Document Link": "Verification Document Link",
            "Enter Verification Document Link": "Enter Verification Document Link",
            "Effective Date": "Effective Date",
            "Enter Effective Date": "Enter Effective Date",
            "Expiry Date": "Expiry Date",
            "Enter Expiry Date": "Enter Expiry Date",
            "Review Status": "Review Status",
            "Enter Review Status": "Enter Review Status",
            "Investor_Bank_Account": "Investor_Bank_Account",
            "INVESTOR_BANK_ACCOUNT": "INVESTOR_BANK_ACCOUNT",
            "Investor Bank Account": "Investor Bank Account",
            "Select Investor Bank Account": "Select Investor Bank Account",
            "Print of Investor Bank Account": "Print of Investor Bank Account",
            "Bank Account ID": "Bank Account ID",
            "Enter Bank Account ID": "Enter Bank Account ID",
            "Account Nickname": "Account Nickname",
            "Enter Account Nickname": "Enter Account Nickname",
            "Bank Name": "Bank Name",
            "Enter Bank Name": "Enter Bank Name",
            "Routing Number Masked": "Routing Number Masked",
            "Enter Routing Number Masked": "Enter Routing Number Masked",
            "Account Number Last4": "Account Number Last4",
            "Enter Account Number Last4": "Enter Account Number Last4",
            "Account Type": "Account Type",
            "Enter Account Type": "Enter Account Type",
            "ACH Verification Status": "ACH Verification Status",
            "Enter ACH Verification Status": "Enter ACH Verification Status",
            "Default For Distributions": "Default For Distributions",
            "Enter Default For Distributions": "Enter Default For Distributions",
            "Investor_Risk_Acknowledgment": "Investor_Risk_Acknowledgment",
            "INVESTOR_RISK_ACKNOWLEDGMENT": "INVESTOR_RISK_ACKNOWLEDGMENT",
            "Investor Risk Acknowledgment": "Investor Risk Acknowledgment",
            "Select Investor Risk Acknowledgment": "Select Investor Risk Acknowledgment",
            "Print of Investor Risk Acknowledgment": "Print of Investor Risk Acknowledgment",
            "Risk Acknowledgment ID": "Risk Acknowledgment ID",
            "Enter Risk Acknowledgment ID": "Enter Risk Acknowledgment ID",
            "Illiquidity Acknowledged": "Illiquidity Acknowledged",
            "Enter Illiquidity Acknowledged": "Enter Illiquidity Acknowledged",
            "Loss Risk Acknowledged": "Loss Risk Acknowledged",
            "Enter Loss Risk Acknowledged": "Enter Loss Risk Acknowledged",
            "No Guaranteed Return Acknowledged": "No Guaranteed Return Acknowledged",
            "Enter No Guaranteed Return Acknowledged": "Enter No Guaranteed Return Acknowledged",
            "Transfer Restriction Acknowledged": "Transfer Restriction Acknowledged",
            "Enter Transfer Restriction Acknowledged": "Enter Transfer Restriction Acknowledged",
            "Construction Risk Acknowledged": "Construction Risk Acknowledged",
            "Enter Construction Risk Acknowledged": "Enter Construction Risk Acknowledged",
            "Auction Risk Acknowledged": "Auction Risk Acknowledged",
            "Enter Auction Risk Acknowledged": "Enter Auction Risk Acknowledged",
            "Acknowledged At": "Acknowledged At",
            "Enter Acknowledged At": "Enter Acknowledged At",
            "Signature Hash": "Signature Hash",
            "Enter Signature Hash": "Enter Signature Hash",
            "04 Asset SPV Due Diligence Legal": "04 Asset SPV Due Diligence Legal",
            "04 ASSET SPV DUE DILIGENCE LEGAL": "04 ASSET SPV DUE DILIGENCE LEGAL",
            "Core_Data_Room": "Core_Data_Room",
            "CORE_DATA_ROOM": "CORE_DATA_ROOM",
            "Core Data Room": "Core Data Room",
            "Select Core Data Room": "Select Core Data Room",
            "Print of Core Data Room": "Print of Core Data Room",
            "Data Room ID": "Data Room ID",
            "Enter Data Room ID": "Enter Data Room ID",
            "Data Room Name": "Data Room Name",
            "Enter Data Room Name": "Enter Data Room Name",
            "Public Access Enabled": "Public Access Enabled",
            "Enter Public Access Enabled": "Enter Public Access Enabled",
            "Investor Access Enabled": "Investor Access Enabled",
            "Enter Investor Access Enabled": "Enter Investor Access Enabled",
            "Compliance Access Enabled": "Compliance Access Enabled",
            "Enter Compliance Access Enabled": "Enter Compliance Access Enabled",
            "Version Locking Enabled": "Version Locking Enabled",
            "Enter Version Locking Enabled": "Enter Version Locking Enabled",
            "Data Room Status": "Data Room Status",
            "Enter Data Room Status": "Enter Data Room Status",
            "Notes": "Notes",
            "Enter Notes": "Enter Notes",
            "Core_Data_Room_Document": "Core_Data_Room_Document",
            "CORE_DATA_ROOM_DOCUMENT": "CORE_DATA_ROOM_DOCUMENT",
            "Core Data Room Document": "Core Data Room Document",
            "Select Core Data Room Document": "Select Core Data Room Document",
            "Print of Core Data Room Document": "Print of Core Data Room Document",
            "Document ID": "Document ID",
            "Enter Document ID": "Enter Document ID",
            "Document Category": "Document Category",
            "Enter Document Category": "Enter Document Category",
            "Document Title": "Document Title",
            "Enter Document Title": "Enter Document Title",
            "Document Link": "Document Link",
            "Enter Document Link": "Enter Document Link",
            "Version Number": "Version Number",
            "Enter Version Number": "Enter Version Number",
            "Expiration Date": "Expiration Date",
            "Enter Expiration Date": "Enter Expiration Date",
            "Document Rule Audience": "Document Rule Audience",
            "Enter Document Rule Audience": "Enter Document Rule Audience",
            "Visibility Level": "Visibility Level",
            "Enter Visibility Level": "Enter Visibility Level",
            "Required For Offering": "Required For Offering",
            "Enter Required For Offering": "Enter Required For Offering",
            "Verified": "Verified",
            "Enter Verified": "Enter Verified",
            "Core_Document_Verification": "Core_Document_Verification",
            "CORE_DOCUMENT_VERIFICATION": "CORE_DOCUMENT_VERIFICATION",
            "Core Document Verification": "Core Document Verification",
            "Select Core Document Verification": "Select Core Document Verification",
            "Print of Core Document Verification": "Print of Core Document Verification",
            "Document Verification ID": "Document Verification ID",
            "Enter Document Verification ID": "Enter Document Verification ID",
            "Verifier Stakeholder Type": "Verifier Stakeholder Type",
            "Enter Verifier Stakeholder Type": "Enter Verifier Stakeholder Type",
            "Verifier ID": "Verifier ID",
            "Enter Verifier ID": "Enter Verifier ID",
            "Verification Issue Type": "Verification Issue Type",
            "Enter Verification Issue Type": "Enter Verification Issue Type",
            "Deficiency Found": "Deficiency Found",
            "Enter Deficiency Found": "Enter Deficiency Found",
            "Deficiency Description": "Deficiency Description",
            "Enter Deficiency Description": "Enter Deficiency Description",
            "Corrective Action Required": "Corrective Action Required",
            "Enter Corrective Action Required": "Enter Corrective Action Required",
            "Verified At": "Verified At",
            "Enter Verified At": "Enter Verified At",
            "Core_Title_Search_Report": "Core_Title_Search_Report",
            "CORE_TITLE_SEARCH_REPORT": "CORE_TITLE_SEARCH_REPORT",
            "Core Title Search Report": "Core Title Search Report",
            "Select Core Title Search Report": "Select Core Title Search Report",
            "Print of Core Title Search Report": "Print of Core Title Search Report",
            "Title Search ID": "Title Search ID",
            "Enter Title Search ID": "Enter Title Search ID",
            "Title Company ID": "Title Company ID",
            "Enter Title Company ID": "Enter Title Company ID",
            "Search Date": "Search Date",
            "Enter Search Date": "Enter Search Date",
            "Vesting Owner": "Vesting Owner",
            "Enter Vesting Owner": "Enter Vesting Owner",
            "Deed Type": "Deed Type",
            "Enter Deed Type": "Enter Deed Type",
            "Lien Found": "Lien Found",
            "Enter Lien Found": "Enter Lien Found",
            "Lien Count": "Lien Count",
            "Enter Lien Count": "Enter Lien Count",
            "Lien Total USD": "Lien Total USD",
            "Enter Lien Total USD": "Enter Lien Total USD",
            "Exception Count": "Exception Count",
            "Enter Exception Count": "Enter Exception Count",
            "Title Search Report Link": "Title Search Report Link",
            "Enter Title Search Report Link": "Enter Title Search Report Link",
            "Title Status": "Title Status",
            "Enter Title Status": "Enter Title Status",
            "Core_Appraisal_Report": "Core_Appraisal_Report",
            "CORE_APPRAISAL_REPORT": "CORE_APPRAISAL_REPORT",
            "Core Appraisal Report": "Core Appraisal Report",
            "Select Core Appraisal Report": "Select Core Appraisal Report",
            "Print of Core Appraisal Report": "Print of Core Appraisal Report",
            "Appraisal ID": "Appraisal ID",
            "Enter Appraisal ID": "Enter Appraisal ID",
            "Appraiser ID": "Appraiser ID",
            "Enter Appraiser ID": "Enter Appraiser ID",
            "Appraisal Date": "Appraisal Date",
            "Enter Appraisal Date": "Enter Appraisal Date",
            "Appraised Value USD": "Appraised Value USD",
            "Enter Appraised Value USD": "Enter Appraised Value USD",
            "Valuation Method": "Valuation Method",
            "Enter Valuation Method": "Enter Valuation Method",
            "Cap Rate": "Cap Rate",
            "Enter Cap Rate": "Enter Cap Rate",
            "NOI Used USD": "NOI Used USD",
            "Enter NOI Used USD": "Enter NOI Used USD",
            "Comparable Count": "Comparable Count",
            "Enter Comparable Count": "Enter Comparable Count",
            "Report Link": "Report Link",
            "Enter Report Link": "Enter Report Link",
            "Reviewer Approval Status": "Reviewer Approval Status",
            "Enter Reviewer Approval Status": "Enter Reviewer Approval Status",
            "Core_Due_Diligence_Checklist": "Core_Due_Diligence_Checklist",
            "CORE_DUE_DILIGENCE_CHECKLIST": "CORE_DUE_DILIGENCE_CHECKLIST",
            "Core Due Diligence Checklist": "Core Due Diligence Checklist",
            "Select Core Due Diligence Checklist": "Select Core Due Diligence Checklist",
            "Print of Core Due Diligence Checklist": "Print of Core Due Diligence Checklist",
            "Due Diligence Checklist ID": "Due Diligence Checklist ID",
            "DD Checklist ID": "DD Checklist ID",
            "Enter DD Checklist ID": "Enter DD Checklist ID",
            "Checklist Item Type": "Checklist Item Type",
            "Enter Checklist Item Type": "Enter Checklist Item Type",
            "Title Complete": "Title Complete",
            "Enter Title Complete": "Enter Title Complete",
            "Appraisal Complete": "Appraisal Complete",
            "Enter Appraisal Complete": "Enter Appraisal Complete",
            "Environmental Complete": "Environmental Complete",
            "Enter Environmental Complete": "Enter Environmental Complete",
            "Zoning Complete": "Zoning Complete",
            "Enter Zoning Complete": "Enter Zoning Complete",
            "Survey Complete": "Survey Complete",
            "Enter Survey Complete": "Enter Survey Complete",
            "Insurance Complete": "Insurance Complete",
            "Enter Insurance Complete": "Enter Insurance Complete",
            "Tax Review Complete": "Tax Review Complete",
            "Enter Tax Review Complete": "Enter Tax Review Complete",
            "Legal Review Complete": "Legal Review Complete",
            "Enter Legal Review Complete": "Enter Legal Review Complete",
            "Open Deficiency Count": "Open Deficiency Count",
            "Enter Open Deficiency Count": "Enter Open Deficiency Count",
            "DD Status": "DD Status",
            "Enter DD Status": "Enter DD Status",
            "Core_Project_SPV": "Core_Project_SPV",
            "CORE_PROJECT_SPV": "CORE_PROJECT_SPV",
            "Core Project SPV": "Core Project SPV",
            "Select Core Project SPV": "Select Core Project SPV",
            "Print of Core Project SPV": "Print of Core Project SPV",
            "SPV ID": "SPV ID",
            "Enter SPV ID": "Enter SPV ID",
            "SPV Legal Name": "SPV Legal Name",
            "Enter SPV Legal Name": "Enter SPV Legal Name",
            "SPV Type": "SPV Type",
            "Enter SPV Type": "Enter SPV Type",
            "Registered Agent Name": "Registered Agent Name",
            "Enter Registered Agent Name": "Enter Registered Agent Name",
            "Operating Agreement Link": "Operating Agreement Link",
            "Enter Operating Agreement Link": "Enter Operating Agreement Link",
            "Liability Segregation Confirmed": "Liability Segregation Confirmed",
            "Enter Liability Segregation Confirmed": "Enter Liability Segregation Confirmed",
            "SPV Status": "SPV Status",
            "Enter SPV Status": "Enter SPV Status",
            "Core_Legal_Opinion": "Core_Legal_Opinion",
            "CORE_LEGAL_OPINION": "CORE_LEGAL_OPINION",
            "Core Legal Opinion": "Core Legal Opinion",
            "Select Core Legal Opinion": "Select Core Legal Opinion",
            "Print of Core Legal Opinion": "Print of Core Legal Opinion",
            "Legal Opinion ID": "Legal Opinion ID",
            "Enter Legal Opinion ID": "Enter Legal Opinion ID",
            "Legal Counsel ID": "Legal Counsel ID",
            "Enter Legal Counsel ID": "Enter Legal Counsel ID",
            "Opinion Type": "Opinion Type",
            "Enter Opinion Type": "Enter Opinion Type",
            "Securities Law Position": "Securities Law Position",
            "Enter Securities Law Position": "Enter Securities Law Position",
            "Exemption Analysis": "Exemption Analysis",
            "Enter Exemption Analysis": "Enter Exemption Analysis",
            "Risk Exceptions": "Risk Exceptions",
            "Enter Risk Exceptions": "Enter Risk Exceptions",
            "Opinion Document Link": "Opinion Document Link",
            "Enter Opinion Document Link": "Enter Opinion Document Link",
            "Opinion Status": "Opinion Status",
            "Enter Opinion Status": "Enter Opinion Status",
            "05 Escrow Investor Protection Market": "05 Escrow Investor Protection Market",
            "05 ESCROW INVESTOR PROTECTION MARKET": "05 ESCROW INVESTOR PROTECTION MARKET",
            "Core_Escrow_Account": "Core_Escrow_Account",
            "CORE_ESCROW_ACCOUNT": "CORE_ESCROW_ACCOUNT",
            "Core Escrow Account": "Core Escrow Account",
            "Select Core Escrow Account": "Select Core Escrow Account",
            "Print of Core Escrow Account": "Print of Core Escrow Account",
            "Escrow Account ID": "Escrow Account ID",
            "Enter Escrow Account ID": "Enter Escrow Account ID",
            "Escrow Agent ID": "Escrow Agent ID",
            "Enter Escrow Agent ID": "Enter Escrow Agent ID",
            "Escrow Bank Name": "Escrow Bank Name",
            "Enter Escrow Bank Name": "Enter Escrow Bank Name",
            "Escrow Account Last 4": "Escrow Account Last 4",
            "Escrow Account Last4": "Escrow Account Last4",
            "Enter Escrow Account Last4": "Enter Escrow Account Last4",
            "Escrow Agreement Link": "Escrow Agreement Link",
            "Enter Escrow Agreement Link": "Enter Escrow Agreement Link",
            "Current Balance USD": "Current Balance USD",
            "Enter Current Balance USD": "Enter Current Balance USD",
            "Funds Release Method": "Funds Release Method",
            "Enter Funds Release Method": "Enter Funds Release Method",
            "Dual Approval Required": "Dual Approval Required",
            "Enter Dual Approval Required": "Enter Dual Approval Required",
            "Escrow Status": "Escrow Status",
            "Enter Escrow Status": "Enter Escrow Status",
            "Core_Investor_Protection_Profile": "Core_Investor_Protection_Profile",
            "CORE_INVESTOR_PROTECTION_PROFILE": "CORE_INVESTOR_PROTECTION_PROFILE",
            "Core Investor Protection Profile": "Core Investor Protection Profile",
            "Select Core Investor Protection Profile": "Select Core Investor Protection Profile",
            "Print of Core Investor Protection Profile": "Print of Core Investor Protection Profile",
            "Protection Profile ID": "Protection Profile ID",
            "Enter Protection Profile ID": "Enter Protection Profile ID",
            "Protection Level": "Protection Level",
            "Enter Protection Level": "Enter Protection Level",
            "Escrow Required": "Escrow Required",
            "Enter Escrow Required": "Enter Escrow Required",
            "Independent Inspection Required": "Independent Inspection Required",
            "Enter Independent Inspection Required": "Enter Independent Inspection Required",
            "Performance Bond Required": "Performance Bond Required",
            "Enter Performance Bond Required": "Enter Performance Bond Required",
            "Payment Bond Required": "Payment Bond Required",
            "Enter Payment Bond Required": "Enter Payment Bond Required",
            "Reserve Fund Required": "Reserve Fund Required",
            "Enter Reserve Fund Required": "Enter Reserve Fund Required",
            "Developer Guarantee Required": "Developer Guarantee Required",
            "Enter Developer Guarantee Required": "Enter Developer Guarantee Required",
            "Freeze Delist Rights": "Freeze Delist Rights",
            "Enter Freeze Delist Rights": "Enter Freeze Delist Rights",
            "Investor Claim Process Link": "Investor Claim Process Link",
            "Enter Investor Claim Process Link": "Enter Investor Claim Process Link",
            "Core_Secondary_Market_Config": "Core_Secondary_Market_Config",
            "CORE_SECONDARY_MARKET_CONFIG": "CORE_SECONDARY_MARKET_CONFIG",
            "Core Secondary Market Config": "Core Secondary Market Config",
            "Select Core Secondary Market Config": "Select Core Secondary Market Config",
            "Print of Core Secondary Market Config": "Print of Core Secondary Market Config",
            "Secondary Market Config ID": "Secondary Market Config ID",
            "Enter Secondary Market Config ID": "Enter Secondary Market Config ID",
            "Secondary Trading Enabled": "Secondary Trading Enabled",
            "Enter Secondary Trading Enabled": "Enter Secondary Trading Enabled",
            "Requires ATS": "Requires ATS",
            "Enter Requires ATS": "Enter Requires ATS",
            "ATS Partner ID": "ATS Partner ID",
            "Enter ATS Partner ID": "Enter ATS Partner ID",
            "Transfer Agent ID": "Transfer Agent ID",
            "Enter Transfer Agent ID": "Enter Transfer Agent ID",
            "Minimum Holding Period Days": "Minimum Holding Period Days",
            "Enter Minimum Holding Period Days": "Enter Minimum Holding Period Days",
            "Eligible Buyer Rule": "Eligible Buyer Rule",
            "Enter Eligible Buyer Rule": "Enter Eligible Buyer Rule",
            "Secondary Market Status": "Secondary Market Status",
            "Enter Secondary Market Status": "Enter Secondary Market Status",
            "Core_Governance_Rule_Set": "Core_Governance_Rule_Set",
            "CORE_GOVERNANCE_RULE_SET": "CORE_GOVERNANCE_RULE_SET",
            "Core Governance Rule Set": "Core Governance Rule Set",
            "Select Core Governance Rule Set": "Select Core Governance Rule Set",
            "Print of Core Governance Rule Set": "Print of Core Governance Rule Set",
            "Governance Rule Set ID": "Governance Rule Set ID",
            "Enter Governance Rule Set ID": "Enter Governance Rule Set ID",
            "Quorum Percentage": "Quorum Percentage",
            "Enter Quorum Percentage": "Enter Quorum Percentage",
            "Standard Approval Percentage": "Standard Approval Percentage",
            "Enter Standard Approval Percentage": "Enter Standard Approval Percentage",
            "Major Decision Approval Percentage": "Major Decision Approval Percentage",
            "Enter Major Decision Approval Percentage": "Enter Major Decision Approval Percentage",
            "Voting Weight Method": "Voting Weight Method",
            "Enter Voting Weight Method": "Enter Voting Weight Method",
            "Rules Document Link": "Rules Document Link",
            "Enter Rules Document Link": "Enter Rules Document Link",
            "06 Core Operations Audit Reporting": "06 Core Operations Audit Reporting",
            "06 CORE OPERATIONS AUDIT REPORTING": "06 CORE OPERATIONS AUDIT REPORTING",
            "Workflow_Instance": "Workflow_Instance",
            "WORKFLOW_INSTANCE": "WORKFLOW_INSTANCE",
            "Workflow Instance": "Workflow Instance",
            "Select Workflow Instance": "Select Workflow Instance",
            "Print of Workflow Instance": "Print of Workflow Instance",
            "Workflow Instance ID": "Workflow Instance ID",
            "Enter Workflow Instance ID": "Enter Workflow Instance ID",
            "Current Step ID": "Current Step ID",
            "Enter Current Step ID": "Enter Current Step ID",
            "Current Step Name": "Current Step Name",
            "Enter Current Step Name": "Enter Current Step Name",
            "Current Assignee User ID": "Current Assignee User ID",
            "Enter Current Assignee User ID": "Enter Current Assignee User ID",
            "Started At": "Started At",
            "Enter Started At": "Enter Started At",
            "Due At": "Due At",
            "Enter Due At": "Enter Due At",
            "Completed At": "Completed At",
            "Enter Completed At": "Enter Completed At",
            "Delay Days": "Delay Days",
            "Enter Delay Days": "Enter Delay Days",
            "Exception Flag": "Exception Flag",
            "Enter Exception Flag": "Enter Exception Flag",
            "Exception Reason": "Exception Reason",
            "Enter Exception Reason": "Enter Exception Reason",
            "Core_Audit_Log": "Core_Audit_Log",
            "CORE_AUDIT_LOG": "CORE_AUDIT_LOG",
            "Core Audit Log": "Core Audit Log",
            "Select Core Audit Log": "Select Core Audit Log",
            "Print of Core Audit Log": "Print of Core Audit Log",
            "Audit Log ID": "Audit Log ID",
            "Enter Audit Log ID": "Enter Audit Log ID",
            "Action Type": "Action Type",
            "Enter Action Type": "Enter Action Type",
            "Entity Type": "Entity Type",
            "Enter Entity Type": "Enter Entity Type",
            "Entity ID": "Entity ID",
            "Enter Entity ID": "Enter Entity ID",
            "Old Value JSON": "Old Value JSON",
            "Enter Old Value JSON": "Enter Old Value JSON",
            "New Value JSON": "New Value JSON",
            "Enter New Value JSON": "Enter New Value JSON",
            "IP Address": "IP Address",
            "IPAddress": "IPAddress",
            "Enter IPAddress": "Enter IPAddress",
            "User Agent": "User Agent",
            "Enter User Agent": "Enter User Agent",
            "Immutable Hash": "Immutable Hash",
            "Enter Immutable Hash": "Enter Immutable Hash",
            "Core_Notification": "Core_Notification",
            "CORE_NOTIFICATION": "CORE_NOTIFICATION",
            "Core Notification": "Core Notification",
            "Select Core Notification": "Select Core Notification",
            "Print of Core Notification": "Print of Core Notification",
            "Notification ID": "Notification ID",
            "Enter Notification ID": "Enter Notification ID",
            "Recipient User ID": "Recipient User ID",
            "Enter Recipient User ID": "Enter Recipient User ID",
            "Related Asset ID": "Related Asset ID",
            "Enter Related Asset ID": "Enter Related Asset ID",
            "Related Offering ID": "Related Offering ID",
            "Enter Related Offering ID": "Enter Related Offering ID",
            "Notification Type": "Notification Type",
            "Enter Notification Type": "Enter Notification Type",
            "Priority": "اولویت",
            "Enter Priority": "اولویت را وارد کنید",
            "Subject": "موضوع",
            "Enter Subject": "Enter Subject",
            "Message Body": "Message Body",
            "Enter Message Body": "Enter Message Body",
            "Delivery Channel": "Delivery Channel",
            "Enter Delivery Channel": "Enter Delivery Channel",
            "Read Status": "Read Status",
            "Enter Read Status": "Enter Read Status",
            "Sent At": "Sent At",
            "Enter Sent At": "Enter Sent At",
            "Core_Escrow_Release_Request": "Core_Escrow_Release_Request",
            "CORE_ESCROW_RELEASE_REQUEST": "CORE_ESCROW_RELEASE_REQUEST",
            "Core Escrow Release Request": "Core Escrow Release Request",
            "Select Core Escrow Release Request": "Select Core Escrow Release Request",
            "Print of Core Escrow Release Request": "Print of Core Escrow Release Request",
            "Escrow Release Request ID": "Escrow Release Request ID",
            "Enter Escrow Release Request ID": "Enter Escrow Release Request ID",
            "Milestone ID": "Milestone ID",
            "Enter Milestone ID": "Enter Milestone ID",
            "Requested Amount USD": "Requested Amount USD",
            "Enter Requested Amount USD": "Enter Requested Amount USD",
            "Requested By": "Requested By",
            "Enter Requested By": "Enter Requested By",
            "Request Reason": "Request Reason",
            "Enter Request Reason": "Enter Request Reason",
            "Supporting Document Link": "Supporting Document Link",
            "Enter Supporting Document Link": "Enter Supporting Document Link",
            "Release Status": "Release Status",
            "Enter Release Status": "Enter Release Status",
            "Submitted By": "Submitted By",
            "Enter Submitted By": "Enter Submitted By",
            "Submitted At": "Submitted At",
            "Enter Submitted At": "Enter Submitted At",
            "Reviewed By": "Reviewed By",
            "Enter Reviewed By": "Enter Reviewed By",
            "Reviewed At": "Reviewed At",
            "Enter Reviewed At": "Enter Reviewed At",
            "Approval Status": "Approval Status",
            "Enter Approval Status": "Enter Approval Status",
            "Core_Tax_Reporting_Package": "Core_Tax_Reporting_Package",
            "CORE_TAX_REPORTING_PACKAGE": "CORE_TAX_REPORTING_PACKAGE",
            "Core Tax Reporting Package": "Core Tax Reporting Package",
            "Select Core Tax Reporting Package": "Select Core Tax Reporting Package",
            "Print of Core Tax Reporting Package": "Print of Core Tax Reporting Package",
            "Tax Package ID": "Tax Package ID",
            "Enter Tax Package ID": "Enter Tax Package ID",
            "Tax Year": "Tax Year",
            "Enter Tax Year": "Enter Tax Year",
            "Form Type": "Form Type",
            "Enter Form Type": "Enter Form Type",
            "Ordinary Income USD": "Ordinary Income USD",
            "Enter Ordinary Income USD": "Enter Ordinary Income USD",
            "Capital Gain USD": "Capital Gain USD",
            "Enter Capital Gain USD": "Enter Capital Gain USD",
            "Depreciation Allocation USD": "Depreciation Allocation USD",
            "Enter Depreciation Allocation USD": "Enter Depreciation Allocation USD",
            "Expense Allocation USD": "Expense Allocation USD",
            "Enter Expense Allocation USD": "Enter Expense Allocation USD",
            "Tax Form Link": "Tax Form Link",
            "Enter Tax Form Link": "Enter Tax Form Link",
            "Delivery Status": "Delivery Status",
            "Enter Delivery Status": "Enter Delivery Status",
            "Core_Platform_Dashboard": "Core_Platform_Dashboard",
            "CORE_PLATFORM_DASHBOARD": "CORE_PLATFORM_DASHBOARD",
            "Core Platform Dashboard": "Core Platform Dashboard",
            "Select Core Platform Dashboard": "Select Core Platform Dashboard",
            "Print of Core Platform Dashboard": "Print of Core Platform Dashboard",
            "Dashboard Record ID": "Dashboard Record ID",
            "Enter Dashboard Record ID": "Enter Dashboard Record ID",
            "Dashboard Date": "Dashboard Date",
            "Enter Dashboard Date": "Enter Dashboard Date",
            "Total Assets Onboarded": "Total Assets Onboarded",
            "Enter Total Assets Onboarded": "Enter Total Assets Onboarded",
            "Total Offerings Launched": "Total Offerings Launched",
            "Enter Total Offerings Launched": "Enter Total Offerings Launched",
            "Total Capital Raised USD": "Total Capital Raised USD",
            "Enter Total Capital Raised USD": "Enter Total Capital Raised USD",
            "Total Investors": "Total Investors",
            "Enter Total Investors": "Enter Total Investors",
            "Average Risk Percentage": "Average Risk Percentage",
            "Enter Average Risk Percentage": "Enter Average Risk Percentage",
            "Open Issues Count": "Open Issues Count",
            "Enter Open Issues Count": "Enter Open Issues Count",
            "01 Asset Owner Sponsor Asset Setup": "01 Asset Owner Sponsor Asset Setup",
            "01 ASSET OWNER SPONSOR ASSET SETUP": "01 ASSET OWNER SPONSOR ASSET SETUP",
            "RENT_Asset_Profile": "RENT_Asset_Profile",
            "RENT_ASSET_PROFILE": "RENT_ASSET_PROFILE",
            "Rental Income Asset Profile": "Rental Income Asset Profile",
            "Select Rental Income Asset Profile": "Select Rental Income Asset Profile",
            "Print of Rental Income Asset Profile": "Print of Rental Income Asset Profile",
            "Rental Income Token Asset Profile ID": "Rental Income Token Asset Profile ID",
            "RENT Asset Profile ID": "RENT Asset Profile ID",
            "Enter RENT Asset Profile ID": "Enter RENT Asset Profile ID",
            "Asset Name": "Asset Name",
            "Enter Asset Name": "Enter Asset Name",
            "Asset Category": "Asset Category",
            "Enter Asset Category": "Enter Asset Category",
            "Asset Subcategory": "Asset Subcategory",
            "Enter Asset Subcategory": "Enter Asset Subcategory",
            "Asset Status": "Asset Status",
            "Enter Asset Status": "Enter Asset Status",
            "Street Address": "Street Address",
            "Enter Street Address": "Enter Street Address",
            "City": "City",
            "Enter City": "Enter City",
            "County": "County",
            "Enter County": "Enter County",
            "State": "State",
            "Enter State": "Enter State",
            "ZIP Code": "ZIP Code",
            "Enter ZIP Code": "Enter ZIP Code",
            "Latitude": "Latitude",
            "Enter Latitude": "Enter Latitude",
            "Longitude": "Longitude",
            "Enter Longitude": "Enter Longitude",
            "Current Owner ID": "Current Owner ID",
            "Enter Current Owner ID": "Enter Current Owner ID",
            "Primary Value Source": "Primary Value Source",
            "Enter Primary Value Source": "Enter Primary Value Source",
            "Asset Use Type": "Asset Use Type",
            "Enter Asset Use Type": "Enter Asset Use Type",
            "Tokenization Readiness Status": "Tokenization Readiness Status",
            "Enter Tokenization Readiness Status": "Enter Tokenization Readiness Status",
            "Map Display Enabled": "Map Display Enabled",
            "Enter Map Display Enabled": "Enter Map Display Enabled",
            "Map Public Visibility": "Map Public Visibility",
            "Enter Map Public Visibility": "Enter Map Public Visibility",
            "Map Listing Status": "Map Listing Status",
            "Enter Map Listing Status": "Enter Map Listing Status",
            "Google Map Place ID": "Google Map Place ID",
            "Enter Google Map Place ID": "Enter Google Map Place ID",
            "Google Maps URL": "Google Maps URL",
            "Enter Google Maps URL": "Enter Google Maps URL",
            "Map Display Address": "Map Display Address",
            "Enter Map Display Address": "Enter Map Display Address",
            "Map Center Latitude": "Map Center Latitude",
            "Enter Map Center Latitude": "Enter Map Center Latitude",
            "Map Center Longitude": "Map Center Longitude",
            "Enter Map Center Longitude": "Enter Map Center Longitude",
            "Map Default Zoom": "Map Default Zoom",
            "Enter Map Default Zoom": "Enter Map Default Zoom",
            "Boundary Type": "Boundary Type",
            "Enter Boundary Type": "Enter Boundary Type",
            "Boundary Source": "Boundary Source",
            "Enter Boundary Source": "Enter Boundary Source",
            "Boundary Verification Status": "Boundary Verification Status",
            "Enter Boundary Verification Status": "Enter Boundary Verification Status",
            "Boundary Geometry Format": "Boundary Geometry Format",
            "Enter Boundary Geometry Format": "Enter Boundary Geometry Format",
            "Boundary GeoJSON": "Boundary GeoJSON",
            "Enter Boundary GeoJSON": "Enter Boundary GeoJSON",
            "Boundary WKT": "Boundary WKT",
            "Enter Boundary WKT": "Enter Boundary WKT",
            "Boundary Bounding Box": "Boundary Bounding Box",
            "Enter Boundary Bounding Box": "Enter Boundary Bounding Box",
            "Parcel ID List": "Parcel ID List",
            "Enter Parcel ID List": "Enter Parcel ID List",
            "Legal Description Link": "Legal Description Link",
            "Enter Legal Description Link": "Enter Legal Description Link",
            "Survey Document Link": "Survey Document Link",
            "Enter Survey Document Link": "Enter Survey Document Link",
            "Boundary Last Verified Date": "Boundary Last Verified Date",
            "Enter Boundary Last Verified Date": "Enter Boundary Last Verified Date",
            "Boundary Verified By": "Boundary Verified By",
            "Enter Boundary Verified By": "Enter Boundary Verified By",
            "Map Disclaimer": "Map Disclaimer",
            "Enter Map Disclaimer": "Enter Map Disclaimer",
            "RENT_Property_Management_Agreement": "RENT_Property_Management_Agreement",
            "RENT_PROPERTY_MANAGEMENT_AGREEMENT": "RENT_PROPERTY_MANAGEMENT_AGREEMENT",
            "Rental Income Property Management Agreement": "Rental Income Property Management Agreement",
            "Select Rental Income Property Management Agreement": "Select Rental Income Property Management Agreement",
            "Print of Rental Income Property Management Agreement": "Print of Rental Income Property Management Agreement",
            "Rental Income Property Management Agreement ID": "Rental Income Property Management Agreement ID",
            "RENT PM Agreement ID": "RENT PM Agreement ID",
            "Enter RENT PM Agreement ID": "Enter RENT PM Agreement ID",
            "Property Manager Stakeholder ID": "Property Manager Stakeholder ID",
            "Enter Property Manager Stakeholder ID": "Enter Property Manager Stakeholder ID",
            "Agreement Start Date": "Agreement Start Date",
            "Enter Agreement Start Date": "Enter Agreement Start Date",
            "Agreement End Date": "Agreement End Date",
            "Enter Agreement End Date": "Enter Agreement End Date",
            "Management Fee Type": "Management Fee Type",
            "Enter Management Fee Type": "Enter Management Fee Type",
            "Management Fee Percentage": "Management Fee Percentage",
            "Enter Management Fee Percentage": "Enter Management Fee Percentage",
            "Flat Management Fee USD": "Flat Management Fee USD",
            "Enter Flat Management Fee USD": "Enter Flat Management Fee USD",
            "Leasing Fee Terms": "Leasing Fee Terms",
            "Enter Leasing Fee Terms": "Enter Leasing Fee Terms",
            "Maintenance Approval Limit USD": "Maintenance Approval Limit USD",
            "Enter Maintenance Approval Limit USD": "Enter Maintenance Approval Limit USD",
            "Rent Collection Responsibility": "Rent Collection Responsibility",
            "Enter Rent Collection Responsibility": "Enter Rent Collection Responsibility",
            "Reporting Frequency": "Reporting Frequency",
            "Enter Reporting Frequency": "Enter Reporting Frequency",
            "Bank Statement Required": "Bank Statement Required",
            "Enter Bank Statement Required": "Enter Bank Statement Required",
            "Investor Report Required": "Investor Report Required",
            "Enter Investor Report Required": "Enter Investor Report Required",
            "Agreement Document Link": "Agreement Document Link",
            "Enter Agreement Document Link": "Enter Agreement Document Link",
            "Agreement Status": "Agreement Status",
            "Enter Agreement Status": "Enter Agreement Status",
            "Approved By": "Approved By",
            "Enter Approved By": "Enter Approved By",
            "Approved At": "Approved At",
            "Enter Approved At": "Enter Approved At",
            "RENT_Unit_Profile": "RENT_Unit_Profile",
            "RENT_UNIT_PROFILE": "RENT_UNIT_PROFILE",
            "Rental Income Unit Profile": "Rental Income Unit Profile",
            "Select Rental Income Unit Profile": "Select Rental Income Unit Profile",
            "Print of Rental Income Unit Profile": "Print of Rental Income Unit Profile",
            "Rental Income Unit Profile ID": "Rental Income Unit Profile ID",
            "RENT Unit Profile ID": "RENT Unit Profile ID",
            "Enter RENT Unit Profile ID": "Enter RENT Unit Profile ID",
            "Unit ID": "Unit ID",
            "Enter Unit ID": "Enter Unit ID",
            "Unit Label": "Unit Label",
            "Enter Unit Label": "Enter Unit Label",
            "Unit Type": "Unit Type",
            "Enter Unit Type": "Enter Unit Type",
            "Bedrooms Count": "Bedrooms Count",
            "Enter Bedrooms Count": "Enter Bedrooms Count",
            "Bathrooms Count": "Bathrooms Count",
            "Enter Bathrooms Count": "Enter Bathrooms Count",
            "Square Feet": "Square Feet",
            "Enter Square Feet": "Enter Square Feet",
            "Market Rent USD": "Market Rent USD",
            "Enter Market Rent USD": "Enter Market Rent USD",
            "Current Lease ID": "Current Lease ID",
            "Enter Current Lease ID": "Enter Current Lease ID",
            "Occupancy Status RENT": "Occupancy Status RENT",
            "Enter Occupancy Status RENT": "Enter Occupancy Status RENT",
            "Rental Unit Condition Rating": "Rental Unit Condition Rating",
            "Unit Condition Rating RENT": "Unit Condition Rating RENT",
            "Enter Unit Condition Rating RENT": "Enter Unit Condition Rating RENT",
            "Last Inspection Date": "Last Inspection Date",
            "Enter Last Inspection Date": "Enter Last Inspection Date",
            "Unit Status": "Unit Status",
            "Enter Unit Status": "Enter Unit Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "RENT_Token_Offering": "RENT_Token_Offering",
            "RENT_TOKEN_OFFERING": "RENT_TOKEN_OFFERING",
            "Rental Income Token Offering": "Rental Income Token Offering",
            "Select Rental Income Token Offering": "Select Rental Income Token Offering",
            "Print of Rental Income Token Offering": "Print of Rental Income Token Offering",
            "Rental Income Token Offering ID": "Rental Income Token Offering ID",
            "RENT Offering ID": "RENT Offering ID",
            "Enter RENT Offering ID": "Enter RENT Offering ID",
            "Offering Name": "Offering Name",
            "Enter Offering Name": "Enter Offering Name",
            "Offering Type": "Offering Type",
            "Enter Offering Type": "Enter Offering Type",
            "SEC Exemption": "SEC Exemption",
            "Enter SEC Exemption": "Enter SEC Exemption",
            "Minimum Investment USD": "Minimum Investment USD",
            "Enter Minimum Investment USD": "Enter Minimum Investment USD",
            "Target Offering Amount USD": "Target Offering Amount USD",
            "Enter Target Offering Amount USD": "Enter Target Offering Amount USD",
            "Maximum Offering Amount USD": "Maximum Offering Amount USD",
            "Enter Maximum Offering Amount USD": "Enter Maximum Offering Amount USD",
            "Token Symbol": "Token Symbol",
            "Enter Token Symbol": "Enter Token Symbol",
            "Total Tokens": "Total Tokens",
            "Enter Total Tokens": "Enter Total Tokens",
            "Token Price USD": "Token Price USD",
            "Enter Token Price USD": "Enter Token Price USD",
            "Offering Start Date": "Offering Start Date",
            "Enter Offering Start Date": "Enter Offering Start Date",
            "Offering End Date": "Offering End Date",
            "Enter Offering End Date": "Enter Offering End Date",
            "Offering Status": "Offering Status",
            "Enter Offering Status": "Enter Offering Status",
            "Sales Map Listing Enabled": "Sales Map Listing Enabled",
            "Enter Sales Map Listing Enabled": "Enter Sales Map Listing Enabled",
            "Sales Map Listing Status": "Sales Map Listing Status",
            "Enter Sales Map Listing Status": "Enter Sales Map Listing Status",
            "Sales Map First Display Trigger": "Sales Map First Display Trigger",
            "Enter Sales Map First Display Trigger": "Enter Sales Map First Display Trigger",
            "Sales Map Public Title": "Sales Map Public Title",
            "Enter Sales Map Public Title": "Enter Sales Map Public Title",
            "Sales Map Public Summary": "Sales Map Public Summary",
            "Enter Sales Map Public Summary": "Enter Sales Map Public Summary",
            "Sales Map Minimum Data Ready": "Sales Map Minimum Data Ready",
            "Enter Sales Map Minimum Data Ready": "Enter Sales Map Minimum Data Ready",
            "Sales Map Security Display Level": "Sales Map Security Display Level",
            "Enter Sales Map Security Display Level": "Enter Sales Map Security Display Level",
            "Sales Map Risk Display Level": "Sales Map Risk Display Level",
            "Enter Sales Map Risk Display Level": "Enter Sales Map Risk Display Level",
            "Sales Map Boundary Display Mode": "Sales Map Boundary Display Mode",
            "Enter Sales Map Boundary Display Mode": "Enter Sales Map Boundary Display Mode",
            "Sales Map Call To Action Status": "Sales Map Call To Action Status",
            "Enter Sales Map Call To Action Status": "Enter Sales Map Call To Action Status",
            "RENT_Token_Class": "RENT_Token_Class",
            "RENT_TOKEN_CLASS": "RENT_TOKEN_CLASS",
            "Rental Income Token Token Class": "Rental Income Token Token Class",
            "Select Rental Income Token Token Class": "Select Rental Income Token Token Class",
            "Print of Rental Income Token Token Class": "Print of Rental Income Token Token Class",
            "Rental Income Token Token Class ID": "Rental Income Token Token Class ID",
            "RENT Token Class ID": "RENT Token Class ID",
            "Enter RENT Token Class ID": "Enter RENT Token Class ID",
            "Token Class Name": "Token Class Name",
            "Enter Token Class Name": "Enter Token Class Name",
            "Seniority Level": "Seniority Level",
            "Enter Seniority Level": "Enter Seniority Level",
            "Preferred Return Percentage": "Preferred Return Percentage",
            "Enter Preferred Return Percentage": "Enter Preferred Return Percentage",
            "Debt Interest Rate": "Debt Interest Rate",
            "Enter Debt Interest Rate": "Enter Debt Interest Rate",
            "Profit Split Percentage": "Profit Split Percentage",
            "Enter Profit Split Percentage": "Enter Profit Split Percentage",
            "Voting Weight": "Voting Weight",
            "Enter Voting Weight": "Enter Voting Weight",
            "Transfer Restricted": "Transfer Restricted",
            "Enter Transfer Restricted": "Enter Transfer Restricted",
            "Class Description": "Class Description",
            "Enter Class Description": "Enter Class Description",
            "RENT_Token_Economics": "RENT_Token_Economics",
            "RENT_TOKEN_ECONOMICS": "RENT_TOKEN_ECONOMICS",
            "Rental Income Token Token Economics": "Rental Income Token Token Economics",
            "Select Rental Income Token Token Economics": "Select Rental Income Token Token Economics",
            "Print of Rental Income Token Token Economics": "Print of Rental Income Token Token Economics",
            "Rental Income Token Token Economics ID": "Rental Income Token Token Economics ID",
            "RENT Token Economics ID": "RENT Token Economics ID",
            "Enter RENT Token Economics ID": "Enter RENT Token Economics ID",
            "Token Class ID": "Token Class ID",
            "Enter Token Class ID": "Enter Token Class ID",
            "Ownership Component Type": "Ownership Component Type",
            "Enter Ownership Component Type": "Enter Ownership Component Type",
            "Ownership Percentage Per Token": "Ownership Percentage Per Token",
            "Enter Ownership Percentage Per Token": "Enter Ownership Percentage Per Token",
            "Total Project Ownership Percentage Represented": "Total Project Ownership Percentage Represented",
            "Enter Total Project Ownership Percentage Represented": "Enter Total Project Ownership Percentage Represented",
            "Building Ownership Percentage Represented": "Building Ownership Percentage Represented",
            "Enter Building Ownership Percentage Represented": "Enter Building Ownership Percentage Represented",
            "Land Ownership Percentage Represented": "Land Ownership Percentage Represented",
            "Enter Land Ownership Percentage Represented": "Enter Land Ownership Percentage Represented",
            "SPV Ownership Percentage Represented": "SPV Ownership Percentage Represented",
            "Enter SPV Ownership Percentage Represented": "Enter SPV Ownership Percentage Represented",
            "Economic Component Type": "Economic Component Type",
            "Enter Economic Component Type": "Enter Economic Component Type",
            "Rental Income Allocation Percentage": "Rental Income Allocation Percentage",
            "Enter Rental Income Allocation Percentage": "Enter Rental Income Allocation Percentage",
            "Sale Profit Allocation Percentage": "Sale Profit Allocation Percentage",
            "Enter Sale Profit Allocation Percentage": "Enter Sale Profit Allocation Percentage",
            "Equity Appreciation Allocation Percentage": "Equity Appreciation Allocation Percentage",
            "Enter Equity Appreciation Allocation Percentage": "Enter Equity Appreciation Allocation Percentage",
            "Revenue Share Allocation Percentage": "Revenue Share Allocation Percentage",
            "Enter Revenue Share Allocation Percentage": "Enter Revenue Share Allocation Percentage",
            "Waterfall Component Type": "Waterfall Component Type",
            "Enter Waterfall Component Type": "Enter Waterfall Component Type",
            "Principal Repayment Priority": "Principal Repayment Priority",
            "Enter Principal Repayment Priority": "Enter Principal Repayment Priority",
            "Waterfall Priority": "Waterfall Priority",
            "Enter Waterfall Priority": "Enter Waterfall Priority",
            "Distribution Frequency": "Distribution Frequency",
            "Enter Distribution Frequency": "Enter Distribution Frequency",
            "Calculation Method": "Calculation Method",
            "Enter Calculation Method": "Enter Calculation Method",
            "NAV Based": "NAV Based",
            "Enter NAV Based": "Enter NAV Based",
            "Investor Disclosure Required": "Investor Disclosure Required",
            "Enter Investor Disclosure Required": "Enter Investor Disclosure Required",
            "Economic Notes": "Economic Notes",
            "Enter Economic Notes": "Enter Economic Notes",
            "RENT_Legal_Rights_Matrix": "RENT_Legal_Rights_Matrix",
            "RENT_LEGAL_RIGHTS_MATRIX": "RENT_LEGAL_RIGHTS_MATRIX",
            "Rental Income Token Legal Rights Matrix": "Rental Income Token Legal Rights Matrix",
            "Select Rental Income Token Legal Rights Matrix": "Select Rental Income Token Legal Rights Matrix",
            "Print of Rental Income Token Legal Rights Matrix": "Print of Rental Income Token Legal Rights Matrix",
            "Rental Income Token Rights Matrix ID": "Rental Income Token Rights Matrix ID",
            "RENT Rights Matrix ID": "RENT Rights Matrix ID",
            "Enter RENT Rights Matrix ID": "Enter RENT Rights Matrix ID",
            "Legal Right Group": "Legal Right Group",
            "Enter Legal Right Group": "Enter Legal Right Group",
            "Ownership Right": "Ownership Right",
            "Enter Ownership Right": "Enter Ownership Right",
            "Rental Income Right": "Rental Income Right",
            "Enter Rental Income Right": "Enter Rental Income Right",
            "Revenue Share Right": "Revenue Share Right",
            "Enter Revenue Share Right": "Enter Revenue Share Right",
            "Sale Profit Right": "Sale Profit Right",
            "Enter Sale Profit Right": "Enter Sale Profit Right",
            "Equity Appreciation Right": "Equity Appreciation Right",
            "Enter Equity Appreciation Right": "Enter Equity Appreciation Right",
            "Debt Interest Right": "Debt Interest Right",
            "Enter Debt Interest Right": "Enter Debt Interest Right",
            "Preferred Return Right": "Preferred Return Right",
            "Enter Preferred Return Right": "Enter Preferred Return Right",
            "Voting Right": "Voting Right",
            "Enter Voting Right": "Enter Voting Right",
            "Information Right": "Information Right",
            "Enter Information Right": "Enter Information Right",
            "Redemption Right": "Redemption Right",
            "Enter Redemption Right": "Enter Redemption Right",
            "Transfer Right": "Transfer Right",
            "Enter Transfer Right": "Enter Transfer Right",
            "Liquidation Priority": "Liquidation Priority",
            "Enter Liquidation Priority": "Enter Liquidation Priority",
            "Restrictions Text": "Restrictions Text",
            "Enter Restrictions Text": "Enter Restrictions Text",
            "RENT_Risk_Score": "RENT_Risk_Score",
            "RENT_RISK_SCORE": "RENT_RISK_SCORE",
            "Rental Income Token Risk Score": "Rental Income Token Risk Score",
            "Select Rental Income Token Risk Score": "Select Rental Income Token Risk Score",
            "Print of Rental Income Token Risk Score": "Print of Rental Income Token Risk Score",
            "Rental Income Token Risk Score ID": "Rental Income Token Risk Score ID",
            "RENT Risk Score ID": "RENT Risk Score ID",
            "Enter RENT Risk Score ID": "Enter RENT Risk Score ID",
            "Overall Risk Percentage": "Overall Risk Percentage",
            "Enter Overall Risk Percentage": "Enter Overall Risk Percentage",
            "Risk Factor Type": "Risk Factor Type",
            "Enter Risk Factor Type": "Enter Risk Factor Type",
            "Legal Risk Percentage": "Legal Risk Percentage",
            "Enter Legal Risk Percentage": "Enter Legal Risk Percentage",
            "Title Risk Percentage": "Title Risk Percentage",
            "Enter Title Risk Percentage": "Enter Title Risk Percentage",
            "Market Risk Percentage": "Market Risk Percentage",
            "Enter Market Risk Percentage": "Enter Market Risk Percentage",
            "Liquidity Risk Percentage": "Liquidity Risk Percentage",
            "Enter Liquidity Risk Percentage": "Enter Liquidity Risk Percentage",
            "Income Risk Percentage": "Income Risk Percentage",
            "Enter Income Risk Percentage": "Enter Income Risk Percentage",
            "Construction Risk Percentage": "Construction Risk Percentage",
            "Enter Construction Risk Percentage": "Enter Construction Risk Percentage",
            "Developer Risk Percentage": "Developer Risk Percentage",
            "Enter Developer Risk Percentage": "Enter Developer Risk Percentage",
            "Auction Risk Percentage": "Auction Risk Percentage",
            "Enter Auction Risk Percentage": "Enter Auction Risk Percentage",
            "Risk Explanation": "Risk Explanation",
            "Enter Risk Explanation": "Enter Risk Explanation",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "RENT_Subscription_Order": "RENT_Subscription_Order",
            "RENT_SUBSCRIPTION_ORDER": "RENT_SUBSCRIPTION_ORDER",
            "Rental Income Token Subscription Order": "Rental Income Token Subscription Order",
            "Select Rental Income Token Subscription Order": "Select Rental Income Token Subscription Order",
            "Print of Rental Income Token Subscription Order": "Print of Rental Income Token Subscription Order",
            "Rental Income Token Subscription ID": "Rental Income Token Subscription ID",
            "RENT Subscription ID": "RENT Subscription ID",
            "Enter RENT Subscription ID": "Enter RENT Subscription ID",
            "Approved Amount USD": "Approved Amount USD",
            "Enter Approved Amount USD": "Enter Approved Amount USD",
            "Token Quantity": "Token Quantity",
            "Enter Token Quantity": "Enter Token Quantity",
            "Payment Method": "روش پرداخت",
            "Enter Payment Method": "Enter Payment Method",
            "Payment Status": "Payment Status",
            "Enter Payment Status": "Enter Payment Status",
            "Escrow Deposit ID": "Escrow Deposit ID",
            "Enter Escrow Deposit ID": "Enter Escrow Deposit ID",
            "Subscription Status": "Subscription Status",
            "Enter Subscription Status": "Enter Subscription Status",
            "Risk Acknowledgment Completed": "Risk Acknowledgment Completed",
            "Enter Risk Acknowledgment Completed": "Enter Risk Acknowledgment Completed",
            "RENT_Token_Ledger": "RENT_Token_Ledger",
            "RENT_TOKEN_LEDGER": "RENT_TOKEN_LEDGER",
            "Rental Income Token Token Ledger": "Rental Income Token Token Ledger",
            "Select Rental Income Token Token Ledger": "Select Rental Income Token Token Ledger",
            "Print of Rental Income Token Token Ledger": "Print of Rental Income Token Token Ledger",
            "Rental Income Token Ledger ID": "Rental Income Token Ledger ID",
            "RENT Ledger ID": "RENT Ledger ID",
            "Enter RENT Ledger ID": "Enter RENT Ledger ID",
            "Token Balance": "Token Balance",
            "Enter Token Balance": "Enter Token Balance",
            "Restricted Token Balance": "Restricted Token Balance",
            "Enter Restricted Token Balance": "Enter Restricted Token Balance",
            "Available Token Balance": "Available Token Balance",
            "Enter Available Token Balance": "Enter Available Token Balance",
            "Ownership Percentage Total": "Ownership Percentage Total",
            "Enter Ownership Percentage Total": "Enter Ownership Percentage Total",
            "Income Allocation Percentage Total": "Income Allocation Percentage Total",
            "Enter Income Allocation Percentage Total": "Enter Income Allocation Percentage Total",
            "Transfer Agent Record ID": "Transfer Agent Record ID",
            "Enter Transfer Agent Record ID": "Enter Transfer Agent Record ID",
            "Last Updated At": "Last Updated At",
            "Enter Last Updated At": "Enter Last Updated At",
            "04 Property Manager Rental Operations": "04 Property Manager Rental Operations",
            "04 PROPERTY MANAGER RENTAL OPERATIONS": "04 PROPERTY MANAGER RENTAL OPERATIONS",
            "RENT_Independent_Inspection_Report": "RENT_Independent_Inspection_Report",
            "RENT_INDEPENDENT_INSPECTION_REPORT": "RENT_INDEPENDENT_INSPECTION_REPORT",
            "Rental Income Token Independent Inspection Report": "Rental Income Token Independent Inspection Report",
            "Select Rental Income Token Independent Inspection Report": "Select Rental Income Token Independent Inspection Report",
            "Print of Rental Income Token Independent Inspection Report": "Print of Rental Income Token Independent Inspection Report",
            "Rental Income Token Inspection Report ID": "Rental Income Token Inspection Report ID",
            "RENT Inspection Report ID": "RENT Inspection Report ID",
            "Enter RENT Inspection Report ID": "Enter RENT Inspection Report ID",
            "Inspector ID": "Inspector ID",
            "Enter Inspector ID": "Enter Inspector ID",
            "Inspection Date": "Inspection Date",
            "Enter Inspection Date": "Enter Inspection Date",
            "Observed Completion Percentage": "Observed Completion Percentage",
            "Enter Observed Completion Percentage": "Enter Observed Completion Percentage",
            "Quality Rating": "Quality Rating",
            "Enter Quality Rating": "Enter Quality Rating",
            "Deficiencies Found": "Deficiencies Found",
            "Enter Deficiencies Found": "Enter Deficiencies Found",
            "Safety Issues Found": "Safety Issues Found",
            "Enter Safety Issues Found": "Enter Safety Issues Found",
            "Photo Report Link": "Photo Report Link",
            "Enter Photo Report Link": "Enter Photo Report Link",
            "Inspector Recommendation": "Inspector Recommendation",
            "Enter Inspector Recommendation": "Enter Inspector Recommendation",
            "Report Notes": "Report Notes",
            "Enter Report Notes": "Enter Report Notes",
            "RENT_Lease_Record": "RENT_Lease_Record",
            "RENT_LEASE_RECORD": "RENT_LEASE_RECORD",
            "Rental Income Lease Record": "Rental Income Lease Record",
            "Select Rental Income Lease Record": "Select Rental Income Lease Record",
            "Print of Rental Income Lease Record": "Print of Rental Income Lease Record",
            "Rental Income Lease ID": "Rental Income Lease ID",
            "RENT Lease ID": "RENT Lease ID",
            "Enter RENT Lease ID": "Enter RENT Lease ID",
            "Tenant Name Masked": "Tenant Name Masked",
            "Enter Tenant Name Masked": "Enter Tenant Name Masked",
            "Tenant Profile ID": "Tenant Profile ID",
            "Enter Tenant Profile ID": "Enter Tenant Profile ID",
            "Unit Profile ID": "Unit Profile ID",
            "Enter Unit Profile ID": "Enter Unit Profile ID",
            "Lease Start Date": "Lease Start Date",
            "Enter Lease Start Date": "Enter Lease Start Date",
            "Lease End Date": "Lease End Date",
            "Enter Lease End Date": "Enter Lease End Date",
            "Monthly Rent USD": "Monthly Rent USD",
            "Enter Monthly Rent USD": "Enter Monthly Rent USD",
            "Security Deposit USD": "Security Deposit USD",
            "Enter Security Deposit USD": "Enter Security Deposit USD",
            "Rent Escalation Type": "Rent Escalation Type",
            "Enter Rent Escalation Type": "Enter Rent Escalation Type",
            "Rent Escalation Percentage": "Rent Escalation Percentage",
            "Enter Rent Escalation Percentage": "Enter Rent Escalation Percentage",
            "Lease Status": "Lease Status",
            "Enter Lease Status": "Enter Lease Status",
            "Lease Renewal Option": "Lease Renewal Option",
            "Enter Lease Renewal Option": "Enter Lease Renewal Option",
            "Lease Document Link": "Lease Document Link",
            "Enter Lease Document Link": "Enter Lease Document Link",
            "Lease Verification Status": "Lease Verification Status",
            "Enter Lease Verification Status": "Enter Lease Verification Status",
            "RENT_Rent_Collection_Record": "RENT_Rent_Collection_Record",
            "RENT_RENT_COLLECTION_RECORD": "RENT_RENT_COLLECTION_RECORD",
            "Rental Income Rent Collection Record": "Rental Income Rent Collection Record",
            "Select Rental Income Rent Collection Record": "Select Rental Income Rent Collection Record",
            "Print of Rental Income Rent Collection Record": "Print of Rental Income Rent Collection Record",
            "Rental Income Rent Collection ID": "Rental Income Rent Collection ID",
            "RENT Rent Collection ID": "RENT Rent Collection ID",
            "Enter RENT Rent Collection ID": "Enter RENT Rent Collection ID",
            "Lease ID": "Lease ID",
            "Enter Lease ID": "Enter Lease ID",
            "Rent Period": "Rent Period",
            "Enter Rent Period": "Enter Rent Period",
            "Rent Due USD": "Rent Due USD",
            "Enter Rent Due USD": "Enter Rent Due USD",
            "Rent Collected USD": "Rent Collected USD",
            "Enter Rent Collected USD": "Enter Rent Collected USD",
            "Late Fee USD": "Late Fee USD",
            "Enter Late Fee USD": "Enter Late Fee USD",
            "Collection Date": "Collection Date",
            "Enter Collection Date": "Enter Collection Date",
            "Collection Status": "Collection Status",
            "Enter Collection Status": "Enter Collection Status",
            "Payment Method RENT": "Payment Method RENT",
            "Enter Payment Method RENT": "Enter Payment Method RENT",
            "ACH Trace Reference": "ACH Trace Reference",
            "Enter ACH Trace Reference": "Enter ACH Trace Reference",
            "Bank Deposit Date": "Bank Deposit Date",
            "Enter Bank Deposit Date": "Enter Bank Deposit Date",
            "Property Manager Attestation": "Property Manager Attestation",
            "Enter Property Manager Attestation": "Enter Property Manager Attestation",
            "Rent Collection Document Link": "Rent Collection Document Link",
            "Enter Rent Collection Document Link": "Enter Rent Collection Document Link",
            "RENT_Property_Manager_Report": "RENT_Property_Manager_Report",
            "RENT_PROPERTY_MANAGER_REPORT": "RENT_PROPERTY_MANAGER_REPORT",
            "Rental Income Property Manager Report": "Rental Income Property Manager Report",
            "Select Rental Income Property Manager Report": "Select Rental Income Property Manager Report",
            "Print of Rental Income Property Manager Report": "Print of Rental Income Property Manager Report",
            "Rental Income PM Report ID": "Rental Income PM Report ID",
            "RENT PM Report ID": "RENT PM Report ID",
            "Enter RENT PM Report ID": "Enter RENT PM Report ID",
            "Report Month": "Report Month",
            "Enter Report Month": "Enter Report Month",
            "Opening Occupancy Rate": "Opening Occupancy Rate",
            "Enter Opening Occupancy Rate": "Enter Opening Occupancy Rate",
            "Ending Occupancy Rate": "Ending Occupancy Rate",
            "Enter Ending Occupancy Rate": "Enter Ending Occupancy Rate",
            "Gross Rent Collected USD": "Gross Rent Collected USD",
            "Enter Gross Rent Collected USD": "Enter Gross Rent Collected USD",
            "Operating Expenses USD": "Operating Expenses USD",
            "Enter Operating Expenses USD": "Enter Operating Expenses USD",
            "NOI USD": "NOI USD",
            "Enter NOI USD": "Enter NOI USD",
            "Beginning Cash Balance USD": "Beginning Cash Balance USD",
            "Enter Beginning Cash Balance USD": "Enter Beginning Cash Balance USD",
            "Ending Cash Balance USD": "Ending Cash Balance USD",
            "Enter Ending Cash Balance USD": "Enter Ending Cash Balance USD",
            "Reserve Balance USD": "Reserve Balance USD",
            "Enter Reserve Balance USD": "Enter Reserve Balance USD",
            "Maintenance Summary": "Maintenance Summary",
            "Enter Maintenance Summary": "Enter Maintenance Summary",
            "Tenant Issues": "Tenant Issues",
            "Enter Tenant Issues": "Enter Tenant Issues",
            "Bank Statement Link": "Bank Statement Link",
            "Enter Bank Statement Link": "Enter Bank Statement Link",
            "RENT_Tenant_Profile": "RENT_Tenant_Profile",
            "RENT_TENANT_PROFILE": "RENT_TENANT_PROFILE",
            "Rental Income Tenant Profile": "Rental Income Tenant Profile",
            "Select Rental Income Tenant Profile": "Select Rental Income Tenant Profile",
            "Print of Rental Income Tenant Profile": "Print of Rental Income Tenant Profile",
            "Rental Income Tenant Profile ID": "Rental Income Tenant Profile ID",
            "RENT Tenant Profile ID": "RENT Tenant Profile ID",
            "Enter RENT Tenant Profile ID": "Enter RENT Tenant Profile ID",
            "Rental Tenant Type": "Rental Tenant Type",
            "Tenant Type RENT": "Tenant Type RENT",
            "Enter Tenant Type RENT": "Enter Tenant Type RENT",
            "Tenant Screening Status": "Tenant Screening Status",
            "Enter Tenant Screening Status": "Enter Tenant Screening Status",
            "Credit Check Status": "Credit Check Status",
            "Enter Credit Check Status": "Enter Credit Check Status",
            "Income Verification Status": "Income Verification Status",
            "Enter Income Verification Status": "Enter Income Verification Status",
            "Move In Date": "Move In Date",
            "Enter Move In Date": "Enter Move In Date",
            "Move Out Date": "Move Out Date",
            "Enter Move Out Date": "Enter Move Out Date",
            "Tenant Risk Rating": "Tenant Risk Rating",
            "Enter Tenant Risk Rating": "Enter Tenant Risk Rating",
            "PII Stored Outside Platform": "PII Stored Outside Platform",
            "Enter PII Stored Outside Platform": "Enter PII Stored Outside Platform",
            "Tenant Document Link": "Tenant Document Link",
            "Enter Tenant Document Link": "Enter Tenant Document Link",
            "Tenant Status": "Tenant Status",
            "Enter Tenant Status": "Enter Tenant Status",
            "RENT_Rent_Roll_Snapshot": "RENT_Rent_Roll_Snapshot",
            "RENT_RENT_ROLL_SNAPSHOT": "RENT_RENT_ROLL_SNAPSHOT",
            "Rental Income Rent Roll Snapshot": "Rental Income Rent Roll Snapshot",
            "Select Rental Income Rent Roll Snapshot": "Select Rental Income Rent Roll Snapshot",
            "Print of Rental Income Rent Roll Snapshot": "Print of Rental Income Rent Roll Snapshot",
            "Rental Income Rent Roll ID": "Rental Income Rent Roll ID",
            "RENT Rent Roll ID": "RENT Rent Roll ID",
            "Enter RENT Rent Roll ID": "Enter RENT Rent Roll ID",
            "Rent Roll Source": "Rent Roll Source",
            "Enter Rent Roll Source": "Enter Rent Roll Source",
            "Contract Rent USD": "Contract Rent USD",
            "Enter Contract Rent USD": "Enter Contract Rent USD",
            "Security Deposit Held USD": "Security Deposit Held USD",
            "Enter Security Deposit Held USD": "Enter Security Deposit Held USD",
            "Delinquent Amount USD": "Delinquent Amount USD",
            "Enter Delinquent Amount USD": "Enter Delinquent Amount USD",
            "Vacancy Flag": "Vacancy Flag",
            "Enter Vacancy Flag": "Enter Vacancy Flag",
            "Snapshot Total Units": "Snapshot Total Units",
            "Enter Snapshot Total Units": "Enter Snapshot Total Units",
            "Snapshot Occupied Units": "Snapshot Occupied Units",
            "Enter Snapshot Occupied Units": "Enter Snapshot Occupied Units",
            "Snapshot Gross Scheduled Rent USD": "Snapshot Gross Scheduled Rent USD",
            "Enter Snapshot Gross Scheduled Rent USD": "Enter Snapshot Gross Scheduled Rent USD",
            "Snapshot Status": "Snapshot Status",
            "Enter Snapshot Status": "Enter Snapshot Status",
            "RENT_Operating_Expense_Record": "RENT_Operating_Expense_Record",
            "RENT_OPERATING_EXPENSE_RECORD": "RENT_OPERATING_EXPENSE_RECORD",
            "Rental Income Operating Expense Record": "Rental Income Operating Expense Record",
            "Select Rental Income Operating Expense Record": "Select Rental Income Operating Expense Record",
            "Print of Rental Income Operating Expense Record": "Print of Rental Income Operating Expense Record",
            "Rental Income Expense ID": "Rental Income Expense ID",
            "RENT Expense ID": "RENT Expense ID",
            "Enter RENT Expense ID": "Enter RENT Expense ID",
            "Expense Date": "Expense Date",
            "Enter Expense Date": "Enter Expense Date",
            "Rental Expense Category": "Rental Expense Category",
            "Expense Category RENT": "Expense Category RENT",
            "Enter Expense Category RENT": "Enter Expense Category RENT",
            "Expense Description": "Expense Description",
            "Enter Expense Description": "Enter Expense Description",
            "Vendor Stakeholder ID": "Vendor Stakeholder ID",
            "Enter Vendor Stakeholder ID": "Enter Vendor Stakeholder ID",
            "Invoice Number": "Invoice Number",
            "Enter Invoice Number": "Enter Invoice Number",
            "Invoice Amount USD": "Invoice Amount USD",
            "Enter Invoice Amount USD": "Enter Invoice Amount USD",
            "Paid Amount USD": "Paid Amount USD",
            "Enter Paid Amount USD": "Enter Paid Amount USD",
            "Payment Date": "Payment Date",
            "Enter Payment Date": "Enter Payment Date",
            "Capital Expense Flag": "Capital Expense Flag",
            "Enter Capital Expense Flag": "Enter Capital Expense Flag",
            "Reserve Funded Flag": "Reserve Funded Flag",
            "Enter Reserve Funded Flag": "Enter Reserve Funded Flag",
            "Expense Document Link": "Expense Document Link",
            "Enter Expense Document Link": "Enter Expense Document Link",
            "Expense Approval Status": "Expense Approval Status",
            "Enter Expense Approval Status": "Enter Expense Approval Status",
            "RENT_Reserve_Account_Record": "RENT_Reserve_Account_Record",
            "RENT_RESERVE_ACCOUNT_RECORD": "RENT_RESERVE_ACCOUNT_RECORD",
            "Rental Income Reserve Account Record": "Rental Income Reserve Account Record",
            "Select Rental Income Reserve Account Record": "Select Rental Income Reserve Account Record",
            "Print of Rental Income Reserve Account Record": "Print of Rental Income Reserve Account Record",
            "Rental Income Reserve Record ID": "Rental Income Reserve Record ID",
            "RENT Reserve Record ID": "RENT Reserve Record ID",
            "Enter RENT Reserve Record ID": "Enter RENT Reserve Record ID",
            "Reserve Period": "Reserve Period",
            "Enter Reserve Period": "Enter Reserve Period",
            "Rental Reserve Type": "Rental Reserve Type",
            "Reserve Type RENT": "Reserve Type RENT",
            "Enter Reserve Type RENT": "Enter Reserve Type RENT",
            "Opening Reserve Balance USD": "Opening Reserve Balance USD",
            "Enter Opening Reserve Balance USD": "Enter Opening Reserve Balance USD",
            "Reserve Contribution USD": "Reserve Contribution USD",
            "Enter Reserve Contribution USD": "Enter Reserve Contribution USD",
            "Reserve Draw USD": "Reserve Draw USD",
            "Enter Reserve Draw USD": "Enter Reserve Draw USD",
            "Closing Reserve Balance USD": "Closing Reserve Balance USD",
            "Enter Closing Reserve Balance USD": "Enter Closing Reserve Balance USD",
            "Minimum Required Reserve USD": "Minimum Required Reserve USD",
            "Enter Minimum Required Reserve USD": "Enter Minimum Required Reserve USD",
            "Reserve Compliance Status": "Reserve Compliance Status",
            "Enter Reserve Compliance Status": "Enter Reserve Compliance Status",
            "Reserve Document Link": "Reserve Document Link",
            "Enter Reserve Document Link": "Enter Reserve Document Link",
            "RENT_Delinquency_Vacancy_Record": "RENT_Delinquency_Vacancy_Record",
            "RENT_DELINQUENCY_VACANCY_RECORD": "RENT_DELINQUENCY_VACANCY_RECORD",
            "Rental Income Delinquency and Vacancy Record": "Rental Income Delinquency and Vacancy Record",
            "Select Rental Income Delinquency and Vacancy Record": "Select Rental Income Delinquency and Vacancy Record",
            "Print of Rental Income Delinquency and Vacancy Record": "Print of Rental Income Delinquency and Vacancy Record",
            "Rental Income Delinquency Vacancy ID": "Rental Income Delinquency Vacancy ID",
            "RENT Delinquency Vacancy ID": "RENT Delinquency Vacancy ID",
            "Enter RENT Delinquency Vacancy ID": "Enter RENT Delinquency Vacancy ID",
            "Rental Issue Type": "Rental Issue Type",
            "Issue Type RENT": "Issue Type RENT",
            "Enter Issue Type RENT": "Enter Issue Type RENT",
            "Days Delinquent": "Days Delinquent",
            "Enter Days Delinquent": "Enter Days Delinquent",
            "Vacancy Start Date": "Vacancy Start Date",
            "Enter Vacancy Start Date": "Enter Vacancy Start Date",
            "Vacancy End Date": "Vacancy End Date",
            "Enter Vacancy End Date": "Enter Vacancy End Date",
            "Lost Rent USD": "Lost Rent USD",
            "Enter Lost Rent USD": "Enter Lost Rent USD",
            "Mitigation Action": "Mitigation Action",
            "Enter Mitigation Action": "Enter Mitigation Action",
            "Legal Action Required": "Legal Action Required",
            "Enter Legal Action Required": "Enter Legal Action Required",
            "Collection Action Status": "Collection Action Status",
            "Enter Collection Action Status": "Enter Collection Action Status",
            "Resolution Status": "Resolution Status",
            "Enter Resolution Status": "Enter Resolution Status",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "RENT_Escrow_Release_Package": "RENT_Escrow_Release_Package",
            "RENT_ESCROW_RELEASE_PACKAGE": "RENT_ESCROW_RELEASE_PACKAGE",
            "Rental Income Token Escrow Release Package": "Rental Income Token Escrow Release Package",
            "Select Rental Income Token Escrow Release Package": "Select Rental Income Token Escrow Release Package",
            "Print of Rental Income Token Escrow Release Package": "Print of Rental Income Token Escrow Release Package",
            "Rental Income Token Escrow Release Package ID": "Rental Income Token Escrow Release Package ID",
            "RENT Escrow Release Package ID": "RENT Escrow Release Package ID",
            "Enter RENT Escrow Release Package ID": "Enter RENT Escrow Release Package ID",
            "Inspection Report ID": "Inspection Report ID",
            "Enter Inspection Report ID": "Enter Inspection Report ID",
            "Requested Release Amount USD": "Requested Release Amount USD",
            "Enter Requested Release Amount USD": "Enter Requested Release Amount USD",
            "Approved Release Amount USD": "Approved Release Amount USD",
            "Enter Approved Release Amount USD": "Enter Approved Release Amount USD",
            "Lien Waivers Complete": "Lien Waivers Complete",
            "Enter Lien Waivers Complete": "Enter Lien Waivers Complete",
            "Budget Variance Acceptable": "Budget Variance Acceptable",
            "Enter Budget Variance Acceptable": "Enter Budget Variance Acceptable",
            "Investor Notice Link": "Investor Notice Link",
            "Enter Investor Notice Link": "Enter Investor Notice Link",
            "Release Recommendation": "Release Recommendation",
            "Enter Release Recommendation": "Enter Release Recommendation",
            "RENT_Investor_Report": "RENT_Investor_Report",
            "RENT_INVESTOR_REPORT": "RENT_INVESTOR_REPORT",
            "Rental Income Token Investor Report": "Rental Income Token Investor Report",
            "Select Rental Income Token Investor Report": "Select Rental Income Token Investor Report",
            "Print of Rental Income Token Investor Report": "Print of Rental Income Token Investor Report",
            "Rental Income Token Investor Report ID": "Rental Income Token Investor Report ID",
            "RENT Investor Report ID": "RENT Investor Report ID",
            "Enter RENT Investor Report ID": "Enter RENT Investor Report ID",
            "Report Period": "Report Period",
            "Enter Report Period": "Enter Report Period",
            "Report Line Type": "Report Line Type",
            "Enter Report Line Type": "Enter Report Line Type",
            "Gross Distribution USD": "Gross Distribution USD",
            "Enter Gross Distribution USD": "Enter Gross Distribution USD",
            "Fees USD": "Fees USD",
            "Enter Fees USD": "Enter Fees USD",
            "Net Distribution USD": "Net Distribution USD",
            "Enter Net Distribution USD": "Enter Net Distribution USD",
            "Estimated Current Value USD": "Estimated Current Value USD",
            "Enter Estimated Current Value USD": "Enter Estimated Current Value USD",
            "Current Risk Percentage": "Current Risk Percentage",
            "Enter Current Risk Percentage": "Enter Current Risk Percentage",
            "Key Update": "Key Update",
            "Enter Key Update": "Enter Key Update",
            "Delivered At": "Delivered At",
            "Enter Delivered At": "Enter Delivered At",
            "RENT_Distribution_Calculation": "RENT_Distribution_Calculation",
            "RENT_DISTRIBUTION_CALCULATION": "RENT_DISTRIBUTION_CALCULATION",
            "Rental Income Token Distribution Calculation": "Rental Income Token Distribution Calculation",
            "Select Rental Income Token Distribution Calculation": "Select Rental Income Token Distribution Calculation",
            "Print of Rental Income Token Distribution Calculation": "Print of Rental Income Token Distribution Calculation",
            "Rental Income Token Distribution ID": "Rental Income Token Distribution ID",
            "RENT Distribution ID": "RENT Distribution ID",
            "Enter RENT Distribution ID": "Enter RENT Distribution ID",
            "Distribution Period Start": "Distribution Period Start",
            "Enter Distribution Period Start": "Enter Distribution Period Start",
            "Distribution Period End": "Distribution Period End",
            "Enter Distribution Period End": "Enter Distribution Period End",
            "PM Report ID": "PM Report ID",
            "Enter PM Report ID": "Enter PM Report ID",
            "Rent Roll ID": "Rent Roll ID",
            "Enter Rent Roll ID": "Enter Rent Roll ID",
            "Reserve Record ID": "Reserve Record ID",
            "Enter Reserve Record ID": "Enter Reserve Record ID",
            "Distribution Component Type": "Distribution Component Type",
            "Enter Distribution Component Type": "Enter Distribution Component Type",
            "Gross Source Amount USD": "Gross Source Amount USD",
            "Enter Gross Source Amount USD": "Enter Gross Source Amount USD",
            "Debt Service USD": "Debt Service USD",
            "Enter Debt Service USD": "Enter Debt Service USD",
            "Preferred Return USD": "Preferred Return USD",
            "Enter Preferred Return USD": "Enter Preferred Return USD",
            "Net Distributable Income USD": "Net Distributable Income USD",
            "Enter Net Distributable Income USD": "Enter Net Distributable Income USD",
            "Distribution Per Token USD": "Distribution Per Token USD",
            "Enter Distribution Per Token USD": "Enter Distribution Per Token USD",
            "Distribution Approval ID": "Distribution Approval ID",
            "Enter Distribution Approval ID": "Enter Distribution Approval ID",
            "Calculation Report Link": "Calculation Report Link",
            "Enter Calculation Report Link": "Enter Calculation Report Link",
            "RENT_Distribution_Approval": "RENT_Distribution_Approval",
            "RENT_DISTRIBUTION_APPROVAL": "RENT_DISTRIBUTION_APPROVAL",
            "Rental Income Distribution Approval": "Rental Income Distribution Approval",
            "Select Rental Income Distribution Approval": "Select Rental Income Distribution Approval",
            "Print of Rental Income Distribution Approval": "Print of Rental Income Distribution Approval",
            "Rental Income Distribution Approval ID": "Rental Income Distribution Approval ID",
            "RENT Distribution Approval ID": "RENT Distribution Approval ID",
            "Enter RENT Distribution Approval ID": "Enter RENT Distribution Approval ID",
            "Distribution ID": "Distribution ID",
            "Enter Distribution ID": "Enter Distribution ID",
            "Property Manager Report ID": "Property Manager Report ID",
            "Calculated Distribution USD": "Calculated Distribution USD",
            "Enter Calculated Distribution USD": "Enter Calculated Distribution USD",
            "Approved Distribution USD": "Approved Distribution USD",
            "Enter Approved Distribution USD": "Enter Approved Distribution USD",
            "Withheld Reserve USD": "Withheld Reserve USD",
            "Enter Withheld Reserve USD": "Enter Withheld Reserve USD",
            "Rental Distribution Approval Decision": "Rental Distribution Approval Decision",
            "Approval Decision RENT": "Approval Decision RENT",
            "Enter Approval Decision RENT": "Enter Approval Decision RENT",
            "Compliance Reviewer ID": "Compliance Reviewer ID",
            "Enter Compliance Reviewer ID": "Enter Compliance Reviewer ID",
            "Financial Reviewer ID": "Financial Reviewer ID",
            "Enter Financial Reviewer ID": "Enter Financial Reviewer ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "RENT_Lifecycle_Milestone": "RENT_Lifecycle_Milestone",
            "RENT_LIFECYCLE_MILESTONE": "RENT_LIFECYCLE_MILESTONE",
            "Rental Income Token Lifecycle Milestone": "Rental Income Token Lifecycle Milestone",
            "Select Rental Income Token Lifecycle Milestone": "Select Rental Income Token Lifecycle Milestone",
            "Print of Rental Income Token Lifecycle Milestone": "Print of Rental Income Token Lifecycle Milestone",
            "Rental Income Token Milestone ID": "Rental Income Token Milestone ID",
            "RENT Milestone ID": "RENT Milestone ID",
            "Enter RENT Milestone ID": "Enter RENT Milestone ID",
            "Milestone Name": "Milestone Name",
            "Enter Milestone Name": "Enter Milestone Name",
            "Milestone Type": "Milestone Type",
            "Enter Milestone Type": "Enter Milestone Type",
            "Milestone Order": "Milestone Order",
            "Enter Milestone Order": "Enter Milestone Order",
            "Planned Start Date": "Planned Start Date",
            "Enter Planned Start Date": "Enter Planned Start Date",
            "Planned End Date": "Planned End Date",
            "Enter Planned End Date": "Enter Planned End Date",
            "Actual Start Date": "Actual Start Date",
            "Enter Actual Start Date": "Enter Actual Start Date",
            "Actual End Date": "Actual End Date",
            "Enter Actual End Date": "Enter Actual End Date",
            "Required Completion Percentage": "Required Completion Percentage",
            "Enter Required Completion Percentage": "Enter Required Completion Percentage",
            "Current Completion Percentage": "Current Completion Percentage",
            "Enter Current Completion Percentage": "Enter Current Completion Percentage",
            "Milestone Status": "Milestone Status",
            "Enter Milestone Status": "Enter Milestone Status",
            "RENT_Exit_Strategy": "RENT_Exit_Strategy",
            "RENT_EXIT_STRATEGY": "RENT_EXIT_STRATEGY",
            "Rental Income Token Exit Strategy": "Rental Income Token Exit Strategy",
            "Select Rental Income Token Exit Strategy": "Select Rental Income Token Exit Strategy",
            "Print of Rental Income Token Exit Strategy": "Print of Rental Income Token Exit Strategy",
            "Rental Income Token Exit Strategy ID": "Rental Income Token Exit Strategy ID",
            "RENT Exit Strategy ID": "RENT Exit Strategy ID",
            "Enter RENT Exit Strategy ID": "Enter RENT Exit Strategy ID",
            "Primary Exit Strategy": "Primary Exit Strategy",
            "Enter Primary Exit Strategy": "Enter Primary Exit Strategy",
            "Expected Hold Period Months": "Expected Hold Period Months",
            "Enter Expected Hold Period Months": "Enter Expected Hold Period Months",
            "Target Sale Price USD": "Target Sale Price USD",
            "Enter Target Sale Price USD": "Enter Target Sale Price USD",
            "Target IRR": "Target IRR",
            "Enter Target IRR": "Enter Target IRR",
            "Refinance Allowed": "Refinance Allowed",
            "Enter Refinance Allowed": "Enter Refinance Allowed",
            "Buyback Option Allowed": "Buyback Option Allowed",
            "Enter Buyback Option Allowed": "Enter Buyback Option Allowed",
            "Token Holder Vote Required": "Token Holder Vote Required",
            "Enter Token Holder Vote Required": "Enter Token Holder Vote Required",
            "Exit Waterfall Text": "Exit Waterfall Text",
            "Enter Exit Waterfall Text": "Enter Exit Waterfall Text",
            "01 Asset Owner Sponsor Revenue Setup": "01 Asset Owner Sponsor Revenue Setup",
            "01 ASSET OWNER SPONSOR REVENUE SETUP": "01 ASSET OWNER SPONSOR REVENUE SETUP",
            "REVSHARE_Asset_Profile": "REVSHARE_Asset_Profile",
            "REVSHARE_ASSET_PROFILE": "REVSHARE_ASSET_PROFILE",
            "Revenue Share Asset Profile": "Revenue Share Asset Profile",
            "Select Revenue Share Asset Profile": "Select Revenue Share Asset Profile",
            "Print of Revenue Share Asset Profile": "Print of Revenue Share Asset Profile",
            "Revenue Share Token Asset Profile ID": "Revenue Share Token Asset Profile ID",
            "REVSHARE Asset Profile ID": "REVSHARE Asset Profile ID",
            "Enter REVSHARE Asset Profile ID": "Enter REVSHARE Asset Profile ID",
            "REVSHARE_Revenue_Source": "REVSHARE_Revenue_Source",
            "REVSHARE_REVENUE_SOURCE": "REVSHARE_REVENUE_SOURCE",
            "Revenue Share Revenue Source": "Revenue Share Revenue Source",
            "Select Revenue Share Revenue Source": "Select Revenue Share Revenue Source",
            "Print of Revenue Share Revenue Source": "Print of Revenue Share Revenue Source",
            "Revenue Share Source ID": "Revenue Share Source ID",
            "REVSHARE Revenue Source ID": "REVSHARE Revenue Source ID",
            "Enter REVSHARE Revenue Source ID": "Enter REVSHARE Revenue Source ID",
            "Revenue Source Type": "Revenue Source Type",
            "Enter Revenue Source Type": "Enter Revenue Source Type",
            "Revenue Source Name": "Revenue Source Name",
            "Enter Revenue Source Name": "Enter Revenue Source Name",
            "Gross Revenue Definition": "Gross Revenue Definition",
            "Enter Gross Revenue Definition": "Enter Gross Revenue Definition",
            "Net Revenue Definition": "Net Revenue Definition",
            "Enter Net Revenue Definition": "Enter Net Revenue Definition",
            "Excluded Revenue Items": "Excluded Revenue Items",
            "Enter Excluded Revenue Items": "Enter Excluded Revenue Items",
            "Revenue Verification Method": "Revenue Verification Method",
            "Enter Revenue Verification Method": "Enter Revenue Verification Method",
            "Revenue Source Status": "Revenue Source Status",
            "Enter Revenue Source Status": "Enter Revenue Source Status",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "REVSHARE_Token_Offering": "REVSHARE_Token_Offering",
            "REVSHARE_TOKEN_OFFERING": "REVSHARE_TOKEN_OFFERING",
            "Revenue Share Token Offering": "Revenue Share Token Offering",
            "Select Revenue Share Token Offering": "Select Revenue Share Token Offering",
            "Print of Revenue Share Token Offering": "Print of Revenue Share Token Offering",
            "Revenue Share Token Offering ID": "Revenue Share Token Offering ID",
            "REVSHARE Offering ID": "REVSHARE Offering ID",
            "Enter REVSHARE Offering ID": "Enter REVSHARE Offering ID",
            "REVSHARE_Token_Class": "REVSHARE_Token_Class",
            "REVSHARE_TOKEN_CLASS": "REVSHARE_TOKEN_CLASS",
            "Revenue Share Token Token Class": "Revenue Share Token Token Class",
            "Select Revenue Share Token Token Class": "Select Revenue Share Token Token Class",
            "Print of Revenue Share Token Token Class": "Print of Revenue Share Token Token Class",
            "Revenue Share Token Token Class ID": "Revenue Share Token Token Class ID",
            "REVSHARE Token Class ID": "REVSHARE Token Class ID",
            "Enter REVSHARE Token Class ID": "Enter REVSHARE Token Class ID",
            "REVSHARE_Token_Economics": "REVSHARE_Token_Economics",
            "REVSHARE_TOKEN_ECONOMICS": "REVSHARE_TOKEN_ECONOMICS",
            "Revenue Share Token Token Economics": "Revenue Share Token Token Economics",
            "Select Revenue Share Token Token Economics": "Select Revenue Share Token Token Economics",
            "Print of Revenue Share Token Token Economics": "Print of Revenue Share Token Token Economics",
            "Revenue Share Token Token Economics ID": "Revenue Share Token Token Economics ID",
            "REVSHARE Token Economics ID": "REVSHARE Token Economics ID",
            "Enter REVSHARE Token Economics ID": "Enter REVSHARE Token Economics ID",
            "REVSHARE_Legal_Rights_Matrix": "REVSHARE_Legal_Rights_Matrix",
            "REVSHARE_LEGAL_RIGHTS_MATRIX": "REVSHARE_LEGAL_RIGHTS_MATRIX",
            "Revenue Share Token Legal Rights Matrix": "Revenue Share Token Legal Rights Matrix",
            "Select Revenue Share Token Legal Rights Matrix": "Select Revenue Share Token Legal Rights Matrix",
            "Print of Revenue Share Token Legal Rights Matrix": "Print of Revenue Share Token Legal Rights Matrix",
            "Revenue Share Token Rights Matrix ID": "Revenue Share Token Rights Matrix ID",
            "REVSHARE Rights Matrix ID": "REVSHARE Rights Matrix ID",
            "Enter REVSHARE Rights Matrix ID": "Enter REVSHARE Rights Matrix ID",
            "REVSHARE_Risk_Score": "REVSHARE_Risk_Score",
            "REVSHARE_RISK_SCORE": "REVSHARE_RISK_SCORE",
            "Revenue Share Token Risk Score": "Revenue Share Token Risk Score",
            "Select Revenue Share Token Risk Score": "Select Revenue Share Token Risk Score",
            "Print of Revenue Share Token Risk Score": "Print of Revenue Share Token Risk Score",
            "Revenue Share Token Risk Score ID": "Revenue Share Token Risk Score ID",
            "REVSHARE Risk Score ID": "REVSHARE Risk Score ID",
            "Enter REVSHARE Risk Score ID": "Enter REVSHARE Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "REVSHARE_Subscription_Order": "REVSHARE_Subscription_Order",
            "REVSHARE_SUBSCRIPTION_ORDER": "REVSHARE_SUBSCRIPTION_ORDER",
            "Revenue Share Token Subscription Order": "Revenue Share Token Subscription Order",
            "Select Revenue Share Token Subscription Order": "Select Revenue Share Token Subscription Order",
            "Print of Revenue Share Token Subscription Order": "Print of Revenue Share Token Subscription Order",
            "Revenue Share Token Subscription ID": "Revenue Share Token Subscription ID",
            "REVSHARE Subscription ID": "REVSHARE Subscription ID",
            "Enter REVSHARE Subscription ID": "Enter REVSHARE Subscription ID",
            "REVSHARE_Token_Ledger": "REVSHARE_Token_Ledger",
            "REVSHARE_TOKEN_LEDGER": "REVSHARE_TOKEN_LEDGER",
            "Revenue Share Token Token Ledger": "Revenue Share Token Token Ledger",
            "Select Revenue Share Token Token Ledger": "Select Revenue Share Token Token Ledger",
            "Print of Revenue Share Token Token Ledger": "Print of Revenue Share Token Token Ledger",
            "Revenue Share Token Ledger ID": "Revenue Share Token Ledger ID",
            "REVSHARE Ledger ID": "REVSHARE Ledger ID",
            "Enter REVSHARE Ledger ID": "Enter REVSHARE Ledger ID",
            "04 Revenue Operator Verifier Operations": "04 Revenue Operator Verifier Operations",
            "04 REVENUE OPERATOR VERIFIER OPERATIONS": "04 REVENUE OPERATOR VERIFIER OPERATIONS",
            "REVSHARE_Independent_Inspection_Report": "REVSHARE_Independent_Inspection_Report",
            "REVSHARE_INDEPENDENT_INSPECTION_REPORT": "REVSHARE_INDEPENDENT_INSPECTION_REPORT",
            "Revenue Share Token Independent Inspection Report": "Revenue Share Token Independent Inspection Report",
            "Select Revenue Share Token Independent Inspection Report": "Select Revenue Share Token Independent Inspection Report",
            "Print of Revenue Share Token Independent Inspection Report": "Print of Revenue Share Token Independent Inspection Report",
            "Revenue Share Token Inspection Report ID": "Revenue Share Token Inspection Report ID",
            "REVSHARE Inspection Report ID": "REVSHARE Inspection Report ID",
            "Enter REVSHARE Inspection Report ID": "Enter REVSHARE Inspection Report ID",
            "REVSHARE_Revenue_Verification_Report": "REVSHARE_Revenue_Verification_Report",
            "REVSHARE_REVENUE_VERIFICATION_REPORT": "REVSHARE_REVENUE_VERIFICATION_REPORT",
            "Revenue Share Revenue Verification Report": "Revenue Share Revenue Verification Report",
            "Select Revenue Share Revenue Verification Report": "Select Revenue Share Revenue Verification Report",
            "Print of Revenue Share Revenue Verification Report": "Print of Revenue Share Revenue Verification Report",
            "Revenue Share Verification ID": "Revenue Share Verification ID",
            "REVSHARE Revenue Verification ID": "REVSHARE Revenue Verification ID",
            "Enter REVSHARE Revenue Verification ID": "Enter REVSHARE Revenue Verification ID",
            "Revenue Source ID": "Revenue Source ID",
            "Enter Revenue Source ID": "Enter Revenue Source ID",
            "Reported Gross Revenue USD": "Reported Gross Revenue USD",
            "Enter Reported Gross Revenue USD": "Enter Reported Gross Revenue USD",
            "Verified Gross Revenue USD": "Verified Gross Revenue USD",
            "Enter Verified Gross Revenue USD": "Enter Verified Gross Revenue USD",
            "Allowable Deductions USD": "Allowable Deductions USD",
            "Enter Allowable Deductions USD": "Enter Allowable Deductions USD",
            "Net Revenue USD": "Net Revenue USD",
            "Enter Net Revenue USD": "Enter Net Revenue USD",
            "Variance USD": "Variance USD",
            "Enter Variance USD": "Enter Variance USD",
            "Verification Report Link": "Verification Report Link",
            "Enter Verification Report Link": "Enter Verification Report Link",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "REVSHARE_Escrow_Release_Package": "REVSHARE_Escrow_Release_Package",
            "REVSHARE_ESCROW_RELEASE_PACKAGE": "REVSHARE_ESCROW_RELEASE_PACKAGE",
            "Revenue Share Token Escrow Release Package": "Revenue Share Token Escrow Release Package",
            "Select Revenue Share Token Escrow Release Package": "Select Revenue Share Token Escrow Release Package",
            "Print of Revenue Share Token Escrow Release Package": "Print of Revenue Share Token Escrow Release Package",
            "Revenue Share Token Escrow Release Package ID": "Revenue Share Token Escrow Release Package ID",
            "REVSHARE Escrow Release Package ID": "REVSHARE Escrow Release Package ID",
            "Enter REVSHARE Escrow Release Package ID": "Enter REVSHARE Escrow Release Package ID",
            "REVSHARE_Distribution_Calculation": "REVSHARE_Distribution_Calculation",
            "REVSHARE_DISTRIBUTION_CALCULATION": "REVSHARE_DISTRIBUTION_CALCULATION",
            "Revenue Share Token Distribution Calculation": "Revenue Share Token Distribution Calculation",
            "Select Revenue Share Token Distribution Calculation": "Select Revenue Share Token Distribution Calculation",
            "Print of Revenue Share Token Distribution Calculation": "Print of Revenue Share Token Distribution Calculation",
            "Revenue Share Token Distribution ID": "Revenue Share Token Distribution ID",
            "REVSHARE Distribution ID": "REVSHARE Distribution ID",
            "Enter REVSHARE Distribution ID": "Enter REVSHARE Distribution ID",
            "REVSHARE_Investor_Report": "REVSHARE_Investor_Report",
            "REVSHARE_INVESTOR_REPORT": "REVSHARE_INVESTOR_REPORT",
            "Revenue Share Token Investor Report": "Revenue Share Token Investor Report",
            "Select Revenue Share Token Investor Report": "Select Revenue Share Token Investor Report",
            "Print of Revenue Share Token Investor Report": "Print of Revenue Share Token Investor Report",
            "Revenue Share Token Investor Report ID": "Revenue Share Token Investor Report ID",
            "REVSHARE Investor Report ID": "REVSHARE Investor Report ID",
            "Enter REVSHARE Investor Report ID": "Enter REVSHARE Investor Report ID",
            "06 Sponsor Governance Lifecycle Exit": "06 Sponsor Governance Lifecycle Exit",
            "06 SPONSOR GOVERNANCE LIFECYCLE EXIT": "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
            "REVSHARE_Lifecycle_Milestone": "REVSHARE_Lifecycle_Milestone",
            "REVSHARE_LIFECYCLE_MILESTONE": "REVSHARE_LIFECYCLE_MILESTONE",
            "Revenue Share Token Lifecycle Milestone": "Revenue Share Token Lifecycle Milestone",
            "Select Revenue Share Token Lifecycle Milestone": "Select Revenue Share Token Lifecycle Milestone",
            "Print of Revenue Share Token Lifecycle Milestone": "Print of Revenue Share Token Lifecycle Milestone",
            "Revenue Share Token Milestone ID": "Revenue Share Token Milestone ID",
            "REVSHARE Milestone ID": "REVSHARE Milestone ID",
            "Enter REVSHARE Milestone ID": "Enter REVSHARE Milestone ID",
            "REVSHARE_Exit_Strategy": "REVSHARE_Exit_Strategy",
            "REVSHARE_EXIT_STRATEGY": "REVSHARE_EXIT_STRATEGY",
            "Revenue Share Token Exit Strategy": "Revenue Share Token Exit Strategy",
            "Select Revenue Share Token Exit Strategy": "Select Revenue Share Token Exit Strategy",
            "Print of Revenue Share Token Exit Strategy": "Print of Revenue Share Token Exit Strategy",
            "Revenue Share Token Exit Strategy ID": "Revenue Share Token Exit Strategy ID",
            "REVSHARE Exit Strategy ID": "REVSHARE Exit Strategy ID",
            "Enter REVSHARE Exit Strategy ID": "Enter REVSHARE Exit Strategy ID",
            "01 Asset Owner Sponsor Asset Exit Setup": "01 Asset Owner Sponsor Asset Exit Setup",
            "01 ASSET OWNER SPONSOR ASSET EXIT SETUP": "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
            "SALEPROFIT_Asset_Profile": "SALEPROFIT_Asset_Profile",
            "SALEPROFIT_ASSET_PROFILE": "SALEPROFIT_ASSET_PROFILE",
            "Sale Profit Asset Profile": "Sale Profit Asset Profile",
            "Select Sale Profit Asset Profile": "Select Sale Profit Asset Profile",
            "Print of Sale Profit Asset Profile": "Print of Sale Profit Asset Profile",
            "Sale Profit Token Asset Profile ID": "Sale Profit Token Asset Profile ID",
            "SALEPROFIT Asset Profile ID": "SALEPROFIT Asset Profile ID",
            "Enter SALEPROFIT Asset Profile ID": "Enter SALEPROFIT Asset Profile ID",
            "SALEPROFIT_Exit_Strategy": "SALEPROFIT_Exit_Strategy",
            "SALEPROFIT_EXIT_STRATEGY": "SALEPROFIT_EXIT_STRATEGY",
            "Sale Profit Token Exit Strategy": "Sale Profit Token Exit Strategy",
            "Select Sale Profit Token Exit Strategy": "Select Sale Profit Token Exit Strategy",
            "Print of Sale Profit Token Exit Strategy": "Print of Sale Profit Token Exit Strategy",
            "Sale Profit Token Exit Strategy ID": "Sale Profit Token Exit Strategy ID",
            "SALEPROFIT Exit Strategy ID": "SALEPROFIT Exit Strategy ID",
            "Enter SALEPROFIT Exit Strategy ID": "Enter SALEPROFIT Exit Strategy ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "SALEPROFIT_Token_Offering": "SALEPROFIT_Token_Offering",
            "SALEPROFIT_TOKEN_OFFERING": "SALEPROFIT_TOKEN_OFFERING",
            "Sale Profit Token Offering": "Sale Profit Token Offering",
            "Select Sale Profit Token Offering": "Select Sale Profit Token Offering",
            "Print of Sale Profit Token Offering": "Print of Sale Profit Token Offering",
            "Sale Profit Token Offering ID": "Sale Profit Token Offering ID",
            "SALEPROFIT Offering ID": "SALEPROFIT Offering ID",
            "Enter SALEPROFIT Offering ID": "Enter SALEPROFIT Offering ID",
            "SALEPROFIT_Token_Class": "SALEPROFIT_Token_Class",
            "SALEPROFIT_TOKEN_CLASS": "SALEPROFIT_TOKEN_CLASS",
            "Sale Profit Token Token Class": "Sale Profit Token Token Class",
            "Select Sale Profit Token Token Class": "Select Sale Profit Token Token Class",
            "Print of Sale Profit Token Token Class": "Print of Sale Profit Token Token Class",
            "Sale Profit Token Token Class ID": "Sale Profit Token Token Class ID",
            "SALEPROFIT Token Class ID": "SALEPROFIT Token Class ID",
            "Enter SALEPROFIT Token Class ID": "Enter SALEPROFIT Token Class ID",
            "SALEPROFIT_Token_Economics": "SALEPROFIT_Token_Economics",
            "SALEPROFIT_TOKEN_ECONOMICS": "SALEPROFIT_TOKEN_ECONOMICS",
            "Sale Profit Token Token Economics": "Sale Profit Token Token Economics",
            "Select Sale Profit Token Token Economics": "Select Sale Profit Token Token Economics",
            "Print of Sale Profit Token Token Economics": "Print of Sale Profit Token Token Economics",
            "Sale Profit Token Token Economics ID": "Sale Profit Token Token Economics ID",
            "SALEPROFIT Token Economics ID": "SALEPROFIT Token Economics ID",
            "Enter SALEPROFIT Token Economics ID": "Enter SALEPROFIT Token Economics ID",
            "SALEPROFIT_Legal_Rights_Matrix": "SALEPROFIT_Legal_Rights_Matrix",
            "SALEPROFIT_LEGAL_RIGHTS_MATRIX": "SALEPROFIT_LEGAL_RIGHTS_MATRIX",
            "Sale Profit Token Legal Rights Matrix": "Sale Profit Token Legal Rights Matrix",
            "Select Sale Profit Token Legal Rights Matrix": "Select Sale Profit Token Legal Rights Matrix",
            "Print of Sale Profit Token Legal Rights Matrix": "Print of Sale Profit Token Legal Rights Matrix",
            "Sale Profit Token Rights Matrix ID": "Sale Profit Token Rights Matrix ID",
            "SALEPROFIT Rights Matrix ID": "SALEPROFIT Rights Matrix ID",
            "Enter SALEPROFIT Rights Matrix ID": "Enter SALEPROFIT Rights Matrix ID",
            "SALEPROFIT_Risk_Score": "SALEPROFIT_Risk_Score",
            "SALEPROFIT_RISK_SCORE": "SALEPROFIT_RISK_SCORE",
            "Sale Profit Token Risk Score": "Sale Profit Token Risk Score",
            "Select Sale Profit Token Risk Score": "Select Sale Profit Token Risk Score",
            "Print of Sale Profit Token Risk Score": "Print of Sale Profit Token Risk Score",
            "Sale Profit Token Risk Score ID": "Sale Profit Token Risk Score ID",
            "SALEPROFIT Risk Score ID": "SALEPROFIT Risk Score ID",
            "Enter SALEPROFIT Risk Score ID": "Enter SALEPROFIT Risk Score ID",
            "SALEPROFIT_Independent_Inspection_Report": "SALEPROFIT_Independent_Inspection_Report",
            "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT": "SALEPROFIT_INDEPENDENT_INSPECTION_REPORT",
            "Sale Profit Token Independent Inspection Report": "Sale Profit Token Independent Inspection Report",
            "Select Sale Profit Token Independent Inspection Report": "Select Sale Profit Token Independent Inspection Report",
            "Print of Sale Profit Token Independent Inspection Report": "Print of Sale Profit Token Independent Inspection Report",
            "Sale Profit Token Inspection Report ID": "Sale Profit Token Inspection Report ID",
            "SALEPROFIT Inspection Report ID": "SALEPROFIT Inspection Report ID",
            "Enter SALEPROFIT Inspection Report ID": "Enter SALEPROFIT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "SALEPROFIT_Subscription_Order": "SALEPROFIT_Subscription_Order",
            "SALEPROFIT_SUBSCRIPTION_ORDER": "SALEPROFIT_SUBSCRIPTION_ORDER",
            "Sale Profit Token Subscription Order": "Sale Profit Token Subscription Order",
            "Select Sale Profit Token Subscription Order": "Select Sale Profit Token Subscription Order",
            "Print of Sale Profit Token Subscription Order": "Print of Sale Profit Token Subscription Order",
            "Sale Profit Token Subscription ID": "Sale Profit Token Subscription ID",
            "SALEPROFIT Subscription ID": "SALEPROFIT Subscription ID",
            "Enter SALEPROFIT Subscription ID": "Enter SALEPROFIT Subscription ID",
            "SALEPROFIT_Token_Ledger": "SALEPROFIT_Token_Ledger",
            "SALEPROFIT_TOKEN_LEDGER": "SALEPROFIT_TOKEN_LEDGER",
            "Sale Profit Token Token Ledger": "Sale Profit Token Token Ledger",
            "Select Sale Profit Token Token Ledger": "Select Sale Profit Token Token Ledger",
            "Print of Sale Profit Token Token Ledger": "Print of Sale Profit Token Token Ledger",
            "Sale Profit Token Ledger ID": "Sale Profit Token Ledger ID",
            "SALEPROFIT Ledger ID": "SALEPROFIT Ledger ID",
            "Enter SALEPROFIT Ledger ID": "Enter SALEPROFIT Ledger ID",
            "04 Asset Manager Sale Process Execution": "04 Asset Manager Sale Process Execution",
            "04 ASSET MANAGER SALE PROCESS EXECUTION": "04 ASSET MANAGER SALE PROCESS EXECUTION",
            "SALEPROFIT_Lifecycle_Milestone": "SALEPROFIT_Lifecycle_Milestone",
            "SALEPROFIT_LIFECYCLE_MILESTONE": "SALEPROFIT_LIFECYCLE_MILESTONE",
            "Sale Profit Token Lifecycle Milestone": "Sale Profit Token Lifecycle Milestone",
            "Select Sale Profit Token Lifecycle Milestone": "Select Sale Profit Token Lifecycle Milestone",
            "Print of Sale Profit Token Lifecycle Milestone": "Print of Sale Profit Token Lifecycle Milestone",
            "Sale Profit Token Milestone ID": "Sale Profit Token Milestone ID",
            "SALEPROFIT Milestone ID": "SALEPROFIT Milestone ID",
            "Enter SALEPROFIT Milestone ID": "Enter SALEPROFIT Milestone ID",
            "SALEPROFIT_Sale_Process": "SALEPROFIT_Sale_Process",
            "SALEPROFIT_SALE_PROCESS": "SALEPROFIT_SALE_PROCESS",
            "Sale Profit Sale Process": "Sale Profit Sale Process",
            "Select Sale Profit Sale Process": "Select Sale Profit Sale Process",
            "Print of Sale Profit Sale Process": "Print of Sale Profit Sale Process",
            "Sale Profit Sale Process ID": "Sale Profit Sale Process ID",
            "SALEPROFIT Sale Process ID": "SALEPROFIT Sale Process ID",
            "Enter SALEPROFIT Sale Process ID": "Enter SALEPROFIT Sale Process ID",
            "Broker ID": "Broker ID",
            "Enter Broker ID": "Enter Broker ID",
            "Listing Date": "Listing Date",
            "Enter Listing Date": "Enter Listing Date",
            "Asking Price USD": "Asking Price USD",
            "Enter Asking Price USD": "Enter Asking Price USD",
            "Offer Received USD": "Offer Received USD",
            "Enter Offer Received USD": "Enter Offer Received USD",
            "Accepted Offer USD": "Accepted Offer USD",
            "Enter Accepted Offer USD": "Enter Accepted Offer USD",
            "Closing Date": "Closing Date",
            "Enter Closing Date": "Enter Closing Date",
            "Sale Status": "Sale Status",
            "Enter Sale Status": "Enter Sale Status",
            "05 Finance Escrow Profit Distribution": "05 Finance Escrow Profit Distribution",
            "05 FINANCE ESCROW PROFIT DISTRIBUTION": "05 FINANCE ESCROW PROFIT DISTRIBUTION",
            "SALEPROFIT_Profit_Waterfall": "SALEPROFIT_Profit_Waterfall",
            "SALEPROFIT_PROFIT_WATERFALL": "SALEPROFIT_PROFIT_WATERFALL",
            "Sale Profit Waterfall": "Sale Profit Waterfall",
            "Select Sale Profit Waterfall": "Select Sale Profit Waterfall",
            "Print of Sale Profit Waterfall": "Print of Sale Profit Waterfall",
            "Sale Profit Waterfall ID": "Sale Profit Waterfall ID",
            "SALEPROFIT Profit Waterfall ID": "SALEPROFIT Profit Waterfall ID",
            "Enter SALEPROFIT Profit Waterfall ID": "Enter SALEPROFIT Profit Waterfall ID",
            "Gross Sale Proceeds USD": "Gross Sale Proceeds USD",
            "Enter Gross Sale Proceeds USD": "Enter Gross Sale Proceeds USD",
            "Closing Costs USD": "Closing Costs USD",
            "Enter Closing Costs USD": "Enter Closing Costs USD",
            "Debt Payoff USD": "Debt Payoff USD",
            "Enter Debt Payoff USD": "Enter Debt Payoff USD",
            "Reserve Release USD": "Reserve Release USD",
            "Enter Reserve Release USD": "Enter Reserve Release USD",
            "Net Sale Profit USD": "Net Sale Profit USD",
            "Enter Net Sale Profit USD": "Enter Net Sale Profit USD",
            "Waterfall Calculation Link": "Waterfall Calculation Link",
            "Enter Waterfall Calculation Link": "Enter Waterfall Calculation Link",
            "SALEPROFIT_Distribution_Calculation": "SALEPROFIT_Distribution_Calculation",
            "SALEPROFIT_DISTRIBUTION_CALCULATION": "SALEPROFIT_DISTRIBUTION_CALCULATION",
            "Sale Profit Token Distribution Calculation": "Sale Profit Token Distribution Calculation",
            "Select Sale Profit Token Distribution Calculation": "Select Sale Profit Token Distribution Calculation",
            "Print of Sale Profit Token Distribution Calculation": "Print of Sale Profit Token Distribution Calculation",
            "Sale Profit Token Distribution ID": "Sale Profit Token Distribution ID",
            "SALEPROFIT Distribution ID": "SALEPROFIT Distribution ID",
            "Enter SALEPROFIT Distribution ID": "Enter SALEPROFIT Distribution ID",
            "SALEPROFIT_Escrow_Release_Package": "SALEPROFIT_Escrow_Release_Package",
            "SALEPROFIT_ESCROW_RELEASE_PACKAGE": "SALEPROFIT_ESCROW_RELEASE_PACKAGE",
            "Sale Profit Token Escrow Release Package": "Sale Profit Token Escrow Release Package",
            "Select Sale Profit Token Escrow Release Package": "Select Sale Profit Token Escrow Release Package",
            "Print of Sale Profit Token Escrow Release Package": "Print of Sale Profit Token Escrow Release Package",
            "Sale Profit Token Escrow Release Package ID": "Sale Profit Token Escrow Release Package ID",
            "SALEPROFIT Escrow Release Package ID": "SALEPROFIT Escrow Release Package ID",
            "Enter SALEPROFIT Escrow Release Package ID": "Enter SALEPROFIT Escrow Release Package ID",
            "06 Investor Relations Tax Closeout": "06 Investor Relations Tax Closeout",
            "06 INVESTOR RELATIONS TAX CLOSEOUT": "06 INVESTOR RELATIONS TAX CLOSEOUT",
            "SALEPROFIT_Investor_Report": "SALEPROFIT_Investor_Report",
            "SALEPROFIT_INVESTOR_REPORT": "SALEPROFIT_INVESTOR_REPORT",
            "Sale Profit Token Investor Report": "Sale Profit Token Investor Report",
            "Select Sale Profit Token Investor Report": "Select Sale Profit Token Investor Report",
            "Print of Sale Profit Token Investor Report": "Print of Sale Profit Token Investor Report",
            "Sale Profit Token Investor Report ID": "Sale Profit Token Investor Report ID",
            "SALEPROFIT Investor Report ID": "SALEPROFIT Investor Report ID",
            "Enter SALEPROFIT Investor Report ID": "Enter SALEPROFIT Investor Report ID",
            "01 Asset Owner Sponsor NAV Asset Setup": "01 Asset Owner Sponsor NAV Asset Setup",
            "01 ASSET OWNER SPONSOR NAV ASSET SETUP": "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
            "EQAPP_Asset_Profile": "EQAPP_Asset_Profile",
            "EQAPP_ASSET_PROFILE": "EQAPP_ASSET_PROFILE",
            "Equity Appreciation Asset Profile": "Equity Appreciation Asset Profile",
            "Select Equity Appreciation Asset Profile": "Select Equity Appreciation Asset Profile",
            "Print of Equity Appreciation Asset Profile": "Print of Equity Appreciation Asset Profile",
            "Equity Appreciation Token Asset Profile ID": "Equity Appreciation Token Asset Profile ID",
            "EQAPP Asset Profile ID": "EQAPP Asset Profile ID",
            "Enter EQAPP Asset Profile ID": "Enter EQAPP Asset Profile ID",
            "02 Offering NAV Legal Compliance Readiness": "02 Offering NAV Legal Compliance Readiness",
            "02 OFFERING NAV LEGAL COMPLIANCE READINESS": "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
            "EQAPP_Token_Offering": "EQAPP_Token_Offering",
            "EQAPP_TOKEN_OFFERING": "EQAPP_TOKEN_OFFERING",
            "Equity Appreciation Token Offering": "Equity Appreciation Token Offering",
            "Select Equity Appreciation Token Offering": "Select Equity Appreciation Token Offering",
            "Print of Equity Appreciation Token Offering": "Print of Equity Appreciation Token Offering",
            "Equity Appreciation Token Offering ID": "Equity Appreciation Token Offering ID",
            "EQAPP Offering ID": "EQAPP Offering ID",
            "Enter EQAPP Offering ID": "Enter EQAPP Offering ID",
            "EQAPP_Token_Class": "EQAPP_Token_Class",
            "EQAPP_TOKEN_CLASS": "EQAPP_TOKEN_CLASS",
            "Equity Appreciation Token Token Class": "Equity Appreciation Token Token Class",
            "Select Equity Appreciation Token Token Class": "Select Equity Appreciation Token Token Class",
            "Print of Equity Appreciation Token Token Class": "Print of Equity Appreciation Token Token Class",
            "Equity Appreciation Token Token Class ID": "Equity Appreciation Token Token Class ID",
            "EQAPP Token Class ID": "EQAPP Token Class ID",
            "Enter EQAPP Token Class ID": "Enter EQAPP Token Class ID",
            "EQAPP_Token_Economics": "EQAPP_Token_Economics",
            "EQAPP_TOKEN_ECONOMICS": "EQAPP_TOKEN_ECONOMICS",
            "Equity Appreciation Token Token Economics": "Equity Appreciation Token Token Economics",
            "Select Equity Appreciation Token Token Economics": "Select Equity Appreciation Token Token Economics",
            "Print of Equity Appreciation Token Token Economics": "Print of Equity Appreciation Token Token Economics",
            "Equity Appreciation Token Token Economics ID": "Equity Appreciation Token Token Economics ID",
            "EQAPP Token Economics ID": "EQAPP Token Economics ID",
            "Enter EQAPP Token Economics ID": "Enter EQAPP Token Economics ID",
            "EQAPP_Legal_Rights_Matrix": "EQAPP_Legal_Rights_Matrix",
            "EQAPP_LEGAL_RIGHTS_MATRIX": "EQAPP_LEGAL_RIGHTS_MATRIX",
            "Equity Appreciation Token Legal Rights Matrix": "Equity Appreciation Token Legal Rights Matrix",
            "Select Equity Appreciation Token Legal Rights Matrix": "Select Equity Appreciation Token Legal Rights Matrix",
            "Print of Equity Appreciation Token Legal Rights Matrix": "Print of Equity Appreciation Token Legal Rights Matrix",
            "Equity Appreciation Token Rights Matrix ID": "Equity Appreciation Token Rights Matrix ID",
            "EQAPP Rights Matrix ID": "EQAPP Rights Matrix ID",
            "Enter EQAPP Rights Matrix ID": "Enter EQAPP Rights Matrix ID",
            "EQAPP_NAV_Valuation_Report": "EQAPP_NAV_Valuation_Report",
            "EQAPP_NAV_VALUATION_REPORT": "EQAPP_NAV_VALUATION_REPORT",
            "Equity Appreciation NAV Valuation Report": "Equity Appreciation NAV Valuation Report",
            "Select Equity Appreciation NAV Valuation Report": "Select Equity Appreciation NAV Valuation Report",
            "Print of Equity Appreciation NAV Valuation Report": "Print of Equity Appreciation NAV Valuation Report",
            "Equity Appreciation NAV Report ID": "Equity Appreciation NAV Report ID",
            "EQAPP NAV Report ID": "EQAPP NAV Report ID",
            "Enter EQAPP NAV Report ID": "Enter EQAPP NAV Report ID",
            "Valuation Date": "Valuation Date",
            "Enter Valuation Date": "Enter Valuation Date",
            "Prior NAV USD": "Prior NAV USD",
            "Enter Prior NAV USD": "Enter Prior NAV USD",
            "Current NAV USD": "Current NAV USD",
            "Enter Current NAV USD": "Enter Current NAV USD",
            "NAV Per Token USD": "NAV Per Token USD",
            "Enter NAV Per Token USD": "Enter NAV Per Token USD",
            "Equity Appreciation USD": "Equity Appreciation USD",
            "Enter Equity Appreciation USD": "Enter Equity Appreciation USD",
            "Valuation Notes": "Valuation Notes",
            "Enter Valuation Notes": "Enter Valuation Notes",
            "EQAPP_Appreciation_Calculation": "EQAPP_Appreciation_Calculation",
            "EQAPP_APPRECIATION_CALCULATION": "EQAPP_APPRECIATION_CALCULATION",
            "Equity Appreciation Calculation": "Equity Appreciation Calculation",
            "Select Equity Appreciation Calculation": "Select Equity Appreciation Calculation",
            "Print of Equity Appreciation Calculation": "Print of Equity Appreciation Calculation",
            "Equity Appreciation Calculation ID": "Equity Appreciation Calculation ID",
            "EQAPP Appreciation Calc ID": "EQAPP Appreciation Calc ID",
            "Enter EQAPP Appreciation Calc ID": "Enter EQAPP Appreciation Calc ID",
            "Opening Asset Value USD": "Opening Asset Value USD",
            "Enter Opening Asset Value USD": "Enter Opening Asset Value USD",
            "Current Asset Value USD": "Current Asset Value USD",
            "Enter Current Asset Value USD": "Enter Current Asset Value USD",
            "Debt Balance USD": "Debt Balance USD",
            "Enter Debt Balance USD": "Enter Debt Balance USD",
            "Net Equity Value USD": "Net Equity Value USD",
            "Enter Net Equity Value USD": "Enter Net Equity Value USD",
            "Appreciation Amount USD": "Appreciation Amount USD",
            "Enter Appreciation Amount USD": "Enter Appreciation Amount USD",
            "Appreciation Percentage": "Appreciation Percentage",
            "Enter Appreciation Percentage": "Enter Appreciation Percentage",
            "Allocation To Tokens USD": "Allocation To Tokens USD",
            "Enter Allocation To Tokens USD": "Enter Allocation To Tokens USD",
            "EQAPP_Risk_Score": "EQAPP_Risk_Score",
            "EQAPP_RISK_SCORE": "EQAPP_RISK_SCORE",
            "Equity Appreciation Token Risk Score": "Equity Appreciation Token Risk Score",
            "Select Equity Appreciation Token Risk Score": "Select Equity Appreciation Token Risk Score",
            "Print of Equity Appreciation Token Risk Score": "Print of Equity Appreciation Token Risk Score",
            "Equity Appreciation Token Risk Score ID": "Equity Appreciation Token Risk Score ID",
            "EQAPP Risk Score ID": "EQAPP Risk Score ID",
            "Enter EQAPP Risk Score ID": "Enter EQAPP Risk Score ID",
            "EQAPP_Independent_Inspection_Report": "EQAPP_Independent_Inspection_Report",
            "EQAPP_INDEPENDENT_INSPECTION_REPORT": "EQAPP_INDEPENDENT_INSPECTION_REPORT",
            "Equity Appreciation Token Independent Inspection Report": "Equity Appreciation Token Independent Inspection Report",
            "Select Equity Appreciation Token Independent Inspection Report": "Select Equity Appreciation Token Independent Inspection Report",
            "Print of Equity Appreciation Token Independent Inspection Report": "Print of Equity Appreciation Token Independent Inspection Report",
            "Equity Appreciation Token Inspection Report ID": "Equity Appreciation Token Inspection Report ID",
            "EQAPP Inspection Report ID": "EQAPP Inspection Report ID",
            "Enter EQAPP Inspection Report ID": "Enter EQAPP Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "EQAPP_Subscription_Order": "EQAPP_Subscription_Order",
            "EQAPP_SUBSCRIPTION_ORDER": "EQAPP_SUBSCRIPTION_ORDER",
            "Equity Appreciation Token Subscription Order": "Equity Appreciation Token Subscription Order",
            "Select Equity Appreciation Token Subscription Order": "Select Equity Appreciation Token Subscription Order",
            "Print of Equity Appreciation Token Subscription Order": "Print of Equity Appreciation Token Subscription Order",
            "Equity Appreciation Token Subscription ID": "Equity Appreciation Token Subscription ID",
            "EQAPP Subscription ID": "EQAPP Subscription ID",
            "Enter EQAPP Subscription ID": "Enter EQAPP Subscription ID",
            "EQAPP_Token_Ledger": "EQAPP_Token_Ledger",
            "EQAPP_TOKEN_LEDGER": "EQAPP_TOKEN_LEDGER",
            "Equity Appreciation Token Token Ledger": "Equity Appreciation Token Token Ledger",
            "Select Equity Appreciation Token Token Ledger": "Select Equity Appreciation Token Token Ledger",
            "Print of Equity Appreciation Token Token Ledger": "Print of Equity Appreciation Token Token Ledger",
            "Equity Appreciation Token Ledger ID": "Equity Appreciation Token Ledger ID",
            "EQAPP Ledger ID": "EQAPP Ledger ID",
            "Enter EQAPP Ledger ID": "Enter EQAPP Ledger ID",
            "04 Asset Manager NAV Lifecycle Monitoring": "04 Asset Manager NAV Lifecycle Monitoring",
            "04 ASSET MANAGER NAV LIFECYCLE MONITORING": "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
            "EQAPP_Lifecycle_Milestone": "EQAPP_Lifecycle_Milestone",
            "EQAPP_LIFECYCLE_MILESTONE": "EQAPP_LIFECYCLE_MILESTONE",
            "Equity Appreciation Token Lifecycle Milestone": "Equity Appreciation Token Lifecycle Milestone",
            "Select Equity Appreciation Token Lifecycle Milestone": "Select Equity Appreciation Token Lifecycle Milestone",
            "Print of Equity Appreciation Token Lifecycle Milestone": "Print of Equity Appreciation Token Lifecycle Milestone",
            "Equity Appreciation Token Milestone ID": "Equity Appreciation Token Milestone ID",
            "EQAPP Milestone ID": "EQAPP Milestone ID",
            "Enter EQAPP Milestone ID": "Enter EQAPP Milestone ID",
            "05 Finance Escrow Appreciation Distribution": "05 Finance Escrow Appreciation Distribution",
            "05 FINANCE ESCROW APPRECIATION DISTRIBUTION": "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
            "EQAPP_Distribution_Calculation": "EQAPP_Distribution_Calculation",
            "EQAPP_DISTRIBUTION_CALCULATION": "EQAPP_DISTRIBUTION_CALCULATION",
            "Equity Appreciation Token Distribution Calculation": "Equity Appreciation Token Distribution Calculation",
            "Select Equity Appreciation Token Distribution Calculation": "Select Equity Appreciation Token Distribution Calculation",
            "Print of Equity Appreciation Token Distribution Calculation": "Print of Equity Appreciation Token Distribution Calculation",
            "Equity Appreciation Token Distribution ID": "Equity Appreciation Token Distribution ID",
            "EQAPP Distribution ID": "EQAPP Distribution ID",
            "Enter EQAPP Distribution ID": "Enter EQAPP Distribution ID",
            "EQAPP_Escrow_Release_Package": "EQAPP_Escrow_Release_Package",
            "EQAPP_ESCROW_RELEASE_PACKAGE": "EQAPP_ESCROW_RELEASE_PACKAGE",
            "Equity Appreciation Token Escrow Release Package": "Equity Appreciation Token Escrow Release Package",
            "Select Equity Appreciation Token Escrow Release Package": "Select Equity Appreciation Token Escrow Release Package",
            "Print of Equity Appreciation Token Escrow Release Package": "Print of Equity Appreciation Token Escrow Release Package",
            "Equity Appreciation Token Escrow Release Package ID": "Equity Appreciation Token Escrow Release Package ID",
            "EQAPP Escrow Release Package ID": "EQAPP Escrow Release Package ID",
            "Enter EQAPP Escrow Release Package ID": "Enter EQAPP Escrow Release Package ID",
            "06 Investor Relations Tax Exit": "06 Investor Relations Tax Exit",
            "06 INVESTOR RELATIONS TAX EXIT": "06 INVESTOR RELATIONS TAX EXIT",
            "EQAPP_Investor_Report": "EQAPP_Investor_Report",
            "EQAPP_INVESTOR_REPORT": "EQAPP_INVESTOR_REPORT",
            "Equity Appreciation Token Investor Report": "Equity Appreciation Token Investor Report",
            "Select Equity Appreciation Token Investor Report": "Select Equity Appreciation Token Investor Report",
            "Print of Equity Appreciation Token Investor Report": "Print of Equity Appreciation Token Investor Report",
            "Equity Appreciation Token Investor Report ID": "Equity Appreciation Token Investor Report ID",
            "EQAPP Investor Report ID": "EQAPP Investor Report ID",
            "Enter EQAPP Investor Report ID": "Enter EQAPP Investor Report ID",
            "EQAPP_Exit_Strategy": "EQAPP_Exit_Strategy",
            "EQAPP_EXIT_STRATEGY": "EQAPP_EXIT_STRATEGY",
            "Equity Appreciation Token Exit Strategy": "Equity Appreciation Token Exit Strategy",
            "Select Equity Appreciation Token Exit Strategy": "Select Equity Appreciation Token Exit Strategy",
            "Print of Equity Appreciation Token Exit Strategy": "Print of Equity Appreciation Token Exit Strategy",
            "Equity Appreciation Token Exit Strategy ID": "Equity Appreciation Token Exit Strategy ID",
            "EQAPP Exit Strategy ID": "EQAPP Exit Strategy ID",
            "Enter EQAPP Exit Strategy ID": "Enter EQAPP Exit Strategy ID",
            "01 Asset Owner Sponsor Preferred Equity Setup": "01 Asset Owner Sponsor Preferred Equity Setup",
            "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP": "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
            "PREFEQ_Asset_Profile": "PREFEQ_Asset_Profile",
            "PREFEQ_ASSET_PROFILE": "PREFEQ_ASSET_PROFILE",
            "Preferred Equity Asset Profile": "Preferred Equity Asset Profile",
            "Select Preferred Equity Asset Profile": "Select Preferred Equity Asset Profile",
            "Print of Preferred Equity Asset Profile": "Print of Preferred Equity Asset Profile",
            "Preferred Equity Token Asset Profile ID": "Preferred Equity Token Asset Profile ID",
            "PREFEQ Asset Profile ID": "PREFEQ Asset Profile ID",
            "Enter PREFEQ Asset Profile ID": "Enter PREFEQ Asset Profile ID",
            "PREFEQ_Token_Offering": "PREFEQ_Token_Offering",
            "PREFEQ_TOKEN_OFFERING": "PREFEQ_TOKEN_OFFERING",
            "Preferred Equity Token Offering": "Preferred Equity Token Offering",
            "Select Preferred Equity Token Offering": "Select Preferred Equity Token Offering",
            "Print of Preferred Equity Token Offering": "Print of Preferred Equity Token Offering",
            "Preferred Equity Token Offering ID": "Preferred Equity Token Offering ID",
            "PREFEQ Offering ID": "PREFEQ Offering ID",
            "Enter PREFEQ Offering ID": "Enter PREFEQ Offering ID",
            "02 Offering Legal Preferred Waterfall Readiness": "02 Offering Legal Preferred Waterfall Readiness",
            "02 OFFERING LEGAL PREFERRED WATERFALL READINESS": "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
            "PREFEQ_Token_Class": "PREFEQ_Token_Class",
            "PREFEQ_TOKEN_CLASS": "PREFEQ_TOKEN_CLASS",
            "Preferred Equity Token Token Class": "Preferred Equity Token Token Class",
            "Select Preferred Equity Token Token Class": "Select Preferred Equity Token Token Class",
            "Print of Preferred Equity Token Token Class": "Print of Preferred Equity Token Token Class",
            "Preferred Equity Token Token Class ID": "Preferred Equity Token Token Class ID",
            "PREFEQ Token Class ID": "PREFEQ Token Class ID",
            "Enter PREFEQ Token Class ID": "Enter PREFEQ Token Class ID",
            "PREFEQ_Token_Economics": "PREFEQ_Token_Economics",
            "PREFEQ_TOKEN_ECONOMICS": "PREFEQ_TOKEN_ECONOMICS",
            "Preferred Equity Token Token Economics": "Preferred Equity Token Token Economics",
            "Select Preferred Equity Token Token Economics": "Select Preferred Equity Token Token Economics",
            "Print of Preferred Equity Token Token Economics": "Print of Preferred Equity Token Token Economics",
            "Preferred Equity Token Token Economics ID": "Preferred Equity Token Token Economics ID",
            "PREFEQ Token Economics ID": "PREFEQ Token Economics ID",
            "Enter PREFEQ Token Economics ID": "Enter PREFEQ Token Economics ID",
            "PREFEQ_Preferred_Return_Waterfall": "PREFEQ_Preferred_Return_Waterfall",
            "PREFEQ_PREFERRED_RETURN_WATERFALL": "PREFEQ_PREFERRED_RETURN_WATERFALL",
            "Preferred Equity Return Waterfall": "Preferred Equity Return Waterfall",
            "Select Preferred Equity Return Waterfall": "Select Preferred Equity Return Waterfall",
            "Print of Preferred Equity Return Waterfall": "Print of Preferred Equity Return Waterfall",
            "Preferred Equity Waterfall ID": "Preferred Equity Waterfall ID",
            "PREFEQ Waterfall ID": "PREFEQ Waterfall ID",
            "Enter PREFEQ Waterfall ID": "Enter PREFEQ Waterfall ID",
            "Accrued Preferred Return USD": "Accrued Preferred Return USD",
            "Enter Accrued Preferred Return USD": "Enter Accrued Preferred Return USD",
            "Paid Preferred Return USD": "Paid Preferred Return USD",
            "Enter Paid Preferred Return USD": "Enter Paid Preferred Return USD",
            "Unpaid Preferred Return USD": "Unpaid Preferred Return USD",
            "Enter Unpaid Preferred Return USD": "Enter Unpaid Preferred Return USD",
            "Catch Up Required": "Catch Up Required",
            "Enter Catch Up Required": "Enter Catch Up Required",
            "Waterfall Report Link": "Waterfall Report Link",
            "Enter Waterfall Report Link": "Enter Waterfall Report Link",
            "PREFEQ_Legal_Rights_Matrix": "PREFEQ_Legal_Rights_Matrix",
            "PREFEQ_LEGAL_RIGHTS_MATRIX": "PREFEQ_LEGAL_RIGHTS_MATRIX",
            "Preferred Equity Token Legal Rights Matrix": "Preferred Equity Token Legal Rights Matrix",
            "Select Preferred Equity Token Legal Rights Matrix": "Select Preferred Equity Token Legal Rights Matrix",
            "Print of Preferred Equity Token Legal Rights Matrix": "Print of Preferred Equity Token Legal Rights Matrix",
            "Preferred Equity Token Rights Matrix ID": "Preferred Equity Token Rights Matrix ID",
            "PREFEQ Rights Matrix ID": "PREFEQ Rights Matrix ID",
            "Enter PREFEQ Rights Matrix ID": "Enter PREFEQ Rights Matrix ID",
            "PREFEQ_Risk_Score": "PREFEQ_Risk_Score",
            "PREFEQ_RISK_SCORE": "PREFEQ_RISK_SCORE",
            "Preferred Equity Token Risk Score": "Preferred Equity Token Risk Score",
            "Select Preferred Equity Token Risk Score": "Select Preferred Equity Token Risk Score",
            "Print of Preferred Equity Token Risk Score": "Print of Preferred Equity Token Risk Score",
            "Preferred Equity Token Risk Score ID": "Preferred Equity Token Risk Score ID",
            "PREFEQ Risk Score ID": "PREFEQ Risk Score ID",
            "Enter PREFEQ Risk Score ID": "Enter PREFEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "PREFEQ_Subscription_Order": "PREFEQ_Subscription_Order",
            "PREFEQ_SUBSCRIPTION_ORDER": "PREFEQ_SUBSCRIPTION_ORDER",
            "Preferred Equity Token Subscription Order": "Preferred Equity Token Subscription Order",
            "Select Preferred Equity Token Subscription Order": "Select Preferred Equity Token Subscription Order",
            "Print of Preferred Equity Token Subscription Order": "Print of Preferred Equity Token Subscription Order",
            "Preferred Equity Token Subscription ID": "Preferred Equity Token Subscription ID",
            "PREFEQ Subscription ID": "PREFEQ Subscription ID",
            "Enter PREFEQ Subscription ID": "Enter PREFEQ Subscription ID",
            "PREFEQ_Token_Ledger": "PREFEQ_Token_Ledger",
            "PREFEQ_TOKEN_LEDGER": "PREFEQ_TOKEN_LEDGER",
            "Preferred Equity Token Token Ledger": "Preferred Equity Token Token Ledger",
            "Select Preferred Equity Token Token Ledger": "Select Preferred Equity Token Token Ledger",
            "Print of Preferred Equity Token Token Ledger": "Print of Preferred Equity Token Token Ledger",
            "Preferred Equity Token Ledger ID": "Preferred Equity Token Ledger ID",
            "PREFEQ Ledger ID": "PREFEQ Ledger ID",
            "Enter PREFEQ Ledger ID": "Enter PREFEQ Ledger ID",
            "PREFEQ_Capital_Account": "PREFEQ_Capital_Account",
            "PREFEQ_CAPITAL_ACCOUNT": "PREFEQ_CAPITAL_ACCOUNT",
            "Preferred Equity Capital Account": "Preferred Equity Capital Account",
            "Select Preferred Equity Capital Account": "Select Preferred Equity Capital Account",
            "Print of Preferred Equity Capital Account": "Print of Preferred Equity Capital Account",
            "Preferred Equity Capital Account ID": "Preferred Equity Capital Account ID",
            "PREFEQ Capital Account ID": "PREFEQ Capital Account ID",
            "Enter PREFEQ Capital Account ID": "Enter PREFEQ Capital Account ID",
            "Opening Capital Balance USD": "Opening Capital Balance USD",
            "Enter Opening Capital Balance USD": "Enter Opening Capital Balance USD",
            "Capital Contribution USD": "Capital Contribution USD",
            "Enter Capital Contribution USD": "Enter Capital Contribution USD",
            "Preferred Return Accrued USD": "Preferred Return Accrued USD",
            "Enter Preferred Return Accrued USD": "Enter Preferred Return Accrued USD",
            "Distributions Paid USD": "Distributions Paid USD",
            "Enter Distributions Paid USD": "Enter Distributions Paid USD",
            "Ending Capital Balance USD": "Ending Capital Balance USD",
            "Enter Ending Capital Balance USD": "Enter Ending Capital Balance USD",
            "Capital Account Status": "Capital Account Status",
            "Enter Capital Account Status": "Enter Capital Account Status",
            "04 Inspection Escrow Capital Release": "04 Inspection Escrow Capital Release",
            "04 INSPECTION ESCROW CAPITAL RELEASE": "04 INSPECTION ESCROW CAPITAL RELEASE",
            "PREFEQ_Independent_Inspection_Report": "PREFEQ_Independent_Inspection_Report",
            "PREFEQ_INDEPENDENT_INSPECTION_REPORT": "PREFEQ_INDEPENDENT_INSPECTION_REPORT",
            "Preferred Equity Token Independent Inspection Report": "Preferred Equity Token Independent Inspection Report",
            "Select Preferred Equity Token Independent Inspection Report": "Select Preferred Equity Token Independent Inspection Report",
            "Print of Preferred Equity Token Independent Inspection Report": "Print of Preferred Equity Token Independent Inspection Report",
            "Preferred Equity Token Inspection Report ID": "Preferred Equity Token Inspection Report ID",
            "PREFEQ Inspection Report ID": "PREFEQ Inspection Report ID",
            "Enter PREFEQ Inspection Report ID": "Enter PREFEQ Inspection Report ID",
            "PREFEQ_Escrow_Release_Package": "PREFEQ_Escrow_Release_Package",
            "PREFEQ_ESCROW_RELEASE_PACKAGE": "PREFEQ_ESCROW_RELEASE_PACKAGE",
            "Preferred Equity Token Escrow Release Package": "Preferred Equity Token Escrow Release Package",
            "Select Preferred Equity Token Escrow Release Package": "Select Preferred Equity Token Escrow Release Package",
            "Print of Preferred Equity Token Escrow Release Package": "Print of Preferred Equity Token Escrow Release Package",
            "Preferred Equity Token Escrow Release Package ID": "Preferred Equity Token Escrow Release Package ID",
            "PREFEQ Escrow Release Package ID": "PREFEQ Escrow Release Package ID",
            "Enter PREFEQ Escrow Release Package ID": "Enter PREFEQ Escrow Release Package ID",
            "05 Finance Preferred Return Distribution": "05 Finance Preferred Return Distribution",
            "05 FINANCE PREFERRED RETURN DISTRIBUTION": "05 FINANCE PREFERRED RETURN DISTRIBUTION",
            "PREFEQ_Distribution_Calculation": "PREFEQ_Distribution_Calculation",
            "PREFEQ_DISTRIBUTION_CALCULATION": "PREFEQ_DISTRIBUTION_CALCULATION",
            "Preferred Equity Token Distribution Calculation": "Preferred Equity Token Distribution Calculation",
            "Select Preferred Equity Token Distribution Calculation": "Select Preferred Equity Token Distribution Calculation",
            "Print of Preferred Equity Token Distribution Calculation": "Print of Preferred Equity Token Distribution Calculation",
            "Preferred Equity Token Distribution ID": "Preferred Equity Token Distribution ID",
            "PREFEQ Distribution ID": "PREFEQ Distribution ID",
            "Enter PREFEQ Distribution ID": "Enter PREFEQ Distribution ID",
            "06 Investor Relations Tax Reporting": "06 Investor Relations Tax Reporting",
            "06 INVESTOR RELATIONS TAX REPORTING": "06 INVESTOR RELATIONS TAX REPORTING",
            "PREFEQ_Investor_Report": "PREFEQ_Investor_Report",
            "PREFEQ_INVESTOR_REPORT": "PREFEQ_INVESTOR_REPORT",
            "Preferred Equity Token Investor Report": "Preferred Equity Token Investor Report",
            "Select Preferred Equity Token Investor Report": "Select Preferred Equity Token Investor Report",
            "Print of Preferred Equity Token Investor Report": "Print of Preferred Equity Token Investor Report",
            "Preferred Equity Token Investor Report ID": "Preferred Equity Token Investor Report ID",
            "PREFEQ Investor Report ID": "PREFEQ Investor Report ID",
            "Enter PREFEQ Investor Report ID": "Enter PREFEQ Investor Report ID",
            "07 Asset Manager Lifecycle Exit": "07 Asset Manager Lifecycle Exit",
            "07 ASSET MANAGER LIFECYCLE EXIT": "07 ASSET MANAGER LIFECYCLE EXIT",
            "PREFEQ_Lifecycle_Milestone": "PREFEQ_Lifecycle_Milestone",
            "PREFEQ_LIFECYCLE_MILESTONE": "PREFEQ_LIFECYCLE_MILESTONE",
            "Preferred Equity Token Lifecycle Milestone": "Preferred Equity Token Lifecycle Milestone",
            "Select Preferred Equity Token Lifecycle Milestone": "Select Preferred Equity Token Lifecycle Milestone",
            "Print of Preferred Equity Token Lifecycle Milestone": "Print of Preferred Equity Token Lifecycle Milestone",
            "Preferred Equity Token Milestone ID": "Preferred Equity Token Milestone ID",
            "PREFEQ Milestone ID": "PREFEQ Milestone ID",
            "Enter PREFEQ Milestone ID": "Enter PREFEQ Milestone ID",
            "PREFEQ_Exit_Strategy": "PREFEQ_Exit_Strategy",
            "PREFEQ_EXIT_STRATEGY": "PREFEQ_EXIT_STRATEGY",
            "Preferred Equity Token Exit Strategy": "Preferred Equity Token Exit Strategy",
            "Select Preferred Equity Token Exit Strategy": "Select Preferred Equity Token Exit Strategy",
            "Print of Preferred Equity Token Exit Strategy": "Print of Preferred Equity Token Exit Strategy",
            "Preferred Equity Token Exit Strategy ID": "Preferred Equity Token Exit Strategy ID",
            "PREFEQ Exit Strategy ID": "PREFEQ Exit Strategy ID",
            "Enter PREFEQ Exit Strategy ID": "Enter PREFEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Equity Setup": "01 Asset Owner Sponsor Equity Setup",
            "01 ASSET OWNER SPONSOR EQUITY SETUP": "01 ASSET OWNER SPONSOR EQUITY SETUP",
            "COMEQ_Asset_Profile": "COMEQ_Asset_Profile",
            "COMEQ_ASSET_PROFILE": "COMEQ_ASSET_PROFILE",
            "Common Equity Asset Profile": "Common Equity Asset Profile",
            "Select Common Equity Asset Profile": "Select Common Equity Asset Profile",
            "Print of Common Equity Asset Profile": "Print of Common Equity Asset Profile",
            "Common Equity Token Asset Profile ID": "Common Equity Token Asset Profile ID",
            "COMEQ Asset Profile ID": "COMEQ Asset Profile ID",
            "Enter COMEQ Asset Profile ID": "Enter COMEQ Asset Profile ID",
            "02 Offering Legal Compliance Readiness": "02 Offering Legal Compliance Readiness",
            "02 OFFERING LEGAL COMPLIANCE READINESS": "02 OFFERING LEGAL COMPLIANCE READINESS",
            "COMEQ_Token_Offering": "COMEQ_Token_Offering",
            "COMEQ_TOKEN_OFFERING": "COMEQ_TOKEN_OFFERING",
            "Common Equity Token Offering": "Common Equity Token Offering",
            "Select Common Equity Token Offering": "Select Common Equity Token Offering",
            "Print of Common Equity Token Offering": "Print of Common Equity Token Offering",
            "Common Equity Token Offering ID": "Common Equity Token Offering ID",
            "COMEQ Offering ID": "COMEQ Offering ID",
            "Enter COMEQ Offering ID": "Enter COMEQ Offering ID",
            "COMEQ_Token_Class": "COMEQ_Token_Class",
            "COMEQ_TOKEN_CLASS": "COMEQ_TOKEN_CLASS",
            "Common Equity Token Token Class": "Common Equity Token Token Class",
            "Select Common Equity Token Token Class": "Select Common Equity Token Token Class",
            "Print of Common Equity Token Token Class": "Print of Common Equity Token Token Class",
            "Common Equity Token Token Class ID": "Common Equity Token Token Class ID",
            "COMEQ Token Class ID": "COMEQ Token Class ID",
            "Enter COMEQ Token Class ID": "Enter COMEQ Token Class ID",
            "COMEQ_Token_Economics": "COMEQ_Token_Economics",
            "COMEQ_TOKEN_ECONOMICS": "COMEQ_TOKEN_ECONOMICS",
            "Common Equity Token Token Economics": "Common Equity Token Token Economics",
            "Select Common Equity Token Token Economics": "Select Common Equity Token Token Economics",
            "Print of Common Equity Token Token Economics": "Print of Common Equity Token Token Economics",
            "Common Equity Token Token Economics ID": "Common Equity Token Token Economics ID",
            "COMEQ Token Economics ID": "COMEQ Token Economics ID",
            "Enter COMEQ Token Economics ID": "Enter COMEQ Token Economics ID",
            "COMEQ_Legal_Rights_Matrix": "COMEQ_Legal_Rights_Matrix",
            "COMEQ_LEGAL_RIGHTS_MATRIX": "COMEQ_LEGAL_RIGHTS_MATRIX",
            "Common Equity Token Legal Rights Matrix": "Common Equity Token Legal Rights Matrix",
            "Select Common Equity Token Legal Rights Matrix": "Select Common Equity Token Legal Rights Matrix",
            "Print of Common Equity Token Legal Rights Matrix": "Print of Common Equity Token Legal Rights Matrix",
            "Common Equity Token Rights Matrix ID": "Common Equity Token Rights Matrix ID",
            "COMEQ Rights Matrix ID": "COMEQ Rights Matrix ID",
            "Enter COMEQ Rights Matrix ID": "Enter COMEQ Rights Matrix ID",
            "COMEQ_Risk_Score": "COMEQ_Risk_Score",
            "COMEQ_RISK_SCORE": "COMEQ_RISK_SCORE",
            "Common Equity Token Risk Score": "Common Equity Token Risk Score",
            "Select Common Equity Token Risk Score": "Select Common Equity Token Risk Score",
            "Print of Common Equity Token Risk Score": "Print of Common Equity Token Risk Score",
            "Common Equity Token Risk Score ID": "Common Equity Token Risk Score ID",
            "COMEQ Risk Score ID": "COMEQ Risk Score ID",
            "Enter COMEQ Risk Score ID": "Enter COMEQ Risk Score ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "COMEQ_Subscription_Order": "COMEQ_Subscription_Order",
            "COMEQ_SUBSCRIPTION_ORDER": "COMEQ_SUBSCRIPTION_ORDER",
            "Common Equity Token Subscription Order": "Common Equity Token Subscription Order",
            "Select Common Equity Token Subscription Order": "Select Common Equity Token Subscription Order",
            "Print of Common Equity Token Subscription Order": "Print of Common Equity Token Subscription Order",
            "Common Equity Token Subscription ID": "Common Equity Token Subscription ID",
            "COMEQ Subscription ID": "COMEQ Subscription ID",
            "Enter COMEQ Subscription ID": "Enter COMEQ Subscription ID",
            "COMEQ_Token_Ledger": "COMEQ_Token_Ledger",
            "COMEQ_TOKEN_LEDGER": "COMEQ_TOKEN_LEDGER",
            "Common Equity Token Token Ledger": "Common Equity Token Token Ledger",
            "Select Common Equity Token Token Ledger": "Select Common Equity Token Token Ledger",
            "Print of Common Equity Token Token Ledger": "Print of Common Equity Token Token Ledger",
            "Common Equity Token Ledger ID": "Common Equity Token Ledger ID",
            "COMEQ Ledger ID": "COMEQ Ledger ID",
            "Enter COMEQ Ledger ID": "Enter COMEQ Ledger ID",
            "COMEQ_Cap_Table": "COMEQ_Cap_Table",
            "COMEQ_CAP_TABLE": "COMEQ_CAP_TABLE",
            "Common Equity Cap Table": "Common Equity Cap Table",
            "Select Common Equity Cap Table": "Select Common Equity Cap Table",
            "Print of Common Equity Cap Table": "Print of Common Equity Cap Table",
            "Common Equity Cap Table ID": "Common Equity Cap Table ID",
            "COMEQ Cap Table ID": "COMEQ Cap Table ID",
            "Enter COMEQ Cap Table ID": "Enter COMEQ Cap Table ID",
            "Dilution Adjustment Factor": "Dilution Adjustment Factor",
            "Enter Dilution Adjustment Factor": "Enter Dilution Adjustment Factor",
            "Cap Table Status": "Cap Table Status",
            "Enter Cap Table Status": "Enter Cap Table Status",
            "04 Equity Ownership Governance Management": "04 Equity Ownership Governance Management",
            "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT": "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
            "COMEQ_Lifecycle_Milestone": "COMEQ_Lifecycle_Milestone",
            "COMEQ_LIFECYCLE_MILESTONE": "COMEQ_LIFECYCLE_MILESTONE",
            "Common Equity Token Lifecycle Milestone": "Common Equity Token Lifecycle Milestone",
            "Select Common Equity Token Lifecycle Milestone": "Select Common Equity Token Lifecycle Milestone",
            "Print of Common Equity Token Lifecycle Milestone": "Print of Common Equity Token Lifecycle Milestone",
            "Common Equity Token Milestone ID": "Common Equity Token Milestone ID",
            "COMEQ Milestone ID": "COMEQ Milestone ID",
            "Enter COMEQ Milestone ID": "Enter COMEQ Milestone ID",
            "COMEQ_Independent_Inspection_Report": "COMEQ_Independent_Inspection_Report",
            "COMEQ_INDEPENDENT_INSPECTION_REPORT": "COMEQ_INDEPENDENT_INSPECTION_REPORT",
            "Common Equity Token Independent Inspection Report": "Common Equity Token Independent Inspection Report",
            "Select Common Equity Token Independent Inspection Report": "Select Common Equity Token Independent Inspection Report",
            "Print of Common Equity Token Independent Inspection Report": "Print of Common Equity Token Independent Inspection Report",
            "Common Equity Token Inspection Report ID": "Common Equity Token Inspection Report ID",
            "COMEQ Inspection Report ID": "COMEQ Inspection Report ID",
            "Enter COMEQ Inspection Report ID": "Enter COMEQ Inspection Report ID",
            "05 Finance Escrow Distribution Reporting": "05 Finance Escrow Distribution Reporting",
            "05 FINANCE ESCROW DISTRIBUTION REPORTING": "05 FINANCE ESCROW DISTRIBUTION REPORTING",
            "COMEQ_Equity_Distribution_Waterfall": "COMEQ_Equity_Distribution_Waterfall",
            "COMEQ_EQUITY_DISTRIBUTION_WATERFALL": "COMEQ_EQUITY_DISTRIBUTION_WATERFALL",
            "Common Equity Distribution Waterfall": "Common Equity Distribution Waterfall",
            "Select Common Equity Distribution Waterfall": "Select Common Equity Distribution Waterfall",
            "Print of Common Equity Distribution Waterfall": "Print of Common Equity Distribution Waterfall",
            "Common Equity Waterfall ID": "Common Equity Waterfall ID",
            "COMEQ Waterfall ID": "COMEQ Waterfall ID",
            "Enter COMEQ Waterfall ID": "Enter COMEQ Waterfall ID",
            "Available Cash USD": "Available Cash USD",
            "Enter Available Cash USD": "Enter Available Cash USD",
            "Preferred Return Paid USD": "Preferred Return Paid USD",
            "Enter Preferred Return Paid USD": "Enter Preferred Return Paid USD",
            "Common Equity Distributable USD": "Common Equity Distributable USD",
            "Enter Common Equity Distributable USD": "Enter Common Equity Distributable USD",
            "COMEQ_Distribution_Calculation": "COMEQ_Distribution_Calculation",
            "COMEQ_DISTRIBUTION_CALCULATION": "COMEQ_DISTRIBUTION_CALCULATION",
            "Common Equity Token Distribution Calculation": "Common Equity Token Distribution Calculation",
            "Select Common Equity Token Distribution Calculation": "Select Common Equity Token Distribution Calculation",
            "Print of Common Equity Token Distribution Calculation": "Print of Common Equity Token Distribution Calculation",
            "Common Equity Token Distribution ID": "Common Equity Token Distribution ID",
            "COMEQ Distribution ID": "COMEQ Distribution ID",
            "Enter COMEQ Distribution ID": "Enter COMEQ Distribution ID",
            "COMEQ_Escrow_Release_Package": "COMEQ_Escrow_Release_Package",
            "COMEQ_ESCROW_RELEASE_PACKAGE": "COMEQ_ESCROW_RELEASE_PACKAGE",
            "Common Equity Token Escrow Release Package": "Common Equity Token Escrow Release Package",
            "Select Common Equity Token Escrow Release Package": "Select Common Equity Token Escrow Release Package",
            "Print of Common Equity Token Escrow Release Package": "Print of Common Equity Token Escrow Release Package",
            "Common Equity Token Escrow Release Package ID": "Common Equity Token Escrow Release Package ID",
            "COMEQ Escrow Release Package ID": "COMEQ Escrow Release Package ID",
            "Enter COMEQ Escrow Release Package ID": "Enter COMEQ Escrow Release Package ID",
            "COMEQ_Investor_Report": "COMEQ_Investor_Report",
            "COMEQ_INVESTOR_REPORT": "COMEQ_INVESTOR_REPORT",
            "Common Equity Token Investor Report": "Common Equity Token Investor Report",
            "Select Common Equity Token Investor Report": "Select Common Equity Token Investor Report",
            "Print of Common Equity Token Investor Report": "Print of Common Equity Token Investor Report",
            "Common Equity Token Investor Report ID": "Common Equity Token Investor Report ID",
            "COMEQ Investor Report ID": "COMEQ Investor Report ID",
            "Enter COMEQ Investor Report ID": "Enter COMEQ Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "COMEQ_Exit_Strategy": "COMEQ_Exit_Strategy",
            "COMEQ_EXIT_STRATEGY": "COMEQ_EXIT_STRATEGY",
            "Common Equity Token Exit Strategy": "Common Equity Token Exit Strategy",
            "Select Common Equity Token Exit Strategy": "Select Common Equity Token Exit Strategy",
            "Print of Common Equity Token Exit Strategy": "Print of Common Equity Token Exit Strategy",
            "Common Equity Token Exit Strategy ID": "Common Equity Token Exit Strategy ID",
            "COMEQ Exit Strategy ID": "COMEQ Exit Strategy ID",
            "Enter COMEQ Exit Strategy ID": "Enter COMEQ Exit Strategy ID",
            "01 Asset Owner Sponsor Collateral Setup": "01 Asset Owner Sponsor Collateral Setup",
            "01 ASSET OWNER SPONSOR COLLATERAL SETUP": "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
            "DEBT_Asset_Profile": "DEBT_Asset_Profile",
            "DEBT_ASSET_PROFILE": "DEBT_ASSET_PROFILE",
            "Debt Note Collateral Asset Profile": "Debt Note Collateral Asset Profile",
            "Select Debt Note Collateral Asset Profile": "Select Debt Note Collateral Asset Profile",
            "Print of Debt Note Collateral Asset Profile": "Print of Debt Note Collateral Asset Profile",
            "Debt Note Token Asset Profile ID": "Debt Note Token Asset Profile ID",
            "DEBT Asset Profile ID": "DEBT Asset Profile ID",
            "Enter DEBT Asset Profile ID": "Enter DEBT Asset Profile ID",
            "DEBT_Token_Offering": "DEBT_Token_Offering",
            "DEBT_TOKEN_OFFERING": "DEBT_TOKEN_OFFERING",
            "Debt Note Token Offering": "Debt Note Token Offering",
            "Select Debt Note Token Offering": "Select Debt Note Token Offering",
            "Print of Debt Note Token Offering": "Print of Debt Note Token Offering",
            "Debt Note Token Offering ID": "Debt Note Token Offering ID",
            "DEBT Offering ID": "DEBT Offering ID",
            "Enter DEBT Offering ID": "Enter DEBT Offering ID",
            "DEBT_Note_Terms": "DEBT_Note_Terms",
            "DEBT_NOTE_TERMS": "DEBT_NOTE_TERMS",
            "Debt Note Terms": "Debt Note Terms",
            "Select Debt Note Terms": "Select Debt Note Terms",
            "Print of Debt Note Terms": "Print of Debt Note Terms",
            "Debt Note Terms ID": "Debt Note Terms ID",
            "DEBT Note Terms ID": "DEBT Note Terms ID",
            "Enter DEBT Note Terms ID": "Enter DEBT Note Terms ID",
            "Principal Amount USD": "Principal Amount USD",
            "Enter Principal Amount USD": "Enter Principal Amount USD",
            "Interest Type": "Interest Type",
            "Enter Interest Type": "Enter Interest Type",
            "Payment Frequency": "Payment Frequency",
            "Enter Payment Frequency": "Enter Payment Frequency",
            "Maturity Date": "Maturity Date",
            "Enter Maturity Date": "Enter Maturity Date",
            "Amortization Type": "Amortization Type",
            "Enter Amortization Type": "Enter Amortization Type",
            "Collateral Asset ID": "Collateral Asset ID",
            "Enter Collateral Asset ID": "Enter Collateral Asset ID",
            "Lien Position": "Lien Position",
            "Enter Lien Position": "Enter Lien Position",
            "Default Interest Rate": "Default Interest Rate",
            "Enter Default Interest Rate": "Enter Default Interest Rate",
            "Debt Covenants": "Debt Covenants",
            "Enter Debt Covenants": "Enter Debt Covenants",
            "02 Debt Structuring Legal Risk Readiness": "02 Debt Structuring Legal Risk Readiness",
            "02 DEBT STRUCTURING LEGAL RISK READINESS": "02 DEBT STRUCTURING LEGAL RISK READINESS",
            "DEBT_Token_Class": "DEBT_Token_Class",
            "DEBT_TOKEN_CLASS": "DEBT_TOKEN_CLASS",
            "Debt Note Token Token Class": "Debt Note Token Token Class",
            "Select Debt Note Token Token Class": "Select Debt Note Token Token Class",
            "Print of Debt Note Token Token Class": "Print of Debt Note Token Token Class",
            "Debt Note Token Token Class ID": "Debt Note Token Token Class ID",
            "DEBT Token Class ID": "DEBT Token Class ID",
            "Enter DEBT Token Class ID": "Enter DEBT Token Class ID",
            "DEBT_Token_Economics": "DEBT_Token_Economics",
            "DEBT_TOKEN_ECONOMICS": "DEBT_TOKEN_ECONOMICS",
            "Debt Note Token Token Economics": "Debt Note Token Token Economics",
            "Select Debt Note Token Token Economics": "Select Debt Note Token Token Economics",
            "Print of Debt Note Token Token Economics": "Print of Debt Note Token Token Economics",
            "Debt Note Token Token Economics ID": "Debt Note Token Token Economics ID",
            "DEBT Token Economics ID": "DEBT Token Economics ID",
            "Enter DEBT Token Economics ID": "Enter DEBT Token Economics ID",
            "DEBT_Payment_Schedule": "DEBT_Payment_Schedule",
            "DEBT_PAYMENT_SCHEDULE": "DEBT_PAYMENT_SCHEDULE",
            "Debt Payment Schedule": "Debt Payment Schedule",
            "Select Debt Payment Schedule": "Select Debt Payment Schedule",
            "Print of Debt Payment Schedule": "Print of Debt Payment Schedule",
            "Debt Payment Schedule ID": "Debt Payment Schedule ID",
            "DEBT Payment Schedule ID": "DEBT Payment Schedule ID",
            "Enter DEBT Payment Schedule ID": "Enter DEBT Payment Schedule ID",
            "Payment Number": "Payment Number",
            "Enter Payment Number": "Enter Payment Number",
            "Payment Due Date": "Payment Due Date",
            "Enter Payment Due Date": "Enter Payment Due Date",
            "Scheduled Principal USD": "Scheduled Principal USD",
            "Enter Scheduled Principal USD": "Enter Scheduled Principal USD",
            "Scheduled Interest USD": "Scheduled Interest USD",
            "Enter Scheduled Interest USD": "Enter Scheduled Interest USD",
            "Total Scheduled Payment USD": "Total Scheduled Payment USD",
            "Enter Total Scheduled Payment USD": "Enter Total Scheduled Payment USD",
            "Actual Payment USD": "Actual Payment USD",
            "Enter Actual Payment USD": "Enter Actual Payment USD",
            "DEBT_Legal_Rights_Matrix": "DEBT_Legal_Rights_Matrix",
            "DEBT_LEGAL_RIGHTS_MATRIX": "DEBT_LEGAL_RIGHTS_MATRIX",
            "Debt Note Token Legal Rights Matrix": "Debt Note Token Legal Rights Matrix",
            "Select Debt Note Token Legal Rights Matrix": "Select Debt Note Token Legal Rights Matrix",
            "Print of Debt Note Token Legal Rights Matrix": "Print of Debt Note Token Legal Rights Matrix",
            "Debt Note Token Rights Matrix ID": "Debt Note Token Rights Matrix ID",
            "DEBT Rights Matrix ID": "DEBT Rights Matrix ID",
            "Enter DEBT Rights Matrix ID": "Enter DEBT Rights Matrix ID",
            "DEBT_Risk_Score": "DEBT_Risk_Score",
            "DEBT_RISK_SCORE": "DEBT_RISK_SCORE",
            "Debt Note Token Risk Score": "Debt Note Token Risk Score",
            "Select Debt Note Token Risk Score": "Select Debt Note Token Risk Score",
            "Print of Debt Note Token Risk Score": "Print of Debt Note Token Risk Score",
            "Debt Note Token Risk Score ID": "Debt Note Token Risk Score ID",
            "DEBT Risk Score ID": "DEBT Risk Score ID",
            "Enter DEBT Risk Score ID": "Enter DEBT Risk Score ID",
            "DEBT_Independent_Inspection_Report": "DEBT_Independent_Inspection_Report",
            "DEBT_INDEPENDENT_INSPECTION_REPORT": "DEBT_INDEPENDENT_INSPECTION_REPORT",
            "Debt Note Token Independent Inspection Report": "Debt Note Token Independent Inspection Report",
            "Select Debt Note Token Independent Inspection Report": "Select Debt Note Token Independent Inspection Report",
            "Print of Debt Note Token Independent Inspection Report": "Print of Debt Note Token Independent Inspection Report",
            "Debt Note Token Inspection Report ID": "Debt Note Token Inspection Report ID",
            "DEBT Inspection Report ID": "DEBT Inspection Report ID",
            "Enter DEBT Inspection Report ID": "Enter DEBT Inspection Report ID",
            "03 Investor Subscription Token Issuance": "03 Investor Subscription Token Issuance",
            "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "DEBT_Subscription_Order": "DEBT_Subscription_Order",
            "DEBT_SUBSCRIPTION_ORDER": "DEBT_SUBSCRIPTION_ORDER",
            "Debt Note Token Subscription Order": "Debt Note Token Subscription Order",
            "Select Debt Note Token Subscription Order": "Select Debt Note Token Subscription Order",
            "Print of Debt Note Token Subscription Order": "Print of Debt Note Token Subscription Order",
            "Debt Note Token Subscription ID": "Debt Note Token Subscription ID",
            "DEBT Subscription ID": "DEBT Subscription ID",
            "Enter DEBT Subscription ID": "Enter DEBT Subscription ID",
            "DEBT_Token_Ledger": "DEBT_Token_Ledger",
            "DEBT_TOKEN_LEDGER": "DEBT_TOKEN_LEDGER",
            "Debt Note Token Token Ledger": "Debt Note Token Token Ledger",
            "Select Debt Note Token Token Ledger": "Select Debt Note Token Token Ledger",
            "Print of Debt Note Token Token Ledger": "Print of Debt Note Token Token Ledger",
            "Debt Note Token Ledger ID": "Debt Note Token Ledger ID",
            "DEBT Ledger ID": "DEBT Ledger ID",
            "Enter DEBT Ledger ID": "Enter DEBT Ledger ID",
            "04 Debt Servicing Interest Payment Management": "04 Debt Servicing Interest Payment Management",
            "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT": "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
            "DEBT_Interest_Accrual": "DEBT_Interest_Accrual",
            "DEBT_INTEREST_ACCRUAL": "DEBT_INTEREST_ACCRUAL",
            "Debt Interest Accrual": "Debt Interest Accrual",
            "Select Debt Interest Accrual": "Select Debt Interest Accrual",
            "Print of Debt Interest Accrual": "Print of Debt Interest Accrual",
            "Debt Interest Accrual ID": "Debt Interest Accrual ID",
            "DEBT Interest Accrual ID": "DEBT Interest Accrual ID",
            "Enter DEBT Interest Accrual ID": "Enter DEBT Interest Accrual ID",
            "Accrual Period Start": "Accrual Period Start",
            "Enter Accrual Period Start": "Enter Accrual Period Start",
            "Accrual Period End": "Accrual Period End",
            "Enter Accrual Period End": "Enter Accrual Period End",
            "Principal Balance USD": "Principal Balance USD",
            "Enter Principal Balance USD": "Enter Principal Balance USD",
            "Interest Accrued USD": "Interest Accrued USD",
            "Enter Interest Accrued USD": "Enter Interest Accrued USD",
            "Interest Paid USD": "Interest Paid USD",
            "Enter Interest Paid USD": "Enter Interest Paid USD",
            "Accrual Status": "Accrual Status",
            "Enter Accrual Status": "Enter Accrual Status",
            "DEBT_Distribution_Calculation": "DEBT_Distribution_Calculation",
            "DEBT_DISTRIBUTION_CALCULATION": "DEBT_DISTRIBUTION_CALCULATION",
            "Debt Note Token Distribution Calculation": "Debt Note Token Distribution Calculation",
            "Select Debt Note Token Distribution Calculation": "Select Debt Note Token Distribution Calculation",
            "Print of Debt Note Token Distribution Calculation": "Print of Debt Note Token Distribution Calculation",
            "Debt Note Token Distribution ID": "Debt Note Token Distribution ID",
            "DEBT Distribution ID": "DEBT Distribution ID",
            "Enter DEBT Distribution ID": "Enter DEBT Distribution ID",
            "05 Finance Escrow Investor Reporting": "05 Finance Escrow Investor Reporting",
            "05 FINANCE ESCROW INVESTOR REPORTING": "05 FINANCE ESCROW INVESTOR REPORTING",
            "DEBT_Escrow_Release_Package": "DEBT_Escrow_Release_Package",
            "DEBT_ESCROW_RELEASE_PACKAGE": "DEBT_ESCROW_RELEASE_PACKAGE",
            "Debt Note Token Escrow Release Package": "Debt Note Token Escrow Release Package",
            "Select Debt Note Token Escrow Release Package": "Select Debt Note Token Escrow Release Package",
            "Print of Debt Note Token Escrow Release Package": "Print of Debt Note Token Escrow Release Package",
            "Debt Note Token Escrow Release Package ID": "Debt Note Token Escrow Release Package ID",
            "DEBT Escrow Release Package ID": "DEBT Escrow Release Package ID",
            "Enter DEBT Escrow Release Package ID": "Enter DEBT Escrow Release Package ID",
            "DEBT_Investor_Report": "DEBT_Investor_Report",
            "DEBT_INVESTOR_REPORT": "DEBT_INVESTOR_REPORT",
            "Debt Note Token Investor Report": "Debt Note Token Investor Report",
            "Select Debt Note Token Investor Report": "Select Debt Note Token Investor Report",
            "Print of Debt Note Token Investor Report": "Print of Debt Note Token Investor Report",
            "Debt Note Token Investor Report ID": "Debt Note Token Investor Report ID",
            "DEBT Investor Report ID": "DEBT Investor Report ID",
            "Enter DEBT Investor Report ID": "Enter DEBT Investor Report ID",
            "06 Lifecycle Default Maturity Exit": "06 Lifecycle Default Maturity Exit",
            "06 LIFECYCLE DEFAULT MATURITY EXIT": "06 LIFECYCLE DEFAULT MATURITY EXIT",
            "DEBT_Lifecycle_Milestone": "DEBT_Lifecycle_Milestone",
            "DEBT_LIFECYCLE_MILESTONE": "DEBT_LIFECYCLE_MILESTONE",
            "Debt Note Token Lifecycle Milestone": "Debt Note Token Lifecycle Milestone",
            "Select Debt Note Token Lifecycle Milestone": "Select Debt Note Token Lifecycle Milestone",
            "Print of Debt Note Token Lifecycle Milestone": "Print of Debt Note Token Lifecycle Milestone",
            "Debt Note Token Milestone ID": "Debt Note Token Milestone ID",
            "DEBT Milestone ID": "DEBT Milestone ID",
            "Enter DEBT Milestone ID": "Enter DEBT Milestone ID",
            "DEBT_Exit_Strategy": "DEBT_Exit_Strategy",
            "DEBT_EXIT_STRATEGY": "DEBT_EXIT_STRATEGY",
            "Debt Note Token Exit Strategy": "Debt Note Token Exit Strategy",
            "Select Debt Note Token Exit Strategy": "Select Debt Note Token Exit Strategy",
            "Print of Debt Note Token Exit Strategy": "Print of Debt Note Token Exit Strategy",
            "Debt Note Token Exit Strategy ID": "Debt Note Token Exit Strategy ID",
            "DEBT Exit Strategy ID": "DEBT Exit Strategy ID",
            "Enter DEBT Exit Strategy ID": "Enter DEBT Exit Strategy ID",
            "01 Asset Owner Sponsor Hybrid Asset Setup": "01 Asset Owner Sponsor Hybrid Asset Setup",
            "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP": "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
            "HYBRID_Asset_Profile": "HYBRID_Asset_Profile",
            "HYBRID_ASSET_PROFILE": "HYBRID_ASSET_PROFILE",
            "Hybrid Asset Profile": "Hybrid Asset Profile",
            "Select Hybrid Asset Profile": "Select Hybrid Asset Profile",
            "Print of Hybrid Asset Profile": "Print of Hybrid Asset Profile",
            "Hybrid Token Asset Profile ID": "Hybrid Token Asset Profile ID",
            "HYBRID Asset Profile ID": "HYBRID Asset Profile ID",
            "Enter HYBRID Asset Profile ID": "Enter HYBRID Asset Profile ID",
            "02 Offering Structuring Hybrid Model Setup": "02 Offering Structuring Hybrid Model Setup",
            "02 OFFERING STRUCTURING HYBRID MODEL SETUP": "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
            "HYBRID_Token_Offering": "HYBRID_Token_Offering",
            "HYBRID_TOKEN_OFFERING": "HYBRID_TOKEN_OFFERING",
            "Hybrid Token Offering": "Hybrid Token Offering",
            "Select Hybrid Token Offering": "Select Hybrid Token Offering",
            "Print of Hybrid Token Offering": "Print of Hybrid Token Offering",
            "Hybrid Token Offering ID": "Hybrid Token Offering ID",
            "HYBRID Offering ID": "HYBRID Offering ID",
            "Enter HYBRID Offering ID": "Enter HYBRID Offering ID",
            "HYBRID_Component_Mix": "HYBRID_Component_Mix",
            "HYBRID_COMPONENT_MIX": "HYBRID_COMPONENT_MIX",
            "Hybrid Component Mix": "Hybrid Component Mix",
            "Select Hybrid Component Mix": "Select Hybrid Component Mix",
            "Print of Hybrid Component Mix": "Print of Hybrid Component Mix",
            "Hybrid Component Mix ID": "Hybrid Component Mix ID",
            "HYBRID Component Mix ID": "HYBRID Component Mix ID",
            "Enter HYBRID Component Mix ID": "Enter HYBRID Component Mix ID",
            "Hybrid Component Type": "Hybrid Component Type",
            "Enter Hybrid Component Type": "Enter Hybrid Component Type",
            "Rental Income Component Percentage": "Rental Income Component Percentage",
            "Enter Rental Income Component Percentage": "Enter Rental Income Component Percentage",
            "Revenue Share Component Percentage": "Revenue Share Component Percentage",
            "Enter Revenue Share Component Percentage": "Enter Revenue Share Component Percentage",
            "Sale Profit Component Percentage": "Sale Profit Component Percentage",
            "Enter Sale Profit Component Percentage": "Enter Sale Profit Component Percentage",
            "Equity Appreciation Component Percentage": "Equity Appreciation Component Percentage",
            "Enter Equity Appreciation Component Percentage": "Enter Equity Appreciation Component Percentage",
            "Preferred Equity Component Percentage": "Preferred Equity Component Percentage",
            "Enter Preferred Equity Component Percentage": "Enter Preferred Equity Component Percentage",
            "Debt Note Component Percentage": "Debt Note Component Percentage",
            "Enter Debt Note Component Percentage": "Enter Debt Note Component Percentage",
            "Common Equity Component Percentage": "Common Equity Component Percentage",
            "Enter Common Equity Component Percentage": "Enter Common Equity Component Percentage",
            "Component Total Percentage": "Component Total Percentage",
            "Enter Component Total Percentage": "Enter Component Total Percentage",
            "Hybrid Model Description": "Hybrid Model Description",
            "Enter Hybrid Model Description": "Enter Hybrid Model Description",
            "HYBRID_Token_Class": "HYBRID_Token_Class",
            "HYBRID_TOKEN_CLASS": "HYBRID_TOKEN_CLASS",
            "Hybrid Token Token Class": "Hybrid Token Token Class",
            "Select Hybrid Token Token Class": "Select Hybrid Token Token Class",
            "Print of Hybrid Token Token Class": "Print of Hybrid Token Token Class",
            "Hybrid Token Token Class ID": "Hybrid Token Token Class ID",
            "HYBRID Token Class ID": "HYBRID Token Class ID",
            "Enter HYBRID Token Class ID": "Enter HYBRID Token Class ID",
            "HYBRID_Token_Economics": "HYBRID_Token_Economics",
            "HYBRID_TOKEN_ECONOMICS": "HYBRID_TOKEN_ECONOMICS",
            "Hybrid Token Token Economics": "Hybrid Token Token Economics",
            "Select Hybrid Token Token Economics": "Select Hybrid Token Token Economics",
            "Print of Hybrid Token Token Economics": "Print of Hybrid Token Token Economics",
            "Hybrid Token Token Economics ID": "Hybrid Token Token Economics ID",
            "HYBRID Token Economics ID": "HYBRID Token Economics ID",
            "Enter HYBRID Token Economics ID": "Enter HYBRID Token Economics ID",
            "03 Legal Risk Escrow Readiness": "03 Legal Risk Escrow Readiness",
            "03 LEGAL RISK ESCROW READINESS": "03 LEGAL RISK ESCROW READINESS",
            "HYBRID_Legal_Rights_Matrix": "HYBRID_Legal_Rights_Matrix",
            "HYBRID_LEGAL_RIGHTS_MATRIX": "HYBRID_LEGAL_RIGHTS_MATRIX",
            "Hybrid Token Legal Rights Matrix": "Hybrid Token Legal Rights Matrix",
            "Select Hybrid Token Legal Rights Matrix": "Select Hybrid Token Legal Rights Matrix",
            "Print of Hybrid Token Legal Rights Matrix": "Print of Hybrid Token Legal Rights Matrix",
            "Hybrid Token Rights Matrix ID": "Hybrid Token Rights Matrix ID",
            "HYBRID Rights Matrix ID": "HYBRID Rights Matrix ID",
            "Enter HYBRID Rights Matrix ID": "Enter HYBRID Rights Matrix ID",
            "HYBRID_Risk_Score": "HYBRID_Risk_Score",
            "HYBRID_RISK_SCORE": "HYBRID_RISK_SCORE",
            "Hybrid Token Risk Score": "Hybrid Token Risk Score",
            "Select Hybrid Token Risk Score": "Select Hybrid Token Risk Score",
            "Print of Hybrid Token Risk Score": "Print of Hybrid Token Risk Score",
            "Hybrid Token Risk Score ID": "Hybrid Token Risk Score ID",
            "HYBRID Risk Score ID": "HYBRID Risk Score ID",
            "Enter HYBRID Risk Score ID": "Enter HYBRID Risk Score ID",
            "HYBRID_Independent_Inspection_Report": "HYBRID_Independent_Inspection_Report",
            "HYBRID_INDEPENDENT_INSPECTION_REPORT": "HYBRID_INDEPENDENT_INSPECTION_REPORT",
            "Hybrid Token Independent Inspection Report": "Hybrid Token Independent Inspection Report",
            "Select Hybrid Token Independent Inspection Report": "Select Hybrid Token Independent Inspection Report",
            "Print of Hybrid Token Independent Inspection Report": "Print of Hybrid Token Independent Inspection Report",
            "Hybrid Token Inspection Report ID": "Hybrid Token Inspection Report ID",
            "HYBRID Inspection Report ID": "HYBRID Inspection Report ID",
            "Enter HYBRID Inspection Report ID": "Enter HYBRID Inspection Report ID",
            "04 Investor Subscription Token Issuance": "04 Investor Subscription Token Issuance",
            "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE": "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
            "HYBRID_Subscription_Order": "HYBRID_Subscription_Order",
            "HYBRID_SUBSCRIPTION_ORDER": "HYBRID_SUBSCRIPTION_ORDER",
            "Hybrid Token Subscription Order": "Hybrid Token Subscription Order",
            "Select Hybrid Token Subscription Order": "Select Hybrid Token Subscription Order",
            "Print of Hybrid Token Subscription Order": "Print of Hybrid Token Subscription Order",
            "Hybrid Token Subscription ID": "Hybrid Token Subscription ID",
            "HYBRID Subscription ID": "HYBRID Subscription ID",
            "Enter HYBRID Subscription ID": "Enter HYBRID Subscription ID",
            "HYBRID_Token_Ledger": "HYBRID_Token_Ledger",
            "HYBRID_TOKEN_LEDGER": "HYBRID_TOKEN_LEDGER",
            "Hybrid Token Token Ledger": "Hybrid Token Token Ledger",
            "Select Hybrid Token Token Ledger": "Select Hybrid Token Token Ledger",
            "Print of Hybrid Token Token Ledger": "Print of Hybrid Token Token Ledger",
            "Hybrid Token Ledger ID": "Hybrid Token Ledger ID",
            "HYBRID Ledger ID": "HYBRID Ledger ID",
            "Enter HYBRID Ledger ID": "Enter HYBRID Ledger ID",
            "05 Finance Waterfall Distribution Reporting": "05 Finance Waterfall Distribution Reporting",
            "05 FINANCE WATERFALL DISTRIBUTION REPORTING": "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
            "HYBRID_Distribution_Calculation": "HYBRID_Distribution_Calculation",
            "HYBRID_DISTRIBUTION_CALCULATION": "HYBRID_DISTRIBUTION_CALCULATION",
            "Hybrid Token Distribution Calculation": "Hybrid Token Distribution Calculation",
            "Select Hybrid Token Distribution Calculation": "Select Hybrid Token Distribution Calculation",
            "Print of Hybrid Token Distribution Calculation": "Print of Hybrid Token Distribution Calculation",
            "Hybrid Token Distribution ID": "Hybrid Token Distribution ID",
            "HYBRID Distribution ID": "HYBRID Distribution ID",
            "Enter HYBRID Distribution ID": "Enter HYBRID Distribution ID",
            "HYBRID_Combined_Distribution_Waterfall": "HYBRID_Combined_Distribution_Waterfall",
            "HYBRID_COMBINED_DISTRIBUTION_WATERFALL": "HYBRID_COMBINED_DISTRIBUTION_WATERFALL",
            "Hybrid Combined Distribution Waterfall": "Hybrid Combined Distribution Waterfall",
            "Select Hybrid Combined Distribution Waterfall": "Select Hybrid Combined Distribution Waterfall",
            "Print of Hybrid Combined Distribution Waterfall": "Print of Hybrid Combined Distribution Waterfall",
            "Hybrid Waterfall ID": "Hybrid Waterfall ID",
            "HYBRID Waterfall ID": "HYBRID Waterfall ID",
            "Enter HYBRID Waterfall ID": "Enter HYBRID Waterfall ID",
            "Rental Income Amount USD": "Rental Income Amount USD",
            "Enter Rental Income Amount USD": "Enter Rental Income Amount USD",
            "Revenue Share Amount USD": "Revenue Share Amount USD",
            "Enter Revenue Share Amount USD": "Enter Revenue Share Amount USD",
            "Sale Profit Amount USD": "Sale Profit Amount USD",
            "Enter Sale Profit Amount USD": "Enter Sale Profit Amount USD",
            "Equity Appreciation Amount USD": "Equity Appreciation Amount USD",
            "Enter Equity Appreciation Amount USD": "Enter Equity Appreciation Amount USD",
            "Debt Interest Amount USD": "Debt Interest Amount USD",
            "Enter Debt Interest Amount USD": "Enter Debt Interest Amount USD",
            "Preferred Return Amount USD": "Preferred Return Amount USD",
            "Enter Preferred Return Amount USD": "Enter Preferred Return Amount USD",
            "Common Equity Amount USD": "Common Equity Amount USD",
            "Enter Common Equity Amount USD": "Enter Common Equity Amount USD",
            "Total Distributable Amount USD": "Total Distributable Amount USD",
            "Enter Total Distributable Amount USD": "Enter Total Distributable Amount USD",
            "HYBRID_Escrow_Release_Package": "HYBRID_Escrow_Release_Package",
            "HYBRID_ESCROW_RELEASE_PACKAGE": "HYBRID_ESCROW_RELEASE_PACKAGE",
            "Hybrid Token Escrow Release Package": "Hybrid Token Escrow Release Package",
            "Select Hybrid Token Escrow Release Package": "Select Hybrid Token Escrow Release Package",
            "Print of Hybrid Token Escrow Release Package": "Print of Hybrid Token Escrow Release Package",
            "Hybrid Token Escrow Release Package ID": "Hybrid Token Escrow Release Package ID",
            "HYBRID Escrow Release Package ID": "HYBRID Escrow Release Package ID",
            "Enter HYBRID Escrow Release Package ID": "Enter HYBRID Escrow Release Package ID",
            "HYBRID_Investor_Report": "HYBRID_Investor_Report",
            "HYBRID_INVESTOR_REPORT": "HYBRID_INVESTOR_REPORT",
            "Hybrid Token Investor Report": "Hybrid Token Investor Report",
            "Select Hybrid Token Investor Report": "Select Hybrid Token Investor Report",
            "Print of Hybrid Token Investor Report": "Print of Hybrid Token Investor Report",
            "Hybrid Token Investor Report ID": "Hybrid Token Investor Report ID",
            "HYBRID Investor Report ID": "HYBRID Investor Report ID",
            "Enter HYBRID Investor Report ID": "Enter HYBRID Investor Report ID",
            "06 Asset Manager Lifecycle Exit": "06 Asset Manager Lifecycle Exit",
            "06 ASSET MANAGER LIFECYCLE EXIT": "06 ASSET MANAGER LIFECYCLE EXIT",
            "HYBRID_Lifecycle_Milestone": "HYBRID_Lifecycle_Milestone",
            "HYBRID_LIFECYCLE_MILESTONE": "HYBRID_LIFECYCLE_MILESTONE",
            "Hybrid Token Lifecycle Milestone": "Hybrid Token Lifecycle Milestone",
            "Select Hybrid Token Lifecycle Milestone": "Select Hybrid Token Lifecycle Milestone",
            "Print of Hybrid Token Lifecycle Milestone": "Print of Hybrid Token Lifecycle Milestone",
            "Hybrid Token Milestone ID": "Hybrid Token Milestone ID",
            "HYBRID Milestone ID": "HYBRID Milestone ID",
            "Enter HYBRID Milestone ID": "Enter HYBRID Milestone ID",
            "HYBRID_Exit_Strategy": "HYBRID_Exit_Strategy",
            "HYBRID_EXIT_STRATEGY": "HYBRID_EXIT_STRATEGY",
            "Hybrid Token Exit Strategy": "Hybrid Token Exit Strategy",
            "Select Hybrid Token Exit Strategy": "Select Hybrid Token Exit Strategy",
            "Print of Hybrid Token Exit Strategy": "Print of Hybrid Token Exit Strategy",
            "Hybrid Token Exit Strategy ID": "Hybrid Token Exit Strategy ID",
            "HYBRID Exit Strategy ID": "HYBRID Exit Strategy ID",
            "Enter HYBRID Exit Strategy ID": "Enter HYBRID Exit Strategy ID",
            "01 Sponsor Auction Opportunity Intake": "01 Sponsor Auction Opportunity Intake",
            "01 SPONSOR AUCTION OPPORTUNITY INTAKE": "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
            "PREAUCT_Auction_Opportunity": "PREAUCT_Auction_Opportunity",
            "PREAUCT_AUCTION_OPPORTUNITY": "PREAUCT_AUCTION_OPPORTUNITY",
            "Pre-Auction Auction Opportunity": "Pre-Auction Auction Opportunity",
            "Select Pre-Auction Auction Opportunity": "Select Pre-Auction Auction Opportunity",
            "Print of Pre-Auction Auction Opportunity": "Print of Pre-Auction Auction Opportunity",
            "Pre-Auction Opportunity ID": "Pre-Auction Opportunity ID",
            "PREAUCT Auction Opportunity ID": "PREAUCT Auction Opportunity ID",
            "Enter PREAUCT Auction Opportunity ID": "Enter PREAUCT Auction Opportunity ID",
            "Auction Source": "Auction Source",
            "Enter Auction Source": "Enter Auction Source",
            "Auction Source Link": "Auction Source Link",
            "Enter Auction Source Link": "Enter Auction Source Link",
            "Auction Type": "Auction Type",
            "Enter Auction Type": "Enter Auction Type",
            "Auction Status": "Auction Status",
            "Enter Auction Status": "Enter Auction Status",
            "Auction Date": "Auction Date",
            "Enter Auction Date": "Enter Auction Date",
            "Bid Deadline": "Bid Deadline",
            "Enter Bid Deadline": "Enter Bid Deadline",
            "Opening Bid USD": "Opening Bid USD",
            "Enter Opening Bid USD": "Enter Opening Bid USD",
            "Estimated Value USD": "Estimated Value USD",
            "Enter Estimated Value USD": "Enter Estimated Value USD",
            "Deposit Required USD": "Deposit Required USD",
            "Enter Deposit Required USD": "Enter Deposit Required USD",
            "Opportunity Notes": "Opportunity Notes",
            "Enter Opportunity Notes": "Enter Opportunity Notes",
            "PREAUCT_Auction_Source_Verification": "PREAUCT_Auction_Source_Verification",
            "PREAUCT_AUCTION_SOURCE_VERIFICATION": "PREAUCT_AUCTION_SOURCE_VERIFICATION",
            "Pre-Auction Source Verification": "Pre-Auction Source Verification",
            "Select Pre-Auction Source Verification": "Select Pre-Auction Source Verification",
            "Print of Pre-Auction Source Verification": "Print of Pre-Auction Source Verification",
            "Pre-Auction Source Verification ID": "Pre-Auction Source Verification ID",
            "PREAUCT Source Verification ID": "PREAUCT Source Verification ID",
            "Enter PREAUCT Source Verification ID": "Enter PREAUCT Source Verification ID",
            "Source Verified": "Source Verified",
            "Enter Source Verified": "Enter Source Verified",
            "Source Verification Method": "Source Verification Method",
            "Enter Source Verification Method": "Enter Source Verification Method",
            "Auctioneer Name": "Auctioneer Name",
            "Enter Auctioneer Name": "Enter Auctioneer Name",
            "Auctioneer License Number": "Auctioneer License Number",
            "Enter Auctioneer License Number": "Enter Auctioneer License Number",
            "Auctioneer Contact Email": "Auctioneer Contact Email",
            "Enter Auctioneer Contact Email": "Enter Auctioneer Contact Email",
            "Auctioneer Contact Phone": "Auctioneer Contact Phone",
            "Enter Auctioneer Contact Phone": "Enter Auctioneer Contact Phone",
            "Auction Terms Link": "Auction Terms Link",
            "Enter Auction Terms Link": "Enter Auction Terms Link",
            "Registration Requirement": "Registration Requirement",
            "Enter Registration Requirement": "Enter Registration Requirement",
            "Bid Deposit Requirement": "Bid Deposit Requirement",
            "Enter Bid Deposit Requirement": "Enter Bid Deposit Requirement",
            "Source Verification Status": "Source Verification Status",
            "Enter Source Verification Status": "Enter Source Verification Status",
            "02 Due Diligence Title Risk Max Bid": "02 Due Diligence Title Risk Max Bid",
            "02 DUE DILIGENCE TITLE RISK MAX BID": "02 DUE DILIGENCE TITLE RISK MAX BID",
            "PREAUCT_Pre_Auction_Due_Diligence": "PREAUCT_Pre_Auction_Due_Diligence",
            "PREAUCT_PRE_AUCTION_DUE_DILIGENCE": "PREAUCT_PRE_AUCTION_DUE_DILIGENCE",
            "Pre-Auction Due Diligence": "Pre-Auction Due Diligence",
            "Select Pre-Auction Due Diligence": "Select Pre-Auction Due Diligence",
            "Print of Pre-Auction Due Diligence": "Print of Pre-Auction Due Diligence",
            "Pre-Auction Due Diligence ID": "Pre-Auction Due Diligence ID",
            "PREAUCT DD ID": "PREAUCT DD ID",
            "Enter PREAUCT DD ID": "Enter PREAUCT DD ID",
            "DD Start Date": "DD Start Date",
            "Enter DD Start Date": "Enter DD Start Date",
            "DD Target Completion Date": "DD Target Completion Date",
            "Enter DD Target Completion Date": "Enter DD Target Completion Date",
            "Title Defect Risk": "Title Defect Risk",
            "Enter Title Defect Risk": "Enter Title Defect Risk",
            "Hidden Lien Risk": "Hidden Lien Risk",
            "Enter Hidden Lien Risk": "Enter Hidden Lien Risk",
            "Tax Delinquency Risk": "Tax Delinquency Risk",
            "Enter Tax Delinquency Risk": "Enter Tax Delinquency Risk",
            "Redemption Period Risk": "Redemption Period Risk",
            "Enter Redemption Period Risk": "Enter Redemption Period Risk",
            "Eviction Risk": "Eviction Risk",
            "Enter Eviction Risk": "Enter Eviction Risk",
            "Repair Risk": "Repair Risk",
            "Enter Repair Risk": "Enter Repair Risk",
            "Market Risk Level": "Market Risk Level",
            "Enter Market Risk Level": "Enter Market Risk Level",
            "Legal Counsel Review Status": "Legal Counsel Review Status",
            "Enter Legal Counsel Review Status": "Enter Legal Counsel Review Status",
            "DD Report Link": "DD Report Link",
            "Enter DD Report Link": "Enter DD Report Link",
            "Cleared For Pool": "Cleared For Pool",
            "Enter Cleared For Pool": "Enter Cleared For Pool",
            "PREAUCT_Title_Lien_Precheck": "PREAUCT_Title_Lien_Precheck",
            "PREAUCT_TITLE_LIEN_PRECHECK": "PREAUCT_TITLE_LIEN_PRECHECK",
            "Pre-Auction Title and Lien Precheck": "Pre-Auction Title and Lien Precheck",
            "Select Pre-Auction Title and Lien Precheck": "Select Pre-Auction Title and Lien Precheck",
            "Print of Pre-Auction Title and Lien Precheck": "Print of Pre-Auction Title and Lien Precheck",
            "Pre-Auction Title/Lien Precheck ID": "Pre-Auction Title/Lien Precheck ID",
            "PREAUCT Title Lien Precheck ID": "PREAUCT Title Lien Precheck ID",
            "Enter PREAUCT Title Lien Precheck ID": "Enter PREAUCT Title Lien Precheck ID",
            "Parcel Number": "Parcel Number",
            "Enter Parcel Number": "Enter Parcel Number",
            "Preliminary Title Source": "Preliminary Title Source",
            "Enter Preliminary Title Source": "Enter Preliminary Title Source",
            "Owner of Record": "Owner of Record",
            "Owner Of Record": "Owner Of Record",
            "Enter Owner Of Record": "Enter Owner Of Record",
            "Lien Search Completed": "Lien Search Completed",
            "Enter Lien Search Completed": "Enter Lien Search Completed",
            "Known Lien Count": "Known Lien Count",
            "Enter Known Lien Count": "Enter Known Lien Count",
            "Known Lien Total USD": "Known Lien Total USD",
            "Enter Known Lien Total USD": "Enter Known Lien Total USD",
            "Tax Delinquent Amount USD": "Tax Delinquent Amount USD",
            "Enter Tax Delinquent Amount USD": "Enter Tax Delinquent Amount USD",
            "Title Exception Notes": "Title Exception Notes",
            "Enter Title Exception Notes": "Enter Title Exception Notes",
            "Precheck Report Link": "Precheck Report Link",
            "Enter Precheck Report Link": "Enter Precheck Report Link",
            "Precheck Status": "Precheck Status",
            "Enter Precheck Status": "Enter Precheck Status",
            "PREAUCT_Auction_Risk_Assessment": "PREAUCT_Auction_Risk_Assessment",
            "PREAUCT_AUCTION_RISK_ASSESSMENT": "PREAUCT_AUCTION_RISK_ASSESSMENT",
            "Pre-Auction Risk Assessment": "Pre-Auction Risk Assessment",
            "Select Pre-Auction Risk Assessment": "Select Pre-Auction Risk Assessment",
            "Print of Pre-Auction Risk Assessment": "Print of Pre-Auction Risk Assessment",
            "Pre-Auction Risk Assessment ID": "Pre-Auction Risk Assessment ID",
            "PREAUCT Risk Assessment ID": "PREAUCT Risk Assessment ID",
            "Enter PREAUCT Risk Assessment ID": "Enter PREAUCT Risk Assessment ID",
            "Refund Risk Percentage": "Refund Risk Percentage",
            "Enter Refund Risk Percentage": "Enter Refund Risk Percentage",
            "Redemption Risk Percentage": "Redemption Risk Percentage",
            "Enter Redemption Risk Percentage": "Enter Redemption Risk Percentage",
            "Occupancy Risk Percentage": "Occupancy Risk Percentage",
            "Enter Occupancy Risk Percentage": "Enter Occupancy Risk Percentage",
            "Repair Risk Percentage": "Repair Risk Percentage",
            "Enter Repair Risk Percentage": "Enter Repair Risk Percentage",
            "Risk Assessment Status": "Risk Assessment Status",
            "Enter Risk Assessment Status": "Enter Risk Assessment Status",
            "PREAUCT_Max_Bid_Analysis": "PREAUCT_Max_Bid_Analysis",
            "PREAUCT_MAX_BID_ANALYSIS": "PREAUCT_MAX_BID_ANALYSIS",
            "Pre-Auction Maximum Bid Analysis": "Pre-Auction Maximum Bid Analysis",
            "Select Pre-Auction Maximum Bid Analysis": "Select Pre-Auction Maximum Bid Analysis",
            "Print of Pre-Auction Maximum Bid Analysis": "Print of Pre-Auction Maximum Bid Analysis",
            "Pre-Auction Max Bid Analysis ID": "Pre-Auction Max Bid Analysis ID",
            "PREAUCT Max Bid Analysis ID": "PREAUCT Max Bid Analysis ID",
            "Enter PREAUCT Max Bid Analysis ID": "Enter PREAUCT Max Bid Analysis ID",
            "Estimated As Is Value USD": "Estimated As Is Value USD",
            "Enter Estimated As Is Value USD": "Enter Estimated As Is Value USD",
            "Estimated After Repair Value USD": "Estimated After Repair Value USD",
            "Enter Estimated After Repair Value USD": "Enter Estimated After Repair Value USD",
            "Estimated Repair Cost USD": "Estimated Repair Cost USD",
            "Enter Estimated Repair Cost USD": "Enter Estimated Repair Cost USD",
            "Estimated Closing Cost USD": "Estimated Closing Cost USD",
            "Enter Estimated Closing Cost USD": "Enter Estimated Closing Cost USD",
            "Estimated Carrying Cost USD": "Estimated Carrying Cost USD",
            "Enter Estimated Carrying Cost USD": "Enter Estimated Carrying Cost USD",
            "Required Reserve USD": "Required Reserve USD",
            "Enter Required Reserve USD": "Enter Required Reserve USD",
            "Target Return Percentage": "Target Return Percentage",
            "Enter Target Return Percentage": "Enter Target Return Percentage",
            "Recommended Max Bid USD": "Recommended Max Bid USD",
            "Enter Recommended Max Bid USD": "Enter Recommended Max Bid USD",
            "Authorized Max Bid USD": "Authorized Max Bid USD",
            "Enter Authorized Max Bid USD": "Enter Authorized Max Bid USD",
            "Bid Strategy": "Bid Strategy",
            "Enter Bid Strategy": "Enter Bid Strategy",
            "Analysis Report Link": "Analysis Report Link",
            "Enter Analysis Report Link": "Enter Analysis Report Link",
            "03 Pool Structuring Escrow Compliance": "03 Pool Structuring Escrow Compliance",
            "03 POOL STRUCTURING ESCROW COMPLIANCE": "03 POOL STRUCTURING ESCROW COMPLIANCE",
            "PREAUCT_Pre_Auction_Pool": "PREAUCT_Pre_Auction_Pool",
            "PREAUCT_PRE_AUCTION_POOL": "PREAUCT_PRE_AUCTION_POOL",
            "Pre-Auction Pool": "Pre-Auction Pool",
            "Select Pre-Auction Pool": "Select Pre-Auction Pool",
            "Print of Pre-Auction Pool": "Print of Pre-Auction Pool",
            "Pre-Auction Pool ID": "Pre-Auction Pool ID",
            "PREAUCT Pre Auction Pool ID": "PREAUCT Pre Auction Pool ID",
            "Enter PREAUCT Pre Auction Pool ID": "Enter PREAUCT Pre Auction Pool ID",
            "Pool Name": "Pool Name",
            "Enter Pool Name": "Enter Pool Name",
            "Pool Target Amount USD": "Pool Target Amount USD",
            "Enter Pool Target Amount USD": "Enter Pool Target Amount USD",
            "Pool Max Amount USD": "Pool Max Amount USD",
            "Enter Pool Max Amount USD": "Enter Pool Max Amount USD",
            "Minimum Pledge USD": "Minimum Pledge USD",
            "Enter Minimum Pledge USD": "Enter Minimum Pledge USD",
            "Maximum Pledge USD": "Maximum Pledge USD",
            "Enter Maximum Pledge USD": "Enter Maximum Pledge USD",
            "Investor Funds Held in Escrow": "Investor Funds Held in Escrow",
            "Investor Funds Held In Escrow": "Investor Funds Held In Escrow",
            "Enter Investor Funds Held In Escrow": "Enter Investor Funds Held In Escrow",
            "Refund If Not Won": "Refund If Not Won",
            "Enter Refund If Not Won": "Enter Refund If Not Won",
            "Winning Bid Required For Tokenization": "Winning Bid Required For Tokenization",
            "Enter Winning Bid Required For Tokenization": "Enter Winning Bid Required For Tokenization",
            "Pool Open Date": "Pool Open Date",
            "Enter Pool Open Date": "Enter Pool Open Date",
            "Pool Close Date": "Pool Close Date",
            "Enter Pool Close Date": "Enter Pool Close Date",
            "Pool Status": "Pool Status",
            "Enter Pool Status": "Enter Pool Status",
            "PREAUCT_Pool_Escrow_Setup": "PREAUCT_Pool_Escrow_Setup",
            "PREAUCT_POOL_ESCROW_SETUP": "PREAUCT_POOL_ESCROW_SETUP",
            "Pre-Auction Pool Escrow Setup": "Pre-Auction Pool Escrow Setup",
            "Select Pre-Auction Pool Escrow Setup": "Select Pre-Auction Pool Escrow Setup",
            "Print of Pre-Auction Pool Escrow Setup": "Print of Pre-Auction Pool Escrow Setup",
            "Pre-Auction Pool Escrow ID": "Pre-Auction Pool Escrow ID",
            "PREAUCT Pool Escrow ID": "PREAUCT Pool Escrow ID",
            "Enter PREAUCT Pool Escrow ID": "Enter PREAUCT Pool Escrow ID",
            "Refund Rules": "Refund Rules",
            "Enter Refund Rules": "Enter Refund Rules",
            "Release Conditions": "Release Conditions",
            "Enter Release Conditions": "Enter Release Conditions",
            "PREAUCT_Compliance_Review": "PREAUCT_Compliance_Review",
            "PREAUCT_COMPLIANCE_REVIEW": "PREAUCT_COMPLIANCE_REVIEW",
            "Pre-Auction Compliance Review": "Pre-Auction Compliance Review",
            "Select Pre-Auction Compliance Review": "Select Pre-Auction Compliance Review",
            "Print of Pre-Auction Compliance Review": "Print of Pre-Auction Compliance Review",
            "Pre-Auction Compliance Review ID": "Pre-Auction Compliance Review ID",
            "PREAUCT Compliance Review ID": "PREAUCT Compliance Review ID",
            "Enter PREAUCT Compliance Review ID": "Enter PREAUCT Compliance Review ID",
            "KYC/AML Requirement Confirmed": "KYC/AML Requirement Confirmed",
            "KYC AML Requirement Confirmed": "KYC AML Requirement Confirmed",
            "Enter KYC AML Requirement Confirmed": "Enter KYC AML Requirement Confirmed",
            "Investor Eligibility Rules Confirmed": "Investor Eligibility Rules Confirmed",
            "Enter Investor Eligibility Rules Confirmed": "Enter Investor Eligibility Rules Confirmed",
            "Escrow Compliance Confirmed": "Escrow Compliance Confirmed",
            "Enter Escrow Compliance Confirmed": "Enter Escrow Compliance Confirmed",
            "Disclosure Package Approved": "Disclosure Package Approved",
            "Enter Disclosure Package Approved": "Enter Disclosure Package Approved",
            "Refund Process Approved": "Refund Process Approved",
            "Enter Refund Process Approved": "Enter Refund Process Approved",
            "Marketing Materials Approved": "Marketing Materials Approved",
            "Enter Marketing Materials Approved": "Enter Marketing Materials Approved",
            "Compliance Risk Level": "Compliance Risk Level",
            "Enter Compliance Risk Level": "Enter Compliance Risk Level",
            "Compliance Review Status": "Compliance Review Status",
            "Enter Compliance Review Status": "Enter Compliance Review Status",
            "04 Investor Pledge Escrow Funding": "04 Investor Pledge Escrow Funding",
            "04 INVESTOR PLEDGE ESCROW FUNDING": "04 INVESTOR PLEDGE ESCROW FUNDING",
            "PREAUCT_Investor_Pledge": "PREAUCT_Investor_Pledge",
            "PREAUCT_INVESTOR_PLEDGE": "PREAUCT_INVESTOR_PLEDGE",
            "Pre-Auction Investor Pledge": "Pre-Auction Investor Pledge",
            "Select Pre-Auction Investor Pledge": "Select Pre-Auction Investor Pledge",
            "Print of Pre-Auction Investor Pledge": "Print of Pre-Auction Investor Pledge",
            "Pre-Auction Pledge ID": "Pre-Auction Pledge ID",
            "PREAUCT Pledge ID": "PREAUCT Pledge ID",
            "Enter PREAUCT Pledge ID": "Enter PREAUCT Pledge ID",
            "Pledge Amount USD": "Pledge Amount USD",
            "Enter Pledge Amount USD": "Enter Pledge Amount USD",
            "Refund Status": "Refund Status",
            "Enter Refund Status": "Enter Refund Status",
            "Risk Acknowledged": "Risk Acknowledged",
            "Enter Risk Acknowledged": "Enter Risk Acknowledged",
            "Conditional Nature Acknowledged": "Conditional Nature Acknowledged",
            "Enter Conditional Nature Acknowledged": "Enter Conditional Nature Acknowledged",
            "No Token Until Winning Bid Acknowledged": "No Token Until Winning Bid Acknowledged",
            "Enter No Token Until Winning Bid Acknowledged": "Enter No Token Until Winning Bid Acknowledged",
            "Pledge Status": "Pledge Status",
            "Enter Pledge Status": "Enter Pledge Status",
            "PREAUCT_Investor_Risk_Acknowledgment": "PREAUCT_Investor_Risk_Acknowledgment",
            "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT": "PREAUCT_INVESTOR_RISK_ACKNOWLEDGMENT",
            "Pre-Auction Investor Risk Acknowledgment": "Pre-Auction Investor Risk Acknowledgment",
            "Select Pre-Auction Investor Risk Acknowledgment": "Select Pre-Auction Investor Risk Acknowledgment",
            "Print of Pre-Auction Investor Risk Acknowledgment": "Print of Pre-Auction Investor Risk Acknowledgment",
            "Pre-Auction Risk Acknowledgment ID": "Pre-Auction Risk Acknowledgment ID",
            "PREAUCT Risk Acknowledgment ID": "PREAUCT Risk Acknowledgment ID",
            "Enter PREAUCT Risk Acknowledgment ID": "Enter PREAUCT Risk Acknowledgment ID",
            "Auction Not Won Risk Acknowledged": "Auction Not Won Risk Acknowledged",
            "Enter Auction Not Won Risk Acknowledged": "Enter Auction Not Won Risk Acknowledged",
            "Refund Timing Risk Acknowledged": "Refund Timing Risk Acknowledged",
            "Enter Refund Timing Risk Acknowledged": "Enter Refund Timing Risk Acknowledged",
            "Title Lien Risk Acknowledged": "Title Lien Risk Acknowledged",
            "Enter Title Lien Risk Acknowledged": "Enter Title Lien Risk Acknowledged",
            "Redemption Period Risk Acknowledged": "Redemption Period Risk Acknowledged",
            "Enter Redemption Period Risk Acknowledged": "Enter Redemption Period Risk Acknowledged",
            "Occupancy/Eviction Risk Acknowledged": "Occupancy/Eviction Risk Acknowledged",
            "Occupancy Eviction Risk Acknowledged": "Occupancy Eviction Risk Acknowledged",
            "Enter Occupancy Eviction Risk Acknowledged": "Enter Occupancy Eviction Risk Acknowledged",
            "Repair Cost Risk Acknowledged": "Repair Cost Risk Acknowledged",
            "Enter Repair Cost Risk Acknowledged": "Enter Repair Cost Risk Acknowledged",
            "No Guaranteed Tokenization Acknowledged": "No Guaranteed Tokenization Acknowledged",
            "Enter No Guaranteed Tokenization Acknowledged": "Enter No Guaranteed Tokenization Acknowledged",
            "05 Bid Authorization Submission Result": "05 Bid Authorization Submission Result",
            "05 BID AUTHORIZATION SUBMISSION RESULT": "05 BID AUTHORIZATION SUBMISSION RESULT",
            "PREAUCT_Bid_Authorization": "PREAUCT_Bid_Authorization",
            "PREAUCT_BID_AUTHORIZATION": "PREAUCT_BID_AUTHORIZATION",
            "Pre-Auction Bid Authorization": "Pre-Auction Bid Authorization",
            "Select Pre-Auction Bid Authorization": "Select Pre-Auction Bid Authorization",
            "Print of Pre-Auction Bid Authorization": "Print of Pre-Auction Bid Authorization",
            "Pre-Auction Bid Authorization ID": "Pre-Auction Bid Authorization ID",
            "PREAUCT Bid Authorization ID": "PREAUCT Bid Authorization ID",
            "Enter PREAUCT Bid Authorization ID": "Enter PREAUCT Bid Authorization ID",
            "Bidder Name": "Bidder Name",
            "Enter Bidder Name": "Enter Bidder Name",
            "Bidder Entity ID": "Bidder Entity ID",
            "Enter Bidder Entity ID": "Enter Bidder Entity ID",
            "Bid Deposit Confirmed": "Bid Deposit Confirmed",
            "Enter Bid Deposit Confirmed": "Enter Bid Deposit Confirmed",
            "Bid Deposit Amount USD": "Bid Deposit Amount USD",
            "Enter Bid Deposit Amount USD": "Enter Bid Deposit Amount USD",
            "Authorization Document Link": "Authorization Document Link",
            "Enter Authorization Document Link": "Enter Authorization Document Link",
            "Bid Authorization Status": "Bid Authorization Status",
            "Enter Bid Authorization Status": "Enter Bid Authorization Status",
            "PREAUCT_Auction_Bid_Submission": "PREAUCT_Auction_Bid_Submission",
            "PREAUCT_AUCTION_BID_SUBMISSION": "PREAUCT_AUCTION_BID_SUBMISSION",
            "Pre-Auction Bid Submission": "Pre-Auction Bid Submission",
            "Select Pre-Auction Bid Submission": "Select Pre-Auction Bid Submission",
            "Print of Pre-Auction Bid Submission": "Print of Pre-Auction Bid Submission",
            "Pre-Auction Bid Submission ID": "Pre-Auction Bid Submission ID",
            "PREAUCT Bid Submission ID": "PREAUCT Bid Submission ID",
            "Enter PREAUCT Bid Submission ID": "Enter PREAUCT Bid Submission ID",
            "Bid Submitted USD": "Bid Submitted USD",
            "Enter Bid Submitted USD": "Enter Bid Submitted USD",
            "Bid Submission DateTime": "Bid Submission DateTime",
            "Enter Bid Submission DateTime": "Enter Bid Submission DateTime",
            "Bid Submitted By": "Bid Submitted By",
            "Enter Bid Submitted By": "Enter Bid Submitted By",
            "Bid Confirmation Number": "Bid Confirmation Number",
            "Enter Bid Confirmation Number": "Enter Bid Confirmation Number",
            "Bid Confirmation Link": "Bid Confirmation Link",
            "Enter Bid Confirmation Link": "Enter Bid Confirmation Link",
            "Bid Submission Status": "Bid Submission Status",
            "Enter Bid Submission Status": "Enter Bid Submission Status",
            "PREAUCT_Auction_Result": "PREAUCT_Auction_Result",
            "PREAUCT_AUCTION_RESULT": "PREAUCT_AUCTION_RESULT",
            "Pre-Auction Auction Result": "Pre-Auction Auction Result",
            "Select Pre-Auction Auction Result": "Select Pre-Auction Auction Result",
            "Print of Pre-Auction Auction Result": "Print of Pre-Auction Auction Result",
            "Pre-Auction Auction Result ID": "Pre-Auction Auction Result ID",
            "PREAUCT Auction Result ID": "PREAUCT Auction Result ID",
            "Enter PREAUCT Auction Result ID": "Enter PREAUCT Auction Result ID",
            "Winning Bid USD": "Winning Bid USD",
            "Enter Winning Bid USD": "Enter Winning Bid USD",
            "Won Auction": "Won Auction",
            "Enter Won Auction": "Enter Won Auction",
            "Result Date": "Result Date",
            "Enter Result Date": "Enter Result Date",
            "Auction Result Document Link": "Auction Result Document Link",
            "Enter Auction Result Document Link": "Enter Auction Result Document Link",
            "Next Action": "Next Action",
            "Enter Next Action": "Enter Next Action",
            "Result Status": "Result Status",
            "Enter Result Status": "Enter Result Status",
            "06 Refund Transition Reporting Closeout": "06 Refund Transition Reporting Closeout",
            "06 REFUND TRANSITION REPORTING CLOSEOUT": "06 REFUND TRANSITION REPORTING CLOSEOUT",
            "PREAUCT_Refund_Process": "PREAUCT_Refund_Process",
            "PREAUCT_REFUND_PROCESS": "PREAUCT_REFUND_PROCESS",
            "Pre-Auction Refund Process": "Pre-Auction Refund Process",
            "Select Pre-Auction Refund Process": "Select Pre-Auction Refund Process",
            "Print of Pre-Auction Refund Process": "Print of Pre-Auction Refund Process",
            "Pre-Auction Refund ID": "Pre-Auction Refund ID",
            "PREAUCT Refund ID": "PREAUCT Refund ID",
            "Enter PREAUCT Refund ID": "Enter PREAUCT Refund ID",
            "Refund Reason": "Refund Reason",
            "Enter Refund Reason": "Enter Refund Reason",
            "Refund Amount USD": "Refund Amount USD",
            "Enter Refund Amount USD": "Enter Refund Amount USD",
            "Refund Method": "Refund Method",
            "Enter Refund Method": "Enter Refund Method",
            "Refund Date": "Refund Date",
            "Enter Refund Date": "Enter Refund Date",
            "Refund Reference": "Refund Reference",
            "Enter Refund Reference": "Enter Refund Reference",
            "PREAUCT_Winning_Bid_Transition": "PREAUCT_Winning_Bid_Transition",
            "PREAUCT_WINNING_BID_TRANSITION": "PREAUCT_WINNING_BID_TRANSITION",
            "Pre-Auction Winning Bid Transition": "Pre-Auction Winning Bid Transition",
            "Select Pre-Auction Winning Bid Transition": "Select Pre-Auction Winning Bid Transition",
            "Print of Pre-Auction Winning Bid Transition": "Print of Pre-Auction Winning Bid Transition",
            "Pre-Auction Winning Bid Transition ID": "Pre-Auction Winning Bid Transition ID",
            "PREAUCT Winning Bid Transition ID": "PREAUCT Winning Bid Transition ID",
            "Enter PREAUCT Winning Bid Transition ID": "Enter PREAUCT Winning Bid Transition ID",
            "Transition Target": "Transition Target",
            "Enter Transition Target": "Enter Transition Target",
            "Post-Auction Record Created": "Post-Auction Record Created",
            "Post Auction Record Created": "Post Auction Record Created",
            "Enter Post Auction Record Created": "Enter Post Auction Record Created",
            "POSTAUCT Post Auction Tokenization ID": "POSTAUCT Post Auction Tokenization ID",
            "Enter POSTAUCT Post Auction Tokenization ID": "Enter POSTAUCT Post Auction Tokenization ID",
            "Acquisition Process Started": "Acquisition Process Started",
            "Enter Acquisition Process Started": "Enter Acquisition Process Started",
            "Escrow Funds Transfer Required": "Escrow Funds Transfer Required",
            "Enter Escrow Funds Transfer Required": "Enter Escrow Funds Transfer Required",
            "Escrow Funds Transferred USD": "Escrow Funds Transferred USD",
            "Enter Escrow Funds Transferred USD": "Enter Escrow Funds Transferred USD",
            "Investor Notice Sent": "Investor Notice Sent",
            "Enter Investor Notice Sent": "Enter Investor Notice Sent",
            "Transition Status": "Transition Status",
            "Enter Transition Status": "Enter Transition Status",
            "PREAUCT_Investor_Update_Report": "PREAUCT_Investor_Update_Report",
            "PREAUCT_INVESTOR_UPDATE_REPORT": "PREAUCT_INVESTOR_UPDATE_REPORT",
            "Pre-Auction Investor Update Report": "Pre-Auction Investor Update Report",
            "Select Pre-Auction Investor Update Report": "Select Pre-Auction Investor Update Report",
            "Print of Pre-Auction Investor Update Report": "Print of Pre-Auction Investor Update Report",
            "Pre-Auction Investor Update ID": "Pre-Auction Investor Update ID",
            "PREAUCT Investor Update ID": "PREAUCT Investor Update ID",
            "Enter PREAUCT Investor Update ID": "Enter PREAUCT Investor Update ID",
            "Amount Pledged USD": "Amount Pledged USD",
            "Enter Amount Pledged USD": "Enter Amount Pledged USD",
            "Investor Count": "Investor Count",
            "Enter Investor Count": "Enter Investor Count",
            "Auction Status Update": "Auction Status Update",
            "Enter Auction Status Update": "Enter Auction Status Update",
            "Risk Update": "Risk Update",
            "Enter Risk Update": "Enter Risk Update",
            "Next Milestone": "Next Milestone",
            "Enter Next Milestone": "Enter Next Milestone",
            "Investor Report Link": "Investor Report Link",
            "Enter Investor Report Link": "Enter Investor Report Link",
            "PREAUCT_Final_Pool_Closeout": "PREAUCT_Final_Pool_Closeout",
            "PREAUCT_FINAL_POOL_CLOSEOUT": "PREAUCT_FINAL_POOL_CLOSEOUT",
            "Pre-Auction Final Pool Closeout": "Pre-Auction Final Pool Closeout",
            "Select Pre-Auction Final Pool Closeout": "Select Pre-Auction Final Pool Closeout",
            "Print of Pre-Auction Final Pool Closeout": "Print of Pre-Auction Final Pool Closeout",
            "Pre-Auction Final Closeout ID": "Pre-Auction Final Closeout ID",
            "PREAUCT Final Closeout ID": "PREAUCT Final Closeout ID",
            "Enter PREAUCT Final Closeout ID": "Enter PREAUCT Final Closeout ID",
            "Total Pledged USD": "Total Pledged USD",
            "Enter Total Pledged USD": "Enter Total Pledged USD",
            "Total Collected USD": "Total Collected USD",
            "Enter Total Collected USD": "Enter Total Collected USD",
            "Total Refunded USD": "Total Refunded USD",
            "Enter Total Refunded USD": "Enter Total Refunded USD",
            "Total Transferred To Post Auction USD": "Total Transferred To Post Auction USD",
            "Enter Total Transferred To Post Auction USD": "Enter Total Transferred To Post Auction USD",
            "Refund Exception Count": "Refund Exception Count",
            "Enter Refund Exception Count": "Enter Refund Exception Count",
            "Closeout Report Link": "Closeout Report Link",
            "Enter Closeout Report Link": "Enter Closeout Report Link",
            "Closeout Status": "Closeout Status",
            "Enter Closeout Status": "Enter Closeout Status",
            "01 Sponsor Auction Result Intake Closing": "01 Sponsor Auction Result Intake Closing",
            "01 SPONSOR AUCTION RESULT INTAKE CLOSING": "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
            "POSTAUCT_Auction_Result_Intake": "POSTAUCT_Auction_Result_Intake",
            "POSTAUCT_AUCTION_RESULT_INTAKE": "POSTAUCT_AUCTION_RESULT_INTAKE",
            "Post-Auction Result Intake": "Post-Auction Result Intake",
            "Select Post-Auction Result Intake": "Select Post-Auction Result Intake",
            "Print of Post-Auction Result Intake": "Print of Post-Auction Result Intake",
            "Post-Auction Result Intake ID": "Post-Auction Result Intake ID",
            "POSTAUCT Result Intake ID": "POSTAUCT Result Intake ID",
            "Enter POSTAUCT Result Intake ID": "Enter POSTAUCT Result Intake ID",
            "Auction Opportunity ID": "Auction Opportunity ID",
            "Enter Auction Opportunity ID": "Enter Auction Opportunity ID",
            "Auction Result Date": "Auction Result Date",
            "Enter Auction Result Date": "Enter Auction Result Date",
            "Winning Bidder Name": "Winning Bidder Name",
            "Enter Winning Bidder Name": "Enter Winning Bidder Name",
            "Result Verified": "Result Verified",
            "Enter Result Verified": "Enter Result Verified",
            "Intake Status": "Intake Status",
            "Enter Intake Status": "Enter Intake Status",
            "POSTAUCT_Acquisition_Closing": "POSTAUCT_Acquisition_Closing",
            "POSTAUCT_ACQUISITION_CLOSING": "POSTAUCT_ACQUISITION_CLOSING",
            "Post-Auction Acquisition Closing": "Post-Auction Acquisition Closing",
            "Select Post-Auction Acquisition Closing": "Select Post-Auction Acquisition Closing",
            "Print of Post-Auction Acquisition Closing": "Print of Post-Auction Acquisition Closing",
            "Post-Auction Acquisition Closing ID": "Post-Auction Acquisition Closing ID",
            "POSTAUCT Acquisition Closing ID": "POSTAUCT Acquisition Closing ID",
            "Enter POSTAUCT Acquisition Closing ID": "Enter POSTAUCT Acquisition Closing ID",
            "Total Acquisition Cost USD": "Total Acquisition Cost USD",
            "Enter Total Acquisition Cost USD": "Enter Total Acquisition Cost USD",
            "Acquisition Date": "Acquisition Date",
            "Enter Acquisition Date": "Enter Acquisition Date",
            "Closing Statement Link": "Closing Statement Link",
            "Enter Closing Statement Link": "Enter Closing Statement Link",
            "Closing Status": "Closing Status",
            "Enter Closing Status": "Enter Closing Status",
            "02 Legal Title Lien Redemption Clearance": "02 Legal Title Lien Redemption Clearance",
            "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE": "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
            "POSTAUCT_Post_Auction_Title_Cure": "POSTAUCT_Post_Auction_Title_Cure",
            "POSTAUCT_POST_AUCTION_TITLE_CURE": "POSTAUCT_POST_AUCTION_TITLE_CURE",
            "Post-Auction Title Cure": "Post-Auction Title Cure",
            "Select Post-Auction Title Cure": "Select Post-Auction Title Cure",
            "Print of Post-Auction Title Cure": "Print of Post-Auction Title Cure",
            "Post-Auction Title Cure ID": "Post-Auction Title Cure ID",
            "POSTAUCT Title Cure ID": "POSTAUCT Title Cure ID",
            "Enter POSTAUCT Title Cure ID": "Enter POSTAUCT Title Cure ID",
            "Title Issue Type": "Title Issue Type",
            "Enter Title Issue Type": "Enter Title Issue Type",
            "Issue Description": "Issue Description",
            "Enter Issue Description": "Enter Issue Description",
            "Estimated Cure Cost USD": "Estimated Cure Cost USD",
            "Enter Estimated Cure Cost USD": "Enter Estimated Cure Cost USD",
            "Actual Cure Cost USD": "Actual Cure Cost USD",
            "Enter Actual Cure Cost USD": "Enter Actual Cure Cost USD",
            "Cure Completion Date": "Cure Completion Date",
            "Enter Cure Completion Date": "Enter Cure Completion Date",
            "Cure Document Link": "Cure Document Link",
            "Enter Cure Document Link": "Enter Cure Document Link",
            "Cure Status": "Cure Status",
            "Enter Cure Status": "Enter Cure Status",
            "POSTAUCT_Lien_Tax_Clearance": "POSTAUCT_Lien_Tax_Clearance",
            "POSTAUCT_LIEN_TAX_CLEARANCE": "POSTAUCT_LIEN_TAX_CLEARANCE",
            "Post-Auction Lien and Tax Clearance": "Post-Auction Lien and Tax Clearance",
            "Select Post-Auction Lien and Tax Clearance": "Select Post-Auction Lien and Tax Clearance",
            "Print of Post-Auction Lien and Tax Clearance": "Print of Post-Auction Lien and Tax Clearance",
            "Post-Auction Lien/Tax Clearance ID": "Post-Auction Lien/Tax Clearance ID",
            "POSTAUCT Lien Tax Clearance ID": "POSTAUCT Lien Tax Clearance ID",
            "Enter POSTAUCT Lien Tax Clearance ID": "Enter POSTAUCT Lien Tax Clearance ID",
            "Lien Clearance Status": "Lien Clearance Status",
            "Enter Lien Clearance Status": "Enter Lien Clearance Status",
            "Tax Clearance Status": "Tax Clearance Status",
            "Enter Tax Clearance Status": "Enter Tax Clearance Status",
            "Clearance Document Link": "Clearance Document Link",
            "Enter Clearance Document Link": "Enter Clearance Document Link",
            "Final Clearance Status": "Final Clearance Status",
            "Enter Final Clearance Status": "Enter Final Clearance Status",
            "POSTAUCT_Redemption_Period_Review": "POSTAUCT_Redemption_Period_Review",
            "POSTAUCT_REDEMPTION_PERIOD_REVIEW": "POSTAUCT_REDEMPTION_PERIOD_REVIEW",
            "Post-Auction Redemption Period Review": "Post-Auction Redemption Period Review",
            "Select Post-Auction Redemption Period Review": "Select Post-Auction Redemption Period Review",
            "Print of Post-Auction Redemption Period Review": "Print of Post-Auction Redemption Period Review",
            "Post-Auction Redemption Review ID": "Post-Auction Redemption Review ID",
            "POSTAUCT Redemption Review ID": "POSTAUCT Redemption Review ID",
            "Enter POSTAUCT Redemption Review ID": "Enter POSTAUCT Redemption Review ID",
            "Redemption Period Applies": "Redemption Period Applies",
            "Enter Redemption Period Applies": "Enter Redemption Period Applies",
            "Redemption Start Date": "Redemption Start Date",
            "Enter Redemption Start Date": "Enter Redemption Start Date",
            "Redemption End Date": "Redemption End Date",
            "Enter Redemption End Date": "Enter Redemption End Date",
            "Redemption Amount USD": "Redemption Amount USD",
            "Enter Redemption Amount USD": "Enter Redemption Amount USD",
            "Review Document Link": "Review Document Link",
            "Enter Review Document Link": "Enter Review Document Link",
            "Redemption Review Status": "Redemption Review Status",
            "Enter Redemption Review Status": "Enter Redemption Review Status",
            "03 Property Control Condition Rehab Appraisal": "03 Property Control Condition Rehab Appraisal",
            "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL": "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
            "POSTAUCT_Occupancy_Eviction_Status": "POSTAUCT_Occupancy_Eviction_Status",
            "POSTAUCT_OCCUPANCY_EVICTION_STATUS": "POSTAUCT_OCCUPANCY_EVICTION_STATUS",
            "Post-Auction Occupancy and Eviction Status": "Post-Auction Occupancy and Eviction Status",
            "Select Post-Auction Occupancy and Eviction Status": "Select Post-Auction Occupancy and Eviction Status",
            "Print of Post-Auction Occupancy and Eviction Status": "Print of Post-Auction Occupancy and Eviction Status",
            "Post-Auction Occupancy/Eviction ID": "Post-Auction Occupancy/Eviction ID",
            "POSTAUCT Occupancy Eviction ID": "POSTAUCT Occupancy Eviction ID",
            "Enter POSTAUCT Occupancy Eviction ID": "Enter POSTAUCT Occupancy Eviction ID",
            "Occupancy Status": "Occupancy Status",
            "Enter Occupancy Status": "Enter Occupancy Status",
            "Tenant or Occupant Type": "Tenant or Occupant Type",
            "Tenant Or Occupant Type": "Tenant Or Occupant Type",
            "Enter Tenant Or Occupant Type": "Enter Tenant Or Occupant Type",
            "Legal Possession Confirmed": "Legal Possession Confirmed",
            "Enter Legal Possession Confirmed": "Enter Legal Possession Confirmed",
            "Eviction Required": "Eviction Required",
            "Enter Eviction Required": "Enter Eviction Required",
            "Estimated Eviction Cost USD": "Estimated Eviction Cost USD",
            "Enter Estimated Eviction Cost USD": "Enter Estimated Eviction Cost USD",
            "Estimated Eviction Timeline Days": "Estimated Eviction Timeline Days",
            "Enter Estimated Eviction Timeline Days": "Enter Estimated Eviction Timeline Days",
            "Eviction Counsel ID": "Eviction Counsel ID",
            "Enter Eviction Counsel ID": "Enter Eviction Counsel ID",
            "Occupancy Report Link": "Occupancy Report Link",
            "Enter Occupancy Report Link": "Enter Occupancy Report Link",
            "Occupancy Clearance Status": "Occupancy Clearance Status",
            "Enter Occupancy Clearance Status": "Enter Occupancy Clearance Status",
            "POSTAUCT_Property_Condition_Assessment": "POSTAUCT_Property_Condition_Assessment",
            "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT": "POSTAUCT_PROPERTY_CONDITION_ASSESSMENT",
            "Post-Auction Property Condition Assessment": "Post-Auction Property Condition Assessment",
            "Select Post-Auction Property Condition Assessment": "Select Post-Auction Property Condition Assessment",
            "Print of Post-Auction Property Condition Assessment": "Print of Post-Auction Property Condition Assessment",
            "Post-Auction Condition Assessment ID": "Post-Auction Condition Assessment ID",
            "POSTAUCT Condition Assessment ID": "POSTAUCT Condition Assessment ID",
            "Enter POSTAUCT Condition Assessment ID": "Enter POSTAUCT Condition Assessment ID",
            "Property Condition Rating": "Property Condition Rating",
            "Enter Property Condition Rating": "Enter Property Condition Rating",
            "Immediate Safety Issues": "Immediate Safety Issues",
            "Enter Immediate Safety Issues": "Enter Immediate Safety Issues",
            "Deferred Maintenance USD": "Deferred Maintenance USD",
            "Enter Deferred Maintenance USD": "Enter Deferred Maintenance USD",
            "Condition Report Link": "Condition Report Link",
            "Enter Condition Report Link": "Enter Condition Report Link",
            "Assessment Status": "Assessment Status",
            "Enter Assessment Status": "Enter Assessment Status",
            "POSTAUCT_Rehab_Budget": "POSTAUCT_Rehab_Budget",
            "POSTAUCT_REHAB_BUDGET": "POSTAUCT_REHAB_BUDGET",
            "Post-Auction Rehab Budget": "Post-Auction Rehab Budget",
            "Select Post-Auction Rehab Budget": "Select Post-Auction Rehab Budget",
            "Print of Post-Auction Rehab Budget": "Print of Post-Auction Rehab Budget",
            "Post-Auction Rehab Budget ID": "Post-Auction Rehab Budget ID",
            "POSTAUCT Rehab Budget ID": "POSTAUCT Rehab Budget ID",
            "Enter POSTAUCT Rehab Budget ID": "Enter POSTAUCT Rehab Budget ID",
            "Contractor ID": "Contractor ID",
            "Enter Contractor ID": "Enter Contractor ID",
            "Rehab Scope": "Rehab Scope",
            "Enter Rehab Scope": "Enter Rehab Scope",
            "Estimated Rehab Cost USD": "Estimated Rehab Cost USD",
            "Enter Estimated Rehab Cost USD": "Enter Estimated Rehab Cost USD",
            "Contingency USD": "Contingency USD",
            "Enter Contingency USD": "Enter Contingency USD",
            "Total Rehab Budget USD": "Total Rehab Budget USD",
            "Enter Total Rehab Budget USD": "Enter Total Rehab Budget USD",
            "Expected Start Date": "Expected Start Date",
            "Enter Expected Start Date": "Enter Expected Start Date",
            "Expected Completion Date": "Expected Completion Date",
            "Enter Expected Completion Date": "Enter Expected Completion Date",
            "Rehab Plan Link": "Rehab Plan Link",
            "Enter Rehab Plan Link": "Enter Rehab Plan Link",
            "Budget Status": "Budget Status",
            "Enter Budget Status": "Enter Budget Status",
            "POSTAUCT_Post_Auction_Appraisal": "POSTAUCT_Post_Auction_Appraisal",
            "POSTAUCT_POST_AUCTION_APPRAISAL": "POSTAUCT_POST_AUCTION_APPRAISAL",
            "Post-Auction Appraisal": "Post-Auction Appraisal",
            "Select Post-Auction Appraisal": "Select Post-Auction Appraisal",
            "Print of Post-Auction Appraisal": "Print of Post-Auction Appraisal",
            "Post-Auction Appraisal ID": "Post-Auction Appraisal ID",
            "POSTAUCT Appraisal ID": "POSTAUCT Appraisal ID",
            "Enter POSTAUCT Appraisal ID": "Enter POSTAUCT Appraisal ID",
            "As-Is Value USD": "As-Is Value USD",
            "As Is Value USD": "As Is Value USD",
            "Enter As Is Value USD": "Enter As Is Value USD",
            "After Repair Value USD": "After Repair Value USD",
            "Enter After Repair Value USD": "Enter After Repair Value USD",
            "Stabilized Value USD": "Stabilized Value USD",
            "Enter Stabilized Value USD": "Enter Stabilized Value USD",
            "Appraisal Report Link": "Appraisal Report Link",
            "Enter Appraisal Report Link": "Enter Appraisal Report Link",
            "04 SPV Transfer Readiness Risk": "04 SPV Transfer Readiness Risk",
            "04 SPV TRANSFER READINESS RISK": "04 SPV TRANSFER READINESS RISK",
            "POSTAUCT_SPV_Asset_Transfer": "POSTAUCT_SPV_Asset_Transfer",
            "POSTAUCT_SPV_ASSET_TRANSFER": "POSTAUCT_SPV_ASSET_TRANSFER",
            "Post-Auction SPV Asset Transfer": "Post-Auction SPV Asset Transfer",
            "Select Post-Auction SPV Asset Transfer": "Select Post-Auction SPV Asset Transfer",
            "Print of Post-Auction SPV Asset Transfer": "Print of Post-Auction SPV Asset Transfer",
            "Post-Auction SPV Asset Transfer ID": "Post-Auction SPV Asset Transfer ID",
            "POSTAUCT SPV Asset Transfer ID": "POSTAUCT SPV Asset Transfer ID",
            "Enter POSTAUCT SPV Asset Transfer ID": "Enter POSTAUCT SPV Asset Transfer ID",
            "Transferor Name": "Transferor Name",
            "Enter Transferor Name": "Enter Transferor Name",
            "Transferee Name": "Transferee Name",
            "Enter Transferee Name": "Enter Transferee Name",
            "Transfer Date": "Transfer Date",
            "Enter Transfer Date": "Enter Transfer Date",
            "Recorded Deed Link": "Recorded Deed Link",
            "Enter Recorded Deed Link": "Enter Recorded Deed Link",
            "Title Insurance Status": "Title Insurance Status",
            "Enter Title Insurance Status": "Enter Title Insurance Status",
            "Transfer Status": "Transfer Status",
            "Enter Transfer Status": "Enter Transfer Status",
            "POSTAUCT_Tokenization_Readiness_Checklist": "POSTAUCT_Tokenization_Readiness_Checklist",
            "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST": "POSTAUCT_TOKENIZATION_READINESS_CHECKLIST",
            "Post-Auction Tokenization Readiness Checklist": "Post-Auction Tokenization Readiness Checklist",
            "Select Post-Auction Tokenization Readiness Checklist": "Select Post-Auction Tokenization Readiness Checklist",
            "Print of Post-Auction Tokenization Readiness Checklist": "Print of Post-Auction Tokenization Readiness Checklist",
            "Post-Auction Readiness Checklist ID": "Post-Auction Readiness Checklist ID",
            "POSTAUCT Readiness Checklist ID": "POSTAUCT Readiness Checklist ID",
            "Enter POSTAUCT Readiness Checklist ID": "Enter POSTAUCT Readiness Checklist ID",
            "Title Cleared": "Title Cleared",
            "Enter Title Cleared": "Enter Title Cleared",
            "Liens Cleared": "Liens Cleared",
            "Enter Liens Cleared": "Enter Liens Cleared",
            "Tax Clearance Confirmed": "Tax Clearance Confirmed",
            "Enter Tax Clearance Confirmed": "Enter Tax Clearance Confirmed",
            "Redemption Reviewed": "Redemption Reviewed",
            "Enter Redemption Reviewed": "Enter Redemption Reviewed",
            "Occupancy Cleared": "Occupancy Cleared",
            "Enter Occupancy Cleared": "Enter Occupancy Cleared",
            "Condition Assessment Complete": "Condition Assessment Complete",
            "Enter Condition Assessment Complete": "Enter Condition Assessment Complete",
            "Appraisal Approved": "Appraisal Approved",
            "Enter Appraisal Approved": "Enter Appraisal Approved",
            "Risk Score Approved": "Risk Score Approved",
            "Enter Risk Score Approved": "Enter Risk Score Approved",
            "Investor Disclosure Ready": "Investor Disclosure Ready",
            "Enter Investor Disclosure Ready": "Enter Investor Disclosure Ready",
            "Ready To Tokenize": "Ready To Tokenize",
            "Enter Ready To Tokenize": "Enter Ready To Tokenize",
            "POSTAUCT_Post_Auction_Risk_Score": "POSTAUCT_Post_Auction_Risk_Score",
            "POSTAUCT_POST_AUCTION_RISK_SCORE": "POSTAUCT_POST_AUCTION_RISK_SCORE",
            "Post-Auction Risk Score": "Post-Auction Risk Score",
            "Select Post-Auction Risk Score": "Select Post-Auction Risk Score",
            "Print of Post-Auction Risk Score": "Print of Post-Auction Risk Score",
            "Post-Auction Risk Score ID": "Post-Auction Risk Score ID",
            "POSTAUCT Risk Score ID": "POSTAUCT Risk Score ID",
            "Enter POSTAUCT Risk Score ID": "Enter POSTAUCT Risk Score ID",
            "05 Offering Disclosure Compliance Approval": "05 Offering Disclosure Compliance Approval",
            "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL": "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
            "POSTAUCT_Offering_Readiness": "POSTAUCT_Offering_Readiness",
            "POSTAUCT_OFFERING_READINESS": "POSTAUCT_OFFERING_READINESS",
            "Post-Auction Offering Readiness": "Post-Auction Offering Readiness",
            "Select Post-Auction Offering Readiness": "Select Post-Auction Offering Readiness",
            "Print of Post-Auction Offering Readiness": "Print of Post-Auction Offering Readiness",
            "Post-Auction Offering Readiness ID": "Post-Auction Offering Readiness ID",
            "POSTAUCT Offering Readiness ID": "POSTAUCT Offering Readiness ID",
            "Enter POSTAUCT Offering Readiness ID": "Enter POSTAUCT Offering Readiness ID",
            "POSTAUCT_Investor_Disclosure_Package": "POSTAUCT_Investor_Disclosure_Package",
            "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE": "POSTAUCT_INVESTOR_DISCLOSURE_PACKAGE",
            "Post-Auction Investor Disclosure Package": "Post-Auction Investor Disclosure Package",
            "Select Post-Auction Investor Disclosure Package": "Select Post-Auction Investor Disclosure Package",
            "Print of Post-Auction Investor Disclosure Package": "Print of Post-Auction Investor Disclosure Package",
            "Post-Auction Disclosure Package ID": "Post-Auction Disclosure Package ID",
            "POSTAUCT Disclosure Package ID": "POSTAUCT Disclosure Package ID",
            "Enter POSTAUCT Disclosure Package ID": "Enter POSTAUCT Disclosure Package ID",
            "Auction Result Disclosure Link": "Auction Result Disclosure Link",
            "Enter Auction Result Disclosure Link": "Enter Auction Result Disclosure Link",
            "Title Risk Disclosure Link": "Title Risk Disclosure Link",
            "Enter Title Risk Disclosure Link": "Enter Title Risk Disclosure Link",
            "Redemption Risk Disclosure Link": "Redemption Risk Disclosure Link",
            "Enter Redemption Risk Disclosure Link": "Enter Redemption Risk Disclosure Link",
            "Occupancy Risk Disclosure Link": "Occupancy Risk Disclosure Link",
            "Enter Occupancy Risk Disclosure Link": "Enter Occupancy Risk Disclosure Link",
            "Repair Risk Disclosure Link": "Repair Risk Disclosure Link",
            "Enter Repair Risk Disclosure Link": "Enter Repair Risk Disclosure Link",
            "Offering Document Link": "Offering Document Link",
            "Enter Offering Document Link": "Enter Offering Document Link",
            "Disclosure Approval Status": "Disclosure Approval Status",
            "Enter Disclosure Approval Status": "Enter Disclosure Approval Status",
            "POSTAUCT_Final_Tokenization_Approval": "POSTAUCT_Final_Tokenization_Approval",
            "POSTAUCT_FINAL_TOKENIZATION_APPROVAL": "POSTAUCT_FINAL_TOKENIZATION_APPROVAL",
            "Post-Auction Final Tokenization Approval": "Post-Auction Final Tokenization Approval",
            "Select Post-Auction Final Tokenization Approval": "Select Post-Auction Final Tokenization Approval",
            "Print of Post-Auction Final Tokenization Approval": "Print of Post-Auction Final Tokenization Approval",
            "Post-Auction Final Tokenization Approval ID": "Post-Auction Final Tokenization Approval ID",
            "POSTAUCT Final Tokenization Approval ID": "POSTAUCT Final Tokenization Approval ID",
            "Enter POSTAUCT Final Tokenization Approval ID": "Enter POSTAUCT Final Tokenization Approval ID",
            "Readiness Checklist ID": "Readiness Checklist ID",
            "Enter Readiness Checklist ID": "Enter Readiness Checklist ID",
            "Legal Approved": "Legal Approved",
            "Enter Legal Approved": "Enter Legal Approved",
            "Compliance Approved": "Compliance Approved",
            "Enter Compliance Approved": "Enter Compliance Approved",
            "Risk Approved": "Risk Approved",
            "Enter Risk Approved": "Enter Risk Approved",
            "Escrow Approved": "Escrow Approved",
            "Enter Escrow Approved": "Enter Escrow Approved",
            "Disclosure Approved": "Disclosure Approved",
            "Enter Disclosure Approved": "Enter Disclosure Approved",
            "Token Issuance Approved": "Token Issuance Approved",
            "Enter Token Issuance Approved": "Enter Token Issuance Approved",
            "Final Tokenization Decision": "Final Tokenization Decision",
            "Enter Final Tokenization Decision": "Enter Final Tokenization Decision",
            "Decision Notes": "Decision Notes",
            "Enter Decision Notes": "Enter Decision Notes",
            "06 Investor Relations Update Reporting": "06 Investor Relations Update Reporting",
            "06 INVESTOR RELATIONS UPDATE REPORTING": "06 INVESTOR RELATIONS UPDATE REPORTING",
            "POSTAUCT_Investor_Update_Report": "POSTAUCT_Investor_Update_Report",
            "POSTAUCT_INVESTOR_UPDATE_REPORT": "POSTAUCT_INVESTOR_UPDATE_REPORT",
            "Post-Auction Investor Update Report": "Post-Auction Investor Update Report",
            "Select Post-Auction Investor Update Report": "Select Post-Auction Investor Update Report",
            "Print of Post-Auction Investor Update Report": "Print of Post-Auction Investor Update Report",
            "Post-Auction Investor Update ID": "Post-Auction Investor Update ID",
            "POSTAUCT Investor Update ID": "POSTAUCT Investor Update ID",
            "Enter POSTAUCT Investor Update ID": "Enter POSTAUCT Investor Update ID",
            "Acquisition Status Update": "Acquisition Status Update",
            "Enter Acquisition Status Update": "Enter Acquisition Status Update",
            "Title Cure Update": "Title Cure Update",
            "Enter Title Cure Update": "Enter Title Cure Update",
            "Rehab Update": "Rehab Update",
            "Enter Rehab Update": "Enter Rehab Update",
            "Tokenization Readiness Update": "Tokenization Readiness Update",
            "Enter Tokenization Readiness Update": "Enter Tokenization Readiness Update"
        }
    }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
